(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.AngularJSForms = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var forms = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	    factory(exports) ;
	}(commonjsGlobal, (function (exports) {
	    function noop() { }
	    function run(fn) {
	        return fn();
	    }
	    function blank_object() {
	        return Object.create(null);
	    }
	    function run_all(fns) {
	        fns.forEach(run);
	    }
	    function is_function(thing) {
	        return typeof thing === 'function';
	    }
	    function safe_not_equal(a, b) {
	        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	    }
	    function is_empty(obj) {
	        return Object.keys(obj).length === 0;
	    }
	    function subscribe(store, ...callbacks) {
	        if (store == null) {
	            return noop;
	        }
	        const unsub = store.subscribe(...callbacks);
	        return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
	    }
	    function component_subscribe(component, store, callback) {
	        component.$$.on_destroy.push(subscribe(store, callback));
	    }
	    function action_destroyer(action_result) {
	        return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
	    }

	    function append(target, node) {
	        target.appendChild(node);
	    }
	    function insert(target, node, anchor) {
	        target.insertBefore(node, anchor || null);
	    }
	    function detach(node) {
	        node.parentNode.removeChild(node);
	    }
	    function destroy_each(iterations, detaching) {
	        for (let i = 0; i < iterations.length; i += 1) {
	            if (iterations[i])
	                iterations[i].d(detaching);
	        }
	    }
	    function element(name) {
	        return document.createElement(name);
	    }
	    function svg_element(name) {
	        return document.createElementNS('http://www.w3.org/2000/svg', name);
	    }
	    function text(data) {
	        return document.createTextNode(data);
	    }
	    function space() {
	        return text(' ');
	    }
	    function empty$1() {
	        return text('');
	    }
	    function listen(node, event, handler, options) {
	        node.addEventListener(event, handler, options);
	        return () => node.removeEventListener(event, handler, options);
	    }
	    function attr(node, attribute, value) {
	        if (value == null)
	            node.removeAttribute(attribute);
	        else if (node.getAttribute(attribute) !== value)
	            node.setAttribute(attribute, value);
	    }
	    function children(element) {
	        return Array.from(element.childNodes);
	    }
	    function set_data(text, data) {
	        data = '' + data;
	        if (text.wholeText !== data)
	            text.data = data;
	    }
	    function set_input_value(input, value) {
	        input.value = value == null ? '' : value;
	    }
	    function set_style(node, key, value, important) {
	        node.style.setProperty(key, value, important ? 'important' : '');
	    }
	    function toggle_class(element, name, toggle) {
	        element.classList[toggle ? 'add' : 'remove'](name);
	    }
	    function custom_event(type, detail) {
	        const e = document.createEvent('CustomEvent');
	        e.initCustomEvent(type, false, false, detail);
	        return e;
	    }
	    class HtmlTag {
	        constructor(anchor = null) {
	            this.a = anchor;
	            this.e = this.n = null;
	        }
	        m(html, target, anchor = null) {
	            if (!this.e) {
	                this.e = element(target.nodeName);
	                this.t = target;
	                this.h(html);
	            }
	            this.i(anchor);
	        }
	        h(html) {
	            this.e.innerHTML = html;
	            this.n = Array.from(this.e.childNodes);
	        }
	        i(anchor) {
	            for (let i = 0; i < this.n.length; i += 1) {
	                insert(this.t, this.n[i], anchor);
	            }
	        }
	        p(html) {
	            this.d();
	            this.h(html);
	            this.i(this.a);
	        }
	        d() {
	            this.n.forEach(detach);
	        }
	    }

	    let current_component;
	    function set_current_component(component) {
	        current_component = component;
	    }
	    function get_current_component() {
	        if (!current_component)
	            throw new Error('Function called outside component initialization');
	        return current_component;
	    }
	    function beforeUpdate(fn) {
	        get_current_component().$$.before_update.push(fn);
	    }
	    function onMount(fn) {
	        get_current_component().$$.on_mount.push(fn);
	    }
	    function onDestroy(fn) {
	        get_current_component().$$.on_destroy.push(fn);
	    }
	    function createEventDispatcher() {
	        const component = get_current_component();
	        return (type, detail) => {
	            const callbacks = component.$$.callbacks[type];
	            if (callbacks) {
	                // TODO are there situations where events could be dispatched
	                // in a server (non-DOM) environment?
	                const event = custom_event(type, detail);
	                callbacks.slice().forEach(fn => {
	                    fn.call(component, event);
	                });
	            }
	        };
	    }

	    const dirty_components = [];
	    const binding_callbacks = [];
	    const render_callbacks = [];
	    const flush_callbacks = [];
	    const resolved_promise = Promise.resolve();
	    let update_scheduled = false;
	    function schedule_update() {
	        if (!update_scheduled) {
	            update_scheduled = true;
	            resolved_promise.then(flush);
	        }
	    }
	    function add_render_callback(fn) {
	        render_callbacks.push(fn);
	    }
	    function add_flush_callback(fn) {
	        flush_callbacks.push(fn);
	    }
	    let flushing = false;
	    const seen_callbacks = new Set();
	    function flush() {
	        if (flushing)
	            return;
	        flushing = true;
	        do {
	            // first, call beforeUpdate functions
	            // and update components
	            for (let i = 0; i < dirty_components.length; i += 1) {
	                const component = dirty_components[i];
	                set_current_component(component);
	                update(component.$$);
	            }
	            set_current_component(null);
	            dirty_components.length = 0;
	            while (binding_callbacks.length)
	                binding_callbacks.pop()();
	            // then, once components are updated, call
	            // afterUpdate functions. This may cause
	            // subsequent updates...
	            for (let i = 0; i < render_callbacks.length; i += 1) {
	                const callback = render_callbacks[i];
	                if (!seen_callbacks.has(callback)) {
	                    // ...so guard against infinite loops
	                    seen_callbacks.add(callback);
	                    callback();
	                }
	            }
	            render_callbacks.length = 0;
	        } while (dirty_components.length);
	        while (flush_callbacks.length) {
	            flush_callbacks.pop()();
	        }
	        update_scheduled = false;
	        flushing = false;
	        seen_callbacks.clear();
	    }
	    function update($$) {
	        if ($$.fragment !== null) {
	            $$.update();
	            run_all($$.before_update);
	            const dirty = $$.dirty;
	            $$.dirty = [-1];
	            $$.fragment && $$.fragment.p($$.ctx, dirty);
	            $$.after_update.forEach(add_render_callback);
	        }
	    }
	    const outroing = new Set();
	    let outros;
	    function group_outros() {
	        outros = {
	            r: 0,
	            c: [],
	            p: outros // parent group
	        };
	    }
	    function check_outros() {
	        if (!outros.r) {
	            run_all(outros.c);
	        }
	        outros = outros.p;
	    }
	    function transition_in(block, local) {
	        if (block && block.i) {
	            outroing.delete(block);
	            block.i(local);
	        }
	    }
	    function transition_out(block, local, detach, callback) {
	        if (block && block.o) {
	            if (outroing.has(block))
	                return;
	            outroing.add(block);
	            outros.c.push(() => {
	                outroing.delete(block);
	                if (callback) {
	                    if (detach)
	                        block.d(1);
	                    callback();
	                }
	            });
	            block.o(local);
	        }
	    }

	    const globals = (typeof window !== 'undefined'
	        ? window
	        : typeof globalThis !== 'undefined'
	            ? globalThis
	            : commonjsGlobal);

	    function bind(component, name, callback) {
	        const index = component.$$.props[name];
	        if (index !== undefined) {
	            component.$$.bound[index] = callback;
	            callback(component.$$.ctx[index]);
	        }
	    }
	    function create_component(block) {
	        block && block.c();
	    }
	    function mount_component(component, target, anchor, customElement) {
	        const { fragment, on_mount, on_destroy, after_update } = component.$$;
	        fragment && fragment.m(target, anchor);
	        if (!customElement) {
	            // onMount happens before the initial afterUpdate
	            add_render_callback(() => {
	                const new_on_destroy = on_mount.map(run).filter(is_function);
	                if (on_destroy) {
	                    on_destroy.push(...new_on_destroy);
	                }
	                else {
	                    // Edge case - component was destroyed immediately,
	                    // most likely as a result of a binding initialising
	                    run_all(new_on_destroy);
	                }
	                component.$$.on_mount = [];
	            });
	        }
	        after_update.forEach(add_render_callback);
	    }
	    function destroy_component(component, detaching) {
	        const $$ = component.$$;
	        if ($$.fragment !== null) {
	            run_all($$.on_destroy);
	            $$.fragment && $$.fragment.d(detaching);
	            // TODO null out other refs, including component.$$ (but need to
	            // preserve final state?)
	            $$.on_destroy = $$.fragment = null;
	            $$.ctx = [];
	        }
	    }
	    function make_dirty(component, i) {
	        if (component.$$.dirty[0] === -1) {
	            dirty_components.push(component);
	            schedule_update();
	            component.$$.dirty.fill(0);
	        }
	        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	    }
	    function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
	        const parent_component = current_component;
	        set_current_component(component);
	        const $$ = component.$$ = {
	            fragment: null,
	            ctx: null,
	            // state
	            props,
	            update: noop,
	            not_equal,
	            bound: blank_object(),
	            // lifecycle
	            on_mount: [],
	            on_destroy: [],
	            on_disconnect: [],
	            before_update: [],
	            after_update: [],
	            context: new Map(parent_component ? parent_component.$$.context : options.context || []),
	            // everything else
	            callbacks: blank_object(),
	            dirty,
	            skip_bound: false
	        };
	        let ready = false;
	        $$.ctx = instance
	            ? instance(component, options.props || {}, (i, ret, ...rest) => {
	                const value = rest.length ? rest[0] : ret;
	                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                    if (!$$.skip_bound && $$.bound[i])
	                        $$.bound[i](value);
	                    if (ready)
	                        make_dirty(component, i);
	                }
	                return ret;
	            })
	            : [];
	        $$.update();
	        ready = true;
	        run_all($$.before_update);
	        // `false` as a special case of no DOM component
	        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	        if (options.target) {
	            if (options.hydrate) {
	                const nodes = children(options.target);
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.l(nodes);
	                nodes.forEach(detach);
	            }
	            else {
	                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                $$.fragment && $$.fragment.c();
	            }
	            if (options.intro)
	                transition_in(component.$$.fragment);
	            mount_component(component, options.target, options.anchor, options.customElement);
	            flush();
	        }
	        set_current_component(parent_component);
	    }
	    /**
	     * Base class for Svelte components. Used when dev=false.
	     */
	    class SvelteComponent {
	        $destroy() {
	            destroy_component(this, 1);
	            this.$destroy = noop;
	        }
	        $on(type, callback) {
	            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	            callbacks.push(callback);
	            return () => {
	                const index = callbacks.indexOf(callback);
	                if (index !== -1)
	                    callbacks.splice(index, 1);
	            };
	        }
	        $set($$props) {
	            if (this.$$set && !is_empty($$props)) {
	                this.$$.skip_bound = true;
	                this.$$set($$props);
	                this.$$.skip_bound = false;
	            }
	        }
	    }

	    const subscriber_queue = [];
	    /**
	     * Creates a `Readable` store that allows reading by subscription.
	     * @param value initial value
	     * @param {StartStopNotifier}start start and stop notifications for subscriptions
	     */
	    function readable(value, start) {
	        return {
	            subscribe: writable(value, start).subscribe
	        };
	    }
	    /**
	     * Create a `Writable` store that allows both updating and reading by subscription.
	     * @param {*=}value initial value
	     * @param {StartStopNotifier=}start start and stop notifications for subscriptions
	     */
	    function writable(value, start = noop) {
	        let stop;
	        const subscribers = [];
	        function set(new_value) {
	            if (safe_not_equal(value, new_value)) {
	                value = new_value;
	                if (stop) { // store is ready
	                    const run_queue = !subscriber_queue.length;
	                    for (let i = 0; i < subscribers.length; i += 1) {
	                        const s = subscribers[i];
	                        s[1]();
	                        subscriber_queue.push(s, value);
	                    }
	                    if (run_queue) {
	                        for (let i = 0; i < subscriber_queue.length; i += 2) {
	                            subscriber_queue[i][0](subscriber_queue[i + 1]);
	                        }
	                        subscriber_queue.length = 0;
	                    }
	                }
	            }
	        }
	        function update(fn) {
	            set(fn(value));
	        }
	        function subscribe(run, invalidate = noop) {
	            const subscriber = [run, invalidate];
	            subscribers.push(subscriber);
	            if (subscribers.length === 1) {
	                stop = start(set) || noop;
	            }
	            run(value);
	            return () => {
	                const index = subscribers.indexOf(subscriber);
	                if (index !== -1) {
	                    subscribers.splice(index, 1);
	                }
	                if (subscribers.length === 0) {
	                    stop();
	                    stop = null;
	                }
	            };
	        }
	        return { set, update, subscribe };
	    }
	    function derived(stores, fn, initial_value) {
	        const single = !Array.isArray(stores);
	        const stores_array = single
	            ? [stores]
	            : stores;
	        const auto = fn.length < 2;
	        return readable(initial_value, (set) => {
	            let inited = false;
	            const values = [];
	            let pending = 0;
	            let cleanup = noop;
	            const sync = () => {
	                if (pending) {
	                    return;
	                }
	                cleanup();
	                const result = fn(single ? values[0] : values, set);
	                if (auto) {
	                    set(result);
	                }
	                else {
	                    cleanup = is_function(result) ? result : noop;
	                }
	            };
	            const unsubscribers = stores_array.map((store, i) => subscribe(store, (value) => {
	                values[i] = value;
	                pending &= ~(1 << i);
	                if (inited) {
	                    sync();
	                }
	            }, () => {
	                pending |= (1 << i);
	            }));
	            inited = true;
	            sync();
	            return function stop() {
	                run_all(unsubscribers);
	                cleanup();
	            };
	        });
	    }

	    var isMergeableObject = function isMergeableObject(value) {
	    	return isNonNullObject(value)
	    		&& !isSpecial(value)
	    };

	    function isNonNullObject(value) {
	    	return !!value && typeof value === 'object'
	    }

	    function isSpecial(value) {
	    	var stringValue = Object.prototype.toString.call(value);

	    	return stringValue === '[object RegExp]'
	    		|| stringValue === '[object Date]'
	    		|| isReactElement(value)
	    }

	    // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	    var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	    function isReactElement(value) {
	    	return value.$$typeof === REACT_ELEMENT_TYPE
	    }

	    function emptyTarget(val) {
	    	return Array.isArray(val) ? [] : {}
	    }

	    function cloneUnlessOtherwiseSpecified(value, options) {
	    	return (options.clone !== false && options.isMergeableObject(value))
	    		? deepmerge(emptyTarget(value), value, options)
	    		: value
	    }

	    function defaultArrayMerge(target, source, options) {
	    	return target.concat(source).map(function(element) {
	    		return cloneUnlessOtherwiseSpecified(element, options)
	    	})
	    }

	    function getMergeFunction(key, options) {
	    	if (!options.customMerge) {
	    		return deepmerge
	    	}
	    	var customMerge = options.customMerge(key);
	    	return typeof customMerge === 'function' ? customMerge : deepmerge
	    }

	    function getEnumerableOwnPropertySymbols(target) {
	    	return Object.getOwnPropertySymbols
	    		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
	    			return Object.propertyIsEnumerable.call(target, symbol)
	    		})
	    		: []
	    }

	    function getKeys(target) {
	    	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	    }

	    function propertyIsOnObject(object, property) {
	    	try {
	    		return property in object
	    	} catch(_) {
	    		return false
	    	}
	    }

	    // Protects from prototype poisoning and unexpected merging up the prototype chain.
	    function propertyIsUnsafe(target, key) {
	    	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
	    		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
	    			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	    }

	    function mergeObject(target, source, options) {
	    	var destination = {};
	    	if (options.isMergeableObject(target)) {
	    		getKeys(target).forEach(function(key) {
	    			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
	    		});
	    	}
	    	getKeys(source).forEach(function(key) {
	    		if (propertyIsUnsafe(target, key)) {
	    			return
	    		}

	    		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
	    			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
	    		} else {
	    			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
	    		}
	    	});
	    	return destination
	    }

	    function deepmerge(target, source, options) {
	    	options = options || {};
	    	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	    	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	    	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	    	// implementations can use it. The caller may not replace it.
	    	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	    	var sourceIsArray = Array.isArray(source);
	    	var targetIsArray = Array.isArray(target);
	    	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	    	if (!sourceAndTargetTypesMatch) {
	    		return cloneUnlessOtherwiseSpecified(source, options)
	    	} else if (sourceIsArray) {
	    		return options.arrayMerge(target, source, options)
	    	} else {
	    		return mergeObject(target, source, options)
	    	}
	    }

	    deepmerge.all = function deepmergeAll(array, options) {
	    	if (!Array.isArray(array)) {
	    		throw new Error('first argument should be an array')
	    	}

	    	return array.reduce(function(prev, next) {
	    		return deepmerge(prev, next, options)
	    	}, {})
	    };

	    var deepmerge_1 = deepmerge;

	    var cjs = deepmerge_1;

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

	    var extendStatics$1 = function(d, b) {
	        extendStatics$1 = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics$1(d, b);
	    };

	    function __extends$1(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics$1(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign$3 = function() {
	        __assign$3 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$3.apply(this, arguments);
	    };

	    function __spreadArray(to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    }

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */

	    var __assign$2 = function() {
	        __assign$2 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$2.apply(this, arguments);
	    };

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    var ErrorKind;
	    (function (ErrorKind) {
	        /** Argument is unclosed (e.g. `{0`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
	        /** Argument is empty (e.g. `{}`). */
	        ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
	        /** Argument is malformed (e.g. `{foo!}``) */
	        ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
	        /** Expect an argument type (e.g. `{foo,}`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
	        /** Unsupported argument type (e.g. `{foo,foo}`) */
	        ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
	        /** Expect an argument style (e.g. `{foo, number, }`) */
	        ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
	        /** The number skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
	        /** The date time skeleton is invalid. */
	        ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
	        /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
	        /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
	        ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
	        /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
	        ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
	        /** Missing select argument options (e.g. `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
	        /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
	        /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
	        /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
	        /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
	        ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
	        /**
	         * Expecting a message fragment after the `plural` or `selectordinal` selector
	         * (e.g. `{foo, plural, one}`)
	         */
	        ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
	        /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
	        ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
	        /**
	         * Duplicate selectors in `plural` or `selectordinal` argument.
	         * (e.g. {foo, plural, one {#} one {#}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
	        /** Duplicate selectors in `select` argument.
	         * (e.g. {foo, select, apple {apple} apple {apple}})
	         */
	        ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
	        /** Plural or select argument option must have `other` clause. */
	        ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
	        /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
	        ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
	        /** The tag name is invalid. (e.g. `<123>foo</123>`) */
	        ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
	        /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
	        ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
	        /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
	        ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
	    })(ErrorKind || (ErrorKind = {}));

	    var TYPE;
	    (function (TYPE) {
	        /**
	         * Raw text
	         */
	        TYPE[TYPE["literal"] = 0] = "literal";
	        /**
	         * Variable w/o any format, e.g `var` in `this is a {var}`
	         */
	        TYPE[TYPE["argument"] = 1] = "argument";
	        /**
	         * Variable w/ number format
	         */
	        TYPE[TYPE["number"] = 2] = "number";
	        /**
	         * Variable w/ date format
	         */
	        TYPE[TYPE["date"] = 3] = "date";
	        /**
	         * Variable w/ time format
	         */
	        TYPE[TYPE["time"] = 4] = "time";
	        /**
	         * Variable w/ select format
	         */
	        TYPE[TYPE["select"] = 5] = "select";
	        /**
	         * Variable w/ plural format
	         */
	        TYPE[TYPE["plural"] = 6] = "plural";
	        /**
	         * Only possible within plural argument.
	         * This is the `#` symbol that will be substituted with the count.
	         */
	        TYPE[TYPE["pound"] = 7] = "pound";
	        /**
	         * XML-like tag
	         */
	        TYPE[TYPE["tag"] = 8] = "tag";
	    })(TYPE || (TYPE = {}));
	    var SKELETON_TYPE;
	    (function (SKELETON_TYPE) {
	        SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
	        SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
	    })(SKELETON_TYPE || (SKELETON_TYPE = {}));
	    /**
	     * Type Guards
	     */
	    function isLiteralElement(el) {
	        return el.type === TYPE.literal;
	    }
	    function isArgumentElement(el) {
	        return el.type === TYPE.argument;
	    }
	    function isNumberElement(el) {
	        return el.type === TYPE.number;
	    }
	    function isDateElement(el) {
	        return el.type === TYPE.date;
	    }
	    function isTimeElement(el) {
	        return el.type === TYPE.time;
	    }
	    function isSelectElement(el) {
	        return el.type === TYPE.select;
	    }
	    function isPluralElement(el) {
	        return el.type === TYPE.plural;
	    }
	    function isPoundElement(el) {
	        return el.type === TYPE.pound;
	    }
	    function isTagElement(el) {
	        return el.type === TYPE.tag;
	    }
	    function isNumberSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
	    }
	    function isDateTimeSkeleton(el) {
	        return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
	    }

	    // @generated from regex-gen.ts
	    var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

	    /**
	     * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	     * with some tweaks
	     */
	    var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	    /**
	     * Parse Date time skeleton into Intl.DateTimeFormatOptions
	     * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	     * @public
	     * @param skeleton skeleton string
	     */
	    function parseDateTimeSkeleton(skeleton) {
	        var result = {};
	        skeleton.replace(DATE_TIME_REGEX, function (match) {
	            var len = match.length;
	            switch (match[0]) {
	                // Era
	                case 'G':
	                    result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                    break;
	                // Year
	                case 'y':
	                    result.year = len === 2 ? '2-digit' : 'numeric';
	                    break;
	                case 'Y':
	                case 'u':
	                case 'U':
	                case 'r':
	                    throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	                // Quarter
	                case 'q':
	                case 'Q':
	                    throw new RangeError('`q/Q` (quarter) patterns are not supported');
	                // Month
	                case 'M':
	                case 'L':
	                    result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                    break;
	                // Week
	                case 'w':
	                case 'W':
	                    throw new RangeError('`w/W` (week) patterns are not supported');
	                case 'd':
	                    result.day = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'D':
	                case 'F':
	                case 'g':
	                    throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	                // Weekday
	                case 'E':
	                    result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                    break;
	                case 'e':
	                    if (len < 4) {
	                        throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                case 'c':
	                    if (len < 4) {
	                        throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                    }
	                    result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                    break;
	                // Period
	                case 'a': // AM, PM
	                    result.hour12 = true;
	                    break;
	                case 'b': // am, pm, noon, midnight
	                case 'B': // flexible day periods
	                    throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	                // Hour
	                case 'h':
	                    result.hourCycle = 'h12';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'H':
	                    result.hourCycle = 'h23';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'K':
	                    result.hourCycle = 'h11';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'k':
	                    result.hourCycle = 'h24';
	                    result.hour = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'j':
	                case 'J':
	                case 'C':
	                    throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	                // Minute
	                case 'm':
	                    result.minute = ['numeric', '2-digit'][len - 1];
	                    break;
	                // Second
	                case 's':
	                    result.second = ['numeric', '2-digit'][len - 1];
	                    break;
	                case 'S':
	                case 'A':
	                    throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
	                // Zone
	                case 'z': // 1..3, 4: specific non-location format
	                    result.timeZoneName = len < 4 ? 'short' : 'long';
	                    break;
	                case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	                case 'O': // 1, 4: miliseconds in day short, long
	                case 'v': // 1, 4: generic non-location format
	                case 'V': // 1, 2, 3, 4: time zone ID or city
	                case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	                case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                    throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
	            }
	            return '';
	        });
	        return result;
	    }

	    /******************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */

	    var __assign$1 = function() {
	        __assign$1 = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign$1.apply(this, arguments);
	    };

	    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };

	    // @generated from regex-gen.ts
	    var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

	    function parseNumberSkeletonFromString(skeleton) {
	        if (skeleton.length === 0) {
	            throw new Error('Number skeleton cannot be empty');
	        }
	        // Parse the skeleton
	        var stringTokens = skeleton
	            .split(WHITE_SPACE_REGEX)
	            .filter(function (x) { return x.length > 0; });
	        var tokens = [];
	        for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
	            var stringToken = stringTokens_1[_i];
	            var stemAndOptions = stringToken.split('/');
	            if (stemAndOptions.length === 0) {
	                throw new Error('Invalid number skeleton');
	            }
	            var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
	            for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
	                var option = options_1[_a];
	                if (option.length === 0) {
	                    throw new Error('Invalid number skeleton');
	                }
	            }
	            tokens.push({ stem: stem, options: options });
	        }
	        return tokens;
	    }
	    function icuUnitToEcma(unit) {
	        return unit.replace(/^(.*?)-/, '');
	    }
	    var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
	    var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
	    var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
	    var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
	    function parseSignificantPrecision(str) {
	        var result = {};
	        if (str[str.length - 1] === 'r') {
	            result.roundingPriority = 'morePrecision';
	        }
	        else if (str[str.length - 1] === 's') {
	            result.roundingPriority = 'lessPrecision';
	        }
	        str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	            // @@@ case
	            if (typeof g2 !== 'string') {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits = g1.length;
	            }
	            // @@@+ case
	            else if (g2 === '+') {
	                result.minimumSignificantDigits = g1.length;
	            }
	            // .### case
	            else if (g1[0] === '#') {
	                result.maximumSignificantDigits = g1.length;
	            }
	            // .@@## or .@@@ case
	            else {
	                result.minimumSignificantDigits = g1.length;
	                result.maximumSignificantDigits =
	                    g1.length + (typeof g2 === 'string' ? g2.length : 0);
	            }
	            return '';
	        });
	        return result;
	    }
	    function parseSign(str) {
	        switch (str) {
	            case 'sign-auto':
	                return {
	                    signDisplay: 'auto',
	                };
	            case 'sign-accounting':
	            case '()':
	                return {
	                    currencySign: 'accounting',
	                };
	            case 'sign-always':
	            case '+!':
	                return {
	                    signDisplay: 'always',
	                };
	            case 'sign-accounting-always':
	            case '()!':
	                return {
	                    signDisplay: 'always',
	                    currencySign: 'accounting',
	                };
	            case 'sign-except-zero':
	            case '+?':
	                return {
	                    signDisplay: 'exceptZero',
	                };
	            case 'sign-accounting-except-zero':
	            case '()?':
	                return {
	                    signDisplay: 'exceptZero',
	                    currencySign: 'accounting',
	                };
	            case 'sign-never':
	            case '+_':
	                return {
	                    signDisplay: 'never',
	                };
	        }
	    }
	    function parseConciseScientificAndEngineeringStem(stem) {
	        // Engineering
	        var result;
	        if (stem[0] === 'E' && stem[1] === 'E') {
	            result = {
	                notation: 'engineering',
	            };
	            stem = stem.slice(2);
	        }
	        else if (stem[0] === 'E') {
	            result = {
	                notation: 'scientific',
	            };
	            stem = stem.slice(1);
	        }
	        if (result) {
	            var signDisplay = stem.slice(0, 2);
	            if (signDisplay === '+!') {
	                result.signDisplay = 'always';
	                stem = stem.slice(2);
	            }
	            else if (signDisplay === '+?') {
	                result.signDisplay = 'exceptZero';
	                stem = stem.slice(2);
	            }
	            if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
	                throw new Error('Malformed concise eng/scientific notation');
	            }
	            result.minimumIntegerDigits = stem.length;
	        }
	        return result;
	    }
	    function parseNotationOptions(opt) {
	        var result = {};
	        var signOpts = parseSign(opt);
	        if (signOpts) {
	            return signOpts;
	        }
	        return result;
	    }
	    /**
	     * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	     */
	    function parseNumberSkeleton(tokens) {
	        var result = {};
	        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	            var token = tokens_1[_i];
	            switch (token.stem) {
	                case 'percent':
	                case '%':
	                    result.style = 'percent';
	                    continue;
	                case '%x100':
	                    result.style = 'percent';
	                    result.scale = 100;
	                    continue;
	                case 'currency':
	                    result.style = 'currency';
	                    result.currency = token.options[0];
	                    continue;
	                case 'group-off':
	                case ',_':
	                    result.useGrouping = false;
	                    continue;
	                case 'precision-integer':
	                case '.':
	                    result.maximumFractionDigits = 0;
	                    continue;
	                case 'measure-unit':
	                case 'unit':
	                    result.style = 'unit';
	                    result.unit = icuUnitToEcma(token.options[0]);
	                    continue;
	                case 'compact-short':
	                case 'K':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'short';
	                    continue;
	                case 'compact-long':
	                case 'KK':
	                    result.notation = 'compact';
	                    result.compactDisplay = 'long';
	                    continue;
	                case 'scientific':
	                    result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'engineering':
	                    result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
	                    continue;
	                case 'notation-simple':
	                    result.notation = 'standard';
	                    continue;
	                // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	                case 'unit-width-narrow':
	                    result.currencyDisplay = 'narrowSymbol';
	                    result.unitDisplay = 'narrow';
	                    continue;
	                case 'unit-width-short':
	                    result.currencyDisplay = 'code';
	                    result.unitDisplay = 'short';
	                    continue;
	                case 'unit-width-full-name':
	                    result.currencyDisplay = 'name';
	                    result.unitDisplay = 'long';
	                    continue;
	                case 'unit-width-iso-code':
	                    result.currencyDisplay = 'symbol';
	                    continue;
	                case 'scale':
	                    result.scale = parseFloat(token.options[0]);
	                    continue;
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	                case 'integer-width':
	                    if (token.options.length > 1) {
	                        throw new RangeError('integer-width stems only accept a single optional option');
	                    }
	                    token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
	                        if (g1) {
	                            result.minimumIntegerDigits = g2.length;
	                        }
	                        else if (g3 && g4) {
	                            throw new Error('We currently do not support maximum integer digits');
	                        }
	                        else if (g5) {
	                            throw new Error('We currently do not support exact integer digits');
	                        }
	                        return '';
	                    });
	                    continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	            if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
	                result.minimumIntegerDigits = token.stem.length;
	                continue;
	            }
	            if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	                // Precision
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
	                // precision-integer case
	                if (token.options.length > 1) {
	                    throw new RangeError('Fraction-precision stems only accept a single optional option');
	                }
	                token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
	                    // .000* case (before ICU67 it was .000+)
	                    if (g2 === '*') {
	                        result.minimumFractionDigits = g1.length;
	                    }
	                    // .### case
	                    else if (g3 && g3[0] === '#') {
	                        result.maximumFractionDigits = g3.length;
	                    }
	                    // .00## case
	                    else if (g4 && g5) {
	                        result.minimumFractionDigits = g4.length;
	                        result.maximumFractionDigits = g4.length + g5.length;
	                    }
	                    else {
	                        result.minimumFractionDigits = g1.length;
	                        result.maximumFractionDigits = g1.length;
	                    }
	                    return '';
	                });
	                var opt = token.options[0];
	                // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
	                if (opt === 'w') {
	                    result = __assign$1(__assign$1({}, result), { trailingZeroDisplay: 'stripIfInteger' });
	                }
	                else if (opt) {
	                    result = __assign$1(__assign$1({}, result), parseSignificantPrecision(opt));
	                }
	                continue;
	            }
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
	            if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	                result = __assign$1(__assign$1({}, result), parseSignificantPrecision(token.stem));
	                continue;
	            }
	            var signOpts = parseSign(token.stem);
	            if (signOpts) {
	                result = __assign$1(__assign$1({}, result), signOpts);
	            }
	            var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
	            if (conciseScientificAndEngineeringOpts) {
	                result = __assign$1(__assign$1({}, result), conciseScientificAndEngineeringOpts);
	            }
	        }
	        return result;
	    }

	    // @generated from time-data-gen.ts
	    // prettier-ignore  
	    var timeData = {
	        "AX": [
	            "H"
	        ],
	        "BQ": [
	            "H"
	        ],
	        "CP": [
	            "H"
	        ],
	        "CZ": [
	            "H"
	        ],
	        "DK": [
	            "H"
	        ],
	        "FI": [
	            "H"
	        ],
	        "ID": [
	            "H"
	        ],
	        "IS": [
	            "H"
	        ],
	        "ML": [
	            "H"
	        ],
	        "NE": [
	            "H"
	        ],
	        "RU": [
	            "H"
	        ],
	        "SE": [
	            "H"
	        ],
	        "SJ": [
	            "H"
	        ],
	        "SK": [
	            "H"
	        ],
	        "AS": [
	            "h",
	            "H"
	        ],
	        "BT": [
	            "h",
	            "H"
	        ],
	        "DJ": [
	            "h",
	            "H"
	        ],
	        "ER": [
	            "h",
	            "H"
	        ],
	        "GH": [
	            "h",
	            "H"
	        ],
	        "IN": [
	            "h",
	            "H"
	        ],
	        "LS": [
	            "h",
	            "H"
	        ],
	        "PG": [
	            "h",
	            "H"
	        ],
	        "PW": [
	            "h",
	            "H"
	        ],
	        "SO": [
	            "h",
	            "H"
	        ],
	        "TO": [
	            "h",
	            "H"
	        ],
	        "VU": [
	            "h",
	            "H"
	        ],
	        "WS": [
	            "h",
	            "H"
	        ],
	        "001": [
	            "H",
	            "h"
	        ],
	        "AL": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "TD": [
	            "h",
	            "H",
	            "hB"
	        ],
	        "ca-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "fr-CA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "gl-ES": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-CH": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "it-IT": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "LU": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "NP": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "PF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SC": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SM": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "SN": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "TF": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "VA": [
	            "H",
	            "h",
	            "hB"
	        ],
	        "CY": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "GR": [
	            "h",
	            "H",
	            "hb",
	            "hB"
	        ],
	        "CO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "DO": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KP": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "KR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "NA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PA": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "PR": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "VE": [
	            "h",
	            "H",
	            "hB",
	            "hb"
	        ],
	        "AC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "AI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BW": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "BZ": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CC": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "CX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "DG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "FK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GB": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "GI": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IM": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "IO": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "JE": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "LT": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MK": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "MS": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NF": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NG": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NR": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "NU": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "PN": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SH": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "SX": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "TA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "ZA": [
	            "H",
	            "h",
	            "hb",
	            "hB"
	        ],
	        "af-ZA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "AR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CL": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "CU": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "EA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BO": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-BR": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-EC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-ES": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-GQ": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "es-PE": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "GT": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "HN": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "IC": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KG": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "KM": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "LK": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MA": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "MX": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "NI": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "PY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "SV": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "UY": [
	            "H",
	            "h",
	            "hB",
	            "hb"
	        ],
	        "JP": [
	            "H",
	            "h",
	            "K"
	        ],
	        "AD": [
	            "H",
	            "hB"
	        ],
	        "AM": [
	            "H",
	            "hB"
	        ],
	        "AO": [
	            "H",
	            "hB"
	        ],
	        "AT": [
	            "H",
	            "hB"
	        ],
	        "AW": [
	            "H",
	            "hB"
	        ],
	        "BE": [
	            "H",
	            "hB"
	        ],
	        "BF": [
	            "H",
	            "hB"
	        ],
	        "BJ": [
	            "H",
	            "hB"
	        ],
	        "BL": [
	            "H",
	            "hB"
	        ],
	        "BR": [
	            "H",
	            "hB"
	        ],
	        "CG": [
	            "H",
	            "hB"
	        ],
	        "CI": [
	            "H",
	            "hB"
	        ],
	        "CV": [
	            "H",
	            "hB"
	        ],
	        "DE": [
	            "H",
	            "hB"
	        ],
	        "EE": [
	            "H",
	            "hB"
	        ],
	        "FR": [
	            "H",
	            "hB"
	        ],
	        "GA": [
	            "H",
	            "hB"
	        ],
	        "GF": [
	            "H",
	            "hB"
	        ],
	        "GN": [
	            "H",
	            "hB"
	        ],
	        "GP": [
	            "H",
	            "hB"
	        ],
	        "GW": [
	            "H",
	            "hB"
	        ],
	        "HR": [
	            "H",
	            "hB"
	        ],
	        "IL": [
	            "H",
	            "hB"
	        ],
	        "IT": [
	            "H",
	            "hB"
	        ],
	        "KZ": [
	            "H",
	            "hB"
	        ],
	        "MC": [
	            "H",
	            "hB"
	        ],
	        "MD": [
	            "H",
	            "hB"
	        ],
	        "MF": [
	            "H",
	            "hB"
	        ],
	        "MQ": [
	            "H",
	            "hB"
	        ],
	        "MZ": [
	            "H",
	            "hB"
	        ],
	        "NC": [
	            "H",
	            "hB"
	        ],
	        "NL": [
	            "H",
	            "hB"
	        ],
	        "PM": [
	            "H",
	            "hB"
	        ],
	        "PT": [
	            "H",
	            "hB"
	        ],
	        "RE": [
	            "H",
	            "hB"
	        ],
	        "RO": [
	            "H",
	            "hB"
	        ],
	        "SI": [
	            "H",
	            "hB"
	        ],
	        "SR": [
	            "H",
	            "hB"
	        ],
	        "ST": [
	            "H",
	            "hB"
	        ],
	        "TG": [
	            "H",
	            "hB"
	        ],
	        "TR": [
	            "H",
	            "hB"
	        ],
	        "WF": [
	            "H",
	            "hB"
	        ],
	        "YT": [
	            "H",
	            "hB"
	        ],
	        "BD": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "PK": [
	            "h",
	            "hB",
	            "H"
	        ],
	        "AZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "BG": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "CH": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "GE": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "LI": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "ME": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "RS": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UA": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "UZ": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "XK": [
	            "H",
	            "hB",
	            "h"
	        ],
	        "AG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "AU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "CA": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "DM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "en-001": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FJ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "FM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GD": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GU": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "GY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "JM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KN": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "KY": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "LR": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MH": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MP": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "MW": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "NZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SB": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SL": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SS": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "SZ": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "TT": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "UM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "US": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VC": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VG": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "VI": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "ZM": [
	            "h",
	            "hb",
	            "H",
	            "hB"
	        ],
	        "BO": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "EC": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "ES": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "GQ": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "PE": [
	            "H",
	            "hB",
	            "h",
	            "hb"
	        ],
	        "AE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "ar-001": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "BH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "DZ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EG": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "EH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "HK": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "IQ": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "JO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "KW": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LB": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "LY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MO": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "MR": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "OM": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PH": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "PS": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "QA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SA": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SD": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "SY": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "TN": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "YE": [
	            "h",
	            "hB",
	            "hb",
	            "H"
	        ],
	        "AF": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "LA": [
	            "H",
	            "hb",
	            "hB",
	            "h"
	        ],
	        "CN": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "LV": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "TL": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "zu-ZA": [
	            "H",
	            "hB",
	            "hb",
	            "h"
	        ],
	        "CD": [
	            "hB",
	            "H"
	        ],
	        "IR": [
	            "hB",
	            "H"
	        ],
	        "hi-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "kn-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "ml-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "te-IN": [
	            "hB",
	            "h",
	            "H"
	        ],
	        "KH": [
	            "hB",
	            "h",
	            "H",
	            "hb"
	        ],
	        "ta-IN": [
	            "hB",
	            "h",
	            "hb",
	            "H"
	        ],
	        "BN": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "MY": [
	            "hb",
	            "hB",
	            "h",
	            "H"
	        ],
	        "ET": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "gu-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "mr-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "pa-IN": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "TW": [
	            "hB",
	            "hb",
	            "h",
	            "H"
	        ],
	        "KE": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "MM": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "TZ": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ],
	        "UG": [
	            "hB",
	            "hb",
	            "H",
	            "h"
	        ]
	    };

	    /**
	     * Returns the best matching date time pattern if a date time skeleton
	     * pattern is provided with a locale. Follows the Unicode specification:
	     * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
	     * @param skeleton date time skeleton pattern that possibly includes j, J or C
	     * @param locale
	     */
	    function getBestPattern(skeleton, locale) {
	        var skeletonCopy = '';
	        for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
	            var patternChar = skeleton.charAt(patternPos);
	            if (patternChar === 'j') {
	                var extraLength = 0;
	                while (patternPos + 1 < skeleton.length &&
	                    skeleton.charAt(patternPos + 1) === patternChar) {
	                    extraLength++;
	                    patternPos++;
	                }
	                var hourLen = 1 + (extraLength & 1);
	                var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
	                var dayPeriodChar = 'a';
	                var hourChar = getDefaultHourSymbolFromLocale(locale);
	                if (hourChar == 'H' || hourChar == 'k') {
	                    dayPeriodLen = 0;
	                }
	                while (dayPeriodLen-- > 0) {
	                    skeletonCopy += dayPeriodChar;
	                }
	                while (hourLen-- > 0) {
	                    skeletonCopy = hourChar + skeletonCopy;
	                }
	            }
	            else if (patternChar === 'J') {
	                skeletonCopy += 'H';
	            }
	            else {
	                skeletonCopy += patternChar;
	            }
	        }
	        return skeletonCopy;
	    }
	    /**
	     * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
	     * of the given `locale` to the corresponding time pattern.
	     * @param locale
	     */
	    function getDefaultHourSymbolFromLocale(locale) {
	        var hourCycle = locale.hourCycle;
	        if (hourCycle === undefined &&
	            // @ts-ignore hourCycle(s) is not identified yet
	            locale.hourCycles &&
	            // @ts-ignore
	            locale.hourCycles.length) {
	            // @ts-ignore
	            hourCycle = locale.hourCycles[0];
	        }
	        if (hourCycle) {
	            switch (hourCycle) {
	                case 'h24':
	                    return 'k';
	                case 'h23':
	                    return 'H';
	                case 'h12':
	                    return 'h';
	                case 'h11':
	                    return 'K';
	                default:
	                    throw new Error('Invalid hourCycle');
	            }
	        }
	        // TODO: Once hourCycle is fully supported remove the following with data generation
	        var languageTag = locale.language;
	        var regionTag;
	        if (languageTag !== 'root') {
	            regionTag = locale.maximize().region;
	        }
	        var hourCycles = timeData[regionTag || ''] ||
	            timeData[languageTag || ''] ||
	            timeData["".concat(languageTag, "-001")] ||
	            timeData['001'];
	        return hourCycles[0];
	    }

	    var _a;
	    var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
	    var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
	    function createLocation(start, end) {
	        return { start: start, end: end };
	    }
	    // #region Ponyfills
	    // Consolidate these variables up top for easier toggling during debugging
	    var hasNativeStartsWith = !!String.prototype.startsWith;
	    var hasNativeFromCodePoint = !!String.fromCodePoint;
	    var hasNativeFromEntries = !!Object.fromEntries;
	    var hasNativeCodePointAt = !!String.prototype.codePointAt;
	    var hasTrimStart = !!String.prototype.trimStart;
	    var hasTrimEnd = !!String.prototype.trimEnd;
	    var hasNativeIsSafeInteger = !!Number.isSafeInteger;
	    var isSafeInteger = hasNativeIsSafeInteger
	        ? Number.isSafeInteger
	        : function (n) {
	            return (typeof n === 'number' &&
	                isFinite(n) &&
	                Math.floor(n) === n &&
	                Math.abs(n) <= 0x1fffffffffffff);
	        };
	    // IE11 does not support y and u.
	    var REGEX_SUPPORTS_U_AND_Y = true;
	    try {
	        var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        /**
	         * legacy Edge or Xbox One browser
	         * Unicode flag support: supported
	         * Pattern_Syntax support: not supported
	         * See https://github.com/formatjs/formatjs/issues/2822
	         */
	        REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
	    }
	    catch (_) {
	        REGEX_SUPPORTS_U_AND_Y = false;
	    }
	    var startsWith = hasNativeStartsWith
	        ? // Native
	            function startsWith(s, search, position) {
	                return s.startsWith(search, position);
	            }
	        : // For IE11
	            function startsWith(s, search, position) {
	                return s.slice(position, position + search.length) === search;
	            };
	    var fromCodePoint = hasNativeFromCodePoint
	        ? String.fromCodePoint
	        : // IE11
	            function fromCodePoint() {
	                var codePoints = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    codePoints[_i] = arguments[_i];
	                }
	                var elements = '';
	                var length = codePoints.length;
	                var i = 0;
	                var code;
	                while (length > i) {
	                    code = codePoints[i++];
	                    if (code > 0x10ffff)
	                        throw RangeError(code + ' is not a valid code point');
	                    elements +=
	                        code < 0x10000
	                            ? String.fromCharCode(code)
	                            : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
	                }
	                return elements;
	            };
	    var fromEntries = 
	    // native
	    hasNativeFromEntries
	        ? Object.fromEntries
	        : // Ponyfill
	            function fromEntries(entries) {
	                var obj = {};
	                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                    var _a = entries_1[_i], k = _a[0], v = _a[1];
	                    obj[k] = v;
	                }
	                return obj;
	            };
	    var codePointAt = hasNativeCodePointAt
	        ? // Native
	            function codePointAt(s, index) {
	                return s.codePointAt(index);
	            }
	        : // IE 11
	            function codePointAt(s, index) {
	                var size = s.length;
	                if (index < 0 || index >= size) {
	                    return undefined;
	                }
	                var first = s.charCodeAt(index);
	                var second;
	                return first < 0xd800 ||
	                    first > 0xdbff ||
	                    index + 1 === size ||
	                    (second = s.charCodeAt(index + 1)) < 0xdc00 ||
	                    second > 0xdfff
	                    ? first
	                    : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
	            };
	    var trimStart = hasTrimStart
	        ? // Native
	            function trimStart(s) {
	                return s.trimStart();
	            }
	        : // Ponyfill
	            function trimStart(s) {
	                return s.replace(SPACE_SEPARATOR_START_REGEX, '');
	            };
	    var trimEnd = hasTrimEnd
	        ? // Native
	            function trimEnd(s) {
	                return s.trimEnd();
	            }
	        : // Ponyfill
	            function trimEnd(s) {
	                return s.replace(SPACE_SEPARATOR_END_REGEX, '');
	            };
	    // Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
	    function RE(s, flag) {
	        return new RegExp(s, flag);
	    }
	    // #endregion
	    var matchIdentifierAtIndex;
	    if (REGEX_SUPPORTS_U_AND_Y) {
	        // Native
	        var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var _a;
	            IDENTIFIER_PREFIX_RE_1.lastIndex = index;
	            var match = IDENTIFIER_PREFIX_RE_1.exec(s);
	            return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
	        };
	    }
	    else {
	        // IE11
	        matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	            var match = [];
	            while (true) {
	                var c = codePointAt(s, index);
	                if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
	                    break;
	                }
	                match.push(c);
	                index += c >= 0x10000 ? 2 : 1;
	            }
	            return fromCodePoint.apply(void 0, match);
	        };
	    }
	    var Parser = /** @class */ (function () {
	        function Parser(message, options) {
	            if (options === void 0) { options = {}; }
	            this.message = message;
	            this.position = { offset: 0, line: 1, column: 1 };
	            this.ignoreTag = !!options.ignoreTag;
	            this.locale = options.locale;
	            this.requiresOtherClause = !!options.requiresOtherClause;
	            this.shouldParseSkeletons = !!options.shouldParseSkeletons;
	        }
	        Parser.prototype.parse = function () {
	            if (this.offset() !== 0) {
	                throw Error('parser can only be used once');
	            }
	            return this.parseMessage(0, '', false);
	        };
	        Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
	            var elements = [];
	            while (!this.isEOF()) {
	                var char = this.char();
	                if (char === 123 /* `{` */) {
	                    var result = this.parseArgument(nestingLevel, expectingCloseTag);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else if (char === 125 /* `}` */ && nestingLevel > 0) {
	                    break;
	                }
	                else if (char === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
	                    var position = this.clonePosition();
	                    this.bump();
	                    elements.push({
	                        type: TYPE.pound,
	                        location: createLocation(position, this.clonePosition()),
	                    });
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    this.peek() === 47 // char code for '/'
	                ) {
	                    if (expectingCloseTag) {
	                        break;
	                    }
	                    else {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
	                    }
	                }
	                else if (char === 60 /* `<` */ &&
	                    !this.ignoreTag &&
	                    _isAlpha(this.peek() || 0)) {
	                    var result = this.parseTag(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	                else {
	                    var result = this.parseLiteral(nestingLevel, parentArgType);
	                    if (result.err) {
	                        return result;
	                    }
	                    elements.push(result.val);
	                }
	            }
	            return { val: elements, err: null };
	        };
	        /**
	         * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	         * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	         * are accepted:
	         *
	         * ```
	         * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	         * tagName ::= [a-z] (PENChar)*
	         * PENChar ::=
	         *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	         *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	         *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	         * ```
	         *
	         * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	         * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	         * since other tag-based engines like React allow it
	         */
	        Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
	            var startPosition = this.clonePosition();
	            this.bump(); // `<`
	            var tagName = this.parseTagName();
	            this.bumpSpace();
	            if (this.bumpIf('/>')) {
	                // Self closing tag
	                return {
	                    val: {
	                        type: TYPE.literal,
	                        value: "<".concat(tagName, "/>"),
	                        location: createLocation(startPosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            else if (this.bumpIf('>')) {
	                var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
	                if (childrenResult.err) {
	                    return childrenResult;
	                }
	                var children = childrenResult.val;
	                // Expecting a close tag
	                var endTagStartPosition = this.clonePosition();
	                if (this.bumpIf('</')) {
	                    if (this.isEOF() || !_isAlpha(this.char())) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    var closingTagNameStartPosition = this.clonePosition();
	                    var closingTagName = this.parseTagName();
	                    if (tagName !== closingTagName) {
	                        return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
	                    }
	                    this.bumpSpace();
	                    if (!this.bumpIf('>')) {
	                        return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                    }
	                    return {
	                        val: {
	                            type: TYPE.tag,
	                            value: tagName,
	                            children: children,
	                            location: createLocation(startPosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                else {
	                    return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
	                }
	            }
	            else {
	                return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
	            }
	        };
	        /**
	         * This method assumes that the caller has peeked ahead for the first tag character.
	         */
	        Parser.prototype.parseTagName = function () {
	            var startOffset = this.offset();
	            this.bump(); // the first tag name character
	            while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
	                this.bump();
	            }
	            return this.message.slice(startOffset, this.offset());
	        };
	        Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
	            var start = this.clonePosition();
	            var value = '';
	            while (true) {
	                var parseQuoteResult = this.tryParseQuote(parentArgType);
	                if (parseQuoteResult) {
	                    value += parseQuoteResult;
	                    continue;
	                }
	                var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
	                if (parseUnquotedResult) {
	                    value += parseUnquotedResult;
	                    continue;
	                }
	                var parseLeftAngleResult = this.tryParseLeftAngleBracket();
	                if (parseLeftAngleResult) {
	                    value += parseLeftAngleResult;
	                    continue;
	                }
	                break;
	            }
	            var location = createLocation(start, this.clonePosition());
	            return {
	                val: { type: TYPE.literal, value: value, location: location },
	                err: null,
	            };
	        };
	        Parser.prototype.tryParseLeftAngleBracket = function () {
	            if (!this.isEOF() &&
	                this.char() === 60 /* `<` */ &&
	                (this.ignoreTag ||
	                    // If at the opening tag or closing tag position, bail.
	                    !_isAlphaOrSlash(this.peek() || 0))) {
	                this.bump(); // `<`
	                return '<';
	            }
	            return null;
	        };
	        /**
	         * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	         * a character that requires quoting (that is, "only where needed"), and works the same in
	         * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	         */
	        Parser.prototype.tryParseQuote = function (parentArgType) {
	            if (this.isEOF() || this.char() !== 39 /* `'` */) {
	                return null;
	            }
	            // Parse escaped char following the apostrophe, or early return if there is no escaped char.
	            // Check if is valid escaped character
	            switch (this.peek()) {
	                case 39 /* `'` */:
	                    // double quote, should return as a single quote.
	                    this.bump();
	                    this.bump();
	                    return "'";
	                // '{', '<', '>', '}'
	                case 123:
	                case 60:
	                case 62:
	                case 125:
	                    break;
	                case 35: // '#'
	                    if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
	                        break;
	                    }
	                    return null;
	                default:
	                    return null;
	            }
	            this.bump(); // apostrophe
	            var codePoints = [this.char()]; // escaped char
	            this.bump();
	            // read chars until the optional closing apostrophe is found
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch === 39 /* `'` */) {
	                    if (this.peek() === 39 /* `'` */) {
	                        codePoints.push(39);
	                        // Bump one more time because we need to skip 2 characters.
	                        this.bump();
	                    }
	                    else {
	                        // Optional closing apostrophe.
	                        this.bump();
	                        break;
	                    }
	                }
	                else {
	                    codePoints.push(ch);
	                }
	                this.bump();
	            }
	            return fromCodePoint.apply(void 0, codePoints);
	        };
	        Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
	            if (this.isEOF()) {
	                return null;
	            }
	            var ch = this.char();
	            if (ch === 60 /* `<` */ ||
	                ch === 123 /* `{` */ ||
	                (ch === 35 /* `#` */ &&
	                    (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
	                (ch === 125 /* `}` */ && nestingLevel > 0)) {
	                return null;
	            }
	            else {
	                this.bump();
	                return fromCodePoint(ch);
	            }
	        };
	        Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
	            var openingBracePosition = this.clonePosition();
	            this.bump(); // `{`
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            if (this.char() === 125 /* `}` */) {
	                this.bump();
	                return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            // argument name
	            var value = this.parseIdentifierIfPossible().value;
	            if (!value) {
	                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bumpSpace();
	            if (this.isEOF()) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            switch (this.char()) {
	                // Simple argument: `{name}`
	                case 125 /* `}` */: {
	                    this.bump(); // `}`
	                    return {
	                        val: {
	                            type: TYPE.argument,
	                            // value does not include the opening and closing braces.
	                            value: value,
	                            location: createLocation(openingBracePosition, this.clonePosition()),
	                        },
	                        err: null,
	                    };
	                }
	                // Argument with options: `{name, format, ...}`
	                case 44 /* `,` */: {
	                    this.bump(); // `,`
	                    this.bumpSpace();
	                    if (this.isEOF()) {
	                        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	                    }
	                    return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
	                }
	                default:
	                    return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	            }
	        };
	        /**
	         * Advance the parser until the end of the identifier, if it is currently on
	         * an identifier character. Return an empty string otherwise.
	         */
	        Parser.prototype.parseIdentifierIfPossible = function () {
	            var startingPosition = this.clonePosition();
	            var startOffset = this.offset();
	            var value = matchIdentifierAtIndex(this.message, startOffset);
	            var endOffset = startOffset + value.length;
	            this.bumpTo(endOffset);
	            var endPosition = this.clonePosition();
	            var location = createLocation(startingPosition, endPosition);
	            return { value: value, location: location };
	        };
	        Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
	            var _a;
	            // Parse this range:
	            // {name, type, style}
	            //        ^---^
	            var typeStartPosition = this.clonePosition();
	            var argType = this.parseIdentifierIfPossible().value;
	            var typeEndPosition = this.clonePosition();
	            switch (argType) {
	                case '':
	                    // Expecting a style string number, date, time, plural, selectordinal, or select.
	                    return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	                case 'number':
	                case 'date':
	                case 'time': {
	                    // Parse this range:
	                    // {name, number, style}
	                    //              ^-------^
	                    this.bumpSpace();
	                    var styleAndLocation = null;
	                    if (this.bumpIf(',')) {
	                        this.bumpSpace();
	                        var styleStartPosition = this.clonePosition();
	                        var result = this.parseSimpleArgStyleIfPossible();
	                        if (result.err) {
	                            return result;
	                        }
	                        var style = trimEnd(result.val);
	                        if (style.length === 0) {
	                            return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        var styleLocation = createLocation(styleStartPosition, this.clonePosition());
	                        styleAndLocation = { style: style, styleLocation: styleLocation };
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_1 = createLocation(openingBracePosition, this.clonePosition());
	                    // Extract style or skeleton
	                    if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
	                        // Skeleton starts with `::`.
	                        var skeleton = trimStart(styleAndLocation.style.slice(2));
	                        if (argType === 'number') {
	                            var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
	                            if (result.err) {
	                                return result;
	                            }
	                            return {
	                                val: { type: TYPE.number, value: value, location: location_1, style: result.val },
	                                err: null,
	                            };
	                        }
	                        else {
	                            if (skeleton.length === 0) {
	                                return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
	                            }
	                            var dateTimePattern = skeleton;
	                            // Get "best match" pattern only if locale is passed, if not, let it
	                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
	                            // for unsupported patterns.
	                            if (this.locale) {
	                                dateTimePattern = getBestPattern(skeleton, this.locale);
	                            }
	                            var style = {
	                                type: SKELETON_TYPE.dateTime,
	                                pattern: dateTimePattern,
	                                location: styleAndLocation.styleLocation,
	                                parsedOptions: this.shouldParseSkeletons
	                                    ? parseDateTimeSkeleton(dateTimePattern)
	                                    : {},
	                            };
	                            var type = argType === 'date' ? TYPE.date : TYPE.time;
	                            return {
	                                val: { type: type, value: value, location: location_1, style: style },
	                                err: null,
	                            };
	                        }
	                    }
	                    // Regular style or no style.
	                    return {
	                        val: {
	                            type: argType === 'number'
	                                ? TYPE.number
	                                : argType === 'date'
	                                    ? TYPE.date
	                                    : TYPE.time,
	                            value: value,
	                            location: location_1,
	                            style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
	                        },
	                        err: null,
	                    };
	                }
	                case 'plural':
	                case 'selectordinal':
	                case 'select': {
	                    // Parse this range:
	                    // {name, plural, options}
	                    //              ^---------^
	                    var typeEndPosition_1 = this.clonePosition();
	                    this.bumpSpace();
	                    if (!this.bumpIf(',')) {
	                        return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign$2({}, typeEndPosition_1)));
	                    }
	                    this.bumpSpace();
	                    // Parse offset:
	                    // {name, plural, offset:1, options}
	                    //                ^-----^
	                    //
	                    // or the first option:
	                    //
	                    // {name, plural, one {...} other {...}}
	                    //                ^--^
	                    var identifierAndLocation = this.parseIdentifierIfPossible();
	                    var pluralOffset = 0;
	                    if (argType !== 'select' && identifierAndLocation.value === 'offset') {
	                        if (!this.bumpIf(':')) {
	                            return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
	                        }
	                        this.bumpSpace();
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
	                        if (result.err) {
	                            return result;
	                        }
	                        // Parse another identifier for option parsing
	                        this.bumpSpace();
	                        identifierAndLocation = this.parseIdentifierIfPossible();
	                        pluralOffset = result.val;
	                    }
	                    var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
	                    if (optionsResult.err) {
	                        return optionsResult;
	                    }
	                    var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                    if (argCloseResult.err) {
	                        return argCloseResult;
	                    }
	                    var location_2 = createLocation(openingBracePosition, this.clonePosition());
	                    if (argType === 'select') {
	                        return {
	                            val: {
	                                type: TYPE.select,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                    else {
	                        return {
	                            val: {
	                                type: TYPE.plural,
	                                value: value,
	                                options: fromEntries(optionsResult.val),
	                                offset: pluralOffset,
	                                pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
	                                location: location_2,
	                            },
	                            err: null,
	                        };
	                    }
	                }
	                default:
	                    return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	            }
	        };
	        Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
	            // Parse: {value, number, ::currency/GBP }
	            //
	            if (this.isEOF() || this.char() !== 125 /* `}` */) {
	                return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	            }
	            this.bump(); // `}`
	            return { val: true, err: null };
	        };
	        /**
	         * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	         */
	        Parser.prototype.parseSimpleArgStyleIfPossible = function () {
	            var nestedBraces = 0;
	            var startPosition = this.clonePosition();
	            while (!this.isEOF()) {
	                var ch = this.char();
	                switch (ch) {
	                    case 39 /* `'` */: {
	                        // Treat apostrophe as quoting but include it in the style part.
	                        // Find the end of the quoted literal text.
	                        this.bump();
	                        var apostrophePosition = this.clonePosition();
	                        if (!this.bumpUntil("'")) {
	                            return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
	                        }
	                        this.bump();
	                        break;
	                    }
	                    case 123 /* `{` */: {
	                        nestedBraces += 1;
	                        this.bump();
	                        break;
	                    }
	                    case 125 /* `}` */: {
	                        if (nestedBraces > 0) {
	                            nestedBraces -= 1;
	                        }
	                        else {
	                            return {
	                                val: this.message.slice(startPosition.offset, this.offset()),
	                                err: null,
	                            };
	                        }
	                        break;
	                    }
	                    default:
	                        this.bump();
	                        break;
	                }
	            }
	            return {
	                val: this.message.slice(startPosition.offset, this.offset()),
	                err: null,
	            };
	        };
	        Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
	            var tokens = [];
	            try {
	                tokens = parseNumberSkeletonFromString(skeleton);
	            }
	            catch (e) {
	                return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
	            }
	            return {
	                val: {
	                    type: SKELETON_TYPE.number,
	                    tokens: tokens,
	                    location: location,
	                    parsedOptions: this.shouldParseSkeletons
	                        ? parseNumberSkeleton(tokens)
	                        : {},
	                },
	                err: null,
	            };
	        };
	        /**
	         * @param nesting_level The current nesting level of messages.
	         *     This can be positive when parsing message fragment in select or plural argument options.
	         * @param parent_arg_type The parent argument's type.
	         * @param parsed_first_identifier If provided, this is the first identifier-like selector of
	         *     the argument. It is a by-product of a previous parsing attempt.
	         * @param expecting_close_tag If true, this message is directly or indirectly nested inside
	         *     between a pair of opening and closing tags. The nested message will not parse beyond
	         *     the closing tag boundary.
	         */
	        Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
	            var _a;
	            var hasOtherClause = false;
	            var options = [];
	            var parsedSelectors = new Set();
	            var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
	            // Parse:
	            // one {one apple}
	            // ^--^
	            while (true) {
	                if (selector.length === 0) {
	                    var startPosition = this.clonePosition();
	                    if (parentArgType !== 'select' && this.bumpIf('=')) {
	                        // Try parse `={number}` selector
	                        var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
	                        if (result.err) {
	                            return result;
	                        }
	                        selectorLocation = createLocation(startPosition, this.clonePosition());
	                        selector = this.message.slice(startPosition.offset, this.offset());
	                    }
	                    else {
	                        break;
	                    }
	                }
	                // Duplicate selector clauses
	                if (parsedSelectors.has(selector)) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
	                        : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
	                }
	                if (selector === 'other') {
	                    hasOtherClause = true;
	                }
	                // Parse:
	                // one {one apple}
	                //     ^----------^
	                this.bumpSpace();
	                var openingBracePosition = this.clonePosition();
	                if (!this.bumpIf('{')) {
	                    return this.error(parentArgType === 'select'
	                        ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
	                        : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
	                }
	                var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
	                if (fragmentResult.err) {
	                    return fragmentResult;
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                options.push([
	                    selector,
	                    {
	                        value: fragmentResult.val,
	                        location: createLocation(openingBracePosition, this.clonePosition()),
	                    },
	                ]);
	                // Keep track of the existing selectors
	                parsedSelectors.add(selector);
	                // Prep next selector clause.
	                this.bumpSpace();
	                (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
	            }
	            if (options.length === 0) {
	                return this.error(parentArgType === 'select'
	                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
	                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            if (this.requiresOtherClause && !hasOtherClause) {
	                return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            return { val: options, err: null };
	        };
	        Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
	            var sign = 1;
	            var startingPosition = this.clonePosition();
	            if (this.bumpIf('+')) ;
	            else if (this.bumpIf('-')) {
	                sign = -1;
	            }
	            var hasDigits = false;
	            var decimal = 0;
	            while (!this.isEOF()) {
	                var ch = this.char();
	                if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
	                    hasDigits = true;
	                    decimal = decimal * 10 + (ch - 48);
	                    this.bump();
	                }
	                else {
	                    break;
	                }
	            }
	            var location = createLocation(startingPosition, this.clonePosition());
	            if (!hasDigits) {
	                return this.error(expectNumberError, location);
	            }
	            decimal *= sign;
	            if (!isSafeInteger(decimal)) {
	                return this.error(invalidNumberError, location);
	            }
	            return { val: decimal, err: null };
	        };
	        Parser.prototype.offset = function () {
	            return this.position.offset;
	        };
	        Parser.prototype.isEOF = function () {
	            return this.offset() === this.message.length;
	        };
	        Parser.prototype.clonePosition = function () {
	            // This is much faster than `Object.assign` or spread.
	            return {
	                offset: this.position.offset,
	                line: this.position.line,
	                column: this.position.column,
	            };
	        };
	        /**
	         * Return the code point at the current position of the parser.
	         * Throws if the index is out of bound.
	         */
	        Parser.prototype.char = function () {
	            var offset = this.position.offset;
	            if (offset >= this.message.length) {
	                throw Error('out of bound');
	            }
	            var code = codePointAt(this.message, offset);
	            if (code === undefined) {
	                throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
	            }
	            return code;
	        };
	        Parser.prototype.error = function (kind, location) {
	            return {
	                val: null,
	                err: {
	                    kind: kind,
	                    message: this.message,
	                    location: location,
	                },
	            };
	        };
	        /** Bump the parser to the next UTF-16 code unit. */
	        Parser.prototype.bump = function () {
	            if (this.isEOF()) {
	                return;
	            }
	            var code = this.char();
	            if (code === 10 /* '\n' */) {
	                this.position.line += 1;
	                this.position.column = 1;
	                this.position.offset += 1;
	            }
	            else {
	                this.position.column += 1;
	                // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
	                this.position.offset += code < 0x10000 ? 1 : 2;
	            }
	        };
	        /**
	         * If the substring starting at the current position of the parser has
	         * the given prefix, then bump the parser to the character immediately
	         * following the prefix and return true. Otherwise, don't bump the parser
	         * and return false.
	         */
	        Parser.prototype.bumpIf = function (prefix) {
	            if (startsWith(this.message, prefix, this.offset())) {
	                for (var i = 0; i < prefix.length; i++) {
	                    this.bump();
	                }
	                return true;
	            }
	            return false;
	        };
	        /**
	         * Bump the parser until the pattern character is found and return `true`.
	         * Otherwise bump to the end of the file and return `false`.
	         */
	        Parser.prototype.bumpUntil = function (pattern) {
	            var currentOffset = this.offset();
	            var index = this.message.indexOf(pattern, currentOffset);
	            if (index >= 0) {
	                this.bumpTo(index);
	                return true;
	            }
	            else {
	                this.bumpTo(this.message.length);
	                return false;
	            }
	        };
	        /**
	         * Bump the parser to the target offset.
	         * If target offset is beyond the end of the input, bump the parser to the end of the input.
	         */
	        Parser.prototype.bumpTo = function (targetOffset) {
	            if (this.offset() > targetOffset) {
	                throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
	            }
	            targetOffset = Math.min(targetOffset, this.message.length);
	            while (true) {
	                var offset = this.offset();
	                if (offset === targetOffset) {
	                    break;
	                }
	                if (offset > targetOffset) {
	                    throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
	                }
	                this.bump();
	                if (this.isEOF()) {
	                    break;
	                }
	            }
	        };
	        /** advance the parser through all whitespace to the next non-whitespace code unit. */
	        Parser.prototype.bumpSpace = function () {
	            while (!this.isEOF() && _isWhiteSpace(this.char())) {
	                this.bump();
	            }
	        };
	        /**
	         * Peek at the *next* Unicode codepoint in the input without advancing the parser.
	         * If the input has been exhausted, then this returns null.
	         */
	        Parser.prototype.peek = function () {
	            if (this.isEOF()) {
	                return null;
	            }
	            var code = this.char();
	            var offset = this.offset();
	            var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
	            return nextCode !== null && nextCode !== void 0 ? nextCode : null;
	        };
	        return Parser;
	    }());
	    /**
	     * This check if codepoint is alphabet (lower & uppercase)
	     * @param codepoint
	     * @returns
	     */
	    function _isAlpha(codepoint) {
	        return ((codepoint >= 97 && codepoint <= 122) ||
	            (codepoint >= 65 && codepoint <= 90));
	    }
	    function _isAlphaOrSlash(codepoint) {
	        return _isAlpha(codepoint) || codepoint === 47; /* '/' */
	    }
	    /** See `parseTag` function docs. */
	    function _isPotentialElementNameChar(c) {
	        return (c === 45 /* '-' */ ||
	            c === 46 /* '.' */ ||
	            (c >= 48 && c <= 57) /* 0..9 */ ||
	            c === 95 /* '_' */ ||
	            (c >= 97 && c <= 122) /** a..z */ ||
	            (c >= 65 && c <= 90) /* A..Z */ ||
	            c == 0xb7 ||
	            (c >= 0xc0 && c <= 0xd6) ||
	            (c >= 0xd8 && c <= 0xf6) ||
	            (c >= 0xf8 && c <= 0x37d) ||
	            (c >= 0x37f && c <= 0x1fff) ||
	            (c >= 0x200c && c <= 0x200d) ||
	            (c >= 0x203f && c <= 0x2040) ||
	            (c >= 0x2070 && c <= 0x218f) ||
	            (c >= 0x2c00 && c <= 0x2fef) ||
	            (c >= 0x3001 && c <= 0xd7ff) ||
	            (c >= 0xf900 && c <= 0xfdcf) ||
	            (c >= 0xfdf0 && c <= 0xfffd) ||
	            (c >= 0x10000 && c <= 0xeffff));
	    }
	    /**
	     * Code point equivalent of regex `\p{White_Space}`.
	     * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isWhiteSpace(c) {
	        return ((c >= 0x0009 && c <= 0x000d) ||
	            c === 0x0020 ||
	            c === 0x0085 ||
	            (c >= 0x200e && c <= 0x200f) ||
	            c === 0x2028 ||
	            c === 0x2029);
	    }
	    /**
	     * Code point equivalent of regex `\p{Pattern_Syntax}`.
	     * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	     */
	    function _isPatternSyntax(c) {
	        return ((c >= 0x0021 && c <= 0x0023) ||
	            c === 0x0024 ||
	            (c >= 0x0025 && c <= 0x0027) ||
	            c === 0x0028 ||
	            c === 0x0029 ||
	            c === 0x002a ||
	            c === 0x002b ||
	            c === 0x002c ||
	            c === 0x002d ||
	            (c >= 0x002e && c <= 0x002f) ||
	            (c >= 0x003a && c <= 0x003b) ||
	            (c >= 0x003c && c <= 0x003e) ||
	            (c >= 0x003f && c <= 0x0040) ||
	            c === 0x005b ||
	            c === 0x005c ||
	            c === 0x005d ||
	            c === 0x005e ||
	            c === 0x0060 ||
	            c === 0x007b ||
	            c === 0x007c ||
	            c === 0x007d ||
	            c === 0x007e ||
	            c === 0x00a1 ||
	            (c >= 0x00a2 && c <= 0x00a5) ||
	            c === 0x00a6 ||
	            c === 0x00a7 ||
	            c === 0x00a9 ||
	            c === 0x00ab ||
	            c === 0x00ac ||
	            c === 0x00ae ||
	            c === 0x00b0 ||
	            c === 0x00b1 ||
	            c === 0x00b6 ||
	            c === 0x00bb ||
	            c === 0x00bf ||
	            c === 0x00d7 ||
	            c === 0x00f7 ||
	            (c >= 0x2010 && c <= 0x2015) ||
	            (c >= 0x2016 && c <= 0x2017) ||
	            c === 0x2018 ||
	            c === 0x2019 ||
	            c === 0x201a ||
	            (c >= 0x201b && c <= 0x201c) ||
	            c === 0x201d ||
	            c === 0x201e ||
	            c === 0x201f ||
	            (c >= 0x2020 && c <= 0x2027) ||
	            (c >= 0x2030 && c <= 0x2038) ||
	            c === 0x2039 ||
	            c === 0x203a ||
	            (c >= 0x203b && c <= 0x203e) ||
	            (c >= 0x2041 && c <= 0x2043) ||
	            c === 0x2044 ||
	            c === 0x2045 ||
	            c === 0x2046 ||
	            (c >= 0x2047 && c <= 0x2051) ||
	            c === 0x2052 ||
	            c === 0x2053 ||
	            (c >= 0x2055 && c <= 0x205e) ||
	            (c >= 0x2190 && c <= 0x2194) ||
	            (c >= 0x2195 && c <= 0x2199) ||
	            (c >= 0x219a && c <= 0x219b) ||
	            (c >= 0x219c && c <= 0x219f) ||
	            c === 0x21a0 ||
	            (c >= 0x21a1 && c <= 0x21a2) ||
	            c === 0x21a3 ||
	            (c >= 0x21a4 && c <= 0x21a5) ||
	            c === 0x21a6 ||
	            (c >= 0x21a7 && c <= 0x21ad) ||
	            c === 0x21ae ||
	            (c >= 0x21af && c <= 0x21cd) ||
	            (c >= 0x21ce && c <= 0x21cf) ||
	            (c >= 0x21d0 && c <= 0x21d1) ||
	            c === 0x21d2 ||
	            c === 0x21d3 ||
	            c === 0x21d4 ||
	            (c >= 0x21d5 && c <= 0x21f3) ||
	            (c >= 0x21f4 && c <= 0x22ff) ||
	            (c >= 0x2300 && c <= 0x2307) ||
	            c === 0x2308 ||
	            c === 0x2309 ||
	            c === 0x230a ||
	            c === 0x230b ||
	            (c >= 0x230c && c <= 0x231f) ||
	            (c >= 0x2320 && c <= 0x2321) ||
	            (c >= 0x2322 && c <= 0x2328) ||
	            c === 0x2329 ||
	            c === 0x232a ||
	            (c >= 0x232b && c <= 0x237b) ||
	            c === 0x237c ||
	            (c >= 0x237d && c <= 0x239a) ||
	            (c >= 0x239b && c <= 0x23b3) ||
	            (c >= 0x23b4 && c <= 0x23db) ||
	            (c >= 0x23dc && c <= 0x23e1) ||
	            (c >= 0x23e2 && c <= 0x2426) ||
	            (c >= 0x2427 && c <= 0x243f) ||
	            (c >= 0x2440 && c <= 0x244a) ||
	            (c >= 0x244b && c <= 0x245f) ||
	            (c >= 0x2500 && c <= 0x25b6) ||
	            c === 0x25b7 ||
	            (c >= 0x25b8 && c <= 0x25c0) ||
	            c === 0x25c1 ||
	            (c >= 0x25c2 && c <= 0x25f7) ||
	            (c >= 0x25f8 && c <= 0x25ff) ||
	            (c >= 0x2600 && c <= 0x266e) ||
	            c === 0x266f ||
	            (c >= 0x2670 && c <= 0x2767) ||
	            c === 0x2768 ||
	            c === 0x2769 ||
	            c === 0x276a ||
	            c === 0x276b ||
	            c === 0x276c ||
	            c === 0x276d ||
	            c === 0x276e ||
	            c === 0x276f ||
	            c === 0x2770 ||
	            c === 0x2771 ||
	            c === 0x2772 ||
	            c === 0x2773 ||
	            c === 0x2774 ||
	            c === 0x2775 ||
	            (c >= 0x2794 && c <= 0x27bf) ||
	            (c >= 0x27c0 && c <= 0x27c4) ||
	            c === 0x27c5 ||
	            c === 0x27c6 ||
	            (c >= 0x27c7 && c <= 0x27e5) ||
	            c === 0x27e6 ||
	            c === 0x27e7 ||
	            c === 0x27e8 ||
	            c === 0x27e9 ||
	            c === 0x27ea ||
	            c === 0x27eb ||
	            c === 0x27ec ||
	            c === 0x27ed ||
	            c === 0x27ee ||
	            c === 0x27ef ||
	            (c >= 0x27f0 && c <= 0x27ff) ||
	            (c >= 0x2800 && c <= 0x28ff) ||
	            (c >= 0x2900 && c <= 0x2982) ||
	            c === 0x2983 ||
	            c === 0x2984 ||
	            c === 0x2985 ||
	            c === 0x2986 ||
	            c === 0x2987 ||
	            c === 0x2988 ||
	            c === 0x2989 ||
	            c === 0x298a ||
	            c === 0x298b ||
	            c === 0x298c ||
	            c === 0x298d ||
	            c === 0x298e ||
	            c === 0x298f ||
	            c === 0x2990 ||
	            c === 0x2991 ||
	            c === 0x2992 ||
	            c === 0x2993 ||
	            c === 0x2994 ||
	            c === 0x2995 ||
	            c === 0x2996 ||
	            c === 0x2997 ||
	            c === 0x2998 ||
	            (c >= 0x2999 && c <= 0x29d7) ||
	            c === 0x29d8 ||
	            c === 0x29d9 ||
	            c === 0x29da ||
	            c === 0x29db ||
	            (c >= 0x29dc && c <= 0x29fb) ||
	            c === 0x29fc ||
	            c === 0x29fd ||
	            (c >= 0x29fe && c <= 0x2aff) ||
	            (c >= 0x2b00 && c <= 0x2b2f) ||
	            (c >= 0x2b30 && c <= 0x2b44) ||
	            (c >= 0x2b45 && c <= 0x2b46) ||
	            (c >= 0x2b47 && c <= 0x2b4c) ||
	            (c >= 0x2b4d && c <= 0x2b73) ||
	            (c >= 0x2b74 && c <= 0x2b75) ||
	            (c >= 0x2b76 && c <= 0x2b95) ||
	            c === 0x2b96 ||
	            (c >= 0x2b97 && c <= 0x2bff) ||
	            (c >= 0x2e00 && c <= 0x2e01) ||
	            c === 0x2e02 ||
	            c === 0x2e03 ||
	            c === 0x2e04 ||
	            c === 0x2e05 ||
	            (c >= 0x2e06 && c <= 0x2e08) ||
	            c === 0x2e09 ||
	            c === 0x2e0a ||
	            c === 0x2e0b ||
	            c === 0x2e0c ||
	            c === 0x2e0d ||
	            (c >= 0x2e0e && c <= 0x2e16) ||
	            c === 0x2e17 ||
	            (c >= 0x2e18 && c <= 0x2e19) ||
	            c === 0x2e1a ||
	            c === 0x2e1b ||
	            c === 0x2e1c ||
	            c === 0x2e1d ||
	            (c >= 0x2e1e && c <= 0x2e1f) ||
	            c === 0x2e20 ||
	            c === 0x2e21 ||
	            c === 0x2e22 ||
	            c === 0x2e23 ||
	            c === 0x2e24 ||
	            c === 0x2e25 ||
	            c === 0x2e26 ||
	            c === 0x2e27 ||
	            c === 0x2e28 ||
	            c === 0x2e29 ||
	            (c >= 0x2e2a && c <= 0x2e2e) ||
	            c === 0x2e2f ||
	            (c >= 0x2e30 && c <= 0x2e39) ||
	            (c >= 0x2e3a && c <= 0x2e3b) ||
	            (c >= 0x2e3c && c <= 0x2e3f) ||
	            c === 0x2e40 ||
	            c === 0x2e41 ||
	            c === 0x2e42 ||
	            (c >= 0x2e43 && c <= 0x2e4f) ||
	            (c >= 0x2e50 && c <= 0x2e51) ||
	            c === 0x2e52 ||
	            (c >= 0x2e53 && c <= 0x2e7f) ||
	            (c >= 0x3001 && c <= 0x3003) ||
	            c === 0x3008 ||
	            c === 0x3009 ||
	            c === 0x300a ||
	            c === 0x300b ||
	            c === 0x300c ||
	            c === 0x300d ||
	            c === 0x300e ||
	            c === 0x300f ||
	            c === 0x3010 ||
	            c === 0x3011 ||
	            (c >= 0x3012 && c <= 0x3013) ||
	            c === 0x3014 ||
	            c === 0x3015 ||
	            c === 0x3016 ||
	            c === 0x3017 ||
	            c === 0x3018 ||
	            c === 0x3019 ||
	            c === 0x301a ||
	            c === 0x301b ||
	            c === 0x301c ||
	            c === 0x301d ||
	            (c >= 0x301e && c <= 0x301f) ||
	            c === 0x3020 ||
	            c === 0x3030 ||
	            c === 0xfd3e ||
	            c === 0xfd3f ||
	            (c >= 0xfe45 && c <= 0xfe46));
	    }

	    function pruneLocation(els) {
	        els.forEach(function (el) {
	            delete el.location;
	            if (isSelectElement(el) || isPluralElement(el)) {
	                for (var k in el.options) {
	                    delete el.options[k].location;
	                    pruneLocation(el.options[k].value);
	                }
	            }
	            else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if ((isDateElement(el) || isTimeElement(el)) &&
	                isDateTimeSkeleton(el.style)) {
	                delete el.style.location;
	            }
	            else if (isTagElement(el)) {
	                pruneLocation(el.children);
	            }
	        });
	    }
	    function parse$1(message, opts) {
	        if (opts === void 0) { opts = {}; }
	        opts = __assign$2({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
	        var result = new Parser(message, opts).parse();
	        if (result.err) {
	            var error = SyntaxError(ErrorKind[result.err.kind]);
	            // @ts-expect-error Assign to error object
	            error.location = result.err.location;
	            // @ts-expect-error Assign to error object
	            error.originalMessage = result.err.message;
	            throw error;
	        }
	        if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
	            pruneLocation(result.val);
	        }
	        return result.val;
	    }

	    //
	    // Main
	    //
	    function memoize$1(fn, options) {
	        var cache = options && options.cache ? options.cache : cacheDefault;
	        var serializer = options && options.serializer ? options.serializer : serializerDefault;
	        var strategy = options && options.strategy ? options.strategy : strategyDefault;
	        return strategy(fn, {
	            cache: cache,
	            serializer: serializer,
	        });
	    }
	    //
	    // Strategy
	    //
	    function isPrimitive(value) {
	        return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
	    }
	    function monadic(fn, cache, serializer, arg) {
	        var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.call(this, arg);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function variadic(fn, cache, serializer) {
	        var args = Array.prototype.slice.call(arguments, 3);
	        var cacheKey = serializer(args);
	        var computedValue = cache.get(cacheKey);
	        if (typeof computedValue === 'undefined') {
	            computedValue = fn.apply(this, args);
	            cache.set(cacheKey, computedValue);
	        }
	        return computedValue;
	    }
	    function assemble(fn, context, strategy, cache, serialize) {
	        return strategy.bind(context, fn, cache, serialize);
	    }
	    function strategyDefault(fn, options) {
	        var strategy = fn.length === 1 ? monadic : variadic;
	        return assemble(fn, this, strategy, options.cache.create(), options.serializer);
	    }
	    function strategyVariadic(fn, options) {
	        return assemble(fn, this, variadic, options.cache.create(), options.serializer);
	    }
	    function strategyMonadic(fn, options) {
	        return assemble(fn, this, monadic, options.cache.create(), options.serializer);
	    }
	    //
	    // Serializer
	    //
	    var serializerDefault = function () {
	        return JSON.stringify(arguments);
	    };
	    //
	    // Cache
	    //
	    function ObjectWithoutPrototypeCache() {
	        this.cache = Object.create(null);
	    }
	    ObjectWithoutPrototypeCache.prototype.get = function (key) {
	        return this.cache[key];
	    };
	    ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	        this.cache[key] = value;
	    };
	    var cacheDefault = {
	        create: function create() {
	            // @ts-ignore
	            return new ObjectWithoutPrototypeCache();
	        },
	    };
	    var strategies = {
	        variadic: strategyVariadic,
	        monadic: strategyMonadic,
	    };

	    var ErrorCode;
	    (function (ErrorCode) {
	        // When we have a placeholder but no value to format
	        ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
	        // When value supplied is invalid
	        ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
	        // When we need specific Intl API but it's not available
	        ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
	    })(ErrorCode || (ErrorCode = {}));
	    var FormatError = /** @class */ (function (_super) {
	        __extends$1(FormatError, _super);
	        function FormatError(msg, code, originalMessage) {
	            var _this = _super.call(this, msg) || this;
	            _this.code = code;
	            _this.originalMessage = originalMessage;
	            return _this;
	        }
	        FormatError.prototype.toString = function () {
	            return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
	        };
	        return FormatError;
	    }(Error));
	    var InvalidValueError = /** @class */ (function (_super) {
	        __extends$1(InvalidValueError, _super);
	        function InvalidValueError(variableId, value, options, originalMessage) {
	            return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueError;
	    }(FormatError));
	    var InvalidValueTypeError = /** @class */ (function (_super) {
	        __extends$1(InvalidValueTypeError, _super);
	        function InvalidValueTypeError(value, type, originalMessage) {
	            return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
	        }
	        return InvalidValueTypeError;
	    }(FormatError));
	    var MissingValueError = /** @class */ (function (_super) {
	        __extends$1(MissingValueError, _super);
	        function MissingValueError(variableId, originalMessage) {
	            return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
	        }
	        return MissingValueError;
	    }(FormatError));

	    var PART_TYPE;
	    (function (PART_TYPE) {
	        PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
	        PART_TYPE[PART_TYPE["object"] = 1] = "object";
	    })(PART_TYPE || (PART_TYPE = {}));
	    function mergeLiteral(parts) {
	        if (parts.length < 2) {
	            return parts;
	        }
	        return parts.reduce(function (all, part) {
	            var lastPart = all[all.length - 1];
	            if (!lastPart ||
	                lastPart.type !== PART_TYPE.literal ||
	                part.type !== PART_TYPE.literal) {
	                all.push(part);
	            }
	            else {
	                lastPart.value += part.value;
	            }
	            return all;
	        }, []);
	    }
	    function isFormatXMLElementFn(el) {
	        return typeof el === 'function';
	    }
	    // TODO(skeleton): add skeleton support
	    function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	    // For debugging
	    originalMessage) {
	        // Hot path for straight simple msg translations
	        if (els.length === 1 && isLiteralElement(els[0])) {
	            return [
	                {
	                    type: PART_TYPE.literal,
	                    value: els[0].value,
	                },
	            ];
	        }
	        var result = [];
	        for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	            var el = els_1[_i];
	            // Exit early for string parts.
	            if (isLiteralElement(el)) {
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: el.value,
	                });
	                continue;
	            }
	            // TODO: should this part be literal type?
	            // Replace `#` in plural rules with the actual numeric value.
	            if (isPoundElement(el)) {
	                if (typeof currentPluralValue === 'number') {
	                    result.push({
	                        type: PART_TYPE.literal,
	                        value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                    });
	                }
	                continue;
	            }
	            var varName = el.value;
	            // Enforce that all required values are provided by the caller.
	            if (!(values && varName in values)) {
	                throw new MissingValueError(varName, originalMessage);
	            }
	            var value = values[varName];
	            if (isArgumentElement(el)) {
	                if (!value || typeof value === 'string' || typeof value === 'number') {
	                    value =
	                        typeof value === 'string' || typeof value === 'number'
	                            ? String(value)
	                            : '';
	                }
	                result.push({
	                    type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                    value: value,
	                });
	                continue;
	            }
	            // Recursively format plural and select parts' option — which can be a
	            // nested pattern structure. The choosing of the option to use is
	            // abstracted-by and delegated-to the part helper object.
	            if (isDateElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.date[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTimeElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.time[el.style]
	                    : isDateTimeSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : formats.time.medium;
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getDateTimeFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isNumberElement(el)) {
	                var style = typeof el.style === 'string'
	                    ? formats.number[el.style]
	                    : isNumberSkeleton(el.style)
	                        ? el.style.parsedOptions
	                        : undefined;
	                if (style && style.scale) {
	                    value =
	                        value *
	                            (style.scale || 1);
	                }
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters
	                        .getNumberFormat(locales, style)
	                        .format(value),
	                });
	                continue;
	            }
	            if (isTagElement(el)) {
	                var children = el.children, value_1 = el.value;
	                var formatFn = values[value_1];
	                if (!isFormatXMLElementFn(formatFn)) {
	                    throw new InvalidValueTypeError(value_1, 'function', originalMessage);
	                }
	                var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
	                var chunks = formatFn(parts.map(function (p) { return p.value; }));
	                if (!Array.isArray(chunks)) {
	                    chunks = [chunks];
	                }
	                result.push.apply(result, chunks.map(function (c) {
	                    return {
	                        type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                        value: c,
	                    };
	                }));
	            }
	            if (isSelectElement(el)) {
	                var opt = el.options[value] || el.options.other;
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	                continue;
	            }
	            if (isPluralElement(el)) {
	                var opt = el.options["=".concat(value)];
	                if (!opt) {
	                    if (!Intl.PluralRules) {
	                        throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
	                    }
	                    var rule = formatters
	                        .getPluralRules(locales, { type: el.pluralType })
	                        .select(value - (el.offset || 0));
	                    opt = el.options[rule] || el.options.other;
	                }
	                if (!opt) {
	                    throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	                }
	                result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	                continue;
	            }
	        }
	        return mergeLiteral(result);
	    }

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    // -- MessageFormat --------------------------------------------------------
	    function mergeConfig(c1, c2) {
	        if (!c2) {
	            return c1;
	        }
	        return __assign$3(__assign$3(__assign$3({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	            all[k] = __assign$3(__assign$3({}, c1[k]), (c2[k] || {}));
	            return all;
	        }, {}));
	    }
	    function mergeConfigs(defaultConfig, configs) {
	        if (!configs) {
	            return defaultConfig;
	        }
	        return Object.keys(defaultConfig).reduce(function (all, k) {
	            all[k] = mergeConfig(defaultConfig[k], configs[k]);
	            return all;
	        }, __assign$3({}, defaultConfig));
	    }
	    function createFastMemoizeCache(store) {
	        return {
	            create: function () {
	                return {
	                    get: function (key) {
	                        return store[key];
	                    },
	                    set: function (key, value) {
	                        store[key] = value;
	                    },
	                };
	            },
	        };
	    }
	    function createDefaultFormatters(cache) {
	        if (cache === void 0) { cache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        }; }
	        return {
	            getNumberFormat: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.number),
	                strategy: strategies.variadic,
	            }),
	            getDateTimeFormat: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.dateTime),
	                strategy: strategies.variadic,
	            }),
	            getPluralRules: memoize$1(function () {
	                var _a;
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
	            }, {
	                cache: createFastMemoizeCache(cache.pluralRules),
	                strategy: strategies.variadic,
	            }),
	        };
	    }
	    var IntlMessageFormat = /** @class */ (function () {
	        function IntlMessageFormat(message, locales, overrideFormats, opts) {
	            var _this = this;
	            if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	            this.formatterCache = {
	                number: {},
	                dateTime: {},
	                pluralRules: {},
	            };
	            this.format = function (values) {
	                var parts = _this.formatToParts(values);
	                // Hot path for straight simple msg translations
	                if (parts.length === 1) {
	                    return parts[0].value;
	                }
	                var result = parts.reduce(function (all, part) {
	                    if (!all.length ||
	                        part.type !== PART_TYPE.literal ||
	                        typeof all[all.length - 1] !== 'string') {
	                        all.push(part.value);
	                    }
	                    else {
	                        all[all.length - 1] += part.value;
	                    }
	                    return all;
	                }, []);
	                if (result.length <= 1) {
	                    return result[0] || '';
	                }
	                return result;
	            };
	            this.formatToParts = function (values) {
	                return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	            };
	            this.resolvedOptions = function () { return ({
	                locale: _this.resolvedLocale.toString(),
	            }); };
	            this.getAst = function () { return _this.ast; };
	            // Defined first because it's used to build the format pattern.
	            this.locales = locales;
	            this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
	            if (typeof message === 'string') {
	                this.message = message;
	                if (!IntlMessageFormat.__parse) {
	                    throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	                }
	                // Parse string messages into an AST.
	                this.ast = IntlMessageFormat.__parse(message, {
	                    ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
	                    locale: this.resolvedLocale,
	                });
	            }
	            else {
	                this.ast = message;
	            }
	            if (!Array.isArray(this.ast)) {
	                throw new TypeError('A message must be provided as a String or AST.');
	            }
	            // Creates a new object with the specified `formats` merged with the default
	            // formats.
	            this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	            this.formatters =
	                (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	        }
	        Object.defineProperty(IntlMessageFormat, "defaultLocale", {
	            get: function () {
	                if (!IntlMessageFormat.memoizedDefaultLocale) {
	                    IntlMessageFormat.memoizedDefaultLocale =
	                        new Intl.NumberFormat().resolvedOptions().locale;
	                }
	                return IntlMessageFormat.memoizedDefaultLocale;
	            },
	            enumerable: false,
	            configurable: true
	        });
	        IntlMessageFormat.memoizedDefaultLocale = null;
	        IntlMessageFormat.resolveLocale = function (locales) {
	            var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
	            if (supportedLocales.length > 0) {
	                return new Intl.Locale(supportedLocales[0]);
	            }
	            return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
	        };
	        IntlMessageFormat.__parse = parse$1;
	        // Default format options used as the prototype of the `formats` provided to the
	        // constructor. These are used when constructing the internal Intl.NumberFormat
	        // and Intl.DateTimeFormat instances.
	        IntlMessageFormat.formats = {
	            number: {
	                integer: {
	                    maximumFractionDigits: 0,
	                },
	                currency: {
	                    style: 'currency',
	                },
	                percent: {
	                    style: 'percent',
	                },
	            },
	            date: {
	                short: {
	                    month: 'numeric',
	                    day: 'numeric',
	                    year: '2-digit',
	                },
	                medium: {
	                    month: 'short',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                long: {
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	                full: {
	                    weekday: 'long',
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                },
	            },
	            time: {
	                short: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                },
	                medium: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                },
	                long: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	                full: {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    second: 'numeric',
	                    timeZoneName: 'short',
	                },
	            },
	        };
	        return IntlMessageFormat;
	    }());

	    /*
	    Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	    Copyrights licensed under the New BSD License.
	    See the accompanying LICENSE file for terms.
	    */
	    var o = IntlMessageFormat;

	    const r={},i=(e,n,t)=>t?(n in r||(r[n]={}),e in r[n]||(r[n][e]=t),t):t,a=(e,n)=>{if(null==n)return;if(n in r&&e in r[n])return r[n][e];const t=E(n);for(let o=0;o<t.length;o++){const r=c(t[o],e);if(r)return i(e,n,r)}};let l;const s=writable({});function u(e){return e in l}function c(e,n){if(!u(e))return null;return function(e,n){if(n in e)return e[n];const t=n.split(".");let o=e;for(let e=0;e<t.length;e++)if("object"==typeof o){if(e>0){const n=t.slice(e,t.length).join(".");if(n in o){o=o[n];break}}o=o[t[e]];}else o=void 0;return o}(function(e){return l[e]||null}(e),n)}function m(e,...n){delete r[e],s.update((o=>(o[e]=cjs.all([o[e]||{},...n]),o)));}derived([s],(([e])=>Object.keys(e)));s.subscribe((e=>l=e));const d={};function g(e){return d[e]}function w(e){return E(e).some((e=>{var n;return null===(n=g(e))||void 0===n?void 0:n.size}))}function h(e,n){return Promise.all(n.map((n=>(function(e,n){d[e].delete(n),0===d[e].size&&delete d[e];}(e,n),n().then((e=>e.default||e)))))).then((n=>m(e,...n)))}const p={};function b(e){if(!w(e))return e in p?p[e]:void 0;const n=function(e){return E(e).map((e=>{const n=g(e);return [e,n?[...n]:[]]})).filter((([,e])=>e.length>0))}(e);return p[e]=Promise.all(n.map((([e,n])=>h(e,n)))).then((()=>{if(w(e))return b(e);delete p[e];})),p[e]}/*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */function v(e,n){var t={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(t[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(e);r<o.length;r++)n.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(e,o[r])&&(t[o[r]]=e[o[r]]);}return t}const O={fallbackLocale:null,initialLocale:null,loadingDelay:200,formats:{number:{scientific:{notation:"scientific"},engineering:{notation:"engineering"},compactLong:{notation:"compact",compactDisplay:"long"},compactShort:{notation:"compact",compactDisplay:"short"}},date:{short:{month:"numeric",day:"numeric",year:"2-digit"},medium:{month:"short",day:"numeric",year:"numeric"},long:{month:"long",day:"numeric",year:"numeric"},full:{weekday:"long",month:"long",day:"numeric",year:"numeric"}},time:{short:{hour:"numeric",minute:"numeric"},medium:{hour:"numeric",minute:"numeric",second:"numeric"},long:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"},full:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"}}},warnOnMissingMessages:!0,ignoreTag:!0};function j(){return O}function $(e){const{formats:n}=e,t=v(e,["formats"]),o=e.initialLocale||e.fallbackLocale;return Object.assign(O,t,{initialLocale:o}),n&&("number"in n&&Object.assign(O.formats.number,n.number),"date"in n&&Object.assign(O.formats.date,n.date),"time"in n&&Object.assign(O.formats.time,n.time)),T.set(o)}const k=writable(!1);let L;const T=writable(null);function x(e){return e.split("-").map(((e,n,t)=>t.slice(0,n+1).join("-"))).reverse()}function E(e,n=j().fallbackLocale){const t=x(e);return n?[...new Set([...t,...x(n)])]:t}function D(){return L}T.subscribe((e=>{L=e,"undefined"!=typeof window&&null!==e&&document.documentElement.setAttribute("lang",e);}));const M=T.set;T.set=e=>{if(function(e){if(null==e)return;const n=E(e);for(let e=0;e<n.length;e++){const t=n[e];if(u(t))return t}}(e)&&w(e)){const{loadingDelay:n}=j();let t;return "undefined"!=typeof window&&null!=D()&&n?t=window.setTimeout((()=>k.set(!0)),n):k.set(!0),b(e).then((()=>{M(e);})).finally((()=>{clearTimeout(t),k.set(!1);}))}return M(e)},T.update=e=>M(e(L));const Z=e=>{const n=Object.create(null);return t=>{const o=JSON.stringify(t);return o in n?n[o]:n[o]=e(t)}},C=(e,n)=>{const{formats:t}=j();if(e in t&&n in t[e])return t[e][n];throw new Error(`[svelte-i18n] Unknown "${n}" ${e} format.`)},G=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format numbers');return t&&(o=C("number",t)),new Intl.NumberFormat(n,o)})),J=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format dates');return t?o=C("date",t):0===Object.keys(o).length&&(o=C("date","short")),new Intl.DateTimeFormat(n,o)})),U=Z((e=>{var{locale:n,format:t}=e,o=v(e,["locale","format"]);if(null==n)throw new Error('[svelte-i18n] A "locale" must be set to format time values');return t?o=C("time",t):0===Object.keys(o).length&&(o=C("time","short")),new Intl.DateTimeFormat(n,o)})),_=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return G(Object.assign({locale:n},t))},q=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return J(Object.assign({locale:n},t))},B=(e={})=>{var{locale:n=D()}=e,t=v(e,["locale"]);return U(Object.assign({locale:n},t))},H=Z(((e,n=D())=>new o(e,n,j().formats,{ignoreTag:j().ignoreTag}))),K=(e,n={})=>{"object"==typeof e&&(e=(n=e).id);const{values:t,locale:o=D(),default:r}=n;if(null==o)throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");let i=a(e,o);if(i){if("string"!=typeof i)return console.warn(`[svelte-i18n] Message with id "${e}" must be of type "string", found: "${typeof i}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`),i}else j().warnOnMissingMessages&&console.warn(`[svelte-i18n] The message "${e}" was not found in "${E(o).join('", "')}".${w(D())?"\n\nNote: there are at least one loader still registered to this locale that wasn't executed.":""}`),i=r||e;if(!t)return i;let l=i;try{l=H(i,o).format(t);}catch(n){console.warn(`[svelte-i18n] Message "${e}" has syntax error:`,n.message);}return l},Q=(e,n)=>B(n).format(e),R=(e,n)=>q(n).format(e),V=(e,n)=>_(n).format(e),W=(e,n=D())=>a(e,n),X=derived([T,s],(()=>K));derived([T],(()=>Q));derived([T],(()=>R));derived([T],(()=>V));derived([T,s],(()=>W));

	    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	    function getDefaultExportFromCjs (x) {
	    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	    }

	    function createCommonjsModule(fn, basedir, module) {
	    	return module = {
	    		path: basedir,
	    		exports: {},
	    		require: function (path, base) {
	    			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
	    		}
	    	}, fn(module, module.exports), module.exports;
	    }

	    function getAugmentedNamespace(n) {
	    	if (n.__esModule) return n;
	    	var a = Object.defineProperty({}, '__esModule', {value: true});
	    	Object.keys(n).forEach(function (k) {
	    		var d = Object.getOwnPropertyDescriptor(n, k);
	    		Object.defineProperty(a, k, d.get ? d : {
	    			enumerable: true,
	    			get: function () {
	    				return n[k];
	    			}
	    		});
	    	});
	    	return a;
	    }

	    function commonjsRequire () {
	    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	    }

	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise */

	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };

	    function __extends(d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }

	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };

	    function __rest(s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    }

	    function __decorate(decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    }

	    function __param(paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    }

	    function __metadata(metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    }

	    function __awaiter(thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    }

	    function __generator(thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    }

	    var __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });

	    function __exportStar(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    }

	    function __values(o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    }

	    function __read(o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    }

	    function __spread() {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    }

	    function __spreadArrays() {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    }
	    function __await(v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    }

	    function __asyncGenerator(thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    }

	    function __asyncDelegator(o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    }

	    function __asyncValues(o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    }

	    function __makeTemplateObject(cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    }
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };

	    function __importStar(mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    }

	    function __importDefault(mod) {
	        return (mod && mod.__esModule) ? mod : { default: mod };
	    }

	    function __classPrivateFieldGet(receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    }

	    function __classPrivateFieldSet(receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    }

	    var tslib_es6 = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        __extends: __extends,
	        get __assign () { return __assign; },
	        __rest: __rest,
	        __decorate: __decorate,
	        __param: __param,
	        __metadata: __metadata,
	        __awaiter: __awaiter,
	        __generator: __generator,
	        __createBinding: __createBinding,
	        __exportStar: __exportStar,
	        __values: __values,
	        __read: __read,
	        __spread: __spread,
	        __spreadArrays: __spreadArrays,
	        __await: __await,
	        __asyncGenerator: __asyncGenerator,
	        __asyncDelegator: __asyncDelegator,
	        __asyncValues: __asyncValues,
	        __makeTemplateObject: __makeTemplateObject,
	        __importStar: __importStar,
	        __importDefault: __importDefault,
	        __classPrivateFieldGet: __classPrivateFieldGet,
	        __classPrivateFieldSet: __classPrivateFieldSet
	    });

	    var Cache_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    /**
	     * Simple cache implementation
	     */
	    var Cache = /** @class */ (function () {
	        function Cache() {
	            this.data = {};
	            this.pending = {};
	        }
	        Cache.prototype.put = function (key, value) {
	            var previousValue = this.data[key];
	            this.data[key] = value;
	            return previousValue;
	        };
	        Cache.prototype.get = function (key) {
	            return this.data[key];
	        };
	        Cache.prototype.remove = function (key) {
	            var previousValue = this.data[key];
	            delete this.data[key];
	            return previousValue;
	        };
	        Cache.prototype.removeAll = function () {
	            this.data = {};
	        };
	        /**
	         * Gets a value from the cache or invokes the callback to populate the value
	         * with the result of a promise. If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refreshIfAbsent = function (key, callback) {
	            if (this.data.hasOwnProperty(key)) {
	                return Promise.resolve(this.data[key]);
	            }
	            return this.refresh(key, callback);
	        };
	        /**
	         * Invokes the callback to populate the value with the result of a promise.
	         * If invoked multiple times, it will return the promise
	         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	         *
	         * @param key cache key
	         * @param callback returns a Promise to populate the cache with
	         * @returns Promise<*> a promise with the cached value
	         */
	        Cache.prototype.refresh = function (key, callback) {
	            var _this = this;
	            // Check if the callback is already pending for this key
	            var pending = this.pending[key];
	            if (pending) {
	                return pending;
	            }
	            pending = callback();
	            this.pending[key] = pending;
	            return pending.then(function (value) {
	                delete _this.pending[key];
	                _this.put(key, value);
	                return value;
	            }).catch(function (error) {
	                delete _this.pending[key];
	                throw error;
	            });
	        };
	        return Cache;
	    }());
	    exports.default = Cache;

	    });

	    var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

	    var Registry_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.SERVICE_REGISTRY_PATH = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
	    var PORTAL_SERVICE_NAME = 'portal_service';
	    var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
	    var DEFAULT_CONFIG = {
	        host: '',
	        cache: new Cache_1$1.default(),
	    };
	    var Registry = /** @class */ (function () {
	        function Registry(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        // Get the underlying registry cache
	        Registry.prototype.getCache = function () {
	            return this.config.cache;
	        };
	        Registry.prototype.getRegistry = function () {
	            var _this = this;
	            return this.config.cache.refreshIfAbsent('registry', function () {
	                var serviceRegistryUrl = _this.getHost();
	                serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
	                var config = {
	                    method: 'GET',
	                    mode: 'cors',
	                    credentials: 'include',
	                    headers: {
	                        'Content-Type': 'application/json',
	                    },
	                };
	                return fetch(serviceRegistryUrl, config).then(function (resp) {
	                    if (!resp.ok) {
	                        return Promise.reject(resp);
	                    }
	                    return resp.json().then(function (data) {
	                        var dataResponse = tslib_1.__assign({ data: data }, resp);
	                        var registry = data.registry;
	                        // Optimization - also stuff the client config URL into the cache.
	                        // Sometimes, this URL can be different if it's requested from the same domain.
	                        var portalService = registry.services[PORTAL_SERVICE_NAME];
	                        if (portalService) {
	                            var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
	                            _this.config.cache.put(clientConfigUrl, dataResponse);
	                        }
	                        return dataResponse;
	                    });
	                });
	            }).then(function (resp) {
	                return resp.data.registry;
	            });
	        };
	        Registry.prototype.getUrl = function (serviceName, path, version) {
	            var _this = this;
	            if (path === void 0) { path = ''; }
	            return this.getRegistry().then(function (data) {
	                var service = data.services[serviceName];
	                if (service === undefined) {
	                    throw new Error("Unable to find service '" + serviceName + "'");
	                }
	                return service;
	            }).then(function (service) {
	                return _this.createServiceUrl(service, path, version);
	            });
	        };
	        Registry.prototype.getServiceBaseUrl = function (service, version) {
	            var baseUrl = service.base_sv_url;
	            if (!baseUrl) {
	                // unversioned service - simply return regular service url
	                return service.sv_url;
	            }
	            if (version === undefined) {
	                // Use configured version if present
	                // if(apiVersions[serviceName]) {
	                //  version = apiVersions[serviceName];
	                // Fallback to version 1 (keeps backwards comparability and generally safe)
	                version = 1;
	            }
	            return this.joinUrlParts(baseUrl, 'v' + version);
	        };
	        Registry.prototype.getServiceHostUrl = function (service) {
	            // Inspired by https://gist.github.com/jlong/2428561
	            var parser = document.createElement('a');
	            parser.href = service.sv_url;
	            return parser.protocol + "//" + parser.host;
	        };
	        Registry.prototype.createServiceUrl = function (service, path, version) {
	            var base;
	            if (path.charAt(0) === '/') {
	                // Host absolute URL
	                base = this.getServiceHostUrl(service);
	            }
	            else {
	                // Service relative URL
	                base = this.getServiceBaseUrl(service, version);
	            }
	            return this.joinUrlParts(base, path);
	        };
	        /**
	         * Determines the registry host in the following order,
	         * 1. Uses the configured host if set
	         * 2. If a PrintOS subdomain is detected as the current hostname,
	         *    the base domain is returned.
	         *    For example, if location.hostname is 'app.www.printos.com',
	         *    then 'www.printos.com' is returned.
	         * 3. Return an empty string otherwise (resulting in a registry call relative
	         *    to the current host).
	         */
	        Registry.prototype.getHost = function () {
	            if (this.config.host) {
	                // Ensure https
	                if (this.config.host.indexOf('https://') !== 0) {
	                    this.config.host = 'https://' + this.config.host;
	                }
	                return this.config.host;
	            }
	            return '';
	        };
	        Registry.prototype.joinUrlParts = function (a, b) {
	            if (!b) {
	                return a;
	            }
	            if (b.charAt(0) === '/') {
	                // Prevent double slashes by ensuring part b doesn't have a slash
	                b = b.substr(1);
	            }
	            if (a.charAt(a.length - 1) === '/') {
	                return a + b;
	            }
	            return a + '/' + b;
	        };
	        return Registry;
	    }());
	    exports.default = Registry;

	    });

	    var Http_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var DEFAULT_CONFIG = {
	        registry: new Registry_1$1.default(),
	    };
	    var Http = /** @class */ (function () {
	        function Http(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	            // Use registry cache by default to cache the registry efficiently
	            // Use registry cache by default to cache the registry efficiently
	            this.config.cache = this.config.cache || this.config.registry.getCache();
	        }
	        Http.prototype.getCookie = function (name) {
	            var value = "; " + document.cookie;
	            var parts = value.split("; " + name + "=");
	            if (parts.length == 2) {
	                return decodeURIComponent(parts.pop().split(';').shift());
	            }
	        };
	        Http.prototype.fetchJsonResponse = function (config) {
	            var _this = this;
	            var url = Http.formatUrl(config);
	            var fetchConfig = {
	                method: config.method,
	                mode: config.mode ? config.mode : 'cors',
	                credentials: config.credentials ? config.credentials : 'include',
	                headers: {},
	            };
	            // if (fetchConfig.credentials === 'include') {
	            //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
	            //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
	            //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
	            //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
	            // }
	            if (config.data !== undefined && config.data !== null) {
	                if (config.data instanceof FormData) {
	                    fetchConfig.body = config.data;
	                    // fetchConfig.headers['Content-Type'] = undefined;
	                    fetchConfig.headers['Accept'] = '*/*';
	                }
	                else {
	                    fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
	                    fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
	                    fetchConfig.headers['Content-Type'] = 'application/json';
	                    // XSRF-TOKEN handling
	                    var xsrfToken = this.getCookie('XSRF-TOKEN');
	                    if (xsrfToken) {
	                        fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
	                    }
	                }
	            }
	            // Add or overwrite any headers that were passed in
	            fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
	            // Clean up any undefined or null values from the object if explicitly set
	            for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
	                var _b = _a[_i], key = _b[0], value = _b[1];
	                if (value === undefined || value === null) {
	                    delete fetchConfig.headers[key];
	                }
	            }
	            return fetch(url, fetchConfig).then(function (resp) {
	                if (_this.responseInterceptor) {
	                    return _this.responseInterceptor(resp);
	                }
	                return resp;
	            }).then(function (resp) {
	                var _a, _b;
	                if (!resp.ok) {
	                    if ((_a = resp.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
	                        return resp.json().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    if ((_b = resp.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('text/plain')) {
	                        return resp.text().then(function (data) {
	                            // Extend response to include data
	                            return Promise.reject(Object.assign(resp, { data: data }));
	                        });
	                    }
	                    return Promise.reject(Object.assign(resp, { data: null }));
	                }
	                if (resp.status === 204) {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                if (fetchConfig.method === 'HEAD') {
	                    return Promise.resolve(Object.assign(resp, { data: null }));
	                }
	                var contentType = resp.headers.get('Content-Type');
	                if (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) {
	                    return resp.json().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    })
	                        .catch(function (e) {
	                        console.warn('HTTP: Failed to parse JSON response', e);
	                        return Object.assign(resp, { data: null });
	                    });
	                }
	                if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('text/plain')) || config.responseType === 'text') {
	                    return resp.text().then(function (data) {
	                        // Extend response to include data
	                        return Object.assign(resp, { data: data });
	                    });
	                }
	                return Promise.resolve(Object.assign(resp));
	            });
	        };
	        Http.formatUrl = function (config) {
	            var url = config.url;
	            if (config.params) {
	                if (url.includes('?')) {
	                    url += '&';
	                }
	                else {
	                    url += '?';
	                }
	                url += Http.getQueryString(config.params);
	            }
	            return url;
	        };
	        // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
	        Http.getQueryString = function (params) {
	            return Object.keys(params).map(function (k) {
	                var param = params[k];
	                if (Array.isArray(param)) {
	                    return param
	                        .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
	                        .join('&');
	                }
	                return encodeURIComponent(k) + "=" + encodeURIComponent(param);
	            }).join('&');
	        };
	        Http.prototype.request = function (config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            if (config.cache === true) {
	                return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            if (config.cache === 'refresh') {
	                return this.config.cache.refresh(Http.formatUrl(config), function () {
	                    return _this.fetchJsonResponse(config);
	                });
	            }
	            return this.fetchJsonResponse(config);
	        };
	        Http.prototype.serviceRequest = function (serviceName, path, config) {
	            var _this = this;
	            if (config === void 0) { config = {}; }
	            return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
	                config.url = url;
	                return _this.request(config);
	            });
	        };
	        //
	        // Shortcut methods
	        //
	        Http.prototype.get = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'GET';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.post = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'POST';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.put = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PUT';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.patch = function (serviceName, path, data, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'PATCH';
	            config.data = data;
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.delete = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'DELETE';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.head = function (serviceName, path, config) {
	            if (config === void 0) { config = {}; }
	            config.method = 'HEAD';
	            return this.serviceRequest(serviceName, path, config);
	        };
	        Http.prototype.fetch = function (url, config) {
	            if (config === void 0) { config = {}; }
	            config.url = url;
	            return this.fetchJsonResponse(config);
	        };
	        return Http;
	    }());
	    exports.default = Http;

	    });

	    var Preferences_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });

	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var DEFAULT_CONFIG = {
	        http: new Http_1$1.default(),
	    };
	    var Preferences = /** @class */ (function () {
	        function Preferences(config) {
	            if (config === void 0) { config = DEFAULT_CONFIG; }
	            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
	        }
	        Preferences.prototype.get = function (path, cache) {
	            if (path === void 0) { path = null; }
	            if (cache === void 0) { cache = true; }
	            var reqPath = 'preferences';
	            if (path) {
	                reqPath += '/' + path;
	            }
	            return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.update = function (prefs) {
	            return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.patch = function (path, prefs) {
	            return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.delete = function (path) {
	            return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
	                return resp.data;
	            });
	        };
	        Preferences.prototype.deleteAll = function () {
	            return this.config.http.delete('portal_service', 'preferences', { version: 2 });
	        };
	        return Preferences;
	    }());
	    exports.default = Preferences;

	    });

	    var Locale_1 = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var Locale = /** @class */ (function () {
	        function Locale() {
	            this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
	        }
	        Locale.prototype.getCookieValue = function (cookieName) {
	            var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
	            if (match) {
	                return decodeURIComponent(match[2]);
	            }
	            return null;
	        };
	        Locale.prototype.getBestFit = function () {
	            var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
	            if (cookie && cookie.locale) {
	                return cookie.locale.split('-')[0];
	            }
	            return window.navigator.language.split('-')[0];
	        };
	        return Locale;
	    }());
	    exports.default = Locale;

	    });

	    var dist = createCommonjsModule(function (module, exports) {
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

	    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
	    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
	    var Http_1$1 = tslib_1.__importDefault(Http_1);
	    var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
	    var Locale_1$1 = tslib_1.__importDefault(Locale_1);
	    // TODO: move into Registry and have it listen for blue ready
	    function getRegistryHost() {
	        var host = '';
	        if (window.printos &&
	            window.printos.blue &&
	            window.printos.blue.ui &&
	            window.printos.blue.ui.registry) {
	            host = window.printos.blue.ui.registry.host;
	        }
	        return host;
	    }
	    exports.cache = new Cache_1$1.default();
	    exports.registry = new Registry_1$1.default({
	        cache: exports.cache,
	        host: getRegistryHost(),
	    });
	    exports.http = new Http_1$1.default({
	        cache: exports.cache,
	        registry: exports.registry
	    });
	    exports.preferences = new Preferences_1$1.default({ http: exports.http });
	    exports.locale = new Locale_1$1.default();
	    exports.default = {
	        cache: exports.cache,
	        registry: exports.registry,
	        http: exports.http,
	        preferences: exports.preferences,
	        locale: exports.locale,
	    };

	    });

	    var core = /*@__PURE__*/getDefaultExportFromCjs(dist);

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var de = {
	      browser: "Durchsuchen",
	      random: "Zufällig",
	      invalidColor: "Ungültige Farbe",
	      today: "Heute",
	      nextMonth: 'Nächster Monat',
	      prevMonth: 'Vorheriger Monat',
	      nextYear: 'Nächstes Jahr',
	      prevYear: 'Vorheriges Jahr',
	      selectDate: "Datum auswählen",
	      validateTooManyFiles: "Zu viele Dateien (maximal {0} Dateien zulässig)",
	      validateTooLong: "Zu lang",
	      validateFileNameTooLong: "Dateiname zu lang (maximal {0} Zeichen zulässig)",
	      validateRequired: "Erforderliches Feld",
	      validateNotANumber: "Keine Zahl",
	      validateLessThanMin: "Die Zahl ist kleiner als das Minimum ({0})",
	      validateMoreThanMax: "Die Zahl ist größer als das Maximum ({0})",
	      validateNotAStepValue: "Kein gültiges Inkrement ({0})",
	      validateColor: "Nicht festgelegt",
	      validateRegex: "Ungültiges Format",
	      validateDate: "Ungültiges Datum (MM/TT/JJJJ)",
	      noSuggestions: "Keine Vorschläge",
	      noValues: "[Keine Werte]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var en$1 = {
	      browser: "Browse",
	      random: "Random",
	      invalidColor: "Invalid Color",
	      today: "Today",
	      nextMonth: 'Next Month',
	      prevMonth: 'Previous Month',
	      nextYear: 'Next Year',
	      prevYear: 'Previous Year',
	      selectDate: "Select Date",
	      validateTooManyFiles: "Too many files ({0} files maximum)",
	      validateTooLong: "Too long",
	      validateFileNameTooLong: "File name too long ({0} characters maximum)",
	      validateRequired: "Required field",
	      validateNotANumber: "Not a number",
	      validateLessThanMin: "Number is less than minimum ({0})",
	      validateMoreThanMax: "Number is more than maximum ({0})",
	      validateNotAStepValue: "Not a valid increment ({0})",
	      validateColor: "Not set",
	      validateRegex: "Invalid Format",
	      validateDate: "Invalid Date (MM/DD/YYYY)",
	      noSuggestions: "No Suggestions",
	      noValues: "[No Values]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var es = {
	      browser: "Examinar",
	      random: "Aleatoria",
	      invalidColor: "Color no válido",
	      today: "Hoy",
	      nextMonth: 'Siguiente mes',
	      prevMonth: 'Mes anterior',
	      nextYear: 'Siguiente año',
	      prevYear: 'Años anterior',
	      selectDate: "Seleccionar fecha",
	      validateTooManyFiles: "Demasiados archivos ({0} archivos máximo)",
	      validateTooLong: "Demasiado largo",
	      validateFileNameTooLong: "Nombre de archivo demasiado largo ({0} caracteres máximo)",
	      validateRequired: "Campo obligatorio",
	      validateNotANumber: "No un número",
	      validateLessThanMin: "El número es inferior al mínimo ({0})",
	      validateMoreThanMax: "El número es superior al máximo ({0})",
	      validateNotAStepValue: "Incremento no válido ({0})",
	      validateColor: "No establecido",
	      validateRegex: "Formato no válido",
	      validateDate: "Fecha no válida (MM/DD/YYYY)",
	      noSuggestions: "Sin sugerencias",
	      noValues: "[Sin valores]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var fr = {
	      browser: "Sfoglia",
	      random: "Casuale",
	      invalidColor: "Colore non valido",
	      today: "Oggi",
	      nextMonth: 'Mese successivo',
	      prevMonth: 'Mese precedente',
	      nextYear: 'Anno prossimo',
	      prevYear: 'Anno precedente',
	      selectDate: "Seleziona data",
	      validateTooManyFiles: "Troppi file (massimo {0} file)",
	      validateTooLong: "Troppo lungo",
	      validateFileNameTooLong: "Nome del file troppo lungo (massimo {0} caratteri)",
	      validateRequired: "Campo obbligatorio",
	      validateNotANumber: "Non un numero",
	      validateLessThanMin: "Numero inferiore al minimo ({0})",
	      validateMoreThanMax: "Number superiore al massimo ({0})",
	      validateNotAStepValue: "Incremento non valido ({0})",
	      validateColor: "Non definito",
	      validateRegex: "Formato non valido",
	      validateDate: "Data non valida (MM/GG/AAAA)",
	      noSuggestions: "Nessun suggerimento",
	      noValues: "[No Values]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (")
	    var it = {
	      browser: "Sfoglia",
	      random: "Casuale",
	      invalidColor: "Colore non valido",
	      today: "Oggi",
	      selectDate: "Seleziona data",
	      validateTooManyFiles: "Troppi file ({0} file al massimo)",
	      validateTooLong: "Troppo lungo",
	      validateFileNameTooLong: "Nome file troppo lungo ({0} caratteri max)",
	      validateRequired: "Campo richiesto",
	      validateNotANumber: "Non è un numero",
	      validateLessThanMin: "Numero inferiore al minimo ({0})",
	      validateMoreThanMax: "Numero maggiore del massimo ({0})",
	      validateNotAStepValue: "Incremento non valido ({0})",
	      validateColor: "Non impostato",
	      validateRegex: "Formato non valido"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ja = {
	      browser: "参照",
	      random: "ランダム",
	      invalidColor: "無効な色",
	      today: "本日",
	      nextMonth: '来月',
	      prevMonth: '先月',
	      nextYear: '来年',
	      prevYear: '前年',
	      selectDate: "日付を選択",
	      validateTooManyFiles: "ファイルが多すぎます（最大{0}ファイル）",
	      validateTooLong: "長すぎます",
	      validateFileNameTooLong: "ファイル名が長すぎます（最大{0}文字）",
	      validateRequired: "必須フィールド",
	      validateNotANumber: "数値ではありません",
	      validateLessThanMin: "数値は最小値（{0}）未満です",
	      validateMoreThanMax: "数値は最大値（{0}）以上です",
	      validateNotAStepValue: "増分が有効ではありません（{0}）",
	      validateColor: "未設定",
	      validateRegex: "無効なフォーマット",
	      validateDate: "無効な日付（YYYY/MM/DD）",
	      noSuggestions: "提案なし",
	      noValues: "[値なし]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ko = {
	      browser: "찾아보기",
	      random: "임의",
	      invalidColor: "잘못된 색상",
	      today: "오늘",
	      nextMonth: '다음 달',
	      prevMonth: '지난 달',
	      nextYear: '다음 해',
	      prevYear: '지난 해',
	      selectDate: "날짜 선택",
	      validateTooManyFiles: "파일이 너무 많음(최대 {0}개 파일)",
	      validateTooLong: "너무 김",
	      validateFileNameTooLong: "파일 이름이 너무 깁니다(최대 {0}자).",
	      validateRequired: "필수 필드",
	      validateNotANumber: "숫자가 아님",
	      validateLessThanMin: "숫자가 최소값({0})보다 작음",
	      validateMoreThanMax: "숫자가 최대값({0})보다 큼",
	      validateNotAStepValue: "유효한 증분({0})이 아님",
	      validateColor: "설정되지 않음",
	      validateRegex: "잘못된 형식",
	      validateDate: "잘못된 날짜(MM/DD/YYYY)",
	      noSuggestions: "제안 없음",
	      noValues: "[값 없음]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var pt = {
	      browser: "Navegar",
	      random: "Aleatório",
	      invalidColor: "Cor inválida",
	      today: "Hoje",
	      nextMonth: 'Próximo mês',
	      prevMonth: 'Mês anterior',
	      nextYear: 'Próximo ano',
	      prevYear: 'Ano anterior',
	      selectDate: "Selecione a data",
	      validateTooManyFiles: "Muitos arquivos (máximo de {0} arquivos)",
	      validateTooLong: "Muito longo",
	      validateFileNameTooLong: "Nome do arquivo muito longo (máximo de {0} caracteres)",
	      validateRequired: "Campo obrigatório",
	      validateNotANumber: "Não é um número",
	      validateLessThanMin: "O número é menor que o mínimo ({0})",
	      validateMoreThanMax: "O número é maior que o máximo ({0})",
	      validateNotAStepValue: "Não é um incremento válido ({0})",
	      validateColor: "Não configurado",
	      validateRegex: "Formato inválido",
	      validateDate: "Data inválida (MM/DD/AAAA)",
	      noSuggestions: "Nenhuma sugestão",
	      noValues: "[Sem valores]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var ru = {
	      browser: "Обзор",
	      random: "Случайный",
	      invalidColor: "Недопустимый цвет",
	      today: "Сегодня",
	      nextMonth: 'Следующий месяц',
	      prevMonth: 'Предыдущий месяц',
	      nextYear: 'Следующий год',
	      prevYear: 'Предыдущий год',
	      selectDate: "Выбрать дату",
	      validateTooManyFiles: "Слишком много файлов (макс. число файлов - {0})",
	      validateTooLong: "Слишком длинное",
	      validateFileNameTooLong: "Слишком длинное имя файла (макс. число символов - {0})",
	      validateRequired: "Обязательно для заполнения",
	      validateNotANumber: "Не число",
	      validateLessThanMin: "Число меньше минимального ({0})",
	      validateMoreThanMax: "Число больше максимального ({0})",
	      validateNotAStepValue: "Недопустимое приращение ({0})",
	      validateColor: "Не задано",
	      validateRegex: "Недопустимый формат",
	      validateDate: "Недопустимая дата (ММ/ДД/ГГГГ)",
	      noSuggestions: "Нет предложений",
	      noValues: "[Нет значений]"
	    };

	    // Using double quotes in this file to prevent issues with apostrophies (')
	    var zh = {
	      browser: "Parcourir",
	      random: "Aléatoire",
	      invalidColor: "Couleur non valide",
	      today: "Aujourd'hui",
	      nextMonth: 'Mois suivant',
	      prevMonth: 'Mois précédent',
	      nextYear: 'Année suivante',
	      prevYear: 'Année précédente',
	      selectDate: "Sélectionner la date",
	      validateTooManyFiles: "Trop de fichiers ({0} fichiers maximum)",
	      validateTooLong: "Trop long",
	      validateFileNameTooLong: "Nom de fichier trop long ({0} caractères maximum)",
	      validateRequired: "Champ obligatoire",
	      validateNotANumber: "N’est pas un nombre",
	      validateLessThanMin: "Le nombre est inférieur au minimum ({0})",
	      validateMoreThanMax: "Le nombre est supérieur au maximum ({0})",
	      validateNotAStepValue: "N’est pas un incrément valide ({0})",
	      validateColor: "Non défini",
	      validateRegex: "Format non valide",
	      validateDate: "Date non valide (MM/JJ/AAAA)",
	      noSuggestions: "Aucune suggestion",
	      noValues: "[Aucune valeur]"
	    };

	    const {
	      locale
	    } = core;
	    const dictionaryLocales = {
	      de,
	      en: en$1,
	      es,
	      fr,
	      it,
	      ja,
	      ko,
	      pt,
	      ru,
	      zh
	    };
	    s.set(dictionaryLocales);

	    // Default to the browser locale, if present
	    let browserLang = locale.getBestFit();
	    $({
	      fallbackLocale: 'en',
	      initialLocale: browserLang
	    });

	    /* src/CheckBox.svelte generated by Svelte v3.38.2 */
	    function add_css$c() {
	      var style = element("style");
	      style.id = "svelte-1iaa7pw-style";
	      style.textContent = ".pros-message-container.svelte-1iaa7pw.svelte-1iaa7pw{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1iaa7pw .pros-status-icon.svelte-1iaa7pw{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1iaa7pw .pros-status-icon svg.svelte-1iaa7pw{height:100%;width:100%}.pros-message-container.svelte-1iaa7pw .pros-message.svelte-1iaa7pw{flex:1}.pros-global-wrapper.svelte-1iaa7pw.svelte-1iaa7pw{width:100%}.pros-control-container.svelte-1iaa7pw .pros-input-container.svelte-1iaa7pw{display:flex;justify-content:flex-start;align-items:center;height:34px;cursor:pointer}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box.svelte-1iaa7pw{display:flex;flex-direction:column;justify-content:center;align-items:center;box-sizing:border-box;width:24px;height:24px;border-width:1px;border-style:solid;border-radius:4px;flex-shrink:0}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{display:none;height:100%;width:100%}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-box.checked .pros-check.svelte-1iaa7pw{display:block}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none;margin-left:8px}.pros-control-container.svelte-1iaa7pw .pros-input-container .pros-label.required.svelte-1iaa7pw::after{content:\" *\"}.pros-control-container.svelte-1iaa7pw .pros-message-container.svelte-1iaa7pw{padding-left:28px;width:unset;max-width:calc(100% - 28px)}.pros-control-container.custom-layout.svelte-1iaa7pw .pros-input-container.svelte-1iaa7pw{height:auto}.pros-global-wrapper[pos--shape=sharp].svelte-1iaa7pw .pros-box.svelte-1iaa7pw{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1iaa7pw .pros-control-container.has-focus .pros-input-container.svelte-1iaa7pw{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container .pros-status-icon.svelte-1iaa7pw{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.error.svelte-1iaa7pw{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1iaa7pw{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-message-container.svelte-1iaa7pw{color:#adadad !important}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container .pros-status-icon.svelte-1iaa7pw{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.error.svelte-1iaa7pw{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1iaa7pw{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-message-container.svelte-1iaa7pw{color:#585858 !important}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.svelte-1iaa7pw{background-color:transparent;border-color:#212121;color:white}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#027aae;border-color:#027aae}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.svelte-1iaa7pw{background-color:rgba(33, 33, 33, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.checked.svelte-1iaa7pw{background-color:#035b84;border-color:#035b84}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container.svelte-1iaa7pw{cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.svelte-1iaa7pw{border-color:#adadad;user-select:none}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{background-color:transparent;color:#ffffff}.pros-global-wrapper[pos--theme=light].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.svelte-1iaa7pw{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.svelte-1iaa7pw{background-color:transparent;border-color:#ffffff;color:#212121}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#3ab4eb;border-color:#3ab4eb}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.svelte-1iaa7pw{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container .pros-input-container.allow-hover:hover .pros-box.checked.svelte-1iaa7pw{background-color:#6dd0fb;border-color:#6dd0fb}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled.svelte-1iaa7pw{color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container.svelte-1iaa7pw{cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.svelte-1iaa7pw{border-color:#585858;user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box.checked.svelte-1iaa7pw{background-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-box .pros-check.svelte-1iaa7pw{background-color:transparent;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1iaa7pw .pros-control-container.disabled .pros-input-container .pros-label.svelte-1iaa7pw{user-select:none}";
	      append(document.head, style);
	    }

	    // (12:6) {#if label}
	    function create_if_block_3$a(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[2]);
	          attr(div, "id", /*_labelId*/ctx[12]);
	          attr(div, "pros-tooltip", "");
	          attr(div, "class", "pros-label svelte-1iaa7pw");
	          toggle_class(div, "required", /*required*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/4) set_data(t, /*label*/ctx[2]);
	          if (dirty[0] & /*_labelId*/4096) {
	            attr(div, "id", /*_labelId*/ctx[12]);
	          }
	          if (dirty[0] & /*required*/16) {
	            toggle_class(div, "required", /*required*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (17:4) {#if display !== 'custom'}
	    function create_if_block$d(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[7] && /*_errors*/ctx[8].length > 0) return create_if_block_1$a;
	        if (/*hint*/ctx[3]) return create_if_block_2$a;
	        return create_else_block$b;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-1iaa7pw");
	          toggle_class(div, "error", /*_dirty*/ctx[7] && /*_errors*/ctx[8].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/384) {
	            toggle_class(div, "error", /*_dirty*/ctx[7] && /*_errors*/ctx[8].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (33:6) {:else}
	    function create_else_block$b(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[14]);
	          attr(div, "class", "pros-message svelte-1iaa7pw");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/16384) {
	            attr(div, "id", /*_messageId*/ctx[14]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (26:21) 
	    function create_if_block_2$a(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1iaa7pw");
	          attr(div0, "id", /*_statusIconId*/ctx[15]);
	          attr(div0, "class", "pros-status-icon svelte-1iaa7pw");
	          attr(div1, "id", /*_messageId*/ctx[14]);
	          attr(div1, "class", "pros-message svelte-1iaa7pw");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/32768) {
	            attr(div0, "id", /*_statusIconId*/ctx[15]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[0] & /*_messageId*/16384) {
	            attr(div1, "id", /*_messageId*/ctx[14]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (19:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$a(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[8][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1iaa7pw");
	          attr(div0, "id", /*_statusIconId*/ctx[15]);
	          attr(div0, "class", "pros-status-icon error svelte-1iaa7pw");
	          attr(div1, "id", /*_messageId*/ctx[14]);
	          attr(div1, "class", "pros-message error svelte-1iaa7pw");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/32768) {
	            attr(div0, "id", /*_statusIconId*/ctx[15]);
	          }
	          if (dirty[0] & /*_errors*/256 && t1_value !== (t1_value = /*_errors*/ctx[8][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/16384) {
	            attr(div1, "id", /*_messageId*/ctx[14]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$d(ctx) {
	      let div4;
	      let div3;
	      let div2;
	      let div1;
	      let t0;
	      let t1;
	      let mounted;
	      let dispose;
	      let if_block0 = /*label*/ctx[2] && create_if_block_3$a(ctx);
	      let if_block1 = /*display*/ctx[0] !== "custom" && create_if_block$d(ctx);
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          div2 = element("div");
	          div1 = element("div");
	          div1.innerHTML = `<div class="pros-check svelte-1iaa7pw"><svg fill="currentColor" focusable="false" version="1.1" viewBox="0 0 32 32"><path d="M13.8,21.63,8.63,16.47l1.13-1.13,4,4,8.44-8.44,1.13,1.13Z"></path></svg></div>`;
	          t0 = space();
	          if (if_block0) if_block0.c();
	          t1 = space();
	          if (if_block1) if_block1.c();
	          attr(div1, "class", "pros-box svelte-1iaa7pw");
	          toggle_class(div1, "checked", /*value*/ctx[1]);
	          attr(div2, "id", /*_inputId*/ctx[13]);
	          attr(div2, "class", "pros-input-container svelte-1iaa7pw");
	          attr(div3, "class", "pros-control-container svelte-1iaa7pw");
	          toggle_class(div3, "custom-layout", /*display*/ctx[0] === "custom");
	          toggle_class(div3, "inline-layout", /*display*/ctx[0] === "form-inline");
	          toggle_class(div3, "error", /*_dirty*/ctx[7] && /*_errors*/ctx[8].length > 0);
	          toggle_class(div3, "disabled", /*disabled*/ctx[5]);
	          toggle_class(div3, "allow-hover", ! /*disabled*/ctx[5]);
	          attr(div4, "class", "pros-global-wrapper pros-form-control svelte-1iaa7pw");
	          attr(div4, "pos--theme", /*_theme*/ctx[9]);
	          attr(div4, "pos--shape", /*_shape*/ctx[10]);
	          attr(div4, "pos--density", /*_density*/ctx[11]);
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          append(div3, div2);
	          append(div2, div1);
	          append(div2, t0);
	          if (if_block0) if_block0.m(div2, null);
	          append(div3, t1);
	          if (if_block1) if_block1.m(div3, null);
	          if (!mounted) {
	            dispose = listen(div2, "click", /*handleClick*/ctx[6]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*value*/2) {
	            toggle_class(div1, "checked", /*value*/ctx[1]);
	          }
	          if (/*label*/ctx[2]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_3$a(ctx);
	              if_block0.c();
	              if_block0.m(div2, null);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[0] & /*_inputId*/8192) {
	            attr(div2, "id", /*_inputId*/ctx[13]);
	          }
	          if (/*display*/ctx[0] !== "custom") {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block$d(ctx);
	              if_block1.c();
	              if_block1.m(div3, null);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*display*/1) {
	            toggle_class(div3, "custom-layout", /*display*/ctx[0] === "custom");
	          }
	          if (dirty[0] & /*display*/1) {
	            toggle_class(div3, "inline-layout", /*display*/ctx[0] === "form-inline");
	          }
	          if (dirty[0] & /*_dirty, _errors*/384) {
	            toggle_class(div3, "error", /*_dirty*/ctx[7] && /*_errors*/ctx[8].length > 0);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div3, "disabled", /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div3, "allow-hover", ! /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*_theme*/512) {
	            attr(div4, "pos--theme", /*_theme*/ctx[9]);
	          }
	          if (dirty[0] & /*_shape*/1024) {
	            attr(div4, "pos--shape", /*_shape*/ctx[10]);
	          }
	          if (dirty[0] & /*_density*/2048) {
	            attr(div4, "pos--density", /*_density*/ctx[11]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div4);
	          if (if_block0) if_block0.d();
	          if (if_block1) if_block1.d();
	          mounted = false;
	          dispose();
	        }
	      };
	    }
	    function hasValue$b(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$d($$self, $$props, $$invalidate) {
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(30, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color Theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape Style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density Style (standard/high)
	      let {
	        value = false
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        id = null
	      } = $$props; // Custom external validation errors

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _labelId = null;
	      let _inputId = null;
	      let _messageId = null;
	      let _statusIconId = null;

	      // Computed values
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(0, display = hasValue$b(display) ? display : "form");
	        $$invalidate(16, theme = hasValue$b(theme) ? theme : "light");
	        $$invalidate(17, shape = hasValue$b(shape) ? shape : "round");
	        $$invalidate(18, density = hasValue$b(density) ? density : "standard");
	        $$invalidate(2, label = hasValue$b(label) ? label : "");
	        $$invalidate(3, hint = hasValue$b(hint) ? hint : "");
	        $$invalidate(1, value = hasValue$b(value) ? value : false);
	        $$invalidate(4, required = hasValue$b(required) ? required : false);
	        $$invalidate(5, disabled = hasValue$b(disabled) ? disabled : false);
	        $$invalidate(19, validation = hasValue$b(validation) ? validation : true);
	        $$invalidate(12, _labelId = hasValue$b(id) ? `${id}-label` : undefined);
	        $$invalidate(13, _inputId = hasValue$b(id) ? `${id}-input` : undefined);
	        $$invalidate(14, _messageId = hasValue$b(id) ? `${id}-message` : undefined);
	        $$invalidate(15, _statusIconId = hasValue$b(id) ? `${id}-status-icon` : undefined);
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(9, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(9, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(9, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(10, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(10, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(10, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(11, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(11, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(11, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function handleClick() {
	        if (disabled) {
	          return;
	        }
	        $$invalidate(7, _dirty = true);
	        $$invalidate(1, value = !value);
	        valueChanged.call(this);
	      }
	      function valueChanged() {
	        doValidate.call(value);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(8, _errors = errors ? errors : []);
	        if (required) {
	          if (!value) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }

	        // We do this here so that valid will be calculated based on built in errors before sending change event
	        if (validation) {
	          $$invalidate(8, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	          }
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("display" in $$props) $$invalidate(0, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(16, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(17, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(18, density = $$props.density);
	        if ("value" in $$props) $$invalidate(1, value = $$props.value);
	        if ("label" in $$props) $$invalidate(2, label = $$props.label);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("required" in $$props) $$invalidate(4, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(19, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(20, errors = $$props.errors);
	        if ("id" in $$props) $$invalidate(21, id = $$props.id);
	      };
	      return [display, value, label, hint, required, disabled, handleClick, _dirty, _errors, _theme, _shape, _density, _labelId, _inputId, _messageId, _statusIconId, theme, shape, density, validation, errors, id];
	    }
	    class CheckBox extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1iaa7pw-style")) add_css$c();
	        init(this, options, instance$d, create_fragment$d, safe_not_equal, {
	          display: 0,
	          theme: 16,
	          shape: 17,
	          density: 18,
	          value: 1,
	          label: 2,
	          hint: 3,
	          required: 4,
	          disabled: 5,
	          validation: 19,
	          errors: 20,
	          id: 21,
	          handleClick: 6
	        }, [-1, -1]);
	      }
	      get handleClick() {
	        return this.$$.ctx[6];
	      }
	    }

	    var lib = createCommonjsModule(function (module) {
	    module.exports=function(e){var r={};function n(t){if(r[t])return r[t].exports;var a=r[t]={i:t,l:!1,exports:{}};return e[t].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=r,n.d=function(e,r,t){n.o(e,r)||Object.defineProperty(e,r,{enumerable:!0,get:t});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,r){if(1&r&&(e=n(e)),8&r)return e;if(4&r&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(n.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&r&&"string"!=typeof e)for(var a in e)n.d(t,a,function(r){return e[r]}.bind(null,a));return t},n.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(r,"a",r),r},n.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},n.p="",n(n.s=0)}([function(e,r,n){n.r(r),n.d(r,"validateHTMLColorName",(function(){return l})),n.d(r,"validateHTMLColorSpecialName",(function(){return i})),n.d(r,"validateHTMLColorHex",(function(){return u})),n.d(r,"validateHTMLColorRgb",(function(){return d})),n.d(r,"validateHTMLColorHsl",(function(){return f})),n.d(r,"validateHTMLColorHwb",(function(){return h})),n.d(r,"validateHTMLColorLab",(function(){return g})),n.d(r,"validateHTMLColor",(function(){return m}));const t=e=>e&&"string"==typeof e,a=["AliceBlue","AntiqueWhite","Aqua","Aquamarine","Azure","Beige","Bisque","Black","BlanchedAlmond","Blue","BlueViolet","Brown","BurlyWood","CadetBlue","Chartreuse","Chocolate","Coral","CornflowerBlue","Cornsilk","Crimson","Cyan","DarkBlue","DarkCyan","DarkGoldenrod","DarkGray","DarkGreen","DarkKhaki","DarkMagenta","DarkOliveGreen","DarkOrange","DarkOrchid","DarkRed","DarkSalmon","DarkSeaGreen","DarkSlateBlue","DarkSlateGray","DarkTurquoise","DarkViolet","DeepPink","DeepSkyBlue","DimGray","DodgerBlue","FireBrick","FloralWhite","ForestGreen","Fuchsia","Gainsboro","GhostWhite","Gold","Goldenrod","Gray","Green","GreenYellow","HoneyDew","HotPink","IndianRed","Indigo","Ivory","Khaki","Lavender","LavenderBlush","LawnGreen","LemonChiffon","LightBlue","LightCoral","LightCyan","LightGoldenrodYellow","LightGray","LightGreen","LightPink","LightSalmon","LightSalmon","LightSeaGreen","LightSkyBlue","LightSlateGray","LightSteelBlue","LightYellow","Lime","LimeGreen","Linen","Magenta","Maroon","MediumAquamarine","MediumBlue","MediumOrchid","MediumPurple","MediumSeaGreen","MediumSlateBlue","MediumSlateBlue","MediumSpringGreen","MediumTurquoise","MediumVioletRed","MidnightBlue","MintCream","MistyRose","Moccasin","NavajoWhite","Navy","OldLace","Olive","OliveDrab","Orange","OrangeRed","Orchid","PaleGoldenrod","PaleGreen","PaleTurquoise","PaleVioletRed","PapayaWhip","PeachPuff","Peru","Pink","Plum","PowderBlue","Purple","RebeccaPurple","Red","RosyBrown","RoyalBlue","SaddleBrown","Salmon","SandyBrown","SeaGreen","SeaShell","Sienna","Silver","SkyBlue","SlateBlue","SlateGray","Snow","SpringGreen","SteelBlue","Tan","Teal","Thistle","Tomato","Turquoise","Violet","Wheat","White","WhiteSmoke","Yellow","YellowGreen"],o=["currentColor","inherit","transparent"],l=e=>{let r=!1;return t(e)&&a.map(n=>(e.toLowerCase()===n.toLowerCase()&&(r=!0),null)),r},i=e=>{let r=!1;return t(e)&&o.map(n=>(e.toLowerCase()===n.toLowerCase()&&(r=!0),null)),r},u=e=>{if(t(e)){const r=/^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;return e&&r.test(e)}},d=e=>{if(t(e)){const r=/(rgb)a?\((\s*\d+%?\s*?,?\s*){2}(\s*\d+%?\s*?,?\s*\)?)(\s*,?\s*\/?\s*(0?\.?\d+%?\s*)?|1|0)?\)$/i;return e&&r.test(e)}},s="(([0-9]|[1-9][0-9]|100)%)",c=`\\s*?\\)?)(\\s*?(\\/?)\\s+${`(((${s}))|(0?(\\.\\d+)?)|1))?`}\\s*?\\)$`,f=e=>{if(t(e)){const r=new RegExp(`(hsl)a?\\((\\s*?(${"(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)"}|${"(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)gra)"}|${"((([0-5])?\\.\\d+|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)"}|${"((0?(\\.\\d+)?|1)turn)"})((\\s*,\\s*)|(\\s+)))(\\s*?(0|${s})((\\s*,\\s*)|(\\s+)))(\\s*?(0|${s})\\s*?\\)?)(\\s*?(\\/?|,?)\\s*?(((${s}))|(0?(\\.\\d+)?)|1))?\\)$`);return e&&r.test(e)}},h=e=>{if(t(e)){const r=new RegExp(`(hwb\\(\\s*?${"(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)"}\\s+)((0|${s})\\s+)((0|${s})${c}`);return e&&r.test(e)}},g=e=>{if(t(e)){const r="(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])(\\.\\d+)??|160))",n=new RegExp(`(lab\\(\\s*?((\\d*(\\.\\d+)?)%)\\s+${r}\\s+${r}${c}`);return e&&n.test(e)}},m=e=>!!(e&&u(e)||d(e)||f(e)||h(e)||g(e));r.default=e=>!!(e&&u(e)||l(e)||i(e)||d(e)||f(e)||h(e)||g(e));}]);
	    });

	    var validateColor = /*@__PURE__*/getDefaultExportFromCjs(lib);

	    /* src/ColorPicker.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1$3
	    } = globals;
	    function add_css$b() {
	      var style = element("style");
	      style.id = "svelte-m61rem-style";
	      style.textContent = ".pros-highlight-container.svelte-m61rem.svelte-m61rem{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-m61rem.svelte-m61rem{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-m61rem.svelte-m61rem{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-m61rem .pros-input.svelte-m61rem{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-m61rem .pros-input.svelte-m61rem{padding-top:18px}.pros-control-container.has-label.svelte-m61rem input.svelte-m61rem::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-m61rem.svelte-m61rem{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-m61rem.svelte-m61rem::after{content:\" *\"}.pros-action-button.svelte-m61rem.svelte-m61rem{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-m61rem svg.svelte-m61rem{width:24px;height:24px}.pros-action-button.svelte-m61rem.svelte-m61rem:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-m61rem.svelte-m61rem{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-m61rem svg.svelte-m61rem{width:auto;height:auto}.pros-control-container.svelte-m61rem.svelte-m61rem{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-m61rem .pros-control-label.svelte-m61rem,.pros-control-container.has-focus.svelte-m61rem .pros-control-label.svelte-m61rem{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-m61rem .pros-highlight-container.svelte-m61rem{cursor:default}.pros-control-container.has-focus.svelte-m61rem .pros-input.svelte-m61rem{cursor:text}.pros-control-container.has-focus.svelte-m61rem .pros-highlight-container.svelte-m61rem{border-width:2px}.pros-control-container.has-focus.svelte-m61rem .pros-input-container.svelte-m61rem{margin-left:11px}.pros-control-container.has-focus.svelte-m61rem .pros-end-cap.svelte-m61rem:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-m61rem input.svelte-m61rem::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-m61rem.svelte-m61rem{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-m61rem .pros-status-icon.svelte-m61rem{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-m61rem .pros-status-icon svg.svelte-m61rem{height:100%;width:100%}.pros-message-container.svelte-m61rem .pros-message.svelte-m61rem{flex:1}.pros-control-container.svelte-m61rem .pros-control-label.svelte-m61rem{transform:translate(64px, 14px)}.pros-control-container.has-value.svelte-m61rem .pros-control-label.svelte-m61rem,.pros-control-container.has-focus.svelte-m61rem .pros-control-label.svelte-m61rem{transform:translate(60px, 8px)}.pros-control-container.has-focus.svelte-m61rem .pros-color-indicator.svelte-m61rem{width:47px}.pros-control-container.has-focus.svelte-m61rem .pros-input-container.svelte-m61rem{margin-left:12px}.pros-color-indicator.svelte-m61rem.svelte-m61rem{width:48px;height:100%;border-right:1px solid}.pros-options-wrapper.svelte-m61rem.svelte-m61rem{position:fixed;max-width:296px;transform:translate(0, 0);z-index:1001;border-radius:12px;border-width:1px;border-style:solid;overflow:hidden}.pros-options-wrapper.open.svelte-m61rem.svelte-m61rem{display:inherit}.pros-color-selector.svelte-m61rem .pros-color-palette.svelte-m61rem{display:flex;justify-content:flex-start;align-items:center;flex-wrap:wrap;padding:28px}.pros-color-selector.svelte-m61rem .pros-color-palette .pros-color.svelte-m61rem{border:1px solid rgba(0, 0, 0, 0.2);border-radius:4px;margin:4px;width:32px;height:24px;box-sizing:border-box}.pros-color-selector.svelte-m61rem .pros-color-palette .pros-color.clickable.svelte-m61rem{cursor:pointer}.pros-global-wrapper[pos--shape=sharp].svelte-m61rem .pros-highlight-container.svelte-m61rem{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container .pros-control-label.svelte-m61rem{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container .pros-highlight-container.svelte-m61rem{height:36px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-m61rem{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container .pros-input-container .pros-input.svelte-m61rem{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-label .pros-input.svelte-m61rem{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-value .pros-control-label.svelte-m61rem,.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-focus .pros-control-label.svelte-m61rem{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-m61rem{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-focus .pros-input-container.svelte-m61rem{margin-left:7px}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container .pros-control-label.svelte-m61rem{transform:translate(60px, 9px)}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-value .pros-control-label.svelte-m61rem,.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-focus .pros-control-label.svelte-m61rem{transform:translate(58px, 2px)}.pros-global-wrapper[pos--density=high].svelte-m61rem .pros-control-container.has-focus .pros-input-container.svelte-m61rem{margin-left:8px}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.svelte-m61rem{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-highlight-container.svelte-m61rem{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-input.svelte-m61rem{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container input.svelte-m61rem::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.allow-hover .pros-highlight-container.svelte-m61rem:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.error .pros-highlight-container.svelte-m61rem{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.has-focus .pros-highlight-container.svelte-m61rem{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-end-cap.svelte-m61rem{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-message-container.svelte-m61rem{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-message-container .pros-status-icon.svelte-m61rem{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-message-container.error.svelte-m61rem{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container .pros-message-container.error .pros-status-icon.svelte-m61rem{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled.svelte-m61rem{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled .pros-highlight-container.svelte-m61rem{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled .pros-input.svelte-m61rem{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled .pros-message-container.svelte-m61rem{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled .pros-end-cap.svelte-m61rem{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-action-button.svelte-m61rem:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.svelte-m61rem{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-highlight-container.svelte-m61rem{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-input.svelte-m61rem{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container input.svelte-m61rem::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.allow-hover .pros-highlight-container.svelte-m61rem:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.error .pros-highlight-container.svelte-m61rem{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.has-focus .pros-highlight-container.svelte-m61rem{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-message-container.svelte-m61rem{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-message-container .pros-status-icon.svelte-m61rem{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-message-container.error.svelte-m61rem{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container .pros-message-container.error .pros-status-icon.svelte-m61rem{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.disabled.svelte-m61rem{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.disabled .pros-highlight-container.svelte-m61rem{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.disabled .pros-input.svelte-m61rem{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.disabled .pros-message-container.svelte-m61rem{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-action-button.svelte-m61rem:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-color-indicator.svelte-m61rem{border-color:#212121}.pros-global-wrapper[pos--theme=light].svelte-m61rem .pros-control-container.disabled .pros-color-indicator.svelte-m61rem{border-color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-color-indicator.svelte-m61rem{border-color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-m61rem .pros-control-container.disabled .pros-color-indicator.svelte-m61rem{border-color:#585858}.pros-options-wrapper[pos--theme=light].svelte-m61rem.svelte-m61rem{background-color:#FFFFFF;color:#212121;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}.pros-options-wrapper[pos--theme=dark].svelte-m61rem.svelte-m61rem{background-color:#2b2b2b;color:white;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}";
	      append(document_1$3.head, style);
	    }
	    function get_each_context$4(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[72] = list[i];
	      return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_7$4(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "id", /*_labelId*/ctx[28]);
	          attr(div, "class", "pros-control-label svelte-m61rem");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[0] & /*_labelId*/268435456) {
	            attr(div, "id", /*_labelId*/ctx[28]);
	          }
	          if (dirty[0] & /*required*/16) {
	            toggle_class(div, "required", /*required*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (33:8) {#if _invalidColor}
	    function create_if_block_6$4(ctx) {
	      let div;
	      let svg;
	      let path;
	      let div_pros_tooltip_value;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M21.1748 18.5143L12.8743 3.57347C12.4933 2.88762 11.507 2.88762 11.126 3.57347L2.82553 18.5143C2.45523 19.1808 2.93716 20 3.69968 20H20.3006C21.0631 20 21.5451 19.1808 21.1748 18.5143ZM11.5 8.49998C11.5 8.22362 11.7237 7.99998 12 7.99998C12.2764 7.99998 12.5 8.22362 12.5 8.49998V12.5C12.5 12.7764 12.2764 13 12 13C11.7237 13 11.5 12.7764 11.5 12.5V8.49998ZM12 17C11.4478 17 11 16.5522 11 16C11 15.4477 11.4478 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5522 12.5523 17 12 17Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div, "id", /*_warningId*/ctx[35]);
	          attr(div, "class", "pros-action-button warning svelte-m61rem");
	          attr(div, "pros-tooltip", div_pros_tooltip_value = /*$_*/ctx[40]("invalidColor"));
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_warningId*/16) {
	            attr(div, "id", /*_warningId*/ctx[35]);
	          }
	          if (dirty[1] & /*$_*/512 && div_pros_tooltip_value !== (div_pros_tooltip_value = /*$_*/ctx[40]("invalidColor"))) {
	            attr(div, "pros-tooltip", div_pros_tooltip_value);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (41:8) {#if clear && _color && !disabled && _showOptions}
	    function create_if_block_5$6(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div, "id", /*_clearId*/ctx[30]);
	          attr(div, "class", "pros-action-button clear svelte-m61rem");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "click", /*handleClear*/ctx[13]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_clearId*/1073741824) {
	            attr(div, "id", /*_clearId*/ctx[30]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (48:8) {#if _showOptions}
	    function create_if_block_4$8(ctx) {
	      let div;
	      let svg;
	      let path;
	      let div_pros_tooltip_value;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M16 9C16 9.6 16.4 10 17 10H20C20.6 10 21 9.6 21 9V6C21 5.4 20.6 5 20 5C19.4 5 19 5.4 19 6V6.3C17.3 4.2 14.7 3 12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 11.4 20.6 11 20 11C19.4 11 19 11.4 19 12C19 15.9 15.9 19 12 19C8.1 19 5 15.9 5 12C5 8.1 8.1 5 12 5C14.2 5 16.3 6 17.6 7.8L17.8 8H17C16.4 8 16 8.4 16 9Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div, "id", /*_randomId*/ctx[31]);
	          attr(div, "class", "pros-action-button random svelte-m61rem");
	          attr(div, "pros-tooltip", div_pros_tooltip_value = /*$_*/ctx[40]("random"));
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "click", /*randomize*/ctx[14]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_randomId*/1) {
	            attr(div, "id", /*_randomId*/ctx[31]);
	          }
	          if (dirty[1] & /*$_*/512 && div_pros_tooltip_value !== (div_pros_tooltip_value = /*$_*/ctx[40]("random"))) {
	            attr(div, "pros-tooltip", div_pros_tooltip_value);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (62:6) {#if _showOptions && !disabled}
	    function create_if_block_3$9(ctx) {
	      let div2;
	      let div1;
	      let div0;
	      let globalClicks_action;
	      let positionOptions_action;
	      let mounted;
	      let dispose;
	      let each_value = /*_colorOptions*/ctx[41];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
	      }
	      return {
	        c() {
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          attr(div0, "class", "pros-color-palette svelte-m61rem");
	          attr(div1, "class", "pros-color-selector svelte-m61rem");
	          attr(div2, "class", "pros-options-wrapper svelte-m61rem");
	          attr(div2, "pos--theme", /*_theme*/ctx[23]);
	          attr(div2, "pos--shape", /*_shape*/ctx[24]);
	          attr(div2, "pos--density", /*_density*/ctx[25]);
	          toggle_class(div2, "open", /*_showOptions*/ctx[22]);
	        },
	        m(target, anchor) {
	          insert(target, div2, anchor);
	          append(div2, div1);
	          append(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          if (!mounted) {
	            dispose = [action_destroyer(globalClicks_action = /*globalClicks*/ctx[7].call(null, div2)), action_destroyer(positionOptions_action = /*positionOptions*/ctx[8].call(null, div2))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*getColorId, handleColorClicked*/32832 | dirty[1] & /*_colorOptions*/1024) {
	            each_value = /*_colorOptions*/ctx[41];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$4(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	              } else {
	                each_blocks[i] = create_each_block$4(child_ctx);
	                each_blocks[i].c();
	                each_blocks[i].m(div0, null);
	              }
	            }
	            for (; i < each_blocks.length; i += 1) {
	              each_blocks[i].d(1);
	            }
	            each_blocks.length = each_value.length;
	          }
	          if (dirty[0] & /*_theme*/8388608) {
	            attr(div2, "pos--theme", /*_theme*/ctx[23]);
	          }
	          if (dirty[0] & /*_shape*/16777216) {
	            attr(div2, "pos--shape", /*_shape*/ctx[24]);
	          }
	          if (dirty[0] & /*_density*/33554432) {
	            attr(div2, "pos--density", /*_density*/ctx[25]);
	          }
	          if (dirty[0] & /*_showOptions*/4194304) {
	            toggle_class(div2, "open", /*_showOptions*/ctx[22]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div2);
	          destroy_each(each_blocks, detaching);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (66:12) {#each _colorOptions as color}
	    function create_each_block$4(ctx) {
	      let div;
	      let mounted;
	      let dispose;
	      function click_handler(...args) {
	        return /*click_handler*/ctx[56](/*color*/ctx[72], ...args);
	      }
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*getColorId*/ctx[6]);
	          attr(div, "class", "pros-color clickable svelte-m61rem");
	          set_style(div, "background-color", /*color*/ctx[72]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if (!mounted) {
	            dispose = listen(div, "click", click_handler);
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (78:4) {#if display !== 'custom'}
	    function create_if_block$c(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[20] && /*_errors*/ctx[21].length > 0) return create_if_block_1$9;
	        if (/*hint*/ctx[2] && /*_showOptions*/ctx[22]) return create_if_block_2$9;
	        return create_else_block$a;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-m61rem");
	          toggle_class(div, "error", /*_dirty*/ctx[20] && /*_errors*/ctx[21].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/3145728) {
	            toggle_class(div, "error", /*_dirty*/ctx[20] && /*_errors*/ctx[21].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (94:6) {:else}
	    function create_else_block$a(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[33]);
	          attr(div, "class", "pros-message svelte-m61rem");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_messageId*/4) {
	            attr(div, "id", /*_messageId*/ctx[33]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (87:37) 
	    function create_if_block_2$9(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[2]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div0, "id", /*_statusIconId*/ctx[34]);
	          attr(div0, "class", "pros-status-icon svelte-m61rem");
	          attr(div1, "id", /*_messageId*/ctx[33]);
	          attr(div1, "class", "pros-message svelte-m61rem");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/8) {
	            attr(div0, "id", /*_statusIconId*/ctx[34]);
	          }
	          if (dirty[0] & /*hint*/4) set_data(t1, /*hint*/ctx[2]);
	          if (dirty[1] & /*_messageId*/4) {
	            attr(div1, "id", /*_messageId*/ctx[33]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (80:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$9(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[21][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div0, "id", /*_statusIconId*/ctx[34]);
	          attr(div0, "class", "pros-status-icon error svelte-m61rem");
	          attr(div1, "id", /*_messageId*/ctx[33]);
	          attr(div1, "class", "pros-message error svelte-m61rem");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/8) {
	            attr(div0, "id", /*_statusIconId*/ctx[34]);
	          }
	          if (dirty[0] & /*_errors*/2097152 && t1_value !== (t1_value = /*_errors*/ctx[21][0] + "")) set_data(t1, t1_value);
	          if (dirty[1] & /*_messageId*/4) {
	            attr(div1, "id", /*_messageId*/ctx[33]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$c(ctx) {
	      let div6;
	      let div5;
	      let t0;
	      let div4;
	      let div0;
	      let t1;
	      let div3;
	      let div1;
	      let input;
	      let t2;
	      let t3;
	      let t4;
	      let t5;
	      let div2;
	      let svg;
	      let path;
	      let t6;
	      let t7;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[39] && create_if_block_7$4(ctx);
	      let if_block1 = /*_invalidColor*/ctx[37] && create_if_block_6$4(ctx);
	      let if_block2 = /*clear*/ctx[3] && /*_color*/ctx[19] && ! /*disabled*/ctx[5] && /*_showOptions*/ctx[22] && create_if_block_5$6(ctx);
	      let if_block3 = /*_showOptions*/ctx[22] && create_if_block_4$8(ctx);
	      let if_block4 = /*_showOptions*/ctx[22] && ! /*disabled*/ctx[5] && create_if_block_3$9(ctx);
	      let if_block5 = /*display*/ctx[1] !== "custom" && create_if_block$c(ctx);
	      return {
	        c() {
	          div6 = element("div");
	          div5 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div4 = element("div");
	          div0 = element("div");
	          t1 = space();
	          div3 = element("div");
	          div1 = element("div");
	          input = element("input");
	          t2 = space();
	          if (if_block1) if_block1.c();
	          t3 = space();
	          if (if_block2) if_block2.c();
	          t4 = space();
	          if (if_block3) if_block3.c();
	          t5 = space();
	          div2 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t6 = space();
	          if (if_block4) if_block4.c();
	          t7 = space();
	          if (if_block5) if_block5.c();
	          attr(div0, "id", /*_indicatorId*/ctx[36]);
	          attr(div0, "class", "pros-color-indicator svelte-m61rem");
	          set_style(div0, "background-color", /*_color*/ctx[19]);
	          attr(input, "class", "pros-input svelte-m61rem");
	          attr(input, "id", /*_inputId*/ctx[29]);
	          attr(input, "spellcheck", false);
	          attr(input, "maxlength", "25");
	          input.disabled = /*disabled*/ctx[5];
	          attr(div1, "class", "pros-input-container svelte-m61rem");
	          attr(path, "d", "M12 22.0107C9.44186 22.0107 7.25387 20.8184 5.99703 18.7393C4.71969 16.6265 4.66061 14.0244 5.83932 11.7778C6.56832 10.3896 7.23385 9.21436 7.87692 8.07764C8.79537 6.45605 9.66256 4.92383 10.4746 3.16504C10.8071 2.43262 11.3632 2.01074 12 2.01074C12.6367 2.01074 13.1928 2.43262 13.5268 3.16797C14.3374 4.92383 15.2046 6.45605 16.123 8.07764C16.7661 9.21436 17.4316 10.3896 18.1606 11.7778C19.3393 14.0244 19.2802 16.6265 18.0029 18.7393C16.7461 20.8184 14.5581 22.0107 12 22.0107ZM12 3.01074C11.6777 3.01074 11.4619 3.40967 11.3842 3.58105C10.5532 5.38086 9.67574 6.93018 8.74752 8.57031C8.11666 9.68457 7.44723 10.8667 6.72506 12.2427C5.71041 14.1763 5.75826 16.4111 6.85299 18.2217C7.92428 19.9941 9.80074 21.0107 12 21.0107C14.1992 21.0107 16.0756 19.9941 17.1469 18.2217C18.2417 16.4111 18.2895 14.1763 17.2749 12.2427C16.5527 10.8667 15.8833 9.68457 15.2524 8.57031C14.3242 6.93018 13.4467 5.38086 12.6172 3.58398C12.538 3.40967 12.3222 3.01074 12 3.01074ZM12 22.0107C9.44186 22.0107 7.25387 20.8184 5.99703 18.7393C4.71969 16.6265 4.66061 14.0244 5.83932 11.7778C6.56832 10.3896 7.23385 9.21436 7.87692 8.07764C8.79537 6.45605 9.66256 4.92383 10.4746 3.16504C10.8071 2.43262 11.3632 2.01074 12 2.01074C12.6367 2.01074 13.1928 2.43262 13.5268 3.16797C14.3374 4.92383 15.2046 6.45605 16.123 8.07764C16.7661 9.21436 17.4316 10.3896 18.1606 11.7778C19.3393 14.0244 19.2802 16.6265 18.0029 18.7393C16.7461 20.8184 14.5581 22.0107 12 22.0107ZM12 3.01074C11.6777 3.01074 11.4619 3.40967 11.3842 3.58105C10.5532 5.38086 9.67574 6.93018 8.74752 8.57031C8.11666 9.68457 7.44723 10.8667 6.72506 12.2427C5.71041 14.1763 5.75826 16.4111 6.85299 18.2217C7.92428 19.9941 9.80074 21.0107 12 21.0107C14.1992 21.0107 16.0756 19.9941 17.1469 18.2217C18.2417 16.4111 18.2895 14.1763 17.2749 12.2427C16.5527 10.8667 15.8833 9.68457 15.2524 8.57031C14.3242 6.93018 13.4467 5.38086 12.6172 3.58398C12.538 3.40967 12.3222 3.01074 12 3.01074ZM13.1054 19.397C14.684 19.0571 15.5112 18.0283 15.8637 17.4453C16.2158 16.8633 16.4243 16.2236 16.4838 15.5435C16.5078 15.2686 16.3047 15.0259 16.0293 15.002C15.7617 14.9756 15.5122 15.1816 15.4878 15.4565C15.4414 15.9829 15.2802 16.478 15.0083 16.9277C14.6792 17.4717 14.0459 18.1714 12.8945 18.4194C12.625 18.4775 12.4531 18.7437 12.5112 19.0137C12.5615 19.248 12.769 19.4082 12.9995 19.4082C13.0341 19.4082 13.0698 19.4048 13.1054 19.397Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-m61rem");
	          attr(div2, "id", /*_capId*/ctx[32]);
	          attr(div2, "class", "pros-end-cap svelte-m61rem");
	          attr(div2, "disabled", /*disabled*/ctx[5]);
	          attr(div3, "class", "pros-content-container svelte-m61rem");
	          attr(div4, "class", "pros-highlight-container svelte-m61rem");
	          attr(div5, "class", "pros-control-container svelte-m61rem");
	          toggle_class(div5, "has-value", /*_hasValue*/ctx[38]);
	          toggle_class(div5, "has-label", /*_hasLabel*/ctx[39]);
	          toggle_class(div5, "has-focus", /*_showOptions*/ctx[22] || /*_hasFocus*/ctx[26]);
	          toggle_class(div5, "custom-layout", /*display*/ctx[1] === "custom");
	          toggle_class(div5, "error", /*_dirty*/ctx[20] && /*_errors*/ctx[21].length > 0);
	          toggle_class(div5, "disabled", /*disabled*/ctx[5]);
	          toggle_class(div5, "allow-hover", ! /*disabled*/ctx[5]);
	          attr(div6, "class", "pros-global-wrapper pros-form-control svelte-m61rem");
	          attr(div6, "pos--theme", /*_theme*/ctx[23]);
	          attr(div6, "pos--shape", /*_shape*/ctx[24]);
	          attr(div6, "pos--density", /*_density*/ctx[25]);
	        },
	        m(target, anchor) {
	          insert(target, div6, anchor);
	          append(div6, div5);
	          if (if_block0) if_block0.m(div5, null);
	          append(div5, t0);
	          append(div5, div4);
	          append(div4, div0);
	          append(div4, t1);
	          append(div4, div3);
	          append(div3, div1);
	          append(div1, input);
	          /*input_binding*/
	          ctx[54](input);
	          set_input_value(input, /*_color*/ctx[19]);
	          append(div3, t2);
	          if (if_block1) if_block1.m(div3, null);
	          append(div3, t3);
	          if (if_block2) if_block2.m(div3, null);
	          append(div3, t4);
	          if (if_block3) if_block3.m(div3, null);
	          append(div3, t5);
	          append(div3, div2);
	          append(div2, svg);
	          append(svg, path);
	          append(div4, t6);
	          if (if_block4) if_block4.m(div4, null);
	          append(div5, t7);
	          if (if_block5) if_block5.m(div5, null);
	          if (!mounted) {
	            dispose = [listen(input, "input", /*input_input_handler*/ctx[55]), listen(input, "keydown", preventEnterOrEsc), listen(input, "keyup", /*closeOnEnterOrEsc*/ctx[17]), listen(input, "input", /*handleColorTextChanged*/ctx[18]), listen(input, "focus", /*handleFocus*/ctx[11]), listen(input, "blur", /*handleBlur*/ctx[12]), listen(input, "click", /*swallowIfOpen*/ctx[9]), listen(div4, "click", /*toggleOpen*/ctx[10]), listen(div4, "keydown", /*closeOnEnterOrEsc*/ctx[17])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[39]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_7$4(ctx);
	              if_block0.c();
	              if_block0.m(div5, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[1] & /*_indicatorId*/32) {
	            attr(div0, "id", /*_indicatorId*/ctx[36]);
	          }
	          if (dirty[0] & /*_color*/524288) {
	            set_style(div0, "background-color", /*_color*/ctx[19]);
	          }
	          if (dirty[0] & /*_inputId*/536870912) {
	            attr(input, "id", /*_inputId*/ctx[29]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            input.disabled = /*disabled*/ctx[5];
	          }
	          if (dirty[0] & /*_color*/524288 && input.value !== /*_color*/ctx[19]) {
	            set_input_value(input, /*_color*/ctx[19]);
	          }
	          if (/*_invalidColor*/ctx[37]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_6$4(ctx);
	              if_block1.c();
	              if_block1.m(div3, t3);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (/*clear*/ctx[3] && /*_color*/ctx[19] && ! /*disabled*/ctx[5] && /*_showOptions*/ctx[22]) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block_5$6(ctx);
	              if_block2.c();
	              if_block2.m(div3, t4);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (/*_showOptions*/ctx[22]) {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	            } else {
	              if_block3 = create_if_block_4$8(ctx);
	              if_block3.c();
	              if_block3.m(div3, t5);
	            }
	          } else if (if_block3) {
	            if_block3.d(1);
	            if_block3 = null;
	          }
	          if (dirty[1] & /*_capId*/2) {
	            attr(div2, "id", /*_capId*/ctx[32]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            attr(div2, "disabled", /*disabled*/ctx[5]);
	          }
	          if (/*_showOptions*/ctx[22] && ! /*disabled*/ctx[5]) {
	            if (if_block4) {
	              if_block4.p(ctx, dirty);
	            } else {
	              if_block4 = create_if_block_3$9(ctx);
	              if_block4.c();
	              if_block4.m(div4, null);
	            }
	          } else if (if_block4) {
	            if_block4.d(1);
	            if_block4 = null;
	          }
	          if (/*display*/ctx[1] !== "custom") {
	            if (if_block5) {
	              if_block5.p(ctx, dirty);
	            } else {
	              if_block5 = create_if_block$c(ctx);
	              if_block5.c();
	              if_block5.m(div5, null);
	            }
	          } else if (if_block5) {
	            if_block5.d(1);
	            if_block5 = null;
	          }
	          if (dirty[1] & /*_hasValue*/128) {
	            toggle_class(div5, "has-value", /*_hasValue*/ctx[38]);
	          }
	          if (dirty[1] & /*_hasLabel*/256) {
	            toggle_class(div5, "has-label", /*_hasLabel*/ctx[39]);
	          }
	          if (dirty[0] & /*_showOptions, _hasFocus*/71303168) {
	            toggle_class(div5, "has-focus", /*_showOptions*/ctx[22] || /*_hasFocus*/ctx[26]);
	          }
	          if (dirty[0] & /*display*/2) {
	            toggle_class(div5, "custom-layout", /*display*/ctx[1] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/3145728) {
	            toggle_class(div5, "error", /*_dirty*/ctx[20] && /*_errors*/ctx[21].length > 0);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div5, "disabled", /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div5, "allow-hover", ! /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*_theme*/8388608) {
	            attr(div6, "pos--theme", /*_theme*/ctx[23]);
	          }
	          if (dirty[0] & /*_shape*/16777216) {
	            attr(div6, "pos--shape", /*_shape*/ctx[24]);
	          }
	          if (dirty[0] & /*_density*/33554432) {
	            attr(div6, "pos--density", /*_density*/ctx[25]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div6);
	          if (if_block0) if_block0.d();
	          /*input_binding*/
	          ctx[54](null);
	          if (if_block1) if_block1.d();
	          if (if_block2) if_block2.d();
	          if (if_block3) if_block3.d();
	          if (if_block4) if_block4.d();
	          if (if_block5) if_block5.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function preventEnterOrEsc(event) {
	      if (event.key === "Enter" || event.key === "Escape") {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	    }
	    function hasValue$a(test) {
	      return test !== undefined && test !== null;
	    }
	    function empty(test) {
	      if (!test) {
	        return true;
	      }
	      return test.trim() === "";
	    }
	    function notEmpty$8(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance$c($$self, $$props, $$invalidate) {
	      let _invalidColor;
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(40, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        globalKeyListener = null
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color Theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape Style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density Style (standard/high)
	      let {
	        value = undefined
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        clear = false
	      } = $$props; // Allow value to be cleared
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _showOptions = false; // Is Selector visible?
	      let _color = value;
	      let _openNode = undefined;
	      let _openParent = undefined;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _hasFocus = false;
	      let _colorOptions = ["#bc58eb", "#eb5ad2", "#eb5e5e", "#eb8d5b", "#f9c086", "#ffde6a", "#e4f148", "#ade855", "#67df6a", "#63e4d0", "#6dd0fb", "#5e57e8", "#dbdbdb", "#520000", "#b55500", "#e0b021", "#135b08", "#0c9f98"];
	      let _colorInput = null;
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _randomId = null;
	      let _capId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      let _warningId = null;
	      let _indicatorId = null;
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_showOptions) {
	          toggleOpen();
	        }
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(1, display = hasValue$a(display) ? display : "form");
	        $$invalidate(45, theme = hasValue$a(theme) ? theme : "light");
	        $$invalidate(46, shape = hasValue$a(shape) ? shape : "round");
	        $$invalidate(47, density = hasValue$a(density) ? density : "standard");
	        $$invalidate(0, label = hasValue$a(label) ? label : "");
	        $$invalidate(48, placeholder = hasValue$a(placeholder) ? placeholder : "");
	        $$invalidate(2, hint = hasValue$a(hint) ? hint : "");
	        $$invalidate(42, value = hasValue$a(value) ? value : undefined);
	        $$invalidate(4, required = hasValue$a(required) ? required : false);
	        $$invalidate(5, disabled = hasValue$a(disabled) ? disabled : false);
	        $$invalidate(49, validation = hasValue$a(validation) ? validation : true);
	        $$invalidate(3, clear = hasValue$a(clear) ? clear : false);
	        $$invalidate(28, _labelId = hasValue$a(id) ? `${id}-label` : undefined);
	        $$invalidate(29, _inputId = hasValue$a(id) ? `${id}-input` : undefined);
	        $$invalidate(30, _clearId = hasValue$a(id) ? `${id}-clear` : undefined);
	        $$invalidate(32, _capId = hasValue$a(id) ? `${id}-cap` : undefined);
	        $$invalidate(33, _messageId = hasValue$a(id) ? `${id}-message` : undefined);
	        $$invalidate(34, _statusIconId = hasValue$a(id) ? `${id}-status-icon` : undefined);
	        $$invalidate(31, _randomId = hasValue$a(id) ? `${id}-random` : undefined);
	        $$invalidate(35, _warningId = hasValue$a(id) ? `${id}-warning-icon` : undefined);
	        $$invalidate(36, _indicatorId = hasValue$a(id) ? `${id}-indicator` : undefined);
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(23, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(23, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(23, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(24, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(24, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(24, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(25, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(25, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(25, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function getColorId(color) {
	        return `${id}-${color}`;
	      }
	      function globalClicks(node) {
	        $$invalidate(43, globalClickListener = event => {
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (!containsClick) {
	            toggleOpen();
	          }
	        });
	        $$invalidate(44, globalKeyListener = event => {
	          myKeyDown.call(this, event);
	        });

	        // Necessary to prevent handling click that opens panel
	        window.setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	          document.addEventListener("keydown", globalKeyListener);
	        }, 0);
	      }
	      function positionOptions(node) {
	        _openNode = node;
	        _openParent = node.parentElement;
	        document.body.appendChild(node);
	        positionNode();
	        focusInput();
	        document.addEventListener("wheel", positionNode);
	        window.addEventListener("scroll", positionNode, true);
	        window.addEventListener("resize", positionNode);
	        return {
	          destroy() {
	            document.removeEventListener("wheel", positionNode);
	            window.removeEventListener("scroll", positionNode);
	            window.removeEventListener("resize", positionNode);
	          }
	        };
	      }
	      function positionNode(event) {
	        if (!_openParent) {
	          document.removeEventListener("wheel", positionNode);
	          window.removeEventListener("scroll", positionNode);
	          window.removeEventListener("resize", positionNode);
	          return;
	        }
	        if (event) {
	          let scrollTop = event.target.scrollTop;
	          let scrollBottom = scrollTop + event.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop || _openParent.offsetParent.offsetTop > scrollBottom) {
	            toggleOpen();
	            return;
	          }
	        }
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        _openNode.style.left = `${rect.right - _openNode.offsetWidth}px`;

	        // node.style.right = `${rect.right}px`;
	        _openNode.style.top = `${rect.bottom + 16}px`;
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          _openNode.style.top = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight}px` : `0`;
	        }
	      }
	      function focusInput() {
	        if (!_openNode) {
	          return;
	        }
	        if (_colorInput) {
	          _colorInput.select();
	          _colorInput.focus();
	        }
	      }
	      function swallowIfOpen(event) {
	        if (_showOptions) {
	          event.stopPropagation();
	        }
	      }
	      function toggleOpen(event) {
	        if (disabled) {
	          return;
	        }
	        $$invalidate(19, _color = value);
	        let opening = !_showOptions;

	        // Clean up if closing
	        if (!opening) {
	          // Re-parent options
	          _openParent.appendChild(_openNode);
	          _openNode = undefined;
	          _openParent = undefined;
	          if (globalClickListener) {
	            document.removeEventListener("click", globalClickListener);
	            $$invalidate(43, globalClickListener = null);
	          }
	          if (globalKeyListener) {
	            document.removeEventListener("keydown", globalKeyListener);
	            $$invalidate(44, globalKeyListener = null);
	          }
	          document.removeEventListener("wheel", positionNode);
	          window.removeEventListener("scroll", positionNode);
	          window.removeEventListener("resize", positionNode);
	          if (_colorInput) {
	            _colorInput.blur();
	          }
	        } else {
	          focusInput();
	        }
	        $$invalidate(22, _showOptions = opening);
	      }
	      function myKeyDown(event) {
	        switch (event.key) {
	          case "Enter":
	            event.stopPropagation();
	            if (_showOptions) {
	              // TODO: select potential selection (for now just toggle)
	              toggleOpen();
	            } else {
	              toggleOpen();
	            }
	            break;
	          case "Escape":
	            toggleOpen();
	            break;
	          case "ArrowDown":
	            if (_showOptions) ; else {
	              toggleOpen(); // TODO: move potential selection down 1 week (change month if applicable)
	            }
	            break;
	          case "ArrowUp":
	            if (_showOptions) {
	              // TODO: move potential selection up 1 week (change month if applicable)
	              // for now just toggle
	              toggleOpen();
	            }
	            break;
	        }
	      }
	      function handleFocus(event) {
	        $$invalidate(26, _hasFocus = true);
	      }
	      function handleBlur(event) {
	        $$invalidate(26, _hasFocus = false);
	      }
	      function handleClear(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        focusInput();
	        $$invalidate(19, _color = null);
	        $$invalidate(42, value = undefined);
	        valueChanged.call(this);
	      }
	      function randomize(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        $$invalidate(42, value = $$invalidate(19, _color = "#" + ("000000" + Math.floor(Math.random() * 16777215).toString(16)).slice(-6)));
	        valueChanged.call(this);
	      }
	      function handleColorClicked(color) {
	        $$invalidate(42, value = color);
	        toggleOpen();
	        valueChanged.call(this);
	      }
	      function closeOnEnterOrEsc(event) {
	        if (event.key === "Enter" || event.key === "Escape") {
	          event.stopPropagation();
	          event.preventDefault();
	          if (!_invalidColor) {
	            toggleOpen();
	          }
	        }
	      }
	      function handleColorTextChanged(event) {
	        if (validateColor(_color.trim())) {
	          $$invalidate(42, value = _color.trim());
	          valueChanged.call(this, value);
	        }
	      }
	      function valueChanged() {
	        $$invalidate(20, _dirty = true);
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(21, _errors = errors ? errors : []);
	        if (required) {
	          if (empty(value)) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (validation) {
	          $$invalidate(21, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (hasValue$a(value) && !valid && !_dirty) {
	              $$invalidate(20, _dirty = true);
	            }
	          }
	        });
	      }
	      function input_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _colorInput = $$value;
	          $$invalidate(27, _colorInput);
	        });
	      }
	      function input_input_handler() {
	        _color = this.value;
	        $$invalidate(19, _color);
	      }
	      const click_handler = (color, event) => handleColorClicked(color);
	      $$self.$$set = $$props => {
	        if ("globalClickListener" in $$props) $$invalidate(43, globalClickListener = $$props.globalClickListener);
	        if ("globalKeyListener" in $$props) $$invalidate(44, globalKeyListener = $$props.globalKeyListener);
	        if ("display" in $$props) $$invalidate(1, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(45, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(46, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(47, density = $$props.density);
	        if ("value" in $$props) $$invalidate(42, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(48, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(2, hint = $$props.hint);
	        if ("clear" in $$props) $$invalidate(3, clear = $$props.clear);
	        if ("required" in $$props) $$invalidate(4, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(49, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(50, errors = $$props.errors);
	        if ("id" in $$props) $$invalidate(51, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*_color*/524288 | $$self.$$.dirty[1] & /*value*/2048) {
	          // Computed values
	          $$invalidate(37, _invalidColor = _color && value !== _color);
	        }
	        if ($$self.$$.dirty[1] & /*value*/2048) {
	          $$invalidate(38, _hasValue = notEmpty$8(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          $$invalidate(39, _hasLabel = notEmpty$8(label));
	        }
	      };
	      return [label, display, hint, clear, required, disabled, getColorId, globalClicks, positionOptions, swallowIfOpen, toggleOpen, handleFocus, handleBlur, handleClear, randomize, handleColorClicked, preventEnterOrEsc, closeOnEnterOrEsc, handleColorTextChanged, _color, _dirty, _errors, _showOptions, _theme, _shape, _density, _hasFocus, _colorInput, _labelId, _inputId, _clearId, _randomId, _capId, _messageId, _statusIconId, _warningId, _indicatorId, _invalidColor, _hasValue, _hasLabel, $_, _colorOptions, value, globalClickListener, globalKeyListener, theme, shape, density, placeholder, validation, errors, id, focusInput, myKeyDown, input_binding, input_input_handler, click_handler];
	    }
	    class ColorPicker extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document_1$3.getElementById("svelte-m61rem-style")) add_css$b();
	        init(this, options, instance$c, create_fragment$c, safe_not_equal, {
	          globalClickListener: 43,
	          globalKeyListener: 44,
	          display: 1,
	          theme: 45,
	          shape: 46,
	          density: 47,
	          value: 42,
	          label: 0,
	          placeholder: 48,
	          hint: 2,
	          clear: 3,
	          required: 4,
	          disabled: 5,
	          validation: 49,
	          errors: 50,
	          id: 51,
	          getColorId: 6,
	          globalClicks: 7,
	          positionOptions: 8,
	          focusInput: 52,
	          swallowIfOpen: 9,
	          toggleOpen: 10,
	          myKeyDown: 53,
	          handleFocus: 11,
	          handleBlur: 12,
	          handleClear: 13,
	          randomize: 14,
	          handleColorClicked: 15,
	          preventEnterOrEsc: 16,
	          closeOnEnterOrEsc: 17,
	          handleColorTextChanged: 18
	        }, [-1, -1, -1]);
	      }
	      get getColorId() {
	        return this.$$.ctx[6];
	      }
	      get globalClicks() {
	        return this.$$.ctx[7];
	      }
	      get positionOptions() {
	        return this.$$.ctx[8];
	      }
	      get focusInput() {
	        return this.$$.ctx[52];
	      }
	      get swallowIfOpen() {
	        return this.$$.ctx[9];
	      }
	      get toggleOpen() {
	        return this.$$.ctx[10];
	      }
	      get myKeyDown() {
	        return this.$$.ctx[53];
	      }
	      get handleFocus() {
	        return this.$$.ctx[11];
	      }
	      get handleBlur() {
	        return this.$$.ctx[12];
	      }
	      get handleClear() {
	        return this.$$.ctx[13];
	      }
	      get randomize() {
	        return this.$$.ctx[14];
	      }
	      get handleColorClicked() {
	        return this.$$.ctx[15];
	      }
	      get preventEnterOrEsc() {
	        return preventEnterOrEsc;
	      }
	      get closeOnEnterOrEsc() {
	        return this.$$.ctx[17];
	      }
	      get handleColorTextChanged() {
	        return this.$$.ctx[18];
	      }
	    }

	    var MILLISECONDS_IN_MINUTE$3 = 60000;

	    /**
	     * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	     * They usually appear for dates that denote time before the timezones were introduced
	     * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	     * and GMT+01:00:00 after that date)
	     *
	     * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	     * which would lead to incorrect calculations.
	     *
	     * This function returns the timezone offset in milliseconds that takes seconds in account.
	     */
	    var getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds (dirtyDate) {
	      var date = new Date(dirtyDate.getTime());
	      var baseTimezoneOffset = date.getTimezoneOffset();
	      date.setSeconds(0, 0);
	      var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE$3;

	      return baseTimezoneOffset * MILLISECONDS_IN_MINUTE$3 + millisecondsPartOfTimezoneOffset
	    };

	    /**
	     * @category Common Helpers
	     * @summary Is the given argument an instance of Date?
	     *
	     * @description
	     * Is the given argument an instance of Date?
	     *
	     * @param {*} argument - the argument to check
	     * @returns {Boolean} the given argument is an instance of Date
	     *
	     * @example
	     * // Is 'mayonnaise' a Date?
	     * var result = isDate('mayonnaise')
	     * //=> false
	     */
	    function isDate (argument) {
	      return argument instanceof Date
	    }

	    var is_date = isDate;

	    var MILLISECONDS_IN_HOUR = 3600000;
	    var MILLISECONDS_IN_MINUTE$2 = 60000;
	    var DEFAULT_ADDITIONAL_DIGITS = 2;

	    var parseTokenDateTimeDelimeter = /[T ]/;
	    var parseTokenPlainTime = /:/;

	    // year tokens
	    var parseTokenYY = /^(\d{2})$/;
	    var parseTokensYYY = [
	      /^([+-]\d{2})$/, // 0 additional digits
	      /^([+-]\d{3})$/, // 1 additional digit
	      /^([+-]\d{4})$/ // 2 additional digits
	    ];

	    var parseTokenYYYY = /^(\d{4})/;
	    var parseTokensYYYYY = [
	      /^([+-]\d{4})/, // 0 additional digits
	      /^([+-]\d{5})/, // 1 additional digit
	      /^([+-]\d{6})/ // 2 additional digits
	    ];

	    // date tokens
	    var parseTokenMM = /^-(\d{2})$/;
	    var parseTokenDDD = /^-?(\d{3})$/;
	    var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
	    var parseTokenWww = /^-?W(\d{2})$/;
	    var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

	    // time tokens
	    var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
	    var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
	    var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

	    // timezone tokens
	    var parseTokenTimezone = /([Z+-].*)$/;
	    var parseTokenTimezoneZ = /^(Z)$/;
	    var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
	    var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

	    /**
	     * @category Common Helpers
	     * @summary Convert the given argument to an instance of Date.
	     *
	     * @description
	     * Convert the given argument to an instance of Date.
	     *
	     * If the argument is an instance of Date, the function returns its clone.
	     *
	     * If the argument is a number, it is treated as a timestamp.
	     *
	     * If an argument is a string, the function tries to parse it.
	     * Function accepts complete ISO 8601 formats as well as partial implementations.
	     * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	     *
	     * If all above fails, the function passes the given argument to Date constructor.
	     *
	     * @param {Date|String|Number} argument - the value to convert
	     * @param {Object} [options] - the object with options
	     * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	     * @returns {Date} the parsed date in the local time zone
	     *
	     * @example
	     * // Convert string '2014-02-11T11:30:30' to date:
	     * var result = parse('2014-02-11T11:30:30')
	     * //=> Tue Feb 11 2014 11:30:30
	     *
	     * @example
	     * // Parse string '+02014101',
	     * // if the additional number of digits in the extended year format is 1:
	     * var result = parse('+02014101', {additionalDigits: 1})
	     * //=> Fri Apr 11 2014 00:00:00
	     */
	    function parse (argument, dirtyOptions) {
	      if (is_date(argument)) {
	        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	        return new Date(argument.getTime())
	      } else if (typeof argument !== 'string') {
	        return new Date(argument)
	      }

	      var options = dirtyOptions || {};
	      var additionalDigits = options.additionalDigits;
	      if (additionalDigits == null) {
	        additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
	      } else {
	        additionalDigits = Number(additionalDigits);
	      }

	      var dateStrings = splitDateString(argument);

	      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	      var year = parseYearResult.year;
	      var restDateString = parseYearResult.restDateString;

	      var date = parseDate(restDateString, year);

	      if (date) {
	        var timestamp = date.getTime();
	        var time = 0;
	        var offset;

	        if (dateStrings.time) {
	          time = parseTime(dateStrings.time);
	        }

	        if (dateStrings.timezone) {
	          offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE$2;
	        } else {
	          var fullTime = timestamp + time;
	          var fullTimeDate = new Date(fullTime);

	          offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

	          // Adjust time when it's coming from DST
	          var fullTimeDateNextDay = new Date(fullTime);
	          fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
	          var offsetDiff =
	            getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
	            getTimezoneOffsetInMilliseconds(fullTimeDate);
	          if (offsetDiff > 0) {
	            offset += offsetDiff;
	          }
	        }

	        return new Date(timestamp + time + offset)
	      } else {
	        return new Date(argument)
	      }
	    }

	    function splitDateString (dateString) {
	      var dateStrings = {};
	      var array = dateString.split(parseTokenDateTimeDelimeter);
	      var timeString;

	      if (parseTokenPlainTime.test(array[0])) {
	        dateStrings.date = null;
	        timeString = array[0];
	      } else {
	        dateStrings.date = array[0];
	        timeString = array[1];
	      }

	      if (timeString) {
	        var token = parseTokenTimezone.exec(timeString);
	        if (token) {
	          dateStrings.time = timeString.replace(token[1], '');
	          dateStrings.timezone = token[1];
	        } else {
	          dateStrings.time = timeString;
	        }
	      }

	      return dateStrings
	    }

	    function parseYear (dateString, additionalDigits) {
	      var parseTokenYYY = parseTokensYYY[additionalDigits];
	      var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

	      var token;

	      // YYYY or ±YYYYY
	      token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
	      if (token) {
	        var yearString = token[1];
	        return {
	          year: parseInt(yearString, 10),
	          restDateString: dateString.slice(yearString.length)
	        }
	      }

	      // YY or ±YYY
	      token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
	      if (token) {
	        var centuryString = token[1];
	        return {
	          year: parseInt(centuryString, 10) * 100,
	          restDateString: dateString.slice(centuryString.length)
	        }
	      }

	      // Invalid ISO-formatted year
	      return {
	        year: null
	      }
	    }

	    function parseDate (dateString, year) {
	      // Invalid ISO-formatted year
	      if (year === null) {
	        return null
	      }

	      var token;
	      var date;
	      var month;
	      var week;

	      // YYYY
	      if (dateString.length === 0) {
	        date = new Date(0);
	        date.setUTCFullYear(year);
	        return date
	      }

	      // YYYY-MM
	      token = parseTokenMM.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        month = parseInt(token[1], 10) - 1;
	        date.setUTCFullYear(year, month);
	        return date
	      }

	      // YYYY-DDD or YYYYDDD
	      token = parseTokenDDD.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        var dayOfYear = parseInt(token[1], 10);
	        date.setUTCFullYear(year, 0, dayOfYear);
	        return date
	      }

	      // YYYY-MM-DD or YYYYMMDD
	      token = parseTokenMMDD.exec(dateString);
	      if (token) {
	        date = new Date(0);
	        month = parseInt(token[1], 10) - 1;
	        var day = parseInt(token[2], 10);
	        date.setUTCFullYear(year, month, day);
	        return date
	      }

	      // YYYY-Www or YYYYWww
	      token = parseTokenWww.exec(dateString);
	      if (token) {
	        week = parseInt(token[1], 10) - 1;
	        return dayOfISOYear(year, week)
	      }

	      // YYYY-Www-D or YYYYWwwD
	      token = parseTokenWwwD.exec(dateString);
	      if (token) {
	        week = parseInt(token[1], 10) - 1;
	        var dayOfWeek = parseInt(token[2], 10) - 1;
	        return dayOfISOYear(year, week, dayOfWeek)
	      }

	      // Invalid ISO-formatted date
	      return null
	    }

	    function parseTime (timeString) {
	      var token;
	      var hours;
	      var minutes;

	      // hh
	      token = parseTokenHH.exec(timeString);
	      if (token) {
	        hours = parseFloat(token[1].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR
	      }

	      // hh:mm or hhmm
	      token = parseTokenHHMM.exec(timeString);
	      if (token) {
	        hours = parseInt(token[1], 10);
	        minutes = parseFloat(token[2].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR +
	          minutes * MILLISECONDS_IN_MINUTE$2
	      }

	      // hh:mm:ss or hhmmss
	      token = parseTokenHHMMSS.exec(timeString);
	      if (token) {
	        hours = parseInt(token[1], 10);
	        minutes = parseInt(token[2], 10);
	        var seconds = parseFloat(token[3].replace(',', '.'));
	        return (hours % 24) * MILLISECONDS_IN_HOUR +
	          minutes * MILLISECONDS_IN_MINUTE$2 +
	          seconds * 1000
	      }

	      // Invalid ISO-formatted time
	      return null
	    }

	    function parseTimezone (timezoneString) {
	      var token;
	      var absoluteOffset;

	      // Z
	      token = parseTokenTimezoneZ.exec(timezoneString);
	      if (token) {
	        return 0
	      }

	      // ±hh
	      token = parseTokenTimezoneHH.exec(timezoneString);
	      if (token) {
	        absoluteOffset = parseInt(token[2], 10) * 60;
	        return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	      }

	      // ±hh:mm or ±hhmm
	      token = parseTokenTimezoneHHMM.exec(timezoneString);
	      if (token) {
	        absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	        return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	      }

	      return 0
	    }

	    function dayOfISOYear (isoYear, week, day) {
	      week = week || 0;
	      day = day || 0;
	      var date = new Date(0);
	      date.setUTCFullYear(isoYear, 0, 4);
	      var fourthOfJanuaryDay = date.getUTCDay() || 7;
	      var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	      date.setUTCDate(date.getUTCDate() + diff);
	      return date
	    }

	    var parse_1 = parse;

	    /**
	     * @category Year Helpers
	     * @summary Return the start of a year for the given date.
	     *
	     * @description
	     * Return the start of a year for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a year
	     *
	     * @example
	     * // The start of a year for 2 September 2014 11:55:00:
	     * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	     * //=> Wed Jan 01 2014 00:00:00
	     */
	    function startOfYear (dirtyDate) {
	      var cleanDate = parse_1(dirtyDate);
	      var date = new Date(0);
	      date.setFullYear(cleanDate.getFullYear(), 0, 1);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_year = startOfYear;

	    /**
	     * @category Day Helpers
	     * @summary Return the start of a day for the given date.
	     *
	     * @description
	     * Return the start of a day for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a day
	     *
	     * @example
	     * // The start of a day for 2 September 2014 11:55:00:
	     * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 02 2014 00:00:00
	     */
	    function startOfDay (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_day = startOfDay;

	    var MILLISECONDS_IN_MINUTE$1 = 60000;
	    var MILLISECONDS_IN_DAY = 86400000;

	    /**
	     * @category Day Helpers
	     * @summary Get the number of calendar days between the given dates.
	     *
	     * @description
	     * Get the number of calendar days between the given dates.
	     *
	     * @param {Date|String|Number} dateLeft - the later date
	     * @param {Date|String|Number} dateRight - the earlier date
	     * @returns {Number} the number of calendar days
	     *
	     * @example
	     * // How many calendar days are between
	     * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	     * var result = differenceInCalendarDays(
	     *   new Date(2012, 6, 2, 0, 0),
	     *   new Date(2011, 6, 2, 23, 0)
	     * )
	     * //=> 366
	     */
	    function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
	      var startOfDayLeft = start_of_day(dirtyDateLeft);
	      var startOfDayRight = start_of_day(dirtyDateRight);

	      var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;
	      var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a day is not constant
	      // (e.g. it's different in the day of the daylight saving time clock shift)
	      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
	    }

	    var difference_in_calendar_days = differenceInCalendarDays;

	    /**
	     * @category Day Helpers
	     * @summary Get the day of the year of the given date.
	     *
	     * @description
	     * Get the day of the year of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the day of year
	     *
	     * @example
	     * // Which day of the year is 2 July 2014?
	     * var result = getDayOfYear(new Date(2014, 6, 2))
	     * //=> 183
	     */
	    function getDayOfYear (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var diff = difference_in_calendar_days(date, start_of_year(date));
	      var dayOfYear = diff + 1;
	      return dayOfYear
	    }

	    var get_day_of_year = getDayOfYear;

	    /**
	     * @category Week Helpers
	     * @summary Return the start of a week for the given date.
	     *
	     * @description
	     * Return the start of a week for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @param {Object} [options] - the object with options
	     * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	     * @returns {Date} the start of a week
	     *
	     * @example
	     * // The start of a week for 2 September 2014 11:55:00:
	     * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Sun Aug 31 2014 00:00:00
	     *
	     * @example
	     * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	     * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfWeek (dirtyDate, dirtyOptions) {
	      var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

	      var date = parse_1(dirtyDate);
	      var day = date.getDay();
	      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

	      date.setDate(date.getDate() - diff);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_week = startOfWeek;

	    /**
	     * @category ISO Week Helpers
	     * @summary Return the start of an ISO week for the given date.
	     *
	     * @description
	     * Return the start of an ISO week for the given date.
	     * The result will be in the local timezone.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of an ISO week
	     *
	     * @example
	     * // The start of an ISO week for 2 September 2014 11:55:00:
	     * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfISOWeek (dirtyDate) {
	      return start_of_week(dirtyDate, {weekStartsOn: 1})
	    }

	    var start_of_iso_week = startOfISOWeek;

	    /**
	     * @category ISO Week-Numbering Year Helpers
	     * @summary Get the ISO week-numbering year of the given date.
	     *
	     * @description
	     * Get the ISO week-numbering year of the given date,
	     * which always starts 3 days before the year's first Thursday.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the ISO week-numbering year
	     *
	     * @example
	     * // Which ISO-week numbering year is 2 January 2005?
	     * var result = getISOYear(new Date(2005, 0, 2))
	     * //=> 2004
	     */
	    function getISOYear (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var year = date.getFullYear();

	      var fourthOfJanuaryOfNextYear = new Date(0);
	      fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	      fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	      var startOfNextYear = start_of_iso_week(fourthOfJanuaryOfNextYear);

	      var fourthOfJanuaryOfThisYear = new Date(0);
	      fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	      fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	      var startOfThisYear = start_of_iso_week(fourthOfJanuaryOfThisYear);

	      if (date.getTime() >= startOfNextYear.getTime()) {
	        return year + 1
	      } else if (date.getTime() >= startOfThisYear.getTime()) {
	        return year
	      } else {
	        return year - 1
	      }
	    }

	    var get_iso_year = getISOYear;

	    /**
	     * @category ISO Week-Numbering Year Helpers
	     * @summary Return the start of an ISO week-numbering year for the given date.
	     *
	     * @description
	     * Return the start of an ISO week-numbering year,
	     * which always starts 3 days before the year's first Thursday.
	     * The result will be in the local timezone.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of an ISO year
	     *
	     * @example
	     * // The start of an ISO week-numbering year for 2 July 2005:
	     * var result = startOfISOYear(new Date(2005, 6, 2))
	     * //=> Mon Jan 03 2005 00:00:00
	     */
	    function startOfISOYear (dirtyDate) {
	      var year = get_iso_year(dirtyDate);
	      var fourthOfJanuary = new Date(0);
	      fourthOfJanuary.setFullYear(year, 0, 4);
	      fourthOfJanuary.setHours(0, 0, 0, 0);
	      var date = start_of_iso_week(fourthOfJanuary);
	      return date
	    }

	    var start_of_iso_year = startOfISOYear;

	    var MILLISECONDS_IN_WEEK$1 = 604800000;

	    /**
	     * @category ISO Week Helpers
	     * @summary Get the ISO week of the given date.
	     *
	     * @description
	     * Get the ISO week of the given date.
	     *
	     * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the ISO week
	     *
	     * @example
	     * // Which week of the ISO-week numbering year is 2 January 2005?
	     * var result = getISOWeek(new Date(2005, 0, 2))
	     * //=> 53
	     */
	    function getISOWeek (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var diff = start_of_iso_week(date).getTime() - start_of_iso_year(date).getTime();

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a week is not constant
	      // (e.g. it's different in the week of the daylight saving time clock shift)
	      return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1
	    }

	    var get_iso_week = getISOWeek;

	    /**
	     * @category Common Helpers
	     * @summary Is the given date valid?
	     *
	     * @description
	     * Returns false if argument is Invalid Date and true otherwise.
	     * Invalid Date is a Date, whose time value is NaN.
	     *
	     * Time value of Date: http://es5.github.io/#x15.9.1.1
	     *
	     * @param {Date} date - the date to check
	     * @returns {Boolean} the date is valid
	     * @throws {TypeError} argument must be an instance of Date
	     *
	     * @example
	     * // For the valid date:
	     * var result = isValid(new Date(2014, 1, 31))
	     * //=> true
	     *
	     * @example
	     * // For the invalid date:
	     * var result = isValid(new Date(''))
	     * //=> false
	     */
	    function isValid (dirtyDate) {
	      if (is_date(dirtyDate)) {
	        return !isNaN(dirtyDate)
	      } else {
	        throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
	      }
	    }

	    var is_valid = isValid;

	    function buildDistanceInWordsLocale () {
	      var distanceInWordsLocale = {
	        lessThanXSeconds: {
	          one: 'less than a second',
	          other: 'less than {{count}} seconds'
	        },

	        xSeconds: {
	          one: '1 second',
	          other: '{{count}} seconds'
	        },

	        halfAMinute: 'half a minute',

	        lessThanXMinutes: {
	          one: 'less than a minute',
	          other: 'less than {{count}} minutes'
	        },

	        xMinutes: {
	          one: '1 minute',
	          other: '{{count}} minutes'
	        },

	        aboutXHours: {
	          one: 'about 1 hour',
	          other: 'about {{count}} hours'
	        },

	        xHours: {
	          one: '1 hour',
	          other: '{{count}} hours'
	        },

	        xDays: {
	          one: '1 day',
	          other: '{{count}} days'
	        },

	        aboutXMonths: {
	          one: 'about 1 month',
	          other: 'about {{count}} months'
	        },

	        xMonths: {
	          one: '1 month',
	          other: '{{count}} months'
	        },

	        aboutXYears: {
	          one: 'about 1 year',
	          other: 'about {{count}} years'
	        },

	        xYears: {
	          one: '1 year',
	          other: '{{count}} years'
	        },

	        overXYears: {
	          one: 'over 1 year',
	          other: 'over {{count}} years'
	        },

	        almostXYears: {
	          one: 'almost 1 year',
	          other: 'almost {{count}} years'
	        }
	      };

	      function localize (token, count, options) {
	        options = options || {};

	        var result;
	        if (typeof distanceInWordsLocale[token] === 'string') {
	          result = distanceInWordsLocale[token];
	        } else if (count === 1) {
	          result = distanceInWordsLocale[token].one;
	        } else {
	          result = distanceInWordsLocale[token].other.replace('{{count}}', count);
	        }

	        if (options.addSuffix) {
	          if (options.comparison > 0) {
	            return 'in ' + result
	          } else {
	            return result + ' ago'
	          }
	        }

	        return result
	      }

	      return {
	        localize: localize
	      }
	    }

	    var build_distance_in_words_locale = buildDistanceInWordsLocale;

	    var commonFormatterKeys = [
	      'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
	      'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
	      'H', 'HH', 'h', 'hh', 'm', 'mm',
	      's', 'ss', 'S', 'SS', 'SSS',
	      'Z', 'ZZ', 'X', 'x'
	    ];

	    function buildFormattingTokensRegExp (formatters) {
	      var formatterKeys = [];
	      for (var key in formatters) {
	        if (formatters.hasOwnProperty(key)) {
	          formatterKeys.push(key);
	        }
	      }

	      var formattingTokens = commonFormatterKeys
	        .concat(formatterKeys)
	        .sort()
	        .reverse();
	      var formattingTokensRegExp = new RegExp(
	        '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
	      );

	      return formattingTokensRegExp
	    }

	    var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;

	    function buildFormatLocale () {
	      // Note: in English, the names of days of the week and months are capitalized.
	      // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	      // Generally, formatted dates should look like they are in the middle of a sentence,
	      // e.g. in Spanish language the weekdays and months should be in the lowercase.
	      var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	      var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	      var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	      var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	      var meridiemUppercase = ['AM', 'PM'];
	      var meridiemLowercase = ['am', 'pm'];
	      var meridiemFull = ['a.m.', 'p.m.'];

	      var formatters = {
	        // Month: Jan, Feb, ..., Dec
	        'MMM': function (date) {
	          return months3char[date.getMonth()]
	        },

	        // Month: January, February, ..., December
	        'MMMM': function (date) {
	          return monthsFull[date.getMonth()]
	        },

	        // Day of week: Su, Mo, ..., Sa
	        'dd': function (date) {
	          return weekdays2char[date.getDay()]
	        },

	        // Day of week: Sun, Mon, ..., Sat
	        'ddd': function (date) {
	          return weekdays3char[date.getDay()]
	        },

	        // Day of week: Sunday, Monday, ..., Saturday
	        'dddd': function (date) {
	          return weekdaysFull[date.getDay()]
	        },

	        // AM, PM
	        'A': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
	        },

	        // am, pm
	        'a': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
	        },

	        // a.m., p.m.
	        'aa': function (date) {
	          return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
	        }
	      };

	      // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
	      var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
	      ordinalFormatters.forEach(function (formatterToken) {
	        formatters[formatterToken + 'o'] = function (date, formatters) {
	          return ordinal(formatters[formatterToken](date))
	        };
	      });

	      return {
	        formatters: formatters,
	        formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
	      }
	    }

	    function ordinal (number) {
	      var rem100 = number % 100;
	      if (rem100 > 20 || rem100 < 10) {
	        switch (rem100 % 10) {
	          case 1:
	            return number + 'st'
	          case 2:
	            return number + 'nd'
	          case 3:
	            return number + 'rd'
	        }
	      }
	      return number + 'th'
	    }

	    var build_format_locale = buildFormatLocale;

	    /**
	     * @category Locales
	     * @summary English locale.
	     */
	    var en = {
	      distanceInWords: build_distance_in_words_locale(),
	      format: build_format_locale()
	    };

	    /**
	     * @category Common Helpers
	     * @summary Format the date.
	     *
	     * @description
	     * Return the formatted date string in the given format.
	     *
	     * Accepted tokens:
	     * | Unit                    | Token | Result examples                  |
	     * |-------------------------|-------|----------------------------------|
	     * | Month                   | M     | 1, 2, ..., 12                    |
	     * |                         | Mo    | 1st, 2nd, ..., 12th              |
	     * |                         | MM    | 01, 02, ..., 12                  |
	     * |                         | MMM   | Jan, Feb, ..., Dec               |
	     * |                         | MMMM  | January, February, ..., December |
	     * | Quarter                 | Q     | 1, 2, 3, 4                       |
	     * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	     * | Day of month            | D     | 1, 2, ..., 31                    |
	     * |                         | Do    | 1st, 2nd, ..., 31st              |
	     * |                         | DD    | 01, 02, ..., 31                  |
	     * | Day of year             | DDD   | 1, 2, ..., 366                   |
	     * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	     * |                         | DDDD  | 001, 002, ..., 366               |
	     * | Day of week             | d     | 0, 1, ..., 6                     |
	     * |                         | do    | 0th, 1st, ..., 6th               |
	     * |                         | dd    | Su, Mo, ..., Sa                  |
	     * |                         | ddd   | Sun, Mon, ..., Sat               |
	     * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	     * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	     * | ISO week                | W     | 1, 2, ..., 53                    |
	     * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	     * |                         | WW    | 01, 02, ..., 53                  |
	     * | Year                    | YY    | 00, 01, ..., 99                  |
	     * |                         | YYYY  | 1900, 1901, ..., 2099            |
	     * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	     * |                         | GGGG  | 1900, 1901, ..., 2099            |
	     * | AM/PM                   | A     | AM, PM                           |
	     * |                         | a     | am, pm                           |
	     * |                         | aa    | a.m., p.m.                       |
	     * | Hour                    | H     | 0, 1, ... 23                     |
	     * |                         | HH    | 00, 01, ... 23                   |
	     * |                         | h     | 1, 2, ..., 12                    |
	     * |                         | hh    | 01, 02, ..., 12                  |
	     * | Minute                  | m     | 0, 1, ..., 59                    |
	     * |                         | mm    | 00, 01, ..., 59                  |
	     * | Second                  | s     | 0, 1, ..., 59                    |
	     * |                         | ss    | 00, 01, ..., 59                  |
	     * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	     * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	     * | Millisecond             | SSS   | 000, 001, ..., 999               |
	     * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	     * |                         | ZZ    | -0100, +0000, ..., +1200         |
	     * | Seconds timestamp       | X     | 512969520                        |
	     * | Milliseconds timestamp  | x     | 512969520900                     |
	     *
	     * The characters wrapped in square brackets are escaped.
	     *
	     * The result may vary by locale.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
	     * @param {Object} [options] - the object with options
	     * @param {Object} [options.locale=enLocale] - the locale object
	     * @returns {String} the formatted date string
	     *
	     * @example
	     * // Represent 11 February 2014 in middle-endian format:
	     * var result = format(
	     *   new Date(2014, 1, 11),
	     *   'MM/DD/YYYY'
	     * )
	     * //=> '02/11/2014'
	     *
	     * @example
	     * // Represent 2 July 2014 in Esperanto:
	     * var eoLocale = require('date-fns/locale/eo')
	     * var result = format(
	     *   new Date(2014, 6, 2),
	     *   'Do [de] MMMM YYYY',
	     *   {locale: eoLocale}
	     * )
	     * //=> '2-a de julio 2014'
	     */
	    function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	      var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
	      var options = dirtyOptions || {};

	      var locale = options.locale;
	      var localeFormatters = en.format.formatters;
	      var formattingTokensRegExp = en.format.formattingTokensRegExp;
	      if (locale && locale.format && locale.format.formatters) {
	        localeFormatters = locale.format.formatters;

	        if (locale.format.formattingTokensRegExp) {
	          formattingTokensRegExp = locale.format.formattingTokensRegExp;
	        }
	      }

	      var date = parse_1(dirtyDate);

	      if (!is_valid(date)) {
	        return 'Invalid Date'
	      }

	      var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

	      return formatFn(date)
	    }

	    var formatters = {
	      // Month: 1, 2, ..., 12
	      'M': function (date) {
	        return date.getMonth() + 1
	      },

	      // Month: 01, 02, ..., 12
	      'MM': function (date) {
	        return addLeadingZeros(date.getMonth() + 1, 2)
	      },

	      // Quarter: 1, 2, 3, 4
	      'Q': function (date) {
	        return Math.ceil((date.getMonth() + 1) / 3)
	      },

	      // Day of month: 1, 2, ..., 31
	      'D': function (date) {
	        return date.getDate()
	      },

	      // Day of month: 01, 02, ..., 31
	      'DD': function (date) {
	        return addLeadingZeros(date.getDate(), 2)
	      },

	      // Day of year: 1, 2, ..., 366
	      'DDD': function (date) {
	        return get_day_of_year(date)
	      },

	      // Day of year: 001, 002, ..., 366
	      'DDDD': function (date) {
	        return addLeadingZeros(get_day_of_year(date), 3)
	      },

	      // Day of week: 0, 1, ..., 6
	      'd': function (date) {
	        return date.getDay()
	      },

	      // Day of ISO week: 1, 2, ..., 7
	      'E': function (date) {
	        return date.getDay() || 7
	      },

	      // ISO week: 1, 2, ..., 53
	      'W': function (date) {
	        return get_iso_week(date)
	      },

	      // ISO week: 01, 02, ..., 53
	      'WW': function (date) {
	        return addLeadingZeros(get_iso_week(date), 2)
	      },

	      // Year: 00, 01, ..., 99
	      'YY': function (date) {
	        return addLeadingZeros(date.getFullYear(), 4).substr(2)
	      },

	      // Year: 1900, 1901, ..., 2099
	      'YYYY': function (date) {
	        return addLeadingZeros(date.getFullYear(), 4)
	      },

	      // ISO week-numbering year: 00, 01, ..., 99
	      'GG': function (date) {
	        return String(get_iso_year(date)).substr(2)
	      },

	      // ISO week-numbering year: 1900, 1901, ..., 2099
	      'GGGG': function (date) {
	        return get_iso_year(date)
	      },

	      // Hour: 0, 1, ... 23
	      'H': function (date) {
	        return date.getHours()
	      },

	      // Hour: 00, 01, ..., 23
	      'HH': function (date) {
	        return addLeadingZeros(date.getHours(), 2)
	      },

	      // Hour: 1, 2, ..., 12
	      'h': function (date) {
	        var hours = date.getHours();
	        if (hours === 0) {
	          return 12
	        } else if (hours > 12) {
	          return hours % 12
	        } else {
	          return hours
	        }
	      },

	      // Hour: 01, 02, ..., 12
	      'hh': function (date) {
	        return addLeadingZeros(formatters['h'](date), 2)
	      },

	      // Minute: 0, 1, ..., 59
	      'm': function (date) {
	        return date.getMinutes()
	      },

	      // Minute: 00, 01, ..., 59
	      'mm': function (date) {
	        return addLeadingZeros(date.getMinutes(), 2)
	      },

	      // Second: 0, 1, ..., 59
	      's': function (date) {
	        return date.getSeconds()
	      },

	      // Second: 00, 01, ..., 59
	      'ss': function (date) {
	        return addLeadingZeros(date.getSeconds(), 2)
	      },

	      // 1/10 of second: 0, 1, ..., 9
	      'S': function (date) {
	        return Math.floor(date.getMilliseconds() / 100)
	      },

	      // 1/100 of second: 00, 01, ..., 99
	      'SS': function (date) {
	        return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
	      },

	      // Millisecond: 000, 001, ..., 999
	      'SSS': function (date) {
	        return addLeadingZeros(date.getMilliseconds(), 3)
	      },

	      // Timezone: -01:00, +00:00, ... +12:00
	      'Z': function (date) {
	        return formatTimezone(date.getTimezoneOffset(), ':')
	      },

	      // Timezone: -0100, +0000, ... +1200
	      'ZZ': function (date) {
	        return formatTimezone(date.getTimezoneOffset())
	      },

	      // Seconds timestamp: 512969520
	      'X': function (date) {
	        return Math.floor(date.getTime() / 1000)
	      },

	      // Milliseconds timestamp: 512969520900
	      'x': function (date) {
	        return date.getTime()
	      }
	    };

	    function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
	      var array = formatStr.match(formattingTokensRegExp);
	      var length = array.length;

	      var i;
	      var formatter;
	      for (i = 0; i < length; i++) {
	        formatter = localeFormatters[array[i]] || formatters[array[i]];
	        if (formatter) {
	          array[i] = formatter;
	        } else {
	          array[i] = removeFormattingTokens(array[i]);
	        }
	      }

	      return function (date) {
	        var output = '';
	        for (var i = 0; i < length; i++) {
	          if (array[i] instanceof Function) {
	            output += array[i](date, formatters);
	          } else {
	            output += array[i];
	          }
	        }
	        return output
	      }
	    }

	    function removeFormattingTokens (input) {
	      if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|]$/g, '')
	      }
	      return input.replace(/\\/g, '')
	    }

	    function formatTimezone (offset, delimeter) {
	      delimeter = delimeter || '';
	      var sign = offset > 0 ? '-' : '+';
	      var absOffset = Math.abs(offset);
	      var hours = Math.floor(absOffset / 60);
	      var minutes = absOffset % 60;
	      return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	    }

	    function addLeadingZeros (number, targetLength) {
	      var output = Math.abs(number).toString();
	      while (output.length < targetLength) {
	        output = '0' + output;
	      }
	      return output
	    }

	    var format_1 = format;

	    /**
	     * @category Day Helpers
	     * @summary Return the array of dates within the specified range.
	     *
	     * @description
	     * Return the array of dates within the specified range.
	     *
	     * @param {Date|String|Number} startDate - the first date
	     * @param {Date|String|Number} endDate - the last date
	     * @param {Number} [step=1] - the step between each day
	     * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
	     * @throws {Error} startDate cannot be after endDate
	     *
	     * @example
	     * // Each day between 6 October 2014 and 10 October 2014:
	     * var result = eachDay(
	     *   new Date(2014, 9, 6),
	     *   new Date(2014, 9, 10)
	     * )
	     * //=> [
	     * //   Mon Oct 06 2014 00:00:00,
	     * //   Tue Oct 07 2014 00:00:00,
	     * //   Wed Oct 08 2014 00:00:00,
	     * //   Thu Oct 09 2014 00:00:00,
	     * //   Fri Oct 10 2014 00:00:00
	     * // ]
	     */
	    function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
	      var startDate = parse_1(dirtyStartDate);
	      var endDate = parse_1(dirtyEndDate);
	      var step = dirtyStep !== undefined ? dirtyStep : 1;

	      var endTime = endDate.getTime();

	      if (startDate.getTime() > endTime) {
	        throw new Error('The first date cannot be after the second date')
	      }

	      var dates = [];

	      var currentDate = startDate;
	      currentDate.setHours(0, 0, 0, 0);

	      while (currentDate.getTime() <= endTime) {
	        dates.push(parse_1(currentDate));
	        currentDate.setDate(currentDate.getDate() + step);
	      }

	      return dates
	    }

	    var each_day = eachDay;

	    /**
	     * @category Month Helpers
	     * @summary Return the start of a month for the given date.
	     *
	     * @description
	     * Return the start of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the start of a month
	     *
	     * @example
	     * // The start of a month for 2 September 2014 11:55:00:
	     * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function startOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      date.setDate(1);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var start_of_month = startOfMonth;

	    /**
	     * @category Month Helpers
	     * @summary Return the end of a month for the given date.
	     *
	     * @description
	     * Return the end of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the end of a month
	     *
	     * @example
	     * // The end of a month for 2 September 2014 11:55:00:
	     * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 30 2014 23:59:59.999
	     */
	    function endOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var month = date.getMonth();
	      date.setFullYear(date.getFullYear(), month + 1, 0);
	      date.setHours(23, 59, 59, 999);
	      return date
	    }

	    var end_of_month = endOfMonth;

	    /**
	     * @category Month Helpers
	     * @summary Return the last day of a month for the given date.
	     *
	     * @description
	     * Return the last day of a month for the given date.
	     * The result will be in the local timezone.
	     *
	     * @param {Date|String|Number} date - the original date
	     * @returns {Date} the last day of a month
	     *
	     * @example
	     * // The last day of a month for 2 September 2014 11:55:00:
	     * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	     * //=> Tue Sep 30 2014 00:00:00
	     */
	    function lastDayOfMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var month = date.getMonth();
	      date.setFullYear(date.getFullYear(), month + 1, 0);
	      date.setHours(0, 0, 0, 0);
	      return date
	    }

	    var last_day_of_month = lastDayOfMonth;

	    /**
	     * @category Weekday Helpers
	     * @summary Get the day of the week of the given date.
	     *
	     * @description
	     * Get the day of the week of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the day of week
	     *
	     * @example
	     * // Which day of the week is 29 February 2012?
	     * var result = getDay(new Date(2012, 1, 29))
	     * //=> 3
	     */
	    function getDay (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var day = date.getDay();
	      return day
	    }

	    var get_day = getDay;

	    var MILLISECONDS_IN_MINUTE = 60000;
	    var MILLISECONDS_IN_WEEK = 604800000;

	    /**
	     * @category Week Helpers
	     * @summary Get the number of calendar weeks between the given dates.
	     *
	     * @description
	     * Get the number of calendar weeks between the given dates.
	     *
	     * @param {Date|String|Number} dateLeft - the later date
	     * @param {Date|String|Number} dateRight - the earlier date
	     * @param {Object} [options] - the object with options
	     * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	     * @returns {Number} the number of calendar weeks
	     *
	     * @example
	     * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	     * var result = differenceInCalendarWeeks(
	     *   new Date(2014, 6, 20),
	     *   new Date(2014, 6, 5)
	     * )
	     * //=> 3
	     *
	     * @example
	     * // If the week starts on Monday,
	     * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	     * var result = differenceInCalendarWeeks(
	     *   new Date(2014, 6, 20),
	     *   new Date(2014, 6, 5),
	     *   {weekStartsOn: 1}
	     * )
	     * //=> 2
	     */
	    function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	      var startOfWeekLeft = start_of_week(dirtyDateLeft, dirtyOptions);
	      var startOfWeekRight = start_of_week(dirtyDateRight, dirtyOptions);

	      var timestampLeft = startOfWeekLeft.getTime() -
	        startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	      var timestampRight = startOfWeekRight.getTime() -
	        startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;

	      // Round the number of days to the nearest integer
	      // because the number of milliseconds in a week is not constant
	      // (e.g. it's different in the week of the daylight saving time clock shift)
	      return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	    }

	    var difference_in_calendar_weeks = differenceInCalendarWeeks;

	    /**
	     * @category Day Helpers
	     * @summary Is the given date today?
	     *
	     * @description
	     * Is the given date today?
	     *
	     * @param {Date|String|Number} date - the date to check
	     * @returns {Boolean} the date is today
	     *
	     * @example
	     * // If today is 6 October 2014, is 6 October 14:00:00 today?
	     * var result = isToday(new Date(2014, 9, 6, 14, 0))
	     * //=> true
	     */
	    function isToday (dirtyDate) {
	      return start_of_day(dirtyDate).getTime() === start_of_day(new Date()).getTime()
	    }

	    var is_today = isToday;

	    /**
	     * @category Day Helpers
	     * @summary Are the given dates in the same day?
	     *
	     * @description
	     * Are the given dates in the same day?
	     *
	     * @param {Date|String|Number} dateLeft - the first date to check
	     * @param {Date|String|Number} dateRight - the second date to check
	     * @returns {Boolean} the dates are in the same day
	     *
	     * @example
	     * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	     * var result = isSameDay(
	     *   new Date(2014, 8, 4, 6, 0),
	     *   new Date(2014, 8, 4, 18, 0)
	     * )
	     * //=> true
	     */
	    function isSameDay (dirtyDateLeft, dirtyDateRight) {
	      var dateLeftStartOfDay = start_of_day(dirtyDateLeft);
	      var dateRightStartOfDay = start_of_day(dirtyDateRight);

	      return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
	    }

	    var is_same_day = isSameDay;

	    /**
	     * @category Common Helpers
	     * @summary Is the first date before the second one?
	     *
	     * @description
	     * Is the first date before the second one?
	     *
	     * @param {Date|String|Number} date - the date that should be before the other one to return true
	     * @param {Date|String|Number} dateToCompare - the date to compare with
	     * @returns {Boolean} the first date is before the second date
	     *
	     * @example
	     * // Is 10 July 1989 before 11 February 1987?
	     * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	     * //=> false
	     */
	    function isBefore (dirtyDate, dirtyDateToCompare) {
	      var date = parse_1(dirtyDate);
	      var dateToCompare = parse_1(dirtyDateToCompare);
	      return date.getTime() < dateToCompare.getTime()
	    }

	    var is_before = isBefore;

	    /**
	     * @category Common Helpers
	     * @summary Is the first date after the second one?
	     *
	     * @description
	     * Is the first date after the second one?
	     *
	     * @param {Date|String|Number} date - the date that should be after the other one to return true
	     * @param {Date|String|Number} dateToCompare - the date to compare with
	     * @returns {Boolean} the first date is after the second date
	     *
	     * @example
	     * // Is 10 July 1989 after 11 February 1987?
	     * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	     * //=> true
	     */
	    function isAfter (dirtyDate, dirtyDateToCompare) {
	      var date = parse_1(dirtyDate);
	      var dateToCompare = parse_1(dirtyDateToCompare);
	      return date.getTime() > dateToCompare.getTime()
	    }

	    var is_after = isAfter;

	    /**
	     * @category Day Helpers
	     * @summary Add the specified number of days to the given date.
	     *
	     * @description
	     * Add the specified number of days to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of days to be added
	     * @returns {Date} the new date with the days added
	     *
	     * @example
	     * // Add 10 days to 1 September 2014:
	     * var result = addDays(new Date(2014, 8, 1), 10)
	     * //=> Thu Sep 11 2014 00:00:00
	     */
	    function addDays (dirtyDate, dirtyAmount) {
	      var date = parse_1(dirtyDate);
	      var amount = Number(dirtyAmount);
	      date.setDate(date.getDate() + amount);
	      return date
	    }

	    var add_days = addDays;

	    /**
	     * @category Day Helpers
	     * @summary Subtract the specified number of days from the given date.
	     *
	     * @description
	     * Subtract the specified number of days from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of days to be subtracted
	     * @returns {Date} the new date with the days subtracted
	     *
	     * @example
	     * // Subtract 10 days from 1 September 2014:
	     * var result = subDays(new Date(2014, 8, 1), 10)
	     * //=> Fri Aug 22 2014 00:00:00
	     */
	    function subDays (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_days(dirtyDate, -amount)
	    }

	    var sub_days = subDays;

	    /**
	     * @category Month Helpers
	     * @summary Get the number of days in a month of the given date.
	     *
	     * @description
	     * Get the number of days in a month of the given date.
	     *
	     * @param {Date|String|Number} date - the given date
	     * @returns {Number} the number of days in a month
	     *
	     * @example
	     * // How many days are in February 2000?
	     * var result = getDaysInMonth(new Date(2000, 1))
	     * //=> 29
	     */
	    function getDaysInMonth (dirtyDate) {
	      var date = parse_1(dirtyDate);
	      var year = date.getFullYear();
	      var monthIndex = date.getMonth();
	      var lastDayOfMonth = new Date(0);
	      lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	      lastDayOfMonth.setHours(0, 0, 0, 0);
	      return lastDayOfMonth.getDate()
	    }

	    var get_days_in_month = getDaysInMonth;

	    /**
	     * @category Month Helpers
	     * @summary Add the specified number of months to the given date.
	     *
	     * @description
	     * Add the specified number of months to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of months to be added
	     * @returns {Date} the new date with the months added
	     *
	     * @example
	     * // Add 5 months to 1 September 2014:
	     * var result = addMonths(new Date(2014, 8, 1), 5)
	     * //=> Sun Feb 01 2015 00:00:00
	     */
	    function addMonths (dirtyDate, dirtyAmount) {
	      var date = parse_1(dirtyDate);
	      var amount = Number(dirtyAmount);
	      var desiredMonth = date.getMonth() + amount;
	      var dateWithDesiredMonth = new Date(0);
	      dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	      dateWithDesiredMonth.setHours(0, 0, 0, 0);
	      var daysInMonth = get_days_in_month(dateWithDesiredMonth);
	      // Set the last day of the new month
	      // if the original date was the last day of the longer month
	      date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	      return date
	    }

	    var add_months = addMonths;

	    /**
	     * @category Year Helpers
	     * @summary Add the specified number of years to the given date.
	     *
	     * @description
	     * Add the specified number of years to the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of years to be added
	     * @returns {Date} the new date with the years added
	     *
	     * @example
	     * // Add 5 years to 1 September 2014:
	     * var result = addYears(new Date(2014, 8, 1), 5)
	     * //=> Sun Sep 01 2019 00:00:00
	     */
	    function addYears (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_months(dirtyDate, amount * 12)
	    }

	    var add_years = addYears;

	    /**
	     * @category Year Helpers
	     * @summary Subtract the specified number of years from the given date.
	     *
	     * @description
	     * Subtract the specified number of years from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of years to be subtracted
	     * @returns {Date} the new date with the years subtracted
	     *
	     * @example
	     * // Subtract 5 years from 1 September 2014:
	     * var result = subYears(new Date(2014, 8, 1), 5)
	     * //=> Tue Sep 01 2009 00:00:00
	     */
	    function subYears (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_years(dirtyDate, -amount)
	    }

	    var sub_years = subYears;

	    /**
	     * @category Month Helpers
	     * @summary Subtract the specified number of months from the given date.
	     *
	     * @description
	     * Subtract the specified number of months from the given date.
	     *
	     * @param {Date|String|Number} date - the date to be changed
	     * @param {Number} amount - the amount of months to be subtracted
	     * @returns {Date} the new date with the months subtracted
	     *
	     * @example
	     * // Subtract 5 months from 1 February 2015:
	     * var result = subMonths(new Date(2015, 1, 1), 5)
	     * //=> Mon Sep 01 2014 00:00:00
	     */
	    function subMonths (dirtyDate, dirtyAmount) {
	      var amount = Number(dirtyAmount);
	      return add_months(dirtyDate, -amount)
	    }

	    var sub_months = subMonths;

	    /* src/DatePicker.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1$2
	    } = globals;
	    function add_css$a() {
	      var style = element("style");
	      style.id = "svelte-1ktvy4d-style";
	      style.textContent = ".pros-highlight-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{padding-top:18px}.pros-control-container.has-label.svelte-1ktvy4d input.svelte-1ktvy4d::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1ktvy4d.svelte-1ktvy4d{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1ktvy4d.svelte-1ktvy4d::after{content:\" *\"}.pros-action-button.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1ktvy4d svg.svelte-1ktvy4d{width:24px;height:24px}.pros-action-button.svelte-1ktvy4d.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-1ktvy4d svg.svelte-1ktvy4d{width:auto;height:auto}.pros-control-container.svelte-1ktvy4d.svelte-1ktvy4d{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1ktvy4d .pros-control-label.svelte-1ktvy4d,.pros-control-container.has-focus.svelte-1ktvy4d .pros-control-label.svelte-1ktvy4d{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{cursor:default}.pros-control-container.has-focus.svelte-1ktvy4d .pros-input.svelte-1ktvy4d{cursor:text}.pros-control-container.has-focus.svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{border-width:2px}.pros-control-container.has-focus.svelte-1ktvy4d .pros-input-container.svelte-1ktvy4d{margin-left:11px}.pros-control-container.has-focus.svelte-1ktvy4d .pros-end-cap.svelte-1ktvy4d:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1ktvy4d input.svelte-1ktvy4d::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1ktvy4d .pros-status-icon.svelte-1ktvy4d{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1ktvy4d .pros-status-icon svg.svelte-1ktvy4d{height:100%;width:100%}.pros-message-container.svelte-1ktvy4d .pros-message.svelte-1ktvy4d{flex:1}.pros-options-wrapper.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;position:fixed;z-index:1001;box-sizing:border-box;border-radius:12px;border-width:1px;border-style:solid}.pros-date-container.svelte-1ktvy4d.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.pros-date-container.svelte-1ktvy4d .pros-month-container.svelte-1ktvy4d{display:flex;justify-content:flex-start;align-items:center;width:100%;padding:8px}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;width:36px;min-width:36px;height:36px;cursor:pointer;margin:0 4px}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.first.svelte-1ktvy4d{margin-left:0}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector.last.svelte-1ktvy4d{margin-right:0}.pros-date-container.svelte-1ktvy4d .pros-month-container .pros-month-selector svg.svelte-1ktvy4d{width:24px;height:24px}.pros-date-container.svelte-1ktvy4d .pros-current-month.svelte-1ktvy4d{flex:1;text-align:center;font-size:16px;font-weight:400;line-height:20px;user-select:none;margin:0 16px;min-width:130px}.pros-date-container.svelte-1ktvy4d .pros-footer.svelte-1ktvy4d{width:100%;padding:8px 0;position:relative}.pros-date-container.svelte-1ktvy4d .pros-footer .pros-button.svelte-1ktvy4d{width:100%}.pros-date-container.svelte-1ktvy4d .pros-calendar-content.svelte-1ktvy4d{width:100%;padding:0 16px}.pros-date-container.svelte-1ktvy4d .pros-calendar.svelte-1ktvy4d{flex:1}.pros-date-container.svelte-1ktvy4d .pros-calendar .week.svelte-1ktvy4d,.pros-date-container.svelte-1ktvy4d .pros-calendar .header.svelte-1ktvy4d{display:grid;grid-template-columns:repeat(7, 1fr);grid-auto-flow:dense;grid-gap:0 0}.pros-date-container.svelte-1ktvy4d .pros-calendar .day.svelte-1ktvy4d{display:contents}.pros-date-container.svelte-1ktvy4d .pros-calendar .week-day.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;font-size:12px;font-weight:300;line-height:24px;user-select:none}.pros-date-container.svelte-1ktvy4d .pros-calendar .day-label.svelte-1ktvy4d{display:flex;flex-direction:column;justify-content:center;align-items:center;grid-row-start:5;cursor:pointer;border:1px solid transparent;border-radius:8px;height:32px;width:100%;line-height:24px;box-sizing:border-box;margin:2px;font-size:16px;font-weight:400;user-select:none}.pros-date-container.svelte-1ktvy4d .pros-calendar .day-label.disabled.svelte-1ktvy4d{cursor:default}.pros-global-wrapper[pos--shape=sharp].svelte-1ktvy4d .pros-highlight-container.svelte-1ktvy4d{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-control-label.svelte-1ktvy4d{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{height:36px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1ktvy4d{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container .pros-input-container .pros-input.svelte-1ktvy4d{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-label .pros-input.svelte-1ktvy4d{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-value .pros-control-label.svelte-1ktvy4d,.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-control-label.svelte-1ktvy4d{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1ktvy4d{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1ktvy4d .pros-control-container.has-focus .pros-input-container.svelte-1ktvy4d{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-input.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container input.svelte-1ktvy4d::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.allow-hover .pros-highlight-container.svelte-1ktvy4d:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.error .pros-highlight-container.svelte-1ktvy4d{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.svelte-1ktvy4d{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-end-cap.svelte-1ktvy4d{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.svelte-1ktvy4d{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container .pros-status-icon.svelte-1ktvy4d{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.error.svelte-1ktvy4d{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1ktvy4d{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled.svelte-1ktvy4d{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-highlight-container.svelte-1ktvy4d{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-input.svelte-1ktvy4d{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-message-container.svelte-1ktvy4d{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-control-container.disabled .pros-end-cap.svelte-1ktvy4d{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1ktvy4d .pros-action-button.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-highlight-container.svelte-1ktvy4d{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-input.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container input.svelte-1ktvy4d::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.allow-hover .pros-highlight-container.svelte-1ktvy4d:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.error .pros-highlight-container.svelte-1ktvy4d{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.has-focus .pros-highlight-container.svelte-1ktvy4d{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.svelte-1ktvy4d{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container .pros-status-icon.svelte-1ktvy4d{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.error.svelte-1ktvy4d{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1ktvy4d{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled.svelte-1ktvy4d{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-highlight-container.svelte-1ktvy4d{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-input.svelte-1ktvy4d{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-control-container.disabled .pros-message-container.svelte-1ktvy4d{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-action-button.svelte-1ktvy4d:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d.svelte-1ktvy4d{background-color:#FFFFFF;color:#212121;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d{color:#212121}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.potential.svelte-1ktvy4d{background-color:#f1f1f1;border-color:#f1f1f1}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.today.svelte-1ktvy4d{border-color:#adadad}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.selected.svelte-1ktvy4d{background-color:#027aae;border-color:#027aae;color:#FFFFFF}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d:hover{background-color:#f1f1f1;border-color:#f1f1f1}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label:hover.selected.svelte-1ktvy4d{background-color:#035b84;border-color:#035b84}.pros-options-wrapper[pos--theme=light].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.disabled.svelte-1ktvy4d{color:#adadad;border-color:transparent;background-color:#FFFFFF}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d.svelte-1ktvy4d{background-color:#2b2b2b;color:white;border-color:transparent;box-shadow:0 0 3px 0 rgba(33, 33, 33, 0.15)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .week-day.svelte-1ktvy4d{color:#adadad}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d{color:white}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.potential.svelte-1ktvy4d{background-color:rgba(255, 255, 255, 0.05);border-color:rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.today.svelte-1ktvy4d{border-color:#585858}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.selected.svelte-1ktvy4d{background-color:#3ab4eb;border-color:#3ab4eb;color:#212121}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.svelte-1ktvy4d:hover{background-color:rgba(255, 255, 255, 0.05);border-color:rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label:hover.selected.svelte-1ktvy4d{background-color:#6dd0fb;border-color:#6dd0fb}.pros-options-wrapper[pos--theme=dark].svelte-1ktvy4d .pros-date-container .pros-calendar .day-label.disabled.svelte-1ktvy4d{color:#585858;border-color:transparent;background-color:#2b2b2b}";
	      append(document_1$2.head, style);
	    }
	    function get_each_context$3(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[96] = list[i];
	      return child_ctx;
	    }
	    function get_each_context_1(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[99] = list[i];
	      return child_ctx;
	    }
	    function get_each_context_2(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[102] = list[i];
	      return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_5$5(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "id", /*_labelId*/ctx[21]);
	          attr(div, "class", "pros-control-label svelte-1ktvy4d");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[5]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[0] & /*_labelId*/2097152) {
	            attr(div, "id", /*_labelId*/ctx[21]);
	          }
	          if (dirty[0] & /*required*/32) {
	            toggle_class(div, "required", /*required*/ctx[5]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (28:8) {#if clear && (_hasValue || _untrimmedValue) && !disabled}
	    function create_if_block_4$7(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1ktvy4d");
	          attr(div, "id", /*_clearId*/ctx[23]);
	          attr(div, "class", "pros-action-button svelte-1ktvy4d");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "mousedown", /*handleClear*/ctx[49]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_clearId*/8388608) {
	            attr(div, "id", /*_clearId*/ctx[23]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (42:6) {#if _showOptions && !disabled}
	    function create_if_block_3$8(ctx) {
	      let div11;
	      let div10;
	      let div5;
	      let div0;
	      let svg0;
	      let path0;
	      let div0_pros_tooltip_value;
	      let t0;
	      let div1;
	      let svg1;
	      let path1;
	      let div1_pros_tooltip_value;
	      let t1;
	      let div2;
	      let t2;
	      let t3;
	      let div3;
	      let svg2;
	      let path2;
	      let div3_pros_tooltip_value;
	      let t4;
	      let div4;
	      let svg3;
	      let path3;
	      let div4_pros_tooltip_value;
	      let t5;
	      let div9;
	      let div7;
	      let div6;
	      let t6;
	      let t7;
	      let div8;
	      let button;
	      let t8_value = /*$_*/ctx[35]("today") + "";
	      let t8;
	      let globalClicks_action;
	      let positionOptions_action;
	      let mounted;
	      let dispose;
	      let each_value_2 = /*_dayLabels*/ctx[36];
	      let each_blocks_1 = [];
	      for (let i = 0; i < each_value_2.length; i += 1) {
	        each_blocks_1[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	      }
	      let each_value = /*weeksOfTheMonth*/ctx[40](/*_date*/ctx[13]);
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
	      }
	      return {
	        c() {
	          div11 = element("div");
	          div10 = element("div");
	          div5 = element("div");
	          div0 = element("div");
	          svg0 = svg_element("svg");
	          path0 = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          svg1 = svg_element("svg");
	          path1 = svg_element("path");
	          t1 = space();
	          div2 = element("div");
	          t2 = text(/*_monthYear*/ctx[14]);
	          t3 = space();
	          div3 = element("div");
	          svg2 = svg_element("svg");
	          path2 = svg_element("path");
	          t4 = space();
	          div4 = element("div");
	          svg3 = svg_element("svg");
	          path3 = svg_element("path");
	          t5 = space();
	          div9 = element("div");
	          div7 = element("div");
	          div6 = element("div");
	          for (let i = 0; i < each_blocks_1.length; i += 1) {
	            each_blocks_1[i].c();
	          }
	          t6 = space();
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t7 = space();
	          div8 = element("div");
	          button = element("button");
	          t8 = text(t8_value);
	          attr(path0, "fill-rule", "evenodd");
	          attr(path0, "clip-rule", "evenodd");
	          attr(path0, "d", "M12.3536 4.85355C12.5488 4.65829 12.5488 4.34171 12.3536 4.14645C12.1583 3.95118 11.8417 3.95118 11.6464 4.14645L4.14645 11.6464C3.95118 11.8417 3.95118 12.1583 4.14645 12.3536L11.6464 19.8536C11.8417 20.0488 12.1583 20.0488 12.3536 19.8536C12.5488 19.6583 12.5488 19.3417 12.3536 19.1464L5.20711 12L12.3536 4.85355ZM19.3536 4.85355C19.5488 4.65829 19.5488 4.34171 19.3536 4.14645C19.1583 3.95118 18.8417 3.95118 18.6464 4.14645L11.1464 11.6464C10.9512 11.8417 10.9512 12.1583 11.1464 12.3536L18.6464 19.8536C18.8417 20.0488 19.1583 20.0488 19.3536 19.8536C19.5488 19.6583 19.5488 19.3417 19.3536 19.1464L12.2071 12L19.3536 4.85355Z");
	          attr(svg0, "width", "24");
	          attr(svg0, "height", "24");
	          attr(svg0, "viewBox", "0 0 24 24");
	          attr(svg0, "fill", "currentColor");
	          attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg0, "class", "svelte-1ktvy4d");
	          attr(div0, "id", /*_prevYearId*/ctx[29]);
	          attr(div0, "class", "pros-button pros-month-selector first svelte-1ktvy4d");
	          attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*$_*/ctx[35]("prevYear"));
	          attr(path1, "d", "M15.4999 20.5C15.372 20.5 15.244 20.4512 15.1464 20.3535L7.14637 12.3535C6.95106 12.1582 6.95106 11.8418 7.14637 11.6465L15.1464 3.64648C15.3417 3.45117 15.6581 3.45117 15.8534 3.64648C16.0487 3.8418 16.0487 4.1582 15.8534 4.35352L8.20692 12L15.8534 19.6465C16.0487 19.8418 16.0487 20.1582 15.8534 20.3535C15.7557 20.4512 15.6278 20.5 15.4999 20.5Z");
	          attr(svg1, "width", "24");
	          attr(svg1, "height", "24");
	          attr(svg1, "viewBox", "0 0 24 24");
	          attr(svg1, "fill", "currentColor");
	          attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg1, "class", "svelte-1ktvy4d");
	          attr(div1, "id", /*_prevMonthId*/ctx[30]);
	          attr(div1, "class", "pros-button pros-month-selector svelte-1ktvy4d");
	          attr(div1, "pros-tooltip", div1_pros_tooltip_value = /*$_*/ctx[35]("prevMonth"));
	          attr(div2, "class", "pros-current-month svelte-1ktvy4d");
	          attr(path2, "d", "M8.49989 20.5C8.37196 20.5 8.24403 20.4512 8.14637 20.3535C7.95106 20.1582 7.95106 19.8418 8.14637 19.6465L15.7929 12L8.14637 4.35352C7.95106 4.1582 7.95106 3.8418 8.14637 3.64648C8.34168 3.45117 8.65809 3.45117 8.8534 3.64648L16.8534 11.6465C17.0487 11.8418 17.0487 12.1582 16.8534 12.3535L8.8534 20.3535C8.75574 20.4512 8.62782 20.5 8.49989 20.5Z");
	          attr(svg2, "width", "24");
	          attr(svg2, "height", "24");
	          attr(svg2, "viewBox", "0 0 24 24");
	          attr(svg2, "fill", "currentColor");
	          attr(svg2, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg2, "class", "svelte-1ktvy4d");
	          attr(div3, "id", /*_nextMonthId*/ctx[27]);
	          attr(div3, "class", "pros-button pros-month-selector svelte-1ktvy4d");
	          attr(div3, "pros-tooltip", div3_pros_tooltip_value = /*$_*/ctx[35]("nextMonth"));
	          attr(path3, "fill-rule", "evenodd");
	          attr(path3, "clip-rule", "evenodd");
	          attr(path3, "d", "M11.6464 4.85355C11.4512 4.65829 11.4512 4.34171 11.6464 4.14645C11.8417 3.95118 12.1583 3.95118 12.3536 4.14645L19.8536 11.6464C20.0488 11.8417 20.0488 12.1583 19.8536 12.3536L12.3536 19.8536C12.1583 20.0488 11.8417 20.0488 11.6464 19.8536C11.4512 19.6583 11.4512 19.3417 11.6464 19.1464L18.7929 12L11.6464 4.85355ZM4.64645 4.85355C4.45118 4.65829 4.45118 4.34171 4.64645 4.14645C4.84171 3.95118 5.15829 3.95118 5.35355 4.14645L12.8536 11.6464C13.0488 11.8417 13.0488 12.1583 12.8536 12.3536L5.35355 19.8536C5.15829 20.0488 4.84171 20.0488 4.64645 19.8536C4.45119 19.6583 4.45119 19.3417 4.64645 19.1464L11.7929 12L4.64645 4.85355Z");
	          attr(svg3, "width", "24");
	          attr(svg3, "height", "24");
	          attr(svg3, "viewBox", "0 0 24 24");
	          attr(svg3, "fill", "currentColor");
	          attr(svg3, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg3, "class", "svelte-1ktvy4d");
	          attr(div4, "id", /*_nextYearId*/ctx[28]);
	          attr(div4, "class", "pros-button pros-month-selector last svelte-1ktvy4d");
	          attr(div4, "pros-tooltip", div4_pros_tooltip_value = /*$_*/ctx[35]("nextYear"));
	          attr(div5, "class", "pros-month-container svelte-1ktvy4d");
	          attr(div6, "class", "header svelte-1ktvy4d");
	          attr(div7, "class", "pros-calendar svelte-1ktvy4d");
	          attr(button, "id", /*_todayId*/ctx[32]);
	          attr(button, "class", "pros-button svelte-1ktvy4d");
	          attr(button, "type", "button");
	          attr(div8, "class", "pros-footer svelte-1ktvy4d");
	          attr(div9, "class", "pros-calendar-content svelte-1ktvy4d");
	          attr(div10, "id", /*_optionsId*/ctx[31]);
	          attr(div10, "class", "pros-date-container svelte-1ktvy4d");
	          attr(div11, "class", "pros-options-wrapper svelte-1ktvy4d");
	          attr(div11, "pos--theme", /*_theme*/ctx[17]);
	          attr(div11, "pos--shape", /*_shape*/ctx[18]);
	          attr(div11, "pos--density", /*_density*/ctx[19]);
	        },
	        m(target, anchor) {
	          insert(target, div11, anchor);
	          append(div11, div10);
	          append(div10, div5);
	          append(div5, div0);
	          append(div0, svg0);
	          append(svg0, path0);
	          append(div5, t0);
	          append(div5, div1);
	          append(div1, svg1);
	          append(svg1, path1);
	          append(div5, t1);
	          append(div5, div2);
	          append(div2, t2);
	          append(div5, t3);
	          append(div5, div3);
	          append(div3, svg2);
	          append(svg2, path2);
	          append(div5, t4);
	          append(div5, div4);
	          append(div4, svg3);
	          append(svg3, path3);
	          append(div10, t5);
	          append(div10, div9);
	          append(div9, div7);
	          append(div7, div6);
	          for (let i = 0; i < each_blocks_1.length; i += 1) {
	            each_blocks_1[i].m(div6, null);
	          }
	          append(div7, t6);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div7, null);
	          }
	          append(div9, t7);
	          append(div9, div8);
	          append(div8, button);
	          append(button, t8);
	          if (!mounted) {
	            dispose = [listen(div0, "click", /*previousYear*/ctx[45]), listen(div0, "mousedown", preventClickPropagation$3), listen(div0, "mouseup", preventClickPropagation$3), listen(div1, "click", /*previousMonth*/ctx[43]), listen(div1, "mousedown", preventClickPropagation$3), listen(div1, "mouseup", preventClickPropagation$3), listen(div3, "click", /*nextMonth*/ctx[42]), listen(div3, "mousedown", preventClickPropagation$3), listen(div3, "mouseup", preventClickPropagation$3), listen(div4, "click", /*nextYear*/ctx[44]), listen(div4, "mousedown", preventClickPropagation$3), listen(div4, "mouseup", preventClickPropagation$3), listen(button, "click", /*click_handler_1*/ctx[68]), listen(button, "mousedown", preventClickPropagation$3), listen(button, "mouseup", preventClickPropagation$3), action_destroyer(globalClicks_action = /*globalClicks*/ctx[37].call(null, div11)), action_destroyer(positionOptions_action = /*positionOptions*/ctx[38].call(null, div11))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_prevYearId*/536870912) {
	            attr(div0, "id", /*_prevYearId*/ctx[29]);
	          }
	          if (dirty[1] & /*$_*/16 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*$_*/ctx[35]("prevYear"))) {
	            attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	          }
	          if (dirty[0] & /*_prevMonthId*/1073741824) {
	            attr(div1, "id", /*_prevMonthId*/ctx[30]);
	          }
	          if (dirty[1] & /*$_*/16 && div1_pros_tooltip_value !== (div1_pros_tooltip_value = /*$_*/ctx[35]("prevMonth"))) {
	            attr(div1, "pros-tooltip", div1_pros_tooltip_value);
	          }
	          if (dirty[0] & /*_monthYear*/16384) set_data(t2, /*_monthYear*/ctx[14]);
	          if (dirty[0] & /*_nextMonthId*/134217728) {
	            attr(div3, "id", /*_nextMonthId*/ctx[27]);
	          }
	          if (dirty[1] & /*$_*/16 && div3_pros_tooltip_value !== (div3_pros_tooltip_value = /*$_*/ctx[35]("nextMonth"))) {
	            attr(div3, "pros-tooltip", div3_pros_tooltip_value);
	          }
	          if (dirty[0] & /*_nextYearId*/268435456) {
	            attr(div4, "id", /*_nextYearId*/ctx[28]);
	          }
	          if (dirty[1] & /*$_*/16 && div4_pros_tooltip_value !== (div4_pros_tooltip_value = /*$_*/ctx[35]("nextYear"))) {
	            attr(div4, "pros-tooltip", div4_pros_tooltip_value);
	          }
	          if (dirty[1] & /*_dayLabels*/32) {
	            each_value_2 = /*_dayLabels*/ctx[36];
	            let i;
	            for (i = 0; i < each_value_2.length; i += 1) {
	              const child_ctx = get_each_context_2(ctx, each_value_2, i);
	              if (each_blocks_1[i]) {
	                each_blocks_1[i].p(child_ctx, dirty);
	              } else {
	                each_blocks_1[i] = create_each_block_2(child_ctx);
	                each_blocks_1[i].c();
	                each_blocks_1[i].m(div6, null);
	              }
	            }
	            for (; i < each_blocks_1.length; i += 1) {
	              each_blocks_1[i].d(1);
	            }
	            each_blocks_1.length = each_value_2.length;
	          }
	          if (dirty[0] & /*_days, _date, preventClickPropagation*/41216 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth, handleDateChanged, dayOfTheMonth*/132864) {
	            each_value = /*weeksOfTheMonth*/ctx[40](/*_date*/ctx[13]);
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$3(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	              } else {
	                each_blocks[i] = create_each_block$3(child_ctx);
	                each_blocks[i].c();
	                each_blocks[i].m(div7, null);
	              }
	            }
	            for (; i < each_blocks.length; i += 1) {
	              each_blocks[i].d(1);
	            }
	            each_blocks.length = each_value.length;
	          }
	          if (dirty[1] & /*$_*/16 && t8_value !== (t8_value = /*$_*/ctx[35]("today") + "")) set_data(t8, t8_value);
	          if (dirty[1] & /*_todayId*/2) {
	            attr(button, "id", /*_todayId*/ctx[32]);
	          }
	          if (dirty[1] & /*_optionsId*/1) {
	            attr(div10, "id", /*_optionsId*/ctx[31]);
	          }
	          if (dirty[0] & /*_theme*/131072) {
	            attr(div11, "pos--theme", /*_theme*/ctx[17]);
	          }
	          if (dirty[0] & /*_shape*/262144) {
	            attr(div11, "pos--shape", /*_shape*/ctx[18]);
	          }
	          if (dirty[0] & /*_density*/524288) {
	            attr(div11, "pos--density", /*_density*/ctx[19]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div11);
	          destroy_each(each_blocks_1, detaching);
	          destroy_each(each_blocks, detaching);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (72:16) {#each _dayLabels as dayLabel}
	    function create_each_block_2(ctx) {
	      let div;
	      let t_value = /*dayLabel*/ctx[102] + "";
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(t_value);
	          attr(div, "class", "week-day svelte-1ktvy4d");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p: noop,
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (79:16) {#each daysOfCurrentWeek(_days, week) as day}
	    function create_each_block_1(ctx) {
	      let div1;
	      let div0;
	      let t_value = /*dayOfTheMonth*/ctx[39](/*day*/ctx[99].value) + "";
	      let t;
	      let div1_id_value;
	      let mounted;
	      let dispose;
	      function click_handler(...args) {
	        return /*click_handler*/ctx[67](/*day*/ctx[99], ...args);
	      }
	      return {
	        c() {
	          div1 = element("div");
	          div0 = element("div");
	          t = text(t_value);
	          attr(div0, "class", "day-label svelte-1ktvy4d");
	          toggle_class(div0, "today", /*day*/ctx[99].isToday);
	          toggle_class(div0, "potential", /*day*/ctx[99].isPotential);
	          toggle_class(div0, "selected", /*day*/ctx[99].isSelected);
	          toggle_class(div0, "disabled", /*day*/ctx[99].isDisabled);
	          attr(div1, "id", div1_id_value = /*day*/ctx[99].id);
	          attr(div1, "class", "day svelte-1ktvy4d");
	        },
	        m(target, anchor) {
	          insert(target, div1, anchor);
	          append(div1, div0);
	          append(div0, t);
	          if (!mounted) {
	            dispose = [listen(div0, "click", click_handler), listen(div0, "mousedown", preventClickPropagation$3), listen(div0, "mouseup", preventClickPropagation$3)];
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          if (dirty[0] & /*_days, _date*/40960 && t_value !== (t_value = /*dayOfTheMonth*/ctx[39](/*day*/ctx[99].value) + "")) set_data(t, t_value);
	          if (dirty[0] & /*_days, _date*/40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/1536) {
	            toggle_class(div0, "today", /*day*/ctx[99].isToday);
	          }
	          if (dirty[0] & /*_days, _date*/40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/1536) {
	            toggle_class(div0, "potential", /*day*/ctx[99].isPotential);
	          }
	          if (dirty[0] & /*_days, _date*/40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/1536) {
	            toggle_class(div0, "selected", /*day*/ctx[99].isSelected);
	          }
	          if (dirty[0] & /*_days, _date*/40960 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth*/1536) {
	            toggle_class(div0, "disabled", /*day*/ctx[99].isDisabled);
	          }
	          if (dirty[0] & /*_days, _date*/40960 && div1_id_value !== (div1_id_value = /*day*/ctx[99].id)) {
	            attr(div1, "id", div1_id_value);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div1);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (77:14) {#each weeksOfTheMonth(_date) as week}
	    function create_each_block$3(ctx) {
	      let div;
	      let t;
	      let each_value_1 = /*daysOfCurrentWeek*/ctx[41](/*_days*/ctx[15], /*week*/ctx[96]);
	      let each_blocks = [];
	      for (let i = 0; i < each_value_1.length; i += 1) {
	        each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	      }
	      return {
	        c() {
	          div = element("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t = space();
	          attr(div, "class", "week svelte-1ktvy4d");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div, null);
	          }
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_days, _date, preventClickPropagation*/41216 | dirty[1] & /*daysOfCurrentWeek, weeksOfTheMonth, handleDateChanged, dayOfTheMonth*/132864) {
	            each_value_1 = /*daysOfCurrentWeek*/ctx[41](/*_days*/ctx[15], /*week*/ctx[96]);
	            let i;
	            for (i = 0; i < each_value_1.length; i += 1) {
	              const child_ctx = get_each_context_1(ctx, each_value_1, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	              } else {
	                each_blocks[i] = create_each_block_1(child_ctx);
	                each_blocks[i].c();
	                each_blocks[i].m(div, t);
	              }
	            }
	            for (; i < each_blocks.length; i += 1) {
	              each_blocks[i].d(1);
	            }
	            each_blocks.length = each_value_1.length;
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          destroy_each(each_blocks, detaching);
	        }
	      };
	    }

	    // (97:4) {#if display !== 'custom'}
	    function create_if_block$b(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[10] && /*_errors*/ctx[9].length > 0) return create_if_block_1$8;
	        if (/*hint*/ctx[3] && /*_showOptions*/ctx[12]) return create_if_block_2$8;
	        return create_else_block$9;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-1ktvy4d");
	          toggle_class(div, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[9].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/1536) {
	            toggle_class(div, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[9].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (113:6) {:else}
	    function create_else_block$9(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[25]);
	          attr(div, "class", "pros-message svelte-1ktvy4d");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (106:37) 
	    function create_if_block_2$8(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1ktvy4d");
	          attr(div0, "id", /*_statusIconId*/ctx[26]);
	          attr(div0, "class", "pros-status-icon svelte-1ktvy4d");
	          attr(div1, "id", /*_messageId*/ctx[25]);
	          attr(div1, "class", "pros-message svelte-1ktvy4d");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/67108864) {
	            attr(div0, "id", /*_statusIconId*/ctx[26]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div1, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (99:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$8(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[9][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1ktvy4d");
	          attr(div0, "id", /*_statusIconId*/ctx[26]);
	          attr(div0, "class", "pros-status-icon error svelte-1ktvy4d");
	          attr(div1, "id", /*_messageId*/ctx[25]);
	          attr(div1, "class", "pros-message error svelte-1ktvy4d");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/67108864) {
	            attr(div0, "id", /*_statusIconId*/ctx[26]);
	          }
	          if (dirty[0] & /*_errors*/512 && t1_value !== (t1_value = /*_errors*/ctx[9][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div1, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$b(ctx) {
	      let div5;
	      let div4;
	      let t0;
	      let div3;
	      let div2;
	      let div0;
	      let input;
	      let t1;
	      let t2;
	      let div1;
	      let svg;
	      let path;
	      let t3;
	      let t4;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[34] && create_if_block_5$5(ctx);
	      let if_block1 = /*clear*/ctx[4] && (/*_hasValue*/ctx[33] || /*_untrimmedValue*/ctx[11]) && ! /*disabled*/ctx[6] && create_if_block_4$7(ctx);
	      let if_block2 = /*_showOptions*/ctx[12] && ! /*disabled*/ctx[6] && create_if_block_3$8(ctx);
	      let if_block3 = /*display*/ctx[1] !== "custom" && create_if_block$b(ctx);
	      return {
	        c() {
	          div5 = element("div");
	          div4 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div3 = element("div");
	          div2 = element("div");
	          div0 = element("div");
	          input = element("input");
	          t1 = space();
	          if (if_block1) if_block1.c();
	          t2 = space();
	          div1 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t3 = space();
	          if (if_block2) if_block2.c();
	          t4 = space();
	          if (if_block3) if_block3.c();
	          attr(input, "type", "text");
	          attr(input, "id", /*_inputId*/ctx[22]);
	          attr(input, "class", "pros-input svelte-1ktvy4d");
	          input.disabled = /*disabled*/ctx[6];
	          attr(input, "placeholder", /*placeholder*/ctx[2]);
	          attr(div0, "class", "pros-input-container svelte-1ktvy4d");
	          attr(path, "d", "M19 5H17V4C17 3.72363 16.7764 3.5 16.5 3.5C16.2236 3.5 16 3.72363 16 4V7C16 7.27637 16.2236 7.5 16.5 7.5C16.7764 7.5 17 7.27637 17 7V6H19C19.5514 6 20 6.44861 20 7V9H4V7C4 6.44861 4.44861 6 5 6H5.5C5.77618 6 6 5.77612 6 5.5C6 5.22388 5.77618 5 5.5 5H5C3.89545 5 3 5.89545 3 7V19C3 20.1046 3.89545 21 5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89545 20.1046 5 19 5ZM19 20H5C4.44861 20 4 19.5514 4 19V10H20V19C20 19.5514 19.5514 20 19 20ZM7 7V4C7 3.72363 7.22363 3.5 7.5 3.5C7.77637 3.5 8 3.72363 8 4V5H14.5C14.7762 5 15 5.22388 15 5.5C15 5.77612 14.7762 6 14.5 6H8V7C8 7.27637 7.77637 7.5 7.5 7.5C7.22363 7.5 7 7.27637 7 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1ktvy4d");
	          attr(div1, "id", /*_capId*/ctx[24]);
	          attr(div1, "class", "pros-end-cap svelte-1ktvy4d");
	          attr(div1, "disabled", /*disabled*/ctx[6]);
	          attr(div2, "class", "pros-content-container svelte-1ktvy4d");
	          attr(div3, "class", "pros-highlight-container svelte-1ktvy4d");
	          attr(div4, "class", "pros-control-container svelte-1ktvy4d");
	          toggle_class(div4, "has-value", /*_hasValue*/ctx[33]);
	          toggle_class(div4, "has-label", /*_hasLabel*/ctx[34]);
	          toggle_class(div4, "has-focus", /*_showOptions*/ctx[12] || /*_hasFocus*/ctx[20]);
	          toggle_class(div4, "custom-layout", /*display*/ctx[1] === "custom");
	          toggle_class(div4, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[9].length > 0);
	          toggle_class(div4, "disabled", /*disabled*/ctx[6]);
	          toggle_class(div4, "allow-hover", ! /*disabled*/ctx[6]);
	          attr(div5, "class", "pros-global-wrapper pros-form-control svelte-1ktvy4d");
	          attr(div5, "pos--theme", /*_theme*/ctx[17]);
	          attr(div5, "pos--shape", /*_shape*/ctx[18]);
	          attr(div5, "pos--density", /*_density*/ctx[19]);
	        },
	        m(target, anchor) {
	          insert(target, div5, anchor);
	          append(div5, div4);
	          if (if_block0) if_block0.m(div4, null);
	          append(div4, t0);
	          append(div4, div3);
	          append(div3, div2);
	          append(div2, div0);
	          append(div0, input);
	          set_input_value(input, /*_untrimmedValue*/ctx[11]);
	          /*input_binding*/
	          ctx[66](input);
	          append(div2, t1);
	          if (if_block1) if_block1.m(div2, null);
	          append(div2, t2);
	          append(div2, div1);
	          append(div1, svg);
	          append(svg, path);
	          append(div3, t3);
	          if (if_block2) if_block2.m(div3, null);
	          append(div4, t4);
	          if (if_block3) if_block3.m(div4, null);
	          if (!mounted) {
	            dispose = [listen(input, "input", /*input_input_handler*/ctx[65]), listen(input, "focus", /*handleFocus*/ctx[46]), listen(input, "blur", /*handleBlur*/ctx[47]), listen(div3, "click", /*openIfClosed*/ctx[7])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[34]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_5$5(ctx);
	              if_block0.c();
	              if_block0.m(div4, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[0] & /*_inputId*/4194304) {
	            attr(input, "id", /*_inputId*/ctx[22]);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            input.disabled = /*disabled*/ctx[6];
	          }
	          if (dirty[0] & /*placeholder*/4) {
	            attr(input, "placeholder", /*placeholder*/ctx[2]);
	          }
	          if (dirty[0] & /*_untrimmedValue*/2048 && input.value !== /*_untrimmedValue*/ctx[11]) {
	            set_input_value(input, /*_untrimmedValue*/ctx[11]);
	          }
	          if (/*clear*/ctx[4] && (/*_hasValue*/ctx[33] || /*_untrimmedValue*/ctx[11]) && ! /*disabled*/ctx[6]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_4$7(ctx);
	              if_block1.c();
	              if_block1.m(div2, t2);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*_capId*/16777216) {
	            attr(div1, "id", /*_capId*/ctx[24]);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            attr(div1, "disabled", /*disabled*/ctx[6]);
	          }
	          if (/*_showOptions*/ctx[12] && ! /*disabled*/ctx[6]) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block_3$8(ctx);
	              if_block2.c();
	              if_block2.m(div3, null);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (/*display*/ctx[1] !== "custom") {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	            } else {
	              if_block3 = create_if_block$b(ctx);
	              if_block3.c();
	              if_block3.m(div4, null);
	            }
	          } else if (if_block3) {
	            if_block3.d(1);
	            if_block3 = null;
	          }
	          if (dirty[1] & /*_hasValue*/4) {
	            toggle_class(div4, "has-value", /*_hasValue*/ctx[33]);
	          }
	          if (dirty[1] & /*_hasLabel*/8) {
	            toggle_class(div4, "has-label", /*_hasLabel*/ctx[34]);
	          }
	          if (dirty[0] & /*_showOptions, _hasFocus*/1052672) {
	            toggle_class(div4, "has-focus", /*_showOptions*/ctx[12] || /*_hasFocus*/ctx[20]);
	          }
	          if (dirty[0] & /*display*/2) {
	            toggle_class(div4, "custom-layout", /*display*/ctx[1] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/1536) {
	            toggle_class(div4, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[9].length > 0);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            toggle_class(div4, "disabled", /*disabled*/ctx[6]);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            toggle_class(div4, "allow-hover", ! /*disabled*/ctx[6]);
	          }
	          if (dirty[0] & /*_theme*/131072) {
	            attr(div5, "pos--theme", /*_theme*/ctx[17]);
	          }
	          if (dirty[0] & /*_shape*/262144) {
	            attr(div5, "pos--shape", /*_shape*/ctx[18]);
	          }
	          if (dirty[0] & /*_density*/524288) {
	            attr(div5, "pos--density", /*_density*/ctx[19]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div5);
	          if (if_block0) if_block0.d();
	          /*input_binding*/
	          ctx[66](null);
	          if (if_block1) if_block1.d();
	          if (if_block2) if_block2.d();
	          if (if_block3) if_block3.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function keyIsNumber(key) {
	      return /^\d+$/.test(key);
	    }
	    function keyIsSlash(key) {
	      return key === "/";
	    }
	    function preventClickPropagation$3(event) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	    function hasValue$9(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty$7(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance$b($$self, $$props, $$invalidate) {
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(35, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      const DAYS_IN_WEEK = 7;
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        globalKeyListener = null
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color Theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = null
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        clear = false
	      } = $$props; // Allow value to be cleared
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        format = "MM/DD/YYYY"
	      } = $$props;
	      let {
	        min = null
	      } = $$props;
	      let {
	        max = null
	      } = $$props;
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _untrimmedValue = ""; // Actual value bound to input box (may include extra whitespace)
	      let _showOptions = false; // Is Selector visible?
	      let _dayLabels = [];
	      let _dateLocale = en;
	      let _openNode = undefined;
	      let _openParent = undefined;
	      let _date = null;
	      let _monthYear = undefined;
	      let _days = undefined;
	      let _lastValue = undefined;
	      let _inputElement = undefined;
	      let _potential = undefined;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _hasFocus = false;
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _capId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      let _nextMonthId = null;
	      let _nextYearId = null;
	      let _prevYearId = null;
	      let _prevMonthId = null;
	      let _optionsId = null;
	      let _todayId = null;
	      onMount(() => {
	        initDayLabels();
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_showOptions) {
	          toggleOpen();
	        }
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(1, display = hasValue$9(display) ? display : "form");
	        $$invalidate(53, theme = hasValue$9(theme) ? theme : "light");
	        $$invalidate(54, shape = hasValue$9(shape) ? shape : "round");
	        $$invalidate(55, density = hasValue$9(density) ? density : "standard");
	        $$invalidate(0, label = hasValue$9(label) ? label : "");
	        $$invalidate(2, placeholder = hasValue$9(placeholder) ? placeholder : "MM/DD/YYYY");
	        $$invalidate(3, hint = hasValue$9(hint) ? hint : "");

	        // value = hasValue(value) ? value : null; // Removing this code due to the infinite loop problem that happens when this component is used in the Grid
	        $$invalidate(5, required = hasValue$9(required) ? required : false);
	        $$invalidate(6, disabled = hasValue$9(disabled) ? disabled : false);
	        $$invalidate(56, validation = hasValue$9(validation) ? validation : true);
	        $$invalidate(4, clear = hasValue$9(clear) ? clear : false);
	        $$invalidate(57, format = "MM/DD/YYYY");
	        $$invalidate(58, min = hasValue$9(min) ? new Date(min) : null);
	        $$invalidate(59, max = hasValue$9(max) ? new Date(max) : null);
	        $$invalidate(21, _labelId = hasValue$9(id) ? `${id}-label` : undefined);
	        $$invalidate(22, _inputId = hasValue$9(id) ? `${id}-input` : undefined);
	        $$invalidate(23, _clearId = hasValue$9(id) ? `${id}-clear` : undefined);
	        $$invalidate(24, _capId = hasValue$9(id) ? `${id}-cap` : undefined);
	        $$invalidate(31, _optionsId = hasValue$9(id) ? `${id}-options` : "pros-options-container");
	        $$invalidate(25, _messageId = hasValue$9(id) ? `${id}-message` : undefined);
	        $$invalidate(26, _statusIconId = hasValue$9(id) ? `${id}-status-icon` : undefined);
	        $$invalidate(27, _nextMonthId = hasValue$9(id) ? `${id}-next-month` : undefined);
	        $$invalidate(28, _nextYearId = hasValue$9(id) ? `${id}-next-year` : undefined);
	        $$invalidate(30, _prevMonthId = hasValue$9(id) ? `${id}-prev-month` : undefined);
	        $$invalidate(29, _prevYearId = hasValue$9(id) ? `${id}-prev-year` : undefined);
	        $$invalidate(32, _todayId = hasValue$9(id) ? `${id}-today` : undefined);
	        if (value !== _lastValue) {
	          $$invalidate(13, _date = value ? value : new Date());
	          _potential = new Date(_date);
	          $$invalidate(11, _untrimmedValue = value ? format_1(value, format, {
	            locale: _dateLocale
	          }) : null);
	          _lastValue = value;
	          initDays();
	        }
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(17, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(17, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(17, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(18, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(18, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(18, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(19, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(19, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(19, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function initDayLabels() {
	        let today = new Date();

	        // Find nearest sunday and loop through to get day labels for all 7 days
	        let sunday = sub_days(today, get_day(today));
	        for (let i = 0; i < DAYS_IN_WEEK; i++) {
	          _dayLabels.push(format_1(sunday, "dd", _dateLocale));
	          sunday = add_days(sunday, 1);
	        }
	      }
	      function initDays() {
	        let blankCounter = 1;
	        $$invalidate(14, _monthYear = format_1(_date, "MMMM YYYY", {
	          locale: _dateLocale
	        }));
	        let days = each_day(start_of_month(_date), last_day_of_month(_date));
	        let startOfWeek = get_day(start_of_month(_date));
	        let endOfWeek = get_day(end_of_month(_date));
	        for (let i = 0; i < startOfWeek; i++) {
	          days.unshift(null);
	        }
	        for (let i = 1; i < endOfWeek - 1; i++) {
	          days.push(null);
	        }
	        $$invalidate(15, _days = days.map(day => {
	          if (day) {
	            return {
	              value: day,
	              isToday: is_today(day),
	              isPotential: is_same_day(day, _potential),
	              isSelected: is_same_day(day, value),
	              isDisabled: min && is_before(day, min) || max && is_after(day, max),
	              id: `${id}-day${dayOfTheMonth(day)}`
	            };
	          } else {
	            return {
	              value: day,
	              isToday: false,
	              isPotential: false,
	              isSelected: false,
	              isDisabled: false,
	              id: `${id}-day-blank${blankCounter++}`
	            };
	          }
	        }));
	        difference_in_calendar_weeks(last_day_of_month(_date), start_of_month(_date)) + 1;
	      }
	      function containsDay(test) {
	        for (let i = 0; i < _days.length; i++) {
	          if (is_same_day(_days[i].value, test)) {
	            return true;
	          }
	        }
	        return false;
	      }
	      function globalClicks(node) {
	        $$invalidate(51, globalClickListener = event => {
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (event.target !== _inputElement && !containsClick) {
	            if (inputIsValid()) {
	              handleDateChanged(new Date(_untrimmedValue.trim()));
	              return;
	            } else {
	              $$invalidate(11, _untrimmedValue = value ? format_1(value, format, {
	                locale: _dateLocale
	              }) : null);
	              toggleOpen();
	            }
	          }
	        });
	        $$invalidate(52, globalKeyListener = event => {
	          myKeyDown.call(this, event);
	        });

	        // Necessary to prevent handling click that opens panel
	        window.setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	          document.addEventListener("keydown", globalKeyListener);
	        }, 0);
	      }
	      function positionOptions(node) {
	        _openNode = node;
	        _openParent = node.parentElement;
	        document.body.appendChild(node);
	        positionNode();
	        document.addEventListener("wheel", positionNode);
	        window.addEventListener("scroll", positionNode, true);
	        window.addEventListener("resize", positionNode);
	        return {
	          destroy() {
	            document.removeEventListener("wheel", positionNode);
	            window.removeEventListener("scroll", positionNode);
	            window.removeEventListener("resize", positionNode);
	          }
	        };
	      }
	      function positionNode(scrollEvent) {
	        if (!_openParent) {
	          document.removeEventListener("wheel", positionNode);
	          window.removeEventListener("scroll", positionNode);
	          window.removeEventListener("resize", positionNode);
	          return;
	        }
	        if (scrollEvent) {
	          let scrollTop = scrollEvent.target.scrollTop;
	          let scrollBottom = scrollTop + scrollEvent.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop || _openParent.offsetParent.offsetTop > scrollBottom) {
	            toggleOpen();
	            return;
	          }
	        }
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        _openNode.style.left = `${rect.right - _openNode.offsetWidth}px`;
	        _openNode.style.top = `${rect.bottom + 16}px`;
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          _openNode.style.top = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight - 16}px` : `0`;
	        }
	      }
	      function openIfClosed() {
	        if (disabled) {
	          return;
	        }
	        if (!_showOptions) {
	          toggleOpen();
	          _inputElement.focus();
	        }
	      }
	      function toggleOpen() {
	        if (disabled) {
	          return;
	        }
	        let opening = !_showOptions;

	        //Clean up if closing
	        if (!opening) {
	          // Re-parent options
	          _openParent.appendChild(_openNode);
	          _openNode = undefined;
	          _openParent = undefined;
	          if (globalClickListener) {
	            document.removeEventListener("click", globalClickListener);
	            $$invalidate(51, globalClickListener = null);
	          }
	          if (globalKeyListener) {
	            document.removeEventListener("keydown", globalKeyListener);
	            $$invalidate(52, globalKeyListener = null);
	          }
	          document.removeEventListener("wheel", positionNode);
	          window.removeEventListener("scroll", positionNode);
	          window.removeEventListener("resize", positionNode);
	        }
	        _inputElement.blur();
	        $$invalidate(12, _showOptions = opening);
	      }
	      function myKeyDown(event) {
	        if (event.target && event.target.id === "date-input") {
	          //console.log('Input Code', event.code);
	          switch (event.code) {
	            case "Enter":
	              if (inputIsValid()) {
	                // Date is valid: Set Date and close
	                handleDateChanged(new Date(_untrimmedValue.trim()));
	              } else {
	                // Date is valid: Ignore so user can fix
	                $$invalidate(10, _dirty = true);
	                event.stopPropagation();
	                event.preventDefault();
	              }
	              return;
	            case "ArrowDown":
	            case "ArrowUp":
	            case "ArrowLeft":
	            case "ArrowRight":
	              _inputElement.blur();
	              initDays();
	              event.stopPropagation();
	              event.preventDefault();
	              return;
	            case "Paste":
	            case "Undo":
	            case "Redo":
	            case "Delete":
	            case "Cut":
	            case "Copy":
	            case "Backspace":
	            case "ArrowLeft":
	            case "ArrowRight":
	            case "Home":
	            case "End":
	            case "Shift":
	              // These are all ok
	              break;
	            default:
	              let trimmed = hasValue$9(_untrimmedValue) ? _untrimmedValue.trim() : "";
	              let parts = trimmed.split("/");
	              if (parts.length === 3) {
	                if (!keyIsNumber(event.key)) {
	                  // Already have enough slashes so ignore
	                  event.stopPropagation();
	                  event.preventDefault();
	                  return;
	                }
	              } else {
	                if (!keyIsNumber(event.key) && !keyIsSlash(event.key)) {
	                  // Do not accept anything but numbers or slashes
	                  event.stopPropagation();
	                  event.preventDefault();
	                  return;
	                }
	              }
	              return;
	          }
	        } else {
	          switch (event.code) {
	            case "Space":
	            case "Enter":
	              event.stopPropagation();
	              if (_potential && !is_same_day(value, _potential)) {
	                handleDateChanged(_potential);
	              } else {
	                toggleOpen();
	              }
	              break;
	            case "Escape":
	              toggleOpen();
	              break;
	            case "ArrowDown":
	              event.stopPropagation();
	              event.preventDefault();
	              if (_showOptions) {
	                let test = new Date(_potential);
	                test.setDate(test.getDate() + 7);
	                if (min && is_before(test, min) || max && is_after(test, max)) {
	                  return;
	                }
	                if (_potential) {
	                  _potential.setDate(_potential.getDate() + 7);
	                }
	                if (!containsDay(_potential)) {
	                  nextMonth(_potential);
	                } else {
	                  initDays();
	                }
	              }
	              break;
	            case "ArrowUp":
	              event.stopPropagation();
	              event.preventDefault();
	              if (_showOptions) {
	                let test = new Date(_potential);
	                test.setDate(test.getDate() - 7);
	                if (min && is_before(test, min) || max && is_after(test, max)) {
	                  return;
	                }
	                _potential.setDate(_potential.getDate() - 7);
	                if (!containsDay(_potential)) {
	                  previousMonth(_potential);
	                } else {
	                  initDays();
	                }
	              }
	              break;
	            case "ArrowRight":
	              event.stopPropagation();
	              event.preventDefault();
	              if (_showOptions) {
	                let test = new Date(_potential);
	                test.setDate(test.getDate() + 1);
	                if (min && is_before(test, min) || max && is_after(test, max)) {
	                  return;
	                }
	                _potential.setDate(_potential.getDate() + 1);
	                if (!containsDay(_potential)) {
	                  nextMonth(_potential);
	                } else {
	                  initDays();
	                }
	              }
	              break;
	            case "ArrowLeft":
	              event.stopPropagation();
	              event.preventDefault();
	              if (_showOptions) {
	                let test = new Date(_potential);
	                test.setDate(test.getDate() - 1);
	                if (min && is_before(test, min) || max && is_after(test, max)) {
	                  return;
	                }
	                _potential.setDate(_potential.getDate() - 1);
	                if (!containsDay(_potential)) {
	                  previousMonth(_potential);
	                } else {
	                  initDays();
	                }
	              }
	              break;
	          }
	        }
	      }
	      function dayOfTheMonth(date) {
	        if (!date) {
	          return "";
	        }
	        return format_1(date, "D");
	      }
	      function weeksOfTheMonth(date) {
	        let week = [];
	        let weeks = difference_in_calendar_weeks(last_day_of_month(date), start_of_month(date)) + 1;
	        for (let i = 1; i <= weeks; i++) {
	          week.push(i);
	        }
	        return week;
	      }

	      // Count the no. of days that can go in current week
	      function daysOfCurrentWeek(days, week) {
	        return _days.slice((week - 1) * DAYS_IN_WEEK, (week - 1) * DAYS_IN_WEEK + DAYS_IN_WEEK);
	      }
	      function nextMonth(date) {
	        $$invalidate(13, _date = add_months(start_of_month(_date), 1));
	        _potential = date ? date : new Date(_date);
	        initDays();
	      }
	      function previousMonth(date) {
	        $$invalidate(13, _date = sub_months(start_of_month(_date), 1));
	        _potential = date ? date : new Date(_date);
	        initDays();
	      }
	      function nextYear() {
	        $$invalidate(13, _date = add_years(start_of_month(_date), 1));
	        _potential = new Date(_date);
	        initDays();
	      }
	      function previousYear() {
	        $$invalidate(13, _date = sub_years(start_of_month(_date), 1));
	        _potential = new Date(_date);
	        initDays();
	      }
	      function handleFocus(event) {
	        $$invalidate(20, _hasFocus = true);
	      }
	      function handleBlur(event) {
	        $$invalidate(20, _hasFocus = false);
	      }
	      function handleDateChanged(day) {
	        if (min && is_before(day, min) || max && is_after(day, max)) {
	          return;
	        }
	        $$invalidate(50, value = day);
	        toggleOpen();
	        valueChanged.call(this);
	      }
	      function handleClear(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        $$invalidate(50, value = null);
	        valueChanged.call(this);
	      }
	      function inputIsValid() {
	        if (!notEmpty$7(_untrimmedValue)) {
	          return false;
	        }
	        let test = _untrimmedValue.trim();
	        let parts = test.split("/");
	        if (parts.length !== 3) {
	          // Incomplete
	          return false;
	        }
	        let month = isNaN(parts[0]) ? 0 : Number(parts[0]);
	        let day = isNaN(parts[1]) ? 0 : Number(parts[1]);
	        let year = isNaN(parts[2]) ? 0 : Number(parts[2]);
	        if (month < 1 || month > 12) {
	          return false;
	        }
	        if (day < 1 || day > 31) {
	          return false;
	        }
	        if (year < 1000 || year > 9999) {
	          return false;
	        }
	        return true;
	      }
	      function valueChanged() {
	        $$invalidate(10, _dirty = true);
	        $$invalidate(11, _untrimmedValue = value ? format_1(value, format, {
	          locale: _dateLocale
	        }) : null);
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(9, _errors = errors ? errors : []);
	        if (notEmpty$7(_untrimmedValue) && !inputIsValid()) {
	          _builtInErrors.push($_("validateDate"));
	        }
	        if (required && !value) {
	          _builtInErrors.push($_("validateRequired"));
	        }
	        if (validation) {
	          $$invalidate(9, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (hasValue$9(value) && !valid && !_dirty) {
	              $$invalidate(10, _dirty = true);
	            }
	          }
	        });
	      }
	      function input_input_handler() {
	        _untrimmedValue = this.value;
	        $$invalidate(11, _untrimmedValue);
	      }
	      function input_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(16, _inputElement);
	        });
	      }
	      const click_handler = (day, event) => handleDateChanged(day.value);
	      const click_handler_1 = event => handleDateChanged(new Date());
	      $$self.$$set = $$props => {
	        if ("globalClickListener" in $$props) $$invalidate(51, globalClickListener = $$props.globalClickListener);
	        if ("globalKeyListener" in $$props) $$invalidate(52, globalKeyListener = $$props.globalKeyListener);
	        if ("display" in $$props) $$invalidate(1, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(53, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(54, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(55, density = $$props.density);
	        if ("value" in $$props) $$invalidate(50, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(2, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("clear" in $$props) $$invalidate(4, clear = $$props.clear);
	        if ("required" in $$props) $$invalidate(5, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(6, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(56, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(61, errors = $$props.errors);
	        if ("format" in $$props) $$invalidate(57, format = $$props.format);
	        if ("min" in $$props) $$invalidate(58, min = $$props.min);
	        if ("max" in $$props) $$invalidate(59, max = $$props.max);
	        if ("id" in $$props) $$invalidate(62, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*_errors*/512) {
	          // Computed values
	          _errors.length === 0;
	        }
	        if ($$self.$$.dirty[1] & /*value*/524288) {
	          $$invalidate(33, _hasValue = hasValue$9(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          $$invalidate(34, _hasLabel = notEmpty$7(label));
	        }
	      };
	      return [label, display, placeholder, hint, clear, required, disabled, openIfClosed, preventClickPropagation$3, _errors, _dirty, _untrimmedValue, _showOptions, _date, _monthYear, _days, _inputElement, _theme, _shape, _density, _hasFocus, _labelId, _inputId, _clearId, _capId, _messageId, _statusIconId, _nextMonthId, _nextYearId, _prevYearId, _prevMonthId, _optionsId, _todayId, _hasValue, _hasLabel, $_, _dayLabels, globalClicks, positionOptions, dayOfTheMonth, weeksOfTheMonth, daysOfCurrentWeek, nextMonth, previousMonth, nextYear, previousYear, handleFocus, handleBlur, handleDateChanged, handleClear, value, globalClickListener, globalKeyListener, theme, shape, density, validation, format, min, max, DAYS_IN_WEEK, errors, id, toggleOpen, myKeyDown, input_input_handler, input_binding, click_handler, click_handler_1];
	    }
	    class DatePicker extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document_1$2.getElementById("svelte-1ktvy4d-style")) add_css$a();
	        init(this, options, instance$b, create_fragment$b, safe_not_equal, {
	          DAYS_IN_WEEK: 60,
	          globalClickListener: 51,
	          globalKeyListener: 52,
	          display: 1,
	          theme: 53,
	          shape: 54,
	          density: 55,
	          value: 50,
	          label: 0,
	          placeholder: 2,
	          hint: 3,
	          clear: 4,
	          required: 5,
	          disabled: 6,
	          validation: 56,
	          errors: 61,
	          format: 57,
	          min: 58,
	          max: 59,
	          id: 62,
	          openIfClosed: 7,
	          toggleOpen: 63,
	          myKeyDown: 64,
	          preventClickPropagation: 8
	        }, [-1, -1, -1, -1]);
	      }
	      get DAYS_IN_WEEK() {
	        return this.$$.ctx[60];
	      }
	      get openIfClosed() {
	        return this.$$.ctx[7];
	      }
	      get toggleOpen() {
	        return this.$$.ctx[63];
	      }
	      get myKeyDown() {
	        return this.$$.ctx[64];
	      }
	      get preventClickPropagation() {
	        return preventClickPropagation$3;
	      }
	    }

	    /* src/RadioButtonGroup.svelte generated by Svelte v3.38.2 */
	    function add_css$9() {
	      var style = element("style");
	      style.id = "svelte-6jjyvj-style";
	      style.textContent = ".pros-message-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-6jjyvj .pros-status-icon.svelte-6jjyvj{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-6jjyvj .pros-status-icon svg.svelte-6jjyvj{height:100%;width:100%}.pros-message-container.svelte-6jjyvj .pros-message.svelte-6jjyvj{flex:1}.pros-control-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;box-sizing:border-box;width:100%;margin:0;font-size:16px}.pros-control-label.svelte-6jjyvj.svelte-6jjyvj{width:100%;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-bottom:8px}.pros-control-label.required.svelte-6jjyvj.svelte-6jjyvj::after{content:\" *\"}.pros-radio-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;width:100%}.pros-radio-container.horizontal.svelte-6jjyvj.svelte-6jjyvj{flex-direction:unset;display:flex;justify-content:start;align-items:center;width:100%;flex-wrap:wrap}.pros-radio-container.horizontal.svelte-6jjyvj .pros-input-container.svelte-6jjyvj{width:auto}.pros-input-container.svelte-6jjyvj.svelte-6jjyvj{display:flex;justify-content:flex-start;align-items:center;width:100%;cursor:pointer;margin-bottom:12px;padding-left:8px}.pros-input-container.svelte-6jjyvj.svelte-6jjyvj:last-of-type{margin-bottom:0}.pros-input-container.svelte-6jjyvj input[type=radio].svelte-6jjyvj{position:absolute;display:none}.pros-input-container.svelte-6jjyvj .pros-radio-value.svelte-6jjyvj{margin-left:12px}.pros-input-container.svelte-6jjyvj .pros-radio-button.svelte-6jjyvj{display:flex;justify-content:center;align-items:center;position:relative;width:24px;height:24px;border-width:1px;border-style:solid;border-radius:100%;box-sizing:border-box}.pros-input-container.selected.svelte-6jjyvj .pros-radio-button.svelte-6jjyvj::before{position:absolute;border-radius:100%;content:\" \";height:12px;width:12px}.pros-global-wrapper[pos--density=high].svelte-6jjyvj .pros-control-label.svelte-6jjyvj{margin-bottom:4px;line-height:20px}.pros-global-wrapper[pos--density=high].svelte-6jjyvj .pros-radio-button.svelte-6jjyvj{width:20px;height:20px}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.svelte-6jjyvj{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#404040;background-color:transparent}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.allow-hover:hover .pros-radio-button.svelte-6jjyvj{background-color:rgba(33, 33, 33, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#027aae;border-color:#027aae}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj::before{background-color:white}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-input-container.allow-hover.selected:hover .pros-radio-button.svelte-6jjyvj{background-color:#035c84;border-color:#035c84}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled.svelte-6jjyvj{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.svelte-6jjyvj{cursor:default}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-value.svelte-6jjyvj{user-select:none}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container.svelte-6jjyvj{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container .pros-status-icon.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=light].svelte-6jjyvj .pros-message-container .pros-message.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.svelte-6jjyvj{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#ffffff;background-color:transparent}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-containerallow-hover:hover .pros-radio-button.svelte-6jjyvj{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#3ab4eb;border-color:#3ab4eb}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-container.selected .pros-radio-button.svelte-6jjyvj::before{background-color:#212121}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-input-containerallow-hover.selected:hover .pros-radio-button.svelte-6jjyvj{background-color:#6dd0fb;border-color:#6dd0fb}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled.svelte-6jjyvj{color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.svelte-6jjyvj{cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-button.svelte-6jjyvj{border-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container.selected .pros-radio-button.svelte-6jjyvj{background-color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-control-container.disabled .pros-input-container .pros-radio-value.svelte-6jjyvj{user-select:none}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container.svelte-6jjyvj{color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container .pros-status-icon.error.svelte-6jjyvj{color:#F04B37}.pros-global-wrapper[pos--theme=dark].svelte-6jjyvj .pros-message-container .pros-message.error.svelte-6jjyvj{color:#F04B37}";
	      append(document.head, style);
	    }
	    function get_each_context$2(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[39] = list[i];
	      child_ctx[41] = i;
	      return child_ctx;
	    }

	    // (8:4) {#if _hasLabel}
	    function create_if_block_3$7(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "class", "pros-control-label svelte-6jjyvj");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[0] & /*required*/16) {
	            toggle_class(div, "required", /*required*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (12:6) {#each options as option, index}
	    function create_each_block$2(ctx) {
	      let div2;
	      let input;
	      let input_value_value;
	      let input_checked_value;
	      let t0;
	      let div0;
	      let t1;
	      let div1;
	      let t2_value = /*option*/ctx[39].display + "";
	      let t2;
	      let t3;
	      let div2_id_value;
	      let mounted;
	      let dispose;
	      function click_handler(...args) {
	        return /*click_handler*/ctx[25](/*option*/ctx[39], ...args);
	      }
	      return {
	        c() {
	          div2 = element("div");
	          input = element("input");
	          t0 = space();
	          div0 = element("div");
	          t1 = space();
	          div1 = element("div");
	          t2 = text(t2_value);
	          t3 = space();
	          attr(input, "type", "radio");
	          attr(input, "name", /*name*/ctx[7]);
	          input.value = input_value_value = /*option*/ctx[39].value;
	          input.disabled = /*disabled*/ctx[5];
	          input.checked = input_checked_value = /*value*/ctx[2] === /*option*/ctx[39].value;
	          attr(input, "class", "svelte-6jjyvj");
	          attr(div0, "class", "pros-radio-button svelte-6jjyvj");
	          attr(div1, "pros-tooltip", "");
	          attr(div1, "class", "pros-radio-value svelte-6jjyvj");
	          toggle_class(div1, "required", /*required*/ctx[4]);
	          attr(div2, "id", div2_id_value = /*getRadioId*/ctx[18](/*index*/ctx[41]));
	          attr(div2, "class", "pros-input-container svelte-6jjyvj");
	          toggle_class(div2, "allow-hover", ! /*disabled*/ctx[5]);
	          toggle_class(div2, "selected", /*value*/ctx[2] === /*option*/ctx[39].value);
	        },
	        m(target, anchor) {
	          insert(target, div2, anchor);
	          append(div2, input);
	          append(div2, t0);
	          append(div2, div0);
	          append(div2, t1);
	          append(div2, div1);
	          append(div1, t2);
	          append(div2, t3);
	          if (!mounted) {
	            dispose = listen(div2, "click", click_handler);
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          if (dirty[0] & /*name*/128) {
	            attr(input, "name", /*name*/ctx[7]);
	          }
	          if (dirty[0] & /*options*/256 && input_value_value !== (input_value_value = /*option*/ctx[39].value)) {
	            input.value = input_value_value;
	          }
	          if (dirty[0] & /*disabled*/32) {
	            input.disabled = /*disabled*/ctx[5];
	          }
	          if (dirty[0] & /*value, options*/260 && input_checked_value !== (input_checked_value = /*value*/ctx[2] === /*option*/ctx[39].value)) {
	            input.checked = input_checked_value;
	          }
	          if (dirty[0] & /*options*/256 && t2_value !== (t2_value = /*option*/ctx[39].display + "")) set_data(t2, t2_value);
	          if (dirty[0] & /*required*/16) {
	            toggle_class(div1, "required", /*required*/ctx[4]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div2, "allow-hover", ! /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*value, options*/260) {
	            toggle_class(div2, "selected", /*value*/ctx[2] === /*option*/ctx[39].value);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div2);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (29:4) {#if display !== 'custom'}
	    function create_if_block$a(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[10] && /*_errors*/ctx[11].length > 0) return create_if_block_1$7;
	        if (/*hint*/ctx[3]) return create_if_block_2$7;
	        return create_else_block$8;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-6jjyvj");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (45:6) {:else}
	    function create_else_block$8(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[15]);
	          attr(div, "class", "pros-message svelte-6jjyvj");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/32768) {
	            attr(div, "id", /*_messageId*/ctx[15]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (38:21) 
	    function create_if_block_2$7(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-6jjyvj");
	          attr(div0, "id", /*_statusIconId*/ctx[16]);
	          attr(div0, "class", "pros-status-icon svelte-6jjyvj");
	          attr(div1, "id", /*_messageId*/ctx[15]);
	          attr(div1, "class", "pros-message svelte-6jjyvj");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/65536) {
	            attr(div0, "id", /*_statusIconId*/ctx[16]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[0] & /*_messageId*/32768) {
	            attr(div1, "id", /*_messageId*/ctx[15]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (31:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$7(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[11][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-6jjyvj");
	          attr(div0, "id", /*_statusIconId*/ctx[16]);
	          attr(div0, "class", "pros-status-icon error svelte-6jjyvj");
	          attr(div1, "id", /*_messageId*/ctx[15]);
	          attr(div1, "class", "pros-message error svelte-6jjyvj");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/65536) {
	            attr(div0, "id", /*_statusIconId*/ctx[16]);
	          }
	          if (dirty[0] & /*_errors*/2048 && t1_value !== (t1_value = /*_errors*/ctx[11][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/32768) {
	            attr(div1, "id", /*_messageId*/ctx[15]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$a(ctx) {
	      let div2;
	      let div1;
	      let t0;
	      let div0;
	      let t1;
	      let if_block0 = /*_hasLabel*/ctx[17] && create_if_block_3$7(ctx);
	      let each_value = /*options*/ctx[8];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
	      }
	      let if_block1 = /*display*/ctx[1] !== "custom" && create_if_block$a(ctx);
	      return {
	        c() {
	          div2 = element("div");
	          div1 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div0 = element("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t1 = space();
	          if (if_block1) if_block1.c();
	          attr(div0, "class", "pros-radio-container svelte-6jjyvj");
	          toggle_class(div0, "horizontal", /*orientation*/ctx[6] === "horizontal");
	          attr(div1, "class", "pros-control-container svelte-6jjyvj");
	          toggle_class(div1, "custom-layout", /*display*/ctx[1] === "custom");
	          toggle_class(div1, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[11].length > 0);
	          toggle_class(div1, "disabled", /*disabled*/ctx[5]);
	          toggle_class(div1, "allow-hover", ! /*disabled*/ctx[5]);
	          attr(div2, "class", "pros-global-wrapper pros-form-control svelte-6jjyvj");
	          attr(div2, "pos--theme", /*_theme*/ctx[12]);
	          attr(div2, "pos--shape", /*_shape*/ctx[13]);
	          attr(div2, "pos--density", /*_density*/ctx[14]);
	        },
	        m(target, anchor) {
	          insert(target, div2, anchor);
	          append(div2, div1);
	          if (if_block0) if_block0.m(div1, null);
	          append(div1, t0);
	          append(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          append(div1, t1);
	          if (if_block1) if_block1.m(div1, null);
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[17]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_3$7(ctx);
	              if_block0.c();
	              if_block0.m(div1, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[0] & /*getRadioId, disabled, value, options, checkRadioButton, required, name*/263092) {
	            each_value = /*options*/ctx[8];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$2(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	              } else {
	                each_blocks[i] = create_each_block$2(child_ctx);
	                each_blocks[i].c();
	                each_blocks[i].m(div0, null);
	              }
	            }
	            for (; i < each_blocks.length; i += 1) {
	              each_blocks[i].d(1);
	            }
	            each_blocks.length = each_value.length;
	          }
	          if (dirty[0] & /*orientation*/64) {
	            toggle_class(div0, "horizontal", /*orientation*/ctx[6] === "horizontal");
	          }
	          if (/*display*/ctx[1] !== "custom") {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block$a(ctx);
	              if_block1.c();
	              if_block1.m(div1, null);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*display*/2) {
	            toggle_class(div1, "custom-layout", /*display*/ctx[1] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/3072) {
	            toggle_class(div1, "error", /*_dirty*/ctx[10] && /*_errors*/ctx[11].length > 0);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div1, "disabled", /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div1, "allow-hover", ! /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*_theme*/4096) {
	            attr(div2, "pos--theme", /*_theme*/ctx[12]);
	          }
	          if (dirty[0] & /*_shape*/8192) {
	            attr(div2, "pos--shape", /*_shape*/ctx[13]);
	          }
	          if (dirty[0] & /*_density*/16384) {
	            attr(div2, "pos--density", /*_density*/ctx[14]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div2);
	          if (if_block0) if_block0.d();
	          destroy_each(each_blocks, detaching);
	          if (if_block1) if_block1.d();
	        }
	      };
	    }
	    function hasValue$8(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty$6(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance$a($$self, $$props, $$invalidate) {
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(35, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        name = "prosRadio"
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = null
	      } = $$props; // Current value of control
	      let {
	        label = null
	      } = $$props; // Control label
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        options = []
	      } = $$props; // Radio Button Options to choose from
	      let {
	        orientation = "vertical"
	      } = $$props; // Horizontal (wrap) or Vertical (stack)
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _messageId = null;
	      let _statusIconId = null;
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(1, display = hasValue$8(display) ? display : "form");
	        $$invalidate(19, theme = hasValue$8(theme) ? theme : "light");
	        $$invalidate(20, shape = hasValue$8(shape) ? shape : "round");
	        $$invalidate(21, density = hasValue$8(density) ? density : "standard");
	        $$invalidate(0, label = hasValue$8(label) ? label : null);
	        $$invalidate(3, hint = hasValue$8(hint) ? hint : "");
	        $$invalidate(2, value = hasValue$8(value) ? value : null);
	        $$invalidate(4, required = hasValue$8(required) ? required : false);
	        $$invalidate(5, disabled = hasValue$8(disabled) ? disabled : false);
	        $$invalidate(22, validation = hasValue$8(validation) ? validation : true);
	        $$invalidate(6, orientation = hasValue$8(orientation) ? orientation : "vertical");
	        $$invalidate(15, _messageId = hasValue$8(id) ? `${id}-message` : undefined);
	        $$invalidate(16, _statusIconId = hasValue$8(id) ? `${id}-status-icon` : undefined);
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(12, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(12, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(12, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(13, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(13, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(13, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(14, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(14, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(14, _density = density);
	          }
	        }
	        doValidate();
	      });
	      function checkRadioButton(option) {
	        if (disabled) {
	          return;
	        }
	        valueChanged.call(this, option.value);
	      }
	      function getRadioId(index) {
	        if (!id) {
	          return null;
	        }
	        return `${id}-input${index}`;
	      }
	      function valueChanged(currentValue) {
	        $$invalidate(10, _dirty = true);
	        $$invalidate(2, value = currentValue);
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(11, _errors = errors ? errors : []);
	        if (required) {
	          if (!hasValue$8(value)) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (validation) {
	          $$invalidate(11, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (hasValue$8(value) && !valid && !_dirty) {
	              $$invalidate(10, _dirty = true);
	            }
	          }
	        });
	      }
	      const click_handler = (option, event) => checkRadioButton(option);
	      $$self.$$set = $$props => {
	        if ("name" in $$props) $$invalidate(7, name = $$props.name);
	        if ("display" in $$props) $$invalidate(1, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(19, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(20, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(21, density = $$props.density);
	        if ("value" in $$props) $$invalidate(2, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("required" in $$props) $$invalidate(4, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(22, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(23, errors = $$props.errors);
	        if ("options" in $$props) $$invalidate(8, options = $$props.options);
	        if ("orientation" in $$props) $$invalidate(6, orientation = $$props.orientation);
	        if ("id" in $$props) $$invalidate(24, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          // Computed values
	          $$invalidate(17, _hasLabel = notEmpty$6(label));
	        }
	      };
	      return [label, display, value, hint, required, disabled, orientation, name, options, checkRadioButton, _dirty, _errors, _theme, _shape, _density, _messageId, _statusIconId, _hasLabel, getRadioId, theme, shape, density, validation, errors, id, click_handler];
	    }
	    class RadioButtonGroup extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-6jjyvj-style")) add_css$9();
	        init(this, options, instance$a, create_fragment$a, safe_not_equal, {
	          name: 7,
	          display: 1,
	          theme: 19,
	          shape: 20,
	          density: 21,
	          value: 2,
	          label: 0,
	          hint: 3,
	          required: 4,
	          disabled: 5,
	          validation: 22,
	          errors: 23,
	          options: 8,
	          orientation: 6,
	          id: 24,
	          checkRadioButton: 9
	        }, [-1, -1]);
	      }
	      get checkRadioButton() {
	        return this.$$.ctx[9];
	      }
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/icon/src/Icon.svelte generated by Svelte v3.38.2 */

	    function add_css$8() {
	    	var style = element("style");
	    	style.id = "svelte-1if0avd-style";
	    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	    	append(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$9(ctx) {
	    	let html_tag;
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty$1();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(/*_content*/ ctx[1], target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    function create_fragment$9(ctx) {
	    	let div1;
	    	let div0;
	    	let div0_pros_tooltip_value;
	    	let div1_class_value;
	    	let if_block = /*_content*/ ctx[1] && create_if_block$9(ctx);

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			if (if_block) if_block.c();
	    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
	    			attr(div0, "style", /*_style*/ ctx[4]);
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
	    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
	    			attr(div1, "style", /*_style*/ ctx[4]);
	    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			if (if_block) if_block.m(div0, null);
	    			/*div1_binding*/ ctx[22](div1);
	    		},
	    		p(ctx, [dirty]) {
	    			if (/*_content*/ ctx[1]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block$9(ctx);
	    					if_block.c();
	    					if_block.m(div0, null);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div0, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
	    				attr(div1, "class", div1_class_value);
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div1, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*_theme*/ 4) {
	    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			}

	    			if (dirty & /*mode*/ 1) {
	    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			}

	    			if (dirty & /*_className, disabled*/ 136) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			if (if_block) if_block.d();
	    			/*div1_binding*/ ctx[22](null);
	    		}
	    	};
	    }

	    function hasValue$7(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$9($$self, $$props, $$invalidate) {
	    	createEventDispatcher();
	    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { mode = "default" } = $$props; // default/form
	    	let { className = "" } = $$props; // Class name
	    	let { tooltip } = $$props;
	    	let { disabled = false } = $$props;
	    	let { size = "24px" } = $$props;
	    	let { constraint = "h" } = $$props;
	    	let { color } = $$props;
	    	let { solid = false } = $$props;
	    	let { _content = undefined } = $$props;
	    	let { _theme } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _className } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _iconElement = undefined } = $$props;
	    	let { _lastName = null } = $$props;
	    	let { _lastPath = null } = $$props;
	    	let { _lastUrl = null } = $$props;

	    	onMount(() => {
	    		$$invalidate(3, _className = hasValue$7(className) ? className : "");
	    		updateContent();
	    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	    	beforeUpdate(() => {
	    		$$invalidate(8, theme = hasValue$7(theme) ? theme : "light");
	    		$$invalidate(0, mode = hasValue$7(mode) ? mode : "icon");

	    		if (theme !== _lastTheme) {
	    			$$invalidate(9, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(2, _theme = theme);
	    			}
	    		}

	    		if (name !== _lastName) {
	    			$$invalidate(10, _lastName = name);
	    			updateContent();
	    		}

	    		if (path !== _lastPath) {
	    			$$invalidate(11, _lastPath = path);
	    			updateContent();
	    		}

	    		if (url !== _lastUrl) {
	    			$$invalidate(12, _lastUrl = url);
	    			updateContent();
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function updateContent() {
	    		if (name) {
	    			let myName = solid ? name : `${name}-o`;
	    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	    		} else if (path) {
	    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	    		} else if (url) {
	    			loadContent.call(this, url);
	    		}
	    	}

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(2, _theme = event.detail.theme);
	    		}
	    	}

	    	// Others
	    	function loadContent(url) {
	    		let config = {
	    			url,
	    			cache: true,
	    			credentials: "omit",
	    			responseType: "text"
	    		};

	    		return dist.http.request(config).then(resp => {
	    			$$invalidate(1, _content = resp.data);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_iconElement = $$value;
	    			$$invalidate(5, _iconElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
	    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
	    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
	    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
	    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
	    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
	    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
	    			// onState
	    			{
	    				if (size) {
	    					let h;
	    					let w;

	    					switch (constraint) {
	    						case "b":
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = isNaN(size) ? size : `${size}px`;
	    							break;
	    						case "w":
	    							w = isNaN(size) ? size : `${size}px`;
	    							h = "fit-content";
	    							break;
	    						case "h":
	    						default:
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = "fit-content";
	    							break;
	    					}

	    					$$invalidate(4, _style = `height:${h};width:${w};`);
	    				}

	    				if (color) {
	    					if (hasValue$7(color)) {
	    						$$invalidate(4, _style += `color:${color};fill:${color}`);
	    					}
	    				}
	    			}
	    		}
	    	};

	    	return [
	    		mode,
	    		_content,
	    		_theme,
	    		_className,
	    		_style,
	    		_iconElement,
	    		tooltip,
	    		disabled,
	    		theme,
	    		_lastTheme,
	    		_lastName,
	    		_lastPath,
	    		_lastUrl,
	    		name,
	    		path,
	    		url,
	    		className,
	    		size,
	    		constraint,
	    		color,
	    		solid,
	    		hasValue$7,
	    		div1_binding
	    	];
	    }

	    class Icon$1 extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1if0avd-style")) add_css$8();

	    		init(this, options, instance$9, create_fragment$9, safe_not_equal, {
	    			name: 13,
	    			path: 14,
	    			url: 15,
	    			theme: 8,
	    			mode: 0,
	    			className: 16,
	    			tooltip: 6,
	    			disabled: 7,
	    			size: 17,
	    			constraint: 18,
	    			color: 19,
	    			solid: 20,
	    			_content: 1,
	    			_theme: 2,
	    			_lastTheme: 9,
	    			_className: 3,
	    			_style: 4,
	    			_iconElement: 5,
	    			_lastName: 10,
	    			_lastPath: 11,
	    			_lastUrl: 12,
	    			hasValue: 21
	    		});
	    	}

	    	get hasValue() {
	    		return hasValue$7;
	    	}
	    }

	    createCommonjsModule(function (module, exports) {
	    (function (global, factory) {
	      factory(exports) ;
	    }(commonjsGlobal$1, (function (exports) {
	      function _classCallCheck(a, n) {
	        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	      }
	      function _defineProperties(e, r) {
	        for (var t = 0; t < r.length; t++) {
	          var o = r[t];
	          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
	        }
	      }
	      function _createClass(e, r, t) {
	        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	          writable: !1
	        }), e;
	      }
	      function _toPrimitive(t, r) {
	        if ("object" != typeof t || !t) return t;
	        var e = t[Symbol.toPrimitive];
	        if (void 0 !== e) {
	          var i = e.call(t, r || "default");
	          if ("object" != typeof i) return i;
	          throw new TypeError("@@toPrimitive must return a primitive value.");
	        }
	        return ("string" === r ? String : Number)(t);
	      }
	      function _toPropertyKey(t) {
	        var i = _toPrimitive(t, "string");
	        return "symbol" == typeof i ? i : i + "";
	      }

	      function styleInject(css, ref) {
	        if ( ref === void 0 ) ref = {};
	        var insertAt = ref.insertAt;

	        if (!css || typeof document === 'undefined') { return; }

	        var head = document.head || document.getElementsByTagName('head')[0];
	        var style = document.createElement('style');
	        style.type = 'text/css';

	        if (insertAt === 'top') {
	          if (head.firstChild) {
	            head.insertBefore(style, head.firstChild);
	          } else {
	            head.appendChild(style);
	          }
	        } else {
	          head.appendChild(style);
	        }

	        if (style.styleSheet) {
	          style.styleSheet.cssText = css;
	        } else {
	          style.appendChild(document.createTextNode(css));
	        }
	      }

	      var css_248z = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:FormaDJR,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}pros-tooltip-overlay.pros-custom-tooltip{padding:0;overflow:hidden}";
	      styleInject(css_248z);

	      var Tooltips = /*#__PURE__*/function () {
	        function Tooltips() {
	          _classCallCheck(this, Tooltips);
	          this._observers = new WeakMap();
	          this._listeners = {
	            mouseenter: new WeakMap(),
	            mouseleave: new WeakMap()
	          };
	        }
	        return _createClass(Tooltips, [{
	          key: "addObserver",
	          value: function addObserver() {
	            var _this = this;
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            if (this._observers.get(target)) {
	              // Could also throw an error
	              return;
	            }
	            var observer = new MutationObserver(function (mutations) {
	              mutations.forEach(function (mutation) {
	                if (mutation.type !== 'childList') {
	                  return;
	                }
	                var addedNodes = mutation.addedNodes;
	                for (var i = 0; i < addedNodes.length; i++) {
	                  var node = addedNodes[i];
	                  if (!node.querySelectorAll) {
	                    continue;
	                  }

	                  //Check node itself and then children
	                  if (node.hasAttribute('pros-tooltip')) {
	                    _this._bind(node);
	                  }
	                  var elements = node.querySelectorAll('[pros-tooltip]');
	                  if (elements.length > 0) {
	                    for (var j = 0; j < elements.length; j++) {
	                      var element = elements[j];
	                      _this._bind(element);
	                    }
	                  }
	                }
	                var removedNodes = mutation.removedNodes;
	                for (var _i = 0; _i < removedNodes.length; _i++) {
	                  var _node = removedNodes[_i];
	                  if (!_node.querySelectorAll) {
	                    continue;
	                  }
	                  if (_node.hasAttribute('pros-tooltip')) {
	                    _this._unbind(_node);
	                  }
	                  var _elements = _node.querySelectorAll('[pros-tooltip]');
	                  if (_elements.length > 0) {
	                    for (var _j = 0; _j < _elements.length; _j++) {
	                      var _element = _elements[_j];
	                      _this._unbind(_element);
	                    }
	                  }
	                }
	              });
	            });
	            observer.observe(target, {
	              childList: true,
	              subtree: true,
	              attributes: false,
	              characterData: false
	            });
	            this._observers.set(target, observer);
	          }
	        }, {
	          key: "removeObserver",
	          value: function removeObserver() {
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	            var observer = this._observers.get(target);
	            if (observer) {
	              observer.disconnect();
	              this._observers["delete"](target);
	            }
	          }
	        }, {
	          key: "hasTooltipContent",
	          value: function hasTooltipContent(value, el) {
	            var attributeValue = el.getAttribute('pros-tooltip');
	            if (attributeValue) {
	              attributeValue = attributeValue.trim();
	            }
	            var elContent = el.textContent.trim();
	            return attributeValue !== '' || elContent !== '';
	          }
	        }, {
	          key: "_bind",
	          value: function _bind(el) {
	            var _this2 = this;
	            var listener = function listener() {
	              var attributeValue = el.getAttribute('pros-tooltip');
	              if (!_this2.hasTooltipContent(attributeValue, el) || !attributeValue && isFullContentVisible(el)) {
	                // not specified and text not truncated - don't show tooltip
	                return;
	              }
	              var tooltipEl = document.createElement('pros-tooltip-overlay');
	              setContent(tooltipEl, el);
	              setPosition(tooltipEl, el);

	              // Hide, then append to get width, then show once width corrected.
	              // Approach from http://stackoverflow.com/a/2930159/277307
	              hideElement(tooltipEl);
	              document.body.appendChild(tooltipEl);
	              ensureEvenWidth(tooltipEl);
	              ensureNotClipped(tooltipEl);
	              showElement(tooltipEl);
	              removeOnMouseLeave.call(_this2, tooltipEl, el);
	            };
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (!enterListener) {
	              el.addEventListener('mouseenter', listener);
	              this._listeners.mouseenter.set(el, listener);
	            }
	          }
	        }, {
	          key: "_unbind",
	          value: function _unbind(el) {
	            var enterListener = this._listeners.mouseenter.get(el);
	            if (enterListener) {
	              el.removeEventListener('mouseenter', enterListener);
	              this._listeners.mouseenter["delete"](el);
	            }
	            var leaveListener = this._listeners.mouseleave.get(el);
	            if (leaveListener) {
	              leaveListener.call(this);
	            }
	          }
	        }]);
	      }(); // Adapted from http://stackoverflow.com/a/10017343/277307
	      function isFullContentVisible(el) {
	        return el.offsetWidth >= el.scrollWidth;
	      }
	      function setPosition(tooltipEl, el) {
	        tooltipEl.style.position = 'fixed';
	        var elRect = el.getBoundingClientRect();
	        tooltipEl.style.top = elRect.top + elRect.height + 'px';
	        // Center horizontally under element
	        tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
	        return tooltipEl;
	      }
	      function setContent(tooltipEl, el) {
	        var attrValue = el.getAttribute('pros-tooltip');
	        if (attrValue) {
	          // Use value if provided
	          if (attrValue[0] === '<') {
	            tooltipEl.innerHTML = attrValue;
	            tooltipEl.style.whiteSpace = 'unset';
	            tooltipEl.classList.add('pros-custom-tooltip');
	          } else {
	            tooltipEl.textContent = attrValue;
	          }
	        } else {
	          // Element text by default
	          tooltipEl.textContent = el.textContent;
	        }
	        return tooltipEl;
	      }
	      function removeOnMouseLeave(tooltipEl, el) {
	        var _this3 = this;
	        var _leaveHandler = function leaveHandler() {
	          document.body.removeChild(tooltipEl);
	          el.removeEventListener('mouseleave', _leaveHandler);
	          _this3._listeners.mouseleave["delete"](el);
	        };
	        el.addEventListener('mouseleave', _leaveHandler);
	        this._listeners.mouseleave.set(el, _leaveHandler);
	      }
	      function hideElement(tooltipEl) {
	        tooltipEl.style.visibility = 'hidden';
	      }
	      function showElement(tooltipEl) {
	        tooltipEl.style.removeProperty('visibility');
	      }

	      // Necessary because of chrome font antialiasing with translations on odd widths
	      // will cause blurry text. See http://stackoverflow.com/a/41456864/277307
	      function ensureEvenWidth(tooltipEl) {
	        var width = Math.round(tooltipEl.getBoundingClientRect().width);
	        if (width % 2 !== 0) {
	          width++;
	          tooltipEl.style.width = width + 'px';
	        }
	      }
	      function ensureNotClipped(tooltipEl) {
	        // Ensure not clipped by window boundary,
	        // since we're transforming left 50% and width could exceed the window.
	        var rect = tooltipEl.getBoundingClientRect();
	        var halfWidth = rect.width / 2;
	        if (rect.left < 0) {
	          tooltipEl.style.left = halfWidth + 'px';
	        } else if (rect.right > window.innerWidth) {
	          tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
	        }
	      }

	      exports.Tooltips = Tooltips;

	      Object.defineProperty(exports, '__esModule', { value: true });

	    })));
	    });

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/button/node_modules/@printos/agnostic-icon/src/Icon.svelte generated by Svelte v3.38.2 */

	    function add_css$7() {
	    	var style = element("style");
	    	style.id = "svelte-1if0avd-style";
	    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
	    	append(document.head, style);
	    }

	    // (3:4) {#if _content}
	    function create_if_block$8(ctx) {
	    	let html_tag;
	    	let html_anchor;

	    	return {
	    		c() {
	    			html_anchor = empty$1();
	    			html_tag = new HtmlTag(html_anchor);
	    		},
	    		m(target, anchor) {
	    			html_tag.m(/*_content*/ ctx[1], target, anchor);
	    			insert(target, html_anchor, anchor);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
	    		},
	    		d(detaching) {
	    			if (detaching) detach(html_anchor);
	    			if (detaching) html_tag.d();
	    		}
	    	};
	    }

	    function create_fragment$8(ctx) {
	    	let div1;
	    	let div0;
	    	let div0_pros_tooltip_value;
	    	let div1_class_value;
	    	let if_block = /*_content*/ ctx[1] && create_if_block$8(ctx);

	    	return {
	    		c() {
	    			div1 = element("div");
	    			div0 = element("div");
	    			if (if_block) if_block.c();
	    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
	    			attr(div0, "style", /*_style*/ ctx[4]);
	    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
	    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
	    			attr(div1, "style", /*_style*/ ctx[4]);
	    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    		},
	    		m(target, anchor) {
	    			insert(target, div1, anchor);
	    			append(div1, div0);
	    			if (if_block) if_block.m(div0, null);
	    			/*div1_binding*/ ctx[22](div1);
	    		},
	    		p(ctx, [dirty]) {
	    			if (/*_content*/ ctx[1]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);
	    				} else {
	    					if_block = create_if_block$8(ctx);
	    					if_block.c();
	    					if_block.m(div0, null);
	    				}
	    			} else if (if_block) {
	    				if_block.d(1);
	    				if_block = null;
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div0, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
	    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
	    			}

	    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
	    				attr(div1, "class", div1_class_value);
	    			}

	    			if (dirty & /*_style*/ 16) {
	    				attr(div1, "style", /*_style*/ ctx[4]);
	    			}

	    			if (dirty & /*_theme*/ 4) {
	    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
	    			}

	    			if (dirty & /*mode*/ 1) {
	    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
	    			}

	    			if (dirty & /*_className, disabled*/ 136) {
	    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div1);
	    			if (if_block) if_block.d();
	    			/*div1_binding*/ ctx[22](null);
	    		}
	    	};
	    }

	    function hasValue$6(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$8($$self, $$props, $$invalidate) {
	    	createEventDispatcher();
	    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
	    	let { mode = "default" } = $$props; // default/form
	    	let { className = "" } = $$props; // Class name
	    	let { tooltip } = $$props;
	    	let { disabled = false } = $$props;
	    	let { size = "24px" } = $$props;
	    	let { constraint = "h" } = $$props;
	    	let { color } = $$props;
	    	let { solid = false } = $$props;
	    	let { _content = undefined } = $$props;
	    	let { _theme } = $$props;
	    	let { _lastTheme } = $$props;
	    	let { _className } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _iconElement = undefined } = $$props;
	    	let { _lastName = null } = $$props;
	    	let { _lastPath = null } = $$props;
	    	let { _lastUrl = null } = $$props;

	    	onMount(() => {
	    		$$invalidate(3, _className = hasValue$6(className) ? className : "");
	    		updateContent();
	    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

	    	beforeUpdate(() => {
	    		$$invalidate(8, theme = hasValue$6(theme) ? theme : "light");
	    		$$invalidate(0, mode = hasValue$6(mode) ? mode : "icon");

	    		if (theme !== _lastTheme) {
	    			$$invalidate(9, _lastTheme = theme);

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(2, _theme = theme);
	    			}
	    		}

	    		if (name !== _lastName) {
	    			$$invalidate(10, _lastName = name);
	    			updateContent();
	    		}

	    		if (path !== _lastPath) {
	    			$$invalidate(11, _lastPath = path);
	    			updateContent();
	    		}

	    		if (url !== _lastUrl) {
	    			$$invalidate(12, _lastUrl = url);
	    			updateContent();
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function updateContent() {
	    		if (name) {
	    			let myName = solid ? name : `${name}-o`;
	    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
	    		} else if (path) {
	    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
	    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
	    		} else if (url) {
	    			loadContent.call(this, url);
	    		}
	    	}

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(2, _theme = event.detail.theme);
	    		}
	    	}

	    	// Others
	    	function loadContent(url) {
	    		let config = {
	    			url,
	    			cache: true,
	    			credentials: "omit",
	    			responseType: "text"
	    		};

	    		return dist.http.request(config).then(resp => {
	    			$$invalidate(1, _content = resp.data);
	    		});
	    	}

	    	function div1_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_iconElement = $$value;
	    			$$invalidate(5, _iconElement);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
	    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
	    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
	    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
	    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
	    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
	    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
	    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
	    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
	    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
	    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
	    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
	    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
	    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
	    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
	    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
	    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
	    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
	    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
	    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
	    			// onState
	    			{
	    				if (size) {
	    					let h;
	    					let w;

	    					switch (constraint) {
	    						case "b":
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = isNaN(size) ? size : `${size}px`;
	    							break;
	    						case "w":
	    							w = isNaN(size) ? size : `${size}px`;
	    							h = "fit-content";
	    							break;
	    						case "h":
	    						default:
	    							h = isNaN(size) ? size : `${size}px`;
	    							w = "fit-content";
	    							break;
	    					}

	    					$$invalidate(4, _style = `height:${h};width:${w};`);
	    				}

	    				if (color) {
	    					if (hasValue$6(color)) {
	    						$$invalidate(4, _style += `color:${color};fill:${color}`);
	    					}
	    				}
	    			}
	    		}
	    	};

	    	return [
	    		mode,
	    		_content,
	    		_theme,
	    		_className,
	    		_style,
	    		_iconElement,
	    		tooltip,
	    		disabled,
	    		theme,
	    		_lastTheme,
	    		_lastName,
	    		_lastPath,
	    		_lastUrl,
	    		name,
	    		path,
	    		url,
	    		className,
	    		size,
	    		constraint,
	    		color,
	    		solid,
	    		hasValue$6,
	    		div1_binding
	    	];
	    }

	    class Icon extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-1if0avd-style")) add_css$7();

	    		init(this, options, instance$8, create_fragment$8, safe_not_equal, {
	    			name: 13,
	    			path: 14,
	    			url: 15,
	    			theme: 8,
	    			mode: 0,
	    			className: 16,
	    			tooltip: 6,
	    			disabled: 7,
	    			size: 17,
	    			constraint: 18,
	    			color: 19,
	    			solid: 20,
	    			_content: 1,
	    			_theme: 2,
	    			_lastTheme: 9,
	    			_className: 3,
	    			_style: 4,
	    			_iconElement: 5,
	    			_lastName: 10,
	    			_lastPath: 11,
	    			_lastUrl: 12,
	    			hasValue: 21
	    		});
	    	}

	    	get hasValue() {
	    		return hasValue$6;
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/spinner/src/Spinner.svelte generated by Svelte v3.38.2 */

	    function create_else_block$7(ctx) {
	    	let svg;
	    	let rect;
	    	let circle;
	    	let animateTransform;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			rect = svg_element("rect");
	    			circle = svg_element("circle");
	    			animateTransform = svg_element("animateTransform");
	    			attr(rect, "x", "0");
	    			attr(rect, "y", "0");
	    			attr(rect, "width", "100");
	    			attr(rect, "height", "100");
	    			attr(rect, "fill", "none");
	    			attr(rect, "class", "bk");
	    			attr(animateTransform, "attributeName", "transform");
	    			attr(animateTransform, "type", "rotate");
	    			attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
	    			attr(animateTransform, "keyTimes", "0;0.5;1");
	    			attr(animateTransform, "dur", "1s");
	    			attr(animateTransform, "repeatCount", "indefinite");
	    			attr(animateTransform, "begin", "0s");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "50");
	    			attr(circle, "r", "42.5");
	    			attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
	    			attr(circle, "stroke", "currentColor");
	    			attr(circle, "fill", "none");
	    			attr(circle, "stroke-width", "15");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "fill", "currentColor");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    			attr(svg, "preserveAspectRatio", "xMidYMid");
	    			attr(svg, "class", "uil-ring");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, rect);
	    			append(svg, circle);
	    			append(circle, animateTransform);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    // (2:2) {#if mode === 'printos'}
	    function create_if_block$7(ctx) {
	    	let svg;
	    	let style;
	    	let t;
	    	let path0;
	    	let path1;
	    	let g;
	    	let circle;

	    	return {
	    		c() {
	    			svg = svg_element("svg");
	    			style = svg_element("style");
	    			t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
	    			path0 = svg_element("path");
	    			path1 = svg_element("path");
	    			g = svg_element("g");
	    			circle = svg_element("circle");
	    			attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
	    			attr(path0, "id", "el_OK7WH8ppuY");
	    			attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
	    			attr(path1, "id", "el_pzIR5oVpeo");
	    			attr(circle, "cx", "50");
	    			attr(circle, "cy", "67.33");
	    			attr(circle, "r", "25");
	    			attr(circle, "stroke-dasharray", "55");
	    			attr(circle, "id", "el_3R6WG92ED-");
	    			attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
	    			attr(g, "data-animator-group", "true");
	    			attr(g, "data-animator-type", "1");
	    			attr(svg, "style", /*_style*/ ctx[0]);
	    			attr(svg, "id", "el_ztyBp85wH");
	    			attr(svg, "data-name", "Layer 1");
	    			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	    			attr(svg, "viewBox", "0 0 100 100");
	    		},
	    		m(target, anchor) {
	    			insert(target, svg, anchor);
	    			append(svg, style);
	    			append(style, t);
	    			append(svg, path0);
	    			append(svg, path1);
	    			append(svg, g);
	    			append(g, circle);
	    		},
	    		p(ctx, dirty) {
	    			if (dirty & /*_style*/ 1) {
	    				attr(svg, "style", /*_style*/ ctx[0]);
	    			}
	    		},
	    		d(detaching) {
	    			if (detaching) detach(svg);
	    		}
	    	};
	    }

	    function create_fragment$7(ctx) {
	    	let div;

	    	function select_block_type(ctx, dirty) {
	    		if (/*mode*/ ctx[1] === "printos") return create_if_block$7;
	    		return create_else_block$7;
	    	}

	    	let current_block_type = select_block_type(ctx);
	    	let if_block = current_block_type(ctx);

	    	return {
	    		c() {
	    			div = element("div");
	    			if_block.c();
	    			attr(div, "class", "pros-spinner");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			if_block.m(div, null);
	    		},
	    		p(ctx, [dirty]) {
	    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	    				if_block.p(ctx, dirty);
	    			} else {
	    				if_block.d(1);
	    				if_block = current_block_type(ctx);

	    				if (if_block) {
	    					if_block.c();
	    					if_block.m(div, null);
	    				}
	    			}
	    		},
	    		i: noop,
	    		o: noop,
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			if_block.d();
	    		}
	    	};
	    }

	    function instance$7($$self, $$props, $$invalidate) {
	    	let { diameter = null } = $$props;
	    	let { mode = null } = $$props;
	    	let { color = null } = $$props;
	    	let { _style = "" } = $$props;
	    	let { _diameter = null } = $$props;

	    	$$self.$$set = $$props => {
	    		if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
	    		if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
	    		if ("color" in $$props) $$invalidate(4, color = $$props.color);
	    		if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
	    		if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/ 31) {
	    			{
	    				$$invalidate(2, _diameter = diameter ? Number(diameter) : null);

	    				if (!_diameter) {
	    					$$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
	    				}

	    				$$invalidate(0, _style = `height:${_diameter}px;width:${_diameter}px;`);
	    				$$invalidate(0, _style += color ? `color:${color};` : `color:#0096d6;`);
	    			}
	    		}
	    	};

	    	return [_style, mode, _diameter, diameter, color];
	    }

	    class Spinner extends SvelteComponent {
	    	constructor(options) {
	    		super();

	    		init(this, options, instance$7, create_fragment$7, safe_not_equal, {
	    			diameter: 3,
	    			mode: 1,
	    			color: 4,
	    			_style: 0,
	    			_diameter: 2
	    		});
	    	}
	    }

	    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/button/src/Button.svelte generated by Svelte v3.38.2 */

	    function add_css$6() {
	    	var style = element("style");
	    	style.id = "svelte-192il0a-style";
	    	style.textContent = ".pros-button-wrapper.svelte-192il0a.svelte-192il0a{display:flex;justify-content:center;align-items:center;height:48px;min-width:48px;padding:0 16px 0 16px;user-select:none;border-radius:12px;box-sizing:border-box;cursor:pointer;appearance:none;outline:none;border:0;margin:0;overflow:visible;text-decoration:none;text-transform:none;box-shadow:none;font-size:16px;position:relative;transition:background-color 0.3s ease}.pros-button-wrapper.icon-only.svelte-192il0a.svelte-192il0a{padding:0 16px;width:48px}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:after{border-radius:14px;border-width:2px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper.svelte-192il0a .pros-button-content.svelte-192il0a{display:flex;justify-content:flex-start;align-items:center}.pros-button-wrapper.svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-4px}.pros-button-wrapper.disabled.svelte-192il0a.svelte-192il0a:after{opacity:0;inset:0}.pros-button-wrapper.svelte-192il0a .pros-icon-container.svelte-192il0a{min-width:24px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.left.svelte-192il0a{margin-right:8px}.pros-button-wrapper.svelte-192il0a .pros-icon-container.right.svelte-192il0a{margin-left:8px}.pros-button-wrapper.svelte-192il0a .pros-button-label.svelte-192il0a{flex:1;white-space:nowrap}.pros-button-wrapper[pos--density=high].svelte-192il0a.svelte-192il0a{height:36px;min-width:36px;border-radius:8px}.pros-button-wrapper[pos--density=high].icon-only.svelte-192il0a.svelte-192il0a{width:36px}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a{border-radius:unset}.pros-button-wrapper[pos--shape=sharp].svelte-192il0a.svelte-192il0a:after{border-radius:0}.pros-button-wrapper[pos--mode=form].svelte-192il0a.svelte-192il0a{margin-bottom:20px}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a{height:auto;width:auto;min-width:unset;padding:0}.pros-button-wrapper[pos--mode=toolbar].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a{height:32px;min-width:32px;padding:0;border-radius:4px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:after{border-radius:4px;border-width:1px}.pros-button-wrapper[pos--mode=action].svelte-192il0a.svelte-192il0a:focus:after{opacity:0;inset:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a{padding:0;max-height:36px;width:36px;min-width:36px;border-radius:10px}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:after{border-radius:12px;border-width:1px;border-style:solid;content:\" \";transition:all 50ms ease 0s;inset:0;position:absolute;opacity:0}.pros-button-wrapper[pos--mode=header].svelte-192il0a.svelte-192il0a:focus:after{opacity:1;inset:-2px}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#035c84}.pros-button-wrapper[pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#212121;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=light][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#404040;background-color:#ffffff}.pros-button-wrapper[pos--theme=light][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#363636}.pros-button-wrapper[pos--theme=light][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#135b08}.pros-button-wrapper[pos--theme=light][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#a90b0a}.pros-button-wrapper[pos--theme=light][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#b55500}.pros-button-wrapper[pos--theme=light][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:rgba(33, 33, 33, 0.05);cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #027aae;color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #1c7a17;color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #be1313;color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #d06702;color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#adadad;background-color:unset;color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#027aae;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#027aae}.pros-button-wrapper[pos--theme=light][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#035c84;background-color:rgba(2, 122, 174, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#1c7a17;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#1c7a17}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#135b08;background-color:rgba(28, 122, 23, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#be1313;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#be1313}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#a90b0a;background-color:rgba(190, 19, 19, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#d06702;background-color:unset}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#d06702}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#b55500;background-color:rgba(208, 103, 2, 0.05)}.pros-button-wrapper[pos--theme=light][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a{color:#404040;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:after{border-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=light].svelte-192il0a.svelte-192il0a:hover{background-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=light].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#6dd0fb}.pros-button-wrapper[pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a{color:#ffffff;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].svelte-192il0a.svelte-192il0a:hover{background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--mode=toolbar].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;background-color:unset;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:#2b2b2b}.pros-button-wrapper[pos--theme=dark][pos--mode=action].svelte-192il0a.svelte-192il0a:hover{color:#f1f1f1}.pros-button-wrapper[pos--theme=dark][pos--mode=action].disabled.svelte-192il0a.svelte-192il0a{color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{background-color:#8ef291}.pros-button-wrapper[pos--theme=dark][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{background-color:#f48787}.pros-button-wrapper[pos--theme=dark][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#212121;background-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{background-color:#fdd1a5}.pros-button-wrapper[pos--theme=dark][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{color:#737373;background-color:rgba(255, 255, 255, 0.05);cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a{border:1px solid #3ab4eb;color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a{border:1px solid #67df6a;color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a{border:1px solid #eb5e5e;color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a{border:1px solid #f9c086;color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=secondary][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{border-color:#737373;background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a{color:#3ab4eb;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:after{border-color:#3ab4eb}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].svelte-192il0a.svelte-192il0a:hover{color:#6dd0fb;background-color:rgba(58, 180, 235, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a{color:#67df6a;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:after{border-color:#67df6a}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].svelte-192il0a.svelte-192il0a:hover{color:#8ef291;background-color:rgba(103, 223, 106, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=positive].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a{color:#eb5e5e;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:after{border-color:#eb5e5e}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].svelte-192il0a.svelte-192il0a:hover{color:#f48787;background-color:rgba(235, 94, 94, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=negative].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a{color:#f9c086;background-color:unset}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:after{border-color:#f9c086}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].svelte-192il0a.svelte-192il0a:hover{color:#fdd1a5;background-color:rgba(249, 192, 134, 0.05)}.pros-button-wrapper[pos--theme=dark][pos--display=ghost][pos--scheme=warning].disabled.svelte-192il0a.svelte-192il0a{background-color:unset;color:#737373;cursor:default}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a{color:#ebebeb;background-color:unset}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:after{border-color:#ebebeb}.pros-button-wrapper[pos--mode=header][pos--theme=dark].svelte-192il0a.svelte-192il0a:hover{background-color:#404040}.pros-button-wrapper[pos--mode=header][pos--theme=dark].disabled.svelte-192il0a.svelte-192il0a{color:#adadad;cursor:default}";
	    	append(document.head, style);
	    }

	    // (16:0) {:else}
	    function create_else_block$6(ctx) {
	    	let button;
	    	let div;
	    	let t;
	    	let button_class_value;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*loading*/ ctx[11] && create_if_block_7$3();
	    	let if_block1 = !/*loading*/ ctx[11] && create_if_block_4$6(ctx);

	    	return {
	    		c() {
	    			button = element("button");
	    			div = element("div");
	    			if (if_block0) if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			attr(div, "class", "pros-button-content svelte-192il0a");
	    			attr(button, "id", /*_id*/ ctx[21]);
	    			attr(button, "type", "button");
	    			attr(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a");
	    			attr(button, "style", /*_style*/ ctx[18]);
	    			attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			attr(button, "pos--density", /*_density*/ ctx[16]);
	    			attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			attr(button, "pos--display", /*display*/ ctx[8]);
	    			toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    		},
	    		m(target, anchor) {
	    			insert(target, button, anchor);
	    			append(button, div);
	    			if (if_block0) if_block0.m(div, null);
	    			append(div, t);
	    			if (if_block1) if_block1.m(div, null);
	    			/*button_binding_1*/ ctx[57](button);
	    			current = true;

	    			if (!mounted) {
	    				dispose = listen(button, "click", /*handleClick*/ ctx[22]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*loading*/ ctx[11]) {
	    				if (if_block0) {
	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_7$3();
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(div, t);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!/*loading*/ ctx[11]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_4$6(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(div, null);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*_id*/ 2097152) {
	    				attr(button, "id", /*_id*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_class*/ 131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a")) {
	    				attr(button, "class", button_class_value);
	    			}

	    			if (!current || dirty[0] & /*_style*/ 262144) {
	    				attr(button, "style", /*_style*/ ctx[18]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 16384) {
	    				attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 32768) {
	    				attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 65536) {
	    				attr(button, "pos--density", /*_density*/ ctx[16]);
	    			}

	    			if (!current || dirty[0] & /*mode*/ 8) {
	    				attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			}

	    			if (!current || dirty[0] & /*scheme*/ 16) {
	    				attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			}

	    			if (!current || dirty[0] & /*display*/ 256) {
	    				attr(button, "pos--display", /*display*/ ctx[8]);
	    			}

	    			if (dirty[0] & /*_class, disabled*/ 132096) {
	    				toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(button);
	    			if (if_block0) if_block0.d();
	    			if (if_block1) if_block1.d();
	    			/*button_binding_1*/ ctx[57](null);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (1:0) {#if _iconOnly}
	    function create_if_block$6(ctx) {
	    	let button;
	    	let div;
	    	let t;
	    	let button_class_value;
	    	let current;
	    	let mounted;
	    	let dispose;
	    	let if_block0 = /*loading*/ ctx[11] && create_if_block_3$6();
	    	let if_block1 = !/*loading*/ ctx[11] && create_if_block_1$6(ctx);

	    	return {
	    		c() {
	    			button = element("button");
	    			div = element("div");
	    			if (if_block0) if_block0.c();
	    			t = space();
	    			if (if_block1) if_block1.c();
	    			attr(div, "class", "pros-button-content svelte-192il0a");
	    			attr(button, "id", /*_id*/ ctx[21]);
	    			attr(button, "type", "button");
	    			attr(button, "class", button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a");
	    			attr(button, "style", /*_style*/ ctx[18]);
	    			attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			attr(button, "pos--density", /*_density*/ ctx[16]);
	    			attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			attr(button, "pos--display", /*display*/ ctx[8]);
	    			attr(button, "pros-tooltip", /*label*/ ctx[9]);
	    			toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			toggle_class(button, "icon-only", /*_iconOnly*/ ctx[12]);
	    		},
	    		m(target, anchor) {
	    			insert(target, button, anchor);
	    			append(button, div);
	    			if (if_block0) if_block0.m(div, null);
	    			append(div, t);
	    			if (if_block1) if_block1.m(div, null);
	    			/*button_binding*/ ctx[42](button);
	    			current = true;

	    			if (!mounted) {
	    				dispose = listen(button, "click", /*handleClick*/ ctx[22]);
	    				mounted = true;
	    			}
	    		},
	    		p(ctx, dirty) {
	    			if (/*loading*/ ctx[11]) {
	    				if (if_block0) {
	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_3$6();
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(div, t);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!/*loading*/ ctx[11]) {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*loading*/ 2048) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_1$6(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(div, null);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*_id*/ 2097152) {
	    				attr(button, "id", /*_id*/ ctx[21]);
	    			}

	    			if (!current || dirty[0] & /*_class*/ 131072 && button_class_value !== (button_class_value = "pros-button-wrapper " + /*_class*/ ctx[17] + " svelte-192il0a")) {
	    				attr(button, "class", button_class_value);
	    			}

	    			if (!current || dirty[0] & /*_style*/ 262144) {
	    				attr(button, "style", /*_style*/ ctx[18]);
	    			}

	    			if (!current || dirty[0] & /*_theme*/ 16384) {
	    				attr(button, "pos--theme", /*_theme*/ ctx[14]);
	    			}

	    			if (!current || dirty[0] & /*_shape*/ 32768) {
	    				attr(button, "pos--shape", /*_shape*/ ctx[15]);
	    			}

	    			if (!current || dirty[0] & /*_density*/ 65536) {
	    				attr(button, "pos--density", /*_density*/ ctx[16]);
	    			}

	    			if (!current || dirty[0] & /*mode*/ 8) {
	    				attr(button, "pos--mode", /*mode*/ ctx[3]);
	    			}

	    			if (!current || dirty[0] & /*scheme*/ 16) {
	    				attr(button, "pos--scheme", /*scheme*/ ctx[4]);
	    			}

	    			if (!current || dirty[0] & /*display*/ 256) {
	    				attr(button, "pos--display", /*display*/ ctx[8]);
	    			}

	    			if (!current || dirty[0] & /*label*/ 512) {
	    				attr(button, "pros-tooltip", /*label*/ ctx[9]);
	    			}

	    			if (dirty[0] & /*_class, disabled*/ 132096) {
	    				toggle_class(button, "disabled", /*disabled*/ ctx[10]);
	    			}

	    			if (dirty[0] & /*_class, _iconOnly*/ 135168) {
	    				toggle_class(button, "icon-only", /*_iconOnly*/ ctx[12]);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(button);
	    			if (if_block0) if_block0.d();
	    			if (if_block1) if_block1.d();
	    			/*button_binding*/ ctx[42](null);
	    			mounted = false;
	    			dispose();
	    		}
	    	};
	    }

	    // (19:4) {#if loading}
	    function create_if_block_7$3(ctx) {
	    	let spinner;
	    	let current;
	    	spinner = new Spinner({ props: { diameter: "24" } });

	    	return {
	    		c() {
	    			create_component(spinner.$$.fragment);
	    		},
	    		m(target, anchor) {
	    			mount_component(spinner, target, anchor);
	    			current = true;
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(spinner.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(spinner.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			destroy_component(spinner, detaching);
	    		}
	    	};
	    }

	    // (22:4) {#if !loading}
	    function create_if_block_4$6(ctx) {
	    	let t0;
	    	let div;
	    	let t1;
	    	let t2;
	    	let if_block1_anchor;
	    	let current;
	    	let if_block0 = /*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "left" && create_if_block_6$3(ctx);
	    	let if_block1 = /*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "right" && create_if_block_5$4(ctx);

	    	return {
	    		c() {
	    			if (if_block0) if_block0.c();
	    			t0 = space();
	    			div = element("div");
	    			t1 = text(/*label*/ ctx[9]);
	    			t2 = space();
	    			if (if_block1) if_block1.c();
	    			if_block1_anchor = empty$1();
	    			attr(div, "class", "pros-button-label svelte-192il0a");
	    			attr(div, "pros-tooltip", "");
	    			toggle_class(div, "right", /*iconPosition*/ ctx[5] === "right");
	    		},
	    		m(target, anchor) {
	    			if (if_block0) if_block0.m(target, anchor);
	    			insert(target, t0, anchor);
	    			insert(target, div, anchor);
	    			append(div, t1);
	    			insert(target, t2, anchor);
	    			if (if_block1) if_block1.m(target, anchor);
	    			insert(target, if_block1_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "left") {
	    				if (if_block0) {
	    					if_block0.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon, iconPosition*/ 8224) {
	    						transition_in(if_block0, 1);
	    					}
	    				} else {
	    					if_block0 = create_if_block_6$3(ctx);
	    					if_block0.c();
	    					transition_in(if_block0, 1);
	    					if_block0.m(t0.parentNode, t0);
	    				}
	    			} else if (if_block0) {
	    				group_outros();

	    				transition_out(if_block0, 1, 1, () => {
	    					if_block0 = null;
	    				});

	    				check_outros();
	    			}

	    			if (!current || dirty[0] & /*label*/ 512) set_data(t1, /*label*/ ctx[9]);

	    			if (dirty[0] & /*iconPosition*/ 32) {
	    				toggle_class(div, "right", /*iconPosition*/ ctx[5] === "right");
	    			}

	    			if (/*_hasIcon*/ ctx[13] && /*iconPosition*/ ctx[5] === "right") {
	    				if (if_block1) {
	    					if_block1.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon, iconPosition*/ 8224) {
	    						transition_in(if_block1, 1);
	    					}
	    				} else {
	    					if_block1 = create_if_block_5$4(ctx);
	    					if_block1.c();
	    					transition_in(if_block1, 1);
	    					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	    				}
	    			} else if (if_block1) {
	    				group_outros();

	    				transition_out(if_block1, 1, 1, () => {
	    					if_block1 = null;
	    				});

	    				check_outros();
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block0);
	    			transition_in(if_block1);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block0);
	    			transition_out(if_block1);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (if_block0) if_block0.d(detaching);
	    			if (detaching) detach(t0);
	    			if (detaching) detach(div);
	    			if (detaching) detach(t2);
	    			if (if_block1) if_block1.d(detaching);
	    			if (detaching) detach(if_block1_anchor);
	    		}
	    	};
	    }

	    // (23:6) {#if _hasIcon && iconPosition === 'left'}
	    function create_if_block_6$3(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding_1(value) {
	    		/*icon_1_name_binding_1*/ ctx[43](value);
	    	}

	    	function icon_1_path_binding_1(value) {
	    		/*icon_1_path_binding_1*/ ctx[44](value);
	    	}

	    	function icon_1_url_binding_1(value) {
	    		/*icon_1_url_binding_1*/ ctx[45](value);
	    	}

	    	function icon_1_solid_binding_1(value) {
	    		/*icon_1_solid_binding_1*/ ctx[46](value);
	    	}

	    	function icon_1_size_binding_1(value) {
	    		/*icon_1_size_binding_1*/ ctx[47](value);
	    	}

	    	function icon_1_constraint_binding_1(value) {
	    		/*icon_1_constraint_binding_1*/ ctx[48](value);
	    	}

	    	function icon_1_theme_binding_1(value) {
	    		/*icon_1_theme_binding_1*/ ctx[49](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding_1));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding_1));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container left svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    // (29:6) {#if _hasIcon && iconPosition === 'right'}
	    function create_if_block_5$4(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding_2(value) {
	    		/*icon_1_name_binding_2*/ ctx[50](value);
	    	}

	    	function icon_1_path_binding_2(value) {
	    		/*icon_1_path_binding_2*/ ctx[51](value);
	    	}

	    	function icon_1_url_binding_2(value) {
	    		/*icon_1_url_binding_2*/ ctx[52](value);
	    	}

	    	function icon_1_solid_binding_2(value) {
	    		/*icon_1_solid_binding_2*/ ctx[53](value);
	    	}

	    	function icon_1_size_binding_2(value) {
	    		/*icon_1_size_binding_2*/ ctx[54](value);
	    	}

	    	function icon_1_constraint_binding_2(value) {
	    		/*icon_1_constraint_binding_2*/ ctx[55](value);
	    	}

	    	function icon_1_theme_binding_2(value) {
	    		/*icon_1_theme_binding_2*/ ctx[56](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding_2));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding_2));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container right svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    // (4:4) {#if loading}
	    function create_if_block_3$6(ctx) {
	    	let spinner;
	    	let current;
	    	spinner = new Spinner({ props: { diameter: "24" } });

	    	return {
	    		c() {
	    			create_component(spinner.$$.fragment);
	    		},
	    		m(target, anchor) {
	    			mount_component(spinner, target, anchor);
	    			current = true;
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(spinner.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(spinner.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			destroy_component(spinner, detaching);
	    		}
	    	};
	    }

	    // (7:4) {#if !loading}
	    function create_if_block_1$6(ctx) {
	    	let if_block_anchor;
	    	let current;
	    	let if_block = /*_hasIcon*/ ctx[13] && create_if_block_2$6(ctx);

	    	return {
	    		c() {
	    			if (if_block) if_block.c();
	    			if_block_anchor = empty$1();
	    		},
	    		m(target, anchor) {
	    			if (if_block) if_block.m(target, anchor);
	    			insert(target, if_block_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			if (/*_hasIcon*/ ctx[13]) {
	    				if (if_block) {
	    					if_block.p(ctx, dirty);

	    					if (dirty[0] & /*_hasIcon*/ 8192) {
	    						transition_in(if_block, 1);
	    					}
	    				} else {
	    					if_block = create_if_block_2$6(ctx);
	    					if_block.c();
	    					transition_in(if_block, 1);
	    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
	    				}
	    			} else if (if_block) {
	    				group_outros();

	    				transition_out(if_block, 1, 1, () => {
	    					if_block = null;
	    				});

	    				check_outros();
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (if_block) if_block.d(detaching);
	    			if (detaching) detach(if_block_anchor);
	    		}
	    	};
	    }

	    // (8:6) {#if _hasIcon}
	    function create_if_block_2$6(ctx) {
	    	let div;
	    	let icon_1;
	    	let updating_name;
	    	let updating_path;
	    	let updating_url;
	    	let updating_solid;
	    	let updating_size;
	    	let updating_constraint;
	    	let updating_theme;
	    	let current;

	    	function icon_1_name_binding(value) {
	    		/*icon_1_name_binding*/ ctx[35](value);
	    	}

	    	function icon_1_path_binding(value) {
	    		/*icon_1_path_binding*/ ctx[36](value);
	    	}

	    	function icon_1_url_binding(value) {
	    		/*icon_1_url_binding*/ ctx[37](value);
	    	}

	    	function icon_1_solid_binding(value) {
	    		/*icon_1_solid_binding*/ ctx[38](value);
	    	}

	    	function icon_1_size_binding(value) {
	    		/*icon_1_size_binding*/ ctx[39](value);
	    	}

	    	function icon_1_constraint_binding(value) {
	    		/*icon_1_constraint_binding*/ ctx[40](value);
	    	}

	    	function icon_1_theme_binding(value) {
	    		/*icon_1_theme_binding*/ ctx[41](value);
	    	}

	    	let icon_1_props = { mode: "button" };

	    	if (/*iconName*/ ctx[0] !== void 0) {
	    		icon_1_props.name = /*iconName*/ ctx[0];
	    	}

	    	if (/*iconPath*/ ctx[1] !== void 0) {
	    		icon_1_props.path = /*iconPath*/ ctx[1];
	    	}

	    	if (/*iconUrl*/ ctx[2] !== void 0) {
	    		icon_1_props.url = /*iconUrl*/ ctx[2];
	    	}

	    	if (/*_solid*/ ctx[19] !== void 0) {
	    		icon_1_props.solid = /*_solid*/ ctx[19];
	    	}

	    	if (/*iconSize*/ ctx[6] !== void 0) {
	    		icon_1_props.size = /*iconSize*/ ctx[6];
	    	}

	    	if (/*iconConstraint*/ ctx[7] !== void 0) {
	    		icon_1_props.constraint = /*iconConstraint*/ ctx[7];
	    	}

	    	if (/*_theme*/ ctx[14] !== void 0) {
	    		icon_1_props.theme = /*_theme*/ ctx[14];
	    	}

	    	icon_1 = new Icon({ props: icon_1_props });
	    	binding_callbacks.push(() => bind(icon_1, "name", icon_1_name_binding));
	    	binding_callbacks.push(() => bind(icon_1, "path", icon_1_path_binding));
	    	binding_callbacks.push(() => bind(icon_1, "url", icon_1_url_binding));
	    	binding_callbacks.push(() => bind(icon_1, "solid", icon_1_solid_binding));
	    	binding_callbacks.push(() => bind(icon_1, "size", icon_1_size_binding));
	    	binding_callbacks.push(() => bind(icon_1, "constraint", icon_1_constraint_binding));
	    	binding_callbacks.push(() => bind(icon_1, "theme", icon_1_theme_binding));

	    	return {
	    		c() {
	    			div = element("div");
	    			create_component(icon_1.$$.fragment);
	    			attr(div, "class", "pros-icon-container svelte-192il0a");
	    		},
	    		m(target, anchor) {
	    			insert(target, div, anchor);
	    			mount_component(icon_1, div, null);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			const icon_1_changes = {};

	    			if (!updating_name && dirty[0] & /*iconName*/ 1) {
	    				updating_name = true;
	    				icon_1_changes.name = /*iconName*/ ctx[0];
	    				add_flush_callback(() => updating_name = false);
	    			}

	    			if (!updating_path && dirty[0] & /*iconPath*/ 2) {
	    				updating_path = true;
	    				icon_1_changes.path = /*iconPath*/ ctx[1];
	    				add_flush_callback(() => updating_path = false);
	    			}

	    			if (!updating_url && dirty[0] & /*iconUrl*/ 4) {
	    				updating_url = true;
	    				icon_1_changes.url = /*iconUrl*/ ctx[2];
	    				add_flush_callback(() => updating_url = false);
	    			}

	    			if (!updating_solid && dirty[0] & /*_solid*/ 524288) {
	    				updating_solid = true;
	    				icon_1_changes.solid = /*_solid*/ ctx[19];
	    				add_flush_callback(() => updating_solid = false);
	    			}

	    			if (!updating_size && dirty[0] & /*iconSize*/ 64) {
	    				updating_size = true;
	    				icon_1_changes.size = /*iconSize*/ ctx[6];
	    				add_flush_callback(() => updating_size = false);
	    			}

	    			if (!updating_constraint && dirty[0] & /*iconConstraint*/ 128) {
	    				updating_constraint = true;
	    				icon_1_changes.constraint = /*iconConstraint*/ ctx[7];
	    				add_flush_callback(() => updating_constraint = false);
	    			}

	    			if (!updating_theme && dirty[0] & /*_theme*/ 16384) {
	    				updating_theme = true;
	    				icon_1_changes.theme = /*_theme*/ ctx[14];
	    				add_flush_callback(() => updating_theme = false);
	    			}

	    			icon_1.$set(icon_1_changes);
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(icon_1.$$.fragment, local);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(icon_1.$$.fragment, local);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if (detaching) detach(div);
	    			destroy_component(icon_1);
	    		}
	    	};
	    }

	    function create_fragment$6(ctx) {
	    	let current_block_type_index;
	    	let if_block;
	    	let if_block_anchor;
	    	let current;
	    	const if_block_creators = [create_if_block$6, create_else_block$6];
	    	const if_blocks = [];

	    	function select_block_type(ctx, dirty) {
	    		if (/*_iconOnly*/ ctx[12]) return 0;
	    		return 1;
	    	}

	    	current_block_type_index = select_block_type(ctx);
	    	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	    	return {
	    		c() {
	    			if_block.c();
	    			if_block_anchor = empty$1();
	    		},
	    		m(target, anchor) {
	    			if_blocks[current_block_type_index].m(target, anchor);
	    			insert(target, if_block_anchor, anchor);
	    			current = true;
	    		},
	    		p(ctx, dirty) {
	    			let previous_block_index = current_block_type_index;
	    			current_block_type_index = select_block_type(ctx);

	    			if (current_block_type_index === previous_block_index) {
	    				if_blocks[current_block_type_index].p(ctx, dirty);
	    			} else {
	    				group_outros();

	    				transition_out(if_blocks[previous_block_index], 1, 1, () => {
	    					if_blocks[previous_block_index] = null;
	    				});

	    				check_outros();
	    				if_block = if_blocks[current_block_type_index];

	    				if (!if_block) {
	    					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	    					if_block.c();
	    				} else {
	    					if_block.p(ctx, dirty);
	    				}

	    				transition_in(if_block, 1);
	    				if_block.m(if_block_anchor.parentNode, if_block_anchor);
	    			}
	    		},
	    		i(local) {
	    			if (current) return;
	    			transition_in(if_block);
	    			current = true;
	    		},
	    		o(local) {
	    			transition_out(if_block);
	    			current = false;
	    		},
	    		d(detaching) {
	    			if_blocks[current_block_type_index].d(detaching);
	    			if (detaching) detach(if_block_anchor);
	    		}
	    	};
	    }

	    function hasValue$5(test) {
	    	return test !== undefined && test !== null;
	    }

	    function instance$6($$self, $$props, $$invalidate) {
	    	const dispatch = createEventDispatcher();
	    	let { mode = "default" } = $$props; // Icon, Button, Toolbar_Icon, Toolbar_Button
	    	let { display = "primary" } = $$props; // primary, secondary, ghost, panel
	    	let { theme = "light" } = $$props; // auto, light, dark
	    	let { shape = "round" } = $$props; // round/sharp
	    	let { density = "standard" } = $$props; // standard/high
	    	let { scheme = "default" } = $$props; // default/positive/negative/warning
	    	let { iconName = "" } = $$props; // Name of veneer image (E.G. 'alarm')
	    	let { iconPath = "" } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
	    	let { iconUrl = "" } = $$props; // Full path of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
	    	let { iconPosition = "left" } = $$props; // Icon to left or right of text
	    	let { iconSize = "24px" } = $$props; // Icon to left or right of text
	    	let { iconConstraint = "h" } = $$props; // Icon to left or right of text
	    	let { icon = false } = $$props; // Icon to left or right of text
	    	let { label = "" } = $$props; // Button name or Tooltip for Icon Button
	    	let { className = "" } = $$props; // Class name
	    	let { disabled = false } = $$props;
	    	let { solid = false } = $$props;
	    	let { height } = $$props;
	    	let { width } = $$props;
	    	let { loading = false } = $$props;
	    	let { id = null } = $$props;

	    	// Internal Data
	    	let _hasIcon = false;

	    	let _iconOnly = false;
	    	let _theme;
	    	let _shape;
	    	let _density;
	    	let _lastTheme;
	    	let _lastShape;
	    	let _lastDensity;
	    	let _class;
	    	let _style = "";
	    	let _solid = false;
	    	let _buttonWrapper;
	    	let _width;
	    	let _height;
	    	let _id;

	    	onMount(() => {
	    		
	    	}); // _buttonWrapper.parentElement.style.height = _height;

	    	beforeUpdate(() => {
	    		$$invalidate(23, theme = hasValue$5(theme) ? theme : "light");
	    		$$invalidate(3, mode = hasValue$5(mode) ? mode : "default");
	    		$$invalidate(4, scheme = hasValue$5(scheme) ? scheme : "default");

	    		$$invalidate(19, _solid = hasValue$5(solid)
	    		? solid === true || solid === "true"
	    		: false);

	    		$$invalidate(17, _class = hasValue$5(className) ? className : "");
	    		$$invalidate(5, iconPosition = hasValue$5(iconPosition) ? iconPosition : "left");
	    		$$invalidate(21, _id = hasValue$5(id) ? `${id}-click` : undefined);

	    		if (theme !== _lastTheme) {
	    			_lastTheme = theme;

	    			if (theme === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--theme");
	    				$$invalidate(14, _theme = themeAttribute ? themeAttribute : "light");
	    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    				window.addEventListener("posh-theme-changed", handleThemeChanged);
	    			} else {
	    				$$invalidate(14, _theme = theme);
	    			}
	    		}

	    		if (shape !== _lastShape) {
	    			_lastShape = shape;

	    			if (shape === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--shape");
	    				$$invalidate(15, _shape = themeAttribute ? themeAttribute : "round");

	    				if (!_shapeEventListener) {
	    					// Only start listening once
	    					_shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	    						if (shape === "auto") {
	    							$$invalidate(15, _shape = event.detail.shape);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(15, _shape = shape);
	    			}
	    		}

	    		if (density !== _lastDensity) {
	    			_lastDensity = density;

	    			if (density === "auto") {
	    				let themeAttribute = window.document.body.getAttribute("pos--density");
	    				$$invalidate(16, _density = themeAttribute ? themeAttribute : "standard");

	    				if (!_densityEventListener) {
	    					// Only start listening once
	    					_densityEventListener = window.addEventListener("posh-density-changed", event => {
	    						if (density === "auto") {
	    							$$invalidate(16, _density = event.detail.density);
	    						}
	    					});
	    				}
	    			} else {
	    				$$invalidate(16, _density = density);
	    			}
	    		}
	    	});

	    	onDestroy(() => {
	    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
	    	});

	    	function handleThemeChanged(event) {
	    		if (theme === "auto") {
	    			$$invalidate(14, _theme = event.detail.theme);
	    		}
	    	}

	    	function handleClick(event) {
	    		if (disabled) {
	    			event.stopPropagation();
	    			return;
	    		}

	    		_buttonWrapper.blur();

	    		window.setTimeout(() => {
	    			dispatch("clicked", event);
	    		});
	    	}

	    	function icon_1_name_binding(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function button_binding($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_buttonWrapper = $$value;
	    			$$invalidate(20, _buttonWrapper);
	    		});
	    	}

	    	function icon_1_name_binding_1(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding_1(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding_1(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding_1(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding_1(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding_1(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding_1(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function icon_1_name_binding_2(value) {
	    		iconName = value;
	    		$$invalidate(0, iconName);
	    	}

	    	function icon_1_path_binding_2(value) {
	    		iconPath = value;
	    		$$invalidate(1, iconPath);
	    	}

	    	function icon_1_url_binding_2(value) {
	    		iconUrl = value;
	    		$$invalidate(2, iconUrl);
	    	}

	    	function icon_1_solid_binding_2(value) {
	    		_solid = value;
	    		$$invalidate(19, _solid);
	    	}

	    	function icon_1_size_binding_2(value) {
	    		iconSize = value;
	    		$$invalidate(6, iconSize);
	    	}

	    	function icon_1_constraint_binding_2(value) {
	    		iconConstraint = value;
	    		$$invalidate(7, iconConstraint);
	    	}

	    	function icon_1_theme_binding_2(value) {
	    		_theme = value;
	    		$$invalidate(14, _theme);
	    	}

	    	function button_binding_1($$value) {
	    		binding_callbacks[$$value ? "unshift" : "push"](() => {
	    			_buttonWrapper = $$value;
	    			$$invalidate(20, _buttonWrapper);
	    		});
	    	}

	    	$$self.$$set = $$props => {
	    		if ("mode" in $$props) $$invalidate(3, mode = $$props.mode);
	    		if ("display" in $$props) $$invalidate(8, display = $$props.display);
	    		if ("theme" in $$props) $$invalidate(23, theme = $$props.theme);
	    		if ("shape" in $$props) $$invalidate(24, shape = $$props.shape);
	    		if ("density" in $$props) $$invalidate(25, density = $$props.density);
	    		if ("scheme" in $$props) $$invalidate(4, scheme = $$props.scheme);
	    		if ("iconName" in $$props) $$invalidate(0, iconName = $$props.iconName);
	    		if ("iconPath" in $$props) $$invalidate(1, iconPath = $$props.iconPath);
	    		if ("iconUrl" in $$props) $$invalidate(2, iconUrl = $$props.iconUrl);
	    		if ("iconPosition" in $$props) $$invalidate(5, iconPosition = $$props.iconPosition);
	    		if ("iconSize" in $$props) $$invalidate(6, iconSize = $$props.iconSize);
	    		if ("iconConstraint" in $$props) $$invalidate(7, iconConstraint = $$props.iconConstraint);
	    		if ("icon" in $$props) $$invalidate(26, icon = $$props.icon);
	    		if ("label" in $$props) $$invalidate(9, label = $$props.label);
	    		if ("className" in $$props) $$invalidate(27, className = $$props.className);
	    		if ("disabled" in $$props) $$invalidate(10, disabled = $$props.disabled);
	    		if ("solid" in $$props) $$invalidate(28, solid = $$props.solid);
	    		if ("height" in $$props) $$invalidate(29, height = $$props.height);
	    		if ("width" in $$props) $$invalidate(30, width = $$props.width);
	    		if ("loading" in $$props) $$invalidate(11, loading = $$props.loading);
	    		if ("id" in $$props) $$invalidate(31, id = $$props.id);
	    	};

	    	$$self.$$.update = () => {
	    		if ($$self.$$.dirty[0] & /*iconName, iconPath, iconUrl, _iconOnly, width, height, _style, icon*/ 1677987847 | $$self.$$.dirty[1] & /*_width, _height*/ 12) {
	    			// onState
	    			{
	    				if (iconName || iconPath || iconUrl) {
	    					$$invalidate(13, _hasIcon = true);
	    				}

	    				$$invalidate(18, _style = "");
	    				const dw = _iconOnly ? null : "auto";
	    				$$invalidate(33, _width = hasValue$5(width) ? width : dw);

	    				if (_width) {
	    					$$invalidate(33, _width = isNaN(_width) ? _width : `${_width}px`);
	    				} // _buttonWrapper.parentElement.style.minWidth = _width;

	    				$$invalidate(34, _height = hasValue$5(height) ? height : null);

	    				if (_height) {
	    					$$invalidate(34, _height = isNaN(_height) ? _height : `${_height}px`);
	    				}

	    				if (_width) {
	    					$$invalidate(18, _style += `min-width:${_width};`);
	    				}

	    				if (_height) {
	    					$$invalidate(18, _style += `height:${_height};`);
	    				}

	    				$$invalidate(12, _iconOnly = hasValue$5(icon) ? icon : false);
	    			}
	    		}
	    	};

	    	return [
	    		iconName,
	    		iconPath,
	    		iconUrl,
	    		mode,
	    		scheme,
	    		iconPosition,
	    		iconSize,
	    		iconConstraint,
	    		display,
	    		label,
	    		disabled,
	    		loading,
	    		_iconOnly,
	    		_hasIcon,
	    		_theme,
	    		_shape,
	    		_density,
	    		_class,
	    		_style,
	    		_solid,
	    		_buttonWrapper,
	    		_id,
	    		handleClick,
	    		theme,
	    		shape,
	    		density,
	    		icon,
	    		className,
	    		solid,
	    		height,
	    		width,
	    		id,
	    		hasValue$5,
	    		_width,
	    		_height,
	    		icon_1_name_binding,
	    		icon_1_path_binding,
	    		icon_1_url_binding,
	    		icon_1_solid_binding,
	    		icon_1_size_binding,
	    		icon_1_constraint_binding,
	    		icon_1_theme_binding,
	    		button_binding,
	    		icon_1_name_binding_1,
	    		icon_1_path_binding_1,
	    		icon_1_url_binding_1,
	    		icon_1_solid_binding_1,
	    		icon_1_size_binding_1,
	    		icon_1_constraint_binding_1,
	    		icon_1_theme_binding_1,
	    		icon_1_name_binding_2,
	    		icon_1_path_binding_2,
	    		icon_1_url_binding_2,
	    		icon_1_solid_binding_2,
	    		icon_1_size_binding_2,
	    		icon_1_constraint_binding_2,
	    		icon_1_theme_binding_2,
	    		button_binding_1
	    	];
	    }

	    class Button extends SvelteComponent {
	    	constructor(options) {
	    		super();
	    		if (!document.getElementById("svelte-192il0a-style")) add_css$6();

	    		init(
	    			this,
	    			options,
	    			instance$6,
	    			create_fragment$6,
	    			safe_not_equal,
	    			{
	    				mode: 3,
	    				display: 8,
	    				theme: 23,
	    				shape: 24,
	    				density: 25,
	    				scheme: 4,
	    				iconName: 0,
	    				iconPath: 1,
	    				iconUrl: 2,
	    				iconPosition: 5,
	    				iconSize: 6,
	    				iconConstraint: 7,
	    				icon: 26,
	    				label: 9,
	    				className: 27,
	    				disabled: 10,
	    				solid: 28,
	    				height: 29,
	    				width: 30,
	    				loading: 11,
	    				id: 31,
	    				hasValue: 32
	    			},
	    			[-1, -1, -1]
	    		);
	    	}

	    	get hasValue() {
	    		return hasValue$5;
	    	}
	    }

	    /* src/FilePicker.svelte generated by Svelte v3.38.2 */
	    function add_css$5() {
	      var style = element("style");
	      style.id = "svelte-1lszwxa-style";
	      style.textContent = ".pros-highlight-container.svelte-1lszwxa.svelte-1lszwxa{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1lszwxa.svelte-1lszwxa{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1lszwxa.svelte-1lszwxa{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1lszwxa .pros-input.svelte-1lszwxa{width:100%;outline:none !important;border:none;padding:0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer}.pros-control-container.has-label.svelte-1lszwxa .pros-input.svelte-1lszwxa{padding-top:18px}.pros-control-container.has-label.svelte-1lszwxa .pros-input.placeholder.svelte-1lszwxa{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1lszwxa.svelte-1lszwxa{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1lszwxa.svelte-1lszwxa::after{content:\" *\"}.pros-action-button.svelte-1lszwxa.svelte-1lszwxa{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1lszwxa svg.svelte-1lszwxa{width:24px;height:24px}.pros-action-button.svelte-1lszwxa.svelte-1lszwxa:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1lszwxa.svelte-1lszwxa{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-control-container.svelte-1lszwxa.svelte-1lszwxa{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1lszwxa .pros-control-label.svelte-1lszwxa,.pros-control-container.has-focus.svelte-1lszwxa .pros-control-label.svelte-1lszwxa{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1lszwxa .pros-highlight-container.svelte-1lszwxa{cursor:default}.pros-control-container.has-focus.svelte-1lszwxa .pros-input.svelte-1lszwxa{cursor:text}.pros-control-container.has-focus.svelte-1lszwxa .pros-highlight-container.svelte-1lszwxa{border-width:2px}.pros-control-container.has-focus.svelte-1lszwxa .pros-input-container.svelte-1lszwxa{margin-left:11px}.pros-control-container.has-focus.svelte-1lszwxa .pros-end-cap.svelte-1lszwxa:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1lszwxa input.svelte-1lszwxa::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1lszwxa .pros-input.placeholder.svelte-1lszwxa{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1lszwxa.svelte-1lszwxa{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1lszwxa .pros-status-icon.svelte-1lszwxa{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1lszwxa .pros-status-icon svg.svelte-1lszwxa{height:100%;width:100%}.pros-message-container.svelte-1lszwxa .pros-message.svelte-1lszwxa{flex:1}.pros-hide.svelte-1lszwxa.svelte-1lszwxa{display:none}.pros-global-wrapper[pos--shape=sharp].svelte-1lszwxa .pros-highlight-container.svelte-1lszwxa{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container .pros-control-label.svelte-1lszwxa{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container .pros-highlight-container.svelte-1lszwxa{height:36px}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1lszwxa{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container .pros-input-container .pros-input.svelte-1lszwxa{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container.has-label .pros-input.svelte-1lszwxa{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container.has-value .pros-control-label.svelte-1lszwxa,.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container.has-focus .pros-control-label.svelte-1lszwxa{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1lszwxa{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1lszwxa .pros-control-container.has-focus .pros-input-container.svelte-1lszwxa{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.svelte-1lszwxa{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-highlight-container.svelte-1lszwxa{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-input.svelte-1lszwxa{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-input.placeholder.svelte-1lszwxa{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container input.svelte-1lszwxa::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.allow-hover .pros-highlight-container.svelte-1lszwxa:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.error .pros-highlight-container.svelte-1lszwxa{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.has-focus .pros-highlight-container.svelte-1lszwxa{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-end-cap.svelte-1lszwxa{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-message-container.svelte-1lszwxa{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-message-container .pros-status-icon.svelte-1lszwxa{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-message-container.error.svelte-1lszwxa{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1lszwxa{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.disabled.svelte-1lszwxa{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.disabled .pros-highlight-container.svelte-1lszwxa{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.disabled .pros-input.svelte-1lszwxa{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.disabled .pros-message-container.svelte-1lszwxa{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-control-container.disabled .pros-end-cap.svelte-1lszwxa{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1lszwxa .pros-action-button.svelte-1lszwxa:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.svelte-1lszwxa{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-highlight-container.svelte-1lszwxa{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-input.svelte-1lszwxa{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-input.placeholder.svelte-1lszwxa{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container input.svelte-1lszwxa::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.allow-hover .pros-highlight-container.svelte-1lszwxa:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.error .pros-highlight-container.svelte-1lszwxa{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.has-focus .pros-highlight-container.svelte-1lszwxa{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-message-container.svelte-1lszwxa{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-message-container .pros-status-icon.svelte-1lszwxa{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-message-container.error.svelte-1lszwxa{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1lszwxa{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.disabled.svelte-1lszwxa{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.disabled .pros-highlight-container.svelte-1lszwxa{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.disabled .pros-input.svelte-1lszwxa{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-control-container.disabled .pros-message-container.svelte-1lszwxa{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1lszwxa .pros-action-button.svelte-1lszwxa:hover{background-color:rgba(0, 0, 0, 0.05)}";
	      append(document.head, style);
	    }

	    // (23:4) {:else}
	    function create_else_block$5(ctx) {
	      let t0;
	      let div3;
	      let div2;
	      let div0;
	      let input;
	      let t1;
	      let t2;
	      let t3;
	      let div1;
	      let icon;
	      let t4;
	      let if_block3_anchor;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[26] && create_if_block_7$2(ctx);
	      function select_block_type_1(ctx, dirty) {
	        if (/*_fileNames*/ctx[24]) return create_if_block_5$3;
	        if (/*placeholder*/ctx[8]) return create_if_block_6$2;
	      }
	      let current_block_type = select_block_type_1(ctx);
	      let if_block1 = current_block_type && current_block_type(ctx);
	      let if_block2 = /*value*/ctx[0].length > 0 && create_if_block_4$5(ctx);
	      icon = new Icon$1({
	        props: {
	          id: /*_capId*/ctx[20],
	          name: "folder"
	        }
	      });
	      let if_block3 = /*display*/ctx[2] !== "custom" && create_if_block_1$5(ctx);
	      return {
	        c() {
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div3 = element("div");
	          div2 = element("div");
	          div0 = element("div");
	          input = element("input");
	          t1 = space();
	          if (if_block1) if_block1.c();
	          t2 = space();
	          if (if_block2) if_block2.c();
	          t3 = space();
	          div1 = element("div");
	          create_component(icon.$$.fragment);
	          t4 = space();
	          if (if_block3) if_block3.c();
	          if_block3_anchor = empty$1();
	          attr(input, "class", "pros-hide svelte-1lszwxa");
	          attr(input, "type", "file");
	          attr(input, "accept", /*accept*/ctx[6]);
	          input.multiple = /*multiple*/ctx[7];
	          attr(div0, "class", "pros-input-container svelte-1lszwxa");
	          attr(div1, "id", /*_capId*/ctx[20]);
	          attr(div1, "class", "pros-end-cap fill svelte-1lszwxa");
	          attr(div1, "disabled", /*disabled*/ctx[5]);
	          attr(div1, "pros-tooltip", /*_fileNames*/ctx[24]);
	          attr(div2, "class", "pros-content-container svelte-1lszwxa");
	          attr(div3, "id", /*_inputId*/ctx[18]);
	          attr(div3, "class", "pros-highlight-container svelte-1lszwxa");
	        },
	        m(target, anchor) {
	          if (if_block0) if_block0.m(target, anchor);
	          insert(target, t0, anchor);
	          insert(target, div3, anchor);
	          append(div3, div2);
	          append(div2, div0);
	          append(div0, input);
	          /*input_binding_1*/
	          ctx[40](input);
	          append(div0, t1);
	          if (if_block1) if_block1.m(div0, null);
	          append(div2, t2);
	          if (if_block2) if_block2.m(div2, null);
	          append(div2, t3);
	          append(div2, div1);
	          mount_component(icon, div1, null);
	          insert(target, t4, anchor);
	          if (if_block3) if_block3.m(target, anchor);
	          insert(target, if_block3_anchor, anchor);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(input, "change", /*handleChanged*/ctx[28]), listen(input, "blur", /*handleBlur*/ctx[10]), listen(div3, "click", /*handleClick*/ctx[27])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[26]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_7$2(ctx);
	              if_block0.c();
	              if_block0.m(t0.parentNode, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (!current || dirty[0] & /*accept*/64) {
	            attr(input, "accept", /*accept*/ctx[6]);
	          }
	          if (!current || dirty[0] & /*multiple*/128) {
	            input.multiple = /*multiple*/ctx[7];
	          }
	          if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block1) {
	            if_block1.p(ctx, dirty);
	          } else {
	            if (if_block1) if_block1.d(1);
	            if_block1 = current_block_type && current_block_type(ctx);
	            if (if_block1) {
	              if_block1.c();
	              if_block1.m(div0, null);
	            }
	          }
	          if (/*value*/ctx[0].length > 0) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block_4$5(ctx);
	              if_block2.c();
	              if_block2.m(div2, t3);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          const icon_changes = {};
	          if (dirty[0] & /*_capId*/1048576) icon_changes.id = /*_capId*/ctx[20];
	          icon.$set(icon_changes);
	          if (!current || dirty[0] & /*_capId*/1048576) {
	            attr(div1, "id", /*_capId*/ctx[20]);
	          }
	          if (!current || dirty[0] & /*disabled*/32) {
	            attr(div1, "disabled", /*disabled*/ctx[5]);
	          }
	          if (!current || dirty[0] & /*_fileNames*/16777216) {
	            attr(div1, "pros-tooltip", /*_fileNames*/ctx[24]);
	          }
	          if (!current || dirty[0] & /*_inputId*/262144) {
	            attr(div3, "id", /*_inputId*/ctx[18]);
	          }
	          if (/*display*/ctx[2] !== "custom") {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	            } else {
	              if_block3 = create_if_block_1$5(ctx);
	              if_block3.c();
	              if_block3.m(if_block3_anchor.parentNode, if_block3_anchor);
	            }
	          } else if (if_block3) {
	            if_block3.d(1);
	            if_block3 = null;
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (if_block0) if_block0.d(detaching);
	          if (detaching) detach(t0);
	          if (detaching) detach(div3);
	          /*input_binding_1*/
	          ctx[40](null);
	          if (if_block1) {
	            if_block1.d();
	          }
	          if (if_block2) if_block2.d();
	          destroy_component(icon);
	          if (detaching) detach(t4);
	          if (if_block3) if_block3.d(detaching);
	          if (detaching) detach(if_block3_anchor);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (11:4) {#if button}
	    function create_if_block$5(ctx) {
	      let div;
	      let input;
	      let t;
	      let button_1;
	      let current;
	      let mounted;
	      let dispose;
	      button_1 = new Button({
	        props: {
	          id: /*_inputId*/ctx[18],
	          iconName: "folder",
	          display: /*_buttonDisplay*/ctx[23],
	          icon: true,
	          solid: "false"
	        }
	      });
	      return {
	        c() {
	          div = element("div");
	          input = element("input");
	          t = space();
	          create_component(button_1.$$.fragment);
	          attr(input, "class", "pros-hide svelte-1lszwxa");
	          attr(input, "type", "file");
	          attr(input, "accept", /*accept*/ctx[6]);
	          input.multiple = /*multiple*/ctx[7];
	          attr(div, "class", "pros-button-container");
	          attr(div, "pros-tooltip", /*label*/ctx[1]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, input);
	          /*input_binding*/
	          ctx[39](input);
	          append(div, t);
	          mount_component(button_1, div, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(input, "change", /*handleChanged*/ctx[28]), listen(input, "blur", /*handleBlur*/ctx[10]), listen(div, "click", /*handleClick*/ctx[27])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (!current || dirty[0] & /*accept*/64) {
	            attr(input, "accept", /*accept*/ctx[6]);
	          }
	          if (!current || dirty[0] & /*multiple*/128) {
	            input.multiple = /*multiple*/ctx[7];
	          }
	          const button_1_changes = {};
	          if (dirty[0] & /*_inputId*/262144) button_1_changes.id = /*_inputId*/ctx[18];
	          if (dirty[0] & /*_buttonDisplay*/8388608) button_1_changes.display = /*_buttonDisplay*/ctx[23];
	          button_1.$set(button_1_changes);
	          if (!current || dirty[0] & /*label*/2) {
	            attr(div, "pros-tooltip", /*label*/ctx[1]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(button_1.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(button_1.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          /*input_binding*/
	          ctx[39](null);
	          destroy_component(button_1);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (24:6) {#if _hasLabel}
	    function create_if_block_7$2(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[1]);
	          attr(div, "class", "pros-control-label svelte-1lszwxa");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "pros-hide", /*button*/ctx[9]);
	          toggle_class(div, "required", /*required*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/2) set_data(t, /*label*/ctx[1]);
	          if (dirty[0] & /*button*/512) {
	            toggle_class(div, "pros-hide", /*button*/ctx[9]);
	          }
	          if (dirty[0] & /*required*/16) {
	            toggle_class(div, "required", /*required*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (42:12) {#if placeholder}
	    function create_if_block_6$2(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*placeholder*/ctx[8]);
	          attr(div, "class", "pros-input placeholder svelte-1lszwxa");
	          attr(div, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*placeholder*/256) set_data(t, /*placeholder*/ctx[8]);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (38:12) {#if _fileNames}
	    function create_if_block_5$3(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*_fileNames*/ctx[24]);
	          attr(div, "class", "pros-input svelte-1lszwxa");
	          attr(div, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_fileNames*/16777216) set_data(t, /*_fileNames*/ctx[24]);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (47:10) {#if value.length > 0}
	    function create_if_block_4$5(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1lszwxa");
	          attr(div, "id", /*_clearId*/ctx[19]);
	          attr(div, "class", "pros-action-button svelte-1lszwxa");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "mousedown", /*handleClear*/ctx[29]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_clearId*/524288) {
	            attr(div, "id", /*_clearId*/ctx[19]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (60:6) {#if display !== 'custom'}
	    function create_if_block_1$5(ctx) {
	      let div;
	      function select_block_type_2(ctx, dirty) {
	        if (/*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0) return create_if_block_2$5;
	        if (/*hint*/ctx[3] && /*_hasFocus*/ctx[14]) return create_if_block_3$5;
	        return create_else_block_1$2;
	      }
	      let current_block_type = select_block_type_2(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-1lszwxa");
	          toggle_class(div, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type_2(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/6144) {
	            toggle_class(div, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (76:8) {:else}
	    function create_else_block_1$2(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[21]);
	          attr(div, "class", "pros-message svelte-1lszwxa");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/2097152) {
	            attr(div, "id", /*_messageId*/ctx[21]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (69:36) 
	    function create_if_block_3$5(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1lszwxa");
	          attr(div0, "id", /*_statusIconId*/ctx[22]);
	          attr(div0, "class", "pros-status-icon svelte-1lszwxa");
	          attr(div1, "id", /*_messageId*/ctx[21]);
	          attr(div1, "class", "pros-message svelte-1lszwxa");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/4194304) {
	            attr(div0, "id", /*_statusIconId*/ctx[22]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[0] & /*_messageId*/2097152) {
	            attr(div1, "id", /*_messageId*/ctx[21]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (62:8) {#if _dirty && _errors.length > 0}
	    function create_if_block_2$5(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[12][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1lszwxa");
	          attr(div0, "id", /*_statusIconId*/ctx[22]);
	          attr(div0, "class", "pros-status-icon error svelte-1lszwxa");
	          attr(div1, "id", /*_messageId*/ctx[21]);
	          attr(div1, "class", "pros-message error svelte-1lszwxa");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/4194304) {
	            attr(div0, "id", /*_statusIconId*/ctx[22]);
	          }
	          if (dirty[0] & /*_errors*/4096 && t1_value !== (t1_value = /*_errors*/ctx[12][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/2097152) {
	            attr(div1, "id", /*_messageId*/ctx[21]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$5(ctx) {
	      let div1;
	      let div0;
	      let current_block_type_index;
	      let if_block;
	      let current;
	      const if_block_creators = [create_if_block$5, create_else_block$5];
	      const if_blocks = [];
	      function select_block_type(ctx, dirty) {
	        if (/*button*/ctx[9]) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type(ctx);
	      if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      return {
	        c() {
	          div1 = element("div");
	          div0 = element("div");
	          if_block.c();
	          attr(div0, "class", "pros-control-container svelte-1lszwxa");
	          toggle_class(div0, "has-value", /*_hasValue*/ctx[25]);
	          toggle_class(div0, "has-label", /*_hasLabel*/ctx[26]);
	          toggle_class(div0, "has-focus", /*_hasFocus*/ctx[14]);
	          toggle_class(div0, "custom-layout", /*display*/ctx[2] === "custom");
	          toggle_class(div0, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          toggle_class(div0, "disabled", /*disabled*/ctx[5]);
	          toggle_class(div0, "allow-hover", ! /*disabled*/ctx[5]);
	          attr(div1, "class", "pros-global-wrapper pros-form-control svelte-1lszwxa");
	          attr(div1, "pos--theme", /*_theme*/ctx[15]);
	          attr(div1, "pos--shape", /*_shape*/ctx[16]);
	          attr(div1, "pos--density", /*_density*/ctx[17]);
	          toggle_class(div1, "button", /*button*/ctx[9]);
	        },
	        m(target, anchor) {
	          insert(target, div1, anchor);
	          append(div1, div0);
	          if_blocks[current_block_type_index].m(div0, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros();
	            transition_out(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros();
	            if_block = if_blocks[current_block_type_index];
	            if (!if_block) {
	              if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block.c();
	            } else {
	              if_block.p(ctx, dirty);
	            }
	            transition_in(if_block, 1);
	            if_block.m(div0, null);
	          }
	          if (dirty[0] & /*_hasValue*/33554432) {
	            toggle_class(div0, "has-value", /*_hasValue*/ctx[25]);
	          }
	          if (dirty[0] & /*_hasLabel*/67108864) {
	            toggle_class(div0, "has-label", /*_hasLabel*/ctx[26]);
	          }
	          if (dirty[0] & /*_hasFocus*/16384) {
	            toggle_class(div0, "has-focus", /*_hasFocus*/ctx[14]);
	          }
	          if (dirty[0] & /*display*/4) {
	            toggle_class(div0, "custom-layout", /*display*/ctx[2] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/6144) {
	            toggle_class(div0, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div0, "disabled", /*disabled*/ctx[5]);
	          }
	          if (dirty[0] & /*disabled*/32) {
	            toggle_class(div0, "allow-hover", ! /*disabled*/ctx[5]);
	          }
	          if (!current || dirty[0] & /*_theme*/32768) {
	            attr(div1, "pos--theme", /*_theme*/ctx[15]);
	          }
	          if (!current || dirty[0] & /*_shape*/65536) {
	            attr(div1, "pos--shape", /*_shape*/ctx[16]);
	          }
	          if (!current || dirty[0] & /*_density*/131072) {
	            attr(div1, "pos--density", /*_density*/ctx[17]);
	          }
	          if (dirty[0] & /*button*/512) {
	            toggle_class(div1, "button", /*button*/ctx[9]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div1);
	          if_blocks[current_block_type_index].d();
	        }
	      };
	    }
	    function hasValue$4(test) {
	      return test !== undefined && test !== null;
	    }
	    function hasArrayValue(test) {
	      return test !== undefined && test !== null && test.length > 0;
	    }
	    function notEmpty$5(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$5($$self, $$props, $$invalidate) {
	      let _fileNames;
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(50, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = []
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        maxLength = undefined
	      } = $$props; // Max length of value allowed
	      let {
	        accept = "*.*"
	      } = $$props; // File input accept pattern
	      let {
	        multiple = false
	      } = $$props; // Allow multiple file selection
	      let {
	        maxFiles = undefined
	      } = $$props; // Maximum number of files to allow
	      let {
	        id = null
	      } = $$props;
	      let {
	        button = false
	      } = $$props;
	      let {
	        buttonDisplay = "primary"
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _inputElement = undefined;
	      let _hasFocus = false;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _inputId = null;
	      let _clearId = null;
	      let _capId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      let _buttonDisplay = null;
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(2, display = hasValue$4(display) ? display : "form");
	        $$invalidate(30, theme = hasValue$4(theme) ? theme : "light");
	        $$invalidate(31, shape = hasValue$4(shape) ? shape : "round");
	        $$invalidate(32, density = hasValue$4(density) ? density : "standard");
	        $$invalidate(1, label = hasValue$4(label) ? label : "");
	        $$invalidate(3, hint = hasValue$4(hint) ? hint : "");
	        $$invalidate(0, value = hasValue$4(value) ? value : []);
	        $$invalidate(4, required = hasValue$4(required) ? required : false);
	        $$invalidate(5, disabled = hasValue$4(disabled) ? disabled : false);
	        $$invalidate(33, validation = hasValue$4(validation) ? validation : true);
	        $$invalidate(34, maxLength = notEmpty$5(maxLength) ? Number(maxLength) : undefined);
	        $$invalidate(35, maxFiles = notEmpty$5(maxFiles) ? Number(maxFiles) : undefined);
	        $$invalidate(6, accept = hasValue$4(accept) ? accept : "*.*");
	        $$invalidate(7, multiple = hasValue$4(multiple) ? multiple : false);
	        $$invalidate(23, _buttonDisplay = hasValue$4(buttonDisplay) ? buttonDisplay : "primary");
	        $$invalidate(18, _inputId = hasValue$4(id) ? `${id}-input` : undefined);
	        $$invalidate(19, _clearId = hasValue$4(id) ? `${id}-clear` : undefined);
	        $$invalidate(20, _capId = hasValue$4(id) ? `${id}-cap` : undefined);
	        $$invalidate(21, _messageId = hasValue$4(id) ? `${id}-message` : undefined);
	        $$invalidate(22, _statusIconId = hasValue$4(id) ? `${id}-status-icon` : undefined);
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(15, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(15, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(15, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(16, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(16, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(16, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(17, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(17, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(17, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function handleFocus() {
	        $$invalidate(14, _hasFocus = false);
	        window.removeEventListener("focus", handleFocus);
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	        window.addEventListener("focus", handleFocus);
	        $$invalidate(14, _hasFocus = true);
	        _inputElement.focus();
	        _inputElement.click();
	      }
	      function handleBlur(event) {
	        $$invalidate(14, _hasFocus = false);
	      }
	      function handleChanged(event) {
	        $$invalidate(14, _hasFocus = false);
	        if (event.currentTarget.files.length === 0) {
	          return;
	        }
	        $$invalidate(0, value = event.currentTarget.files);
	        valueChanged.call(this);
	      }
	      function handleClear(event) {
	        event.preventDefault();
	        $$invalidate(0, value = $$invalidate(13, _inputElement.value = [], _inputElement));
	        $$invalidate(14, _hasFocus = false);
	        _inputElement.blur();
	        valueChanged.call(this);
	      }
	      function valueChanged() {
	        $$invalidate(11, _dirty = true);
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(12, _errors = errors ? errors : []);
	        if (required) {
	          if (!value || value.length === 0) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (maxFiles) {
	          if (value && value.length > maxFiles) {
	            _builtInErrors.push($_("validateTooManyFiles", {
	              values: {
	                0: maxFiles
	              }
	            }));
	          }
	        }
	        if (hasValue$4(maxLength) && value) {
	          for (let i = 0; i < value.length; i++) {
	            if (value[i].name.trim().length > maxLength) {
	              _builtInErrors.push($_("validateFileNameTooLong", {
	                values: {
	                  0: maxLength
	                }
	              }));
	              break;
	            }
	          }
	        }
	        if (validation) {
	          $$invalidate(12, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	          }
	        });
	      }
	      function input_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(13, _inputElement);
	        });
	      }
	      function input_binding_1($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(13, _inputElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("display" in $$props) $$invalidate(2, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(30, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(31, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(32, density = $$props.density);
	        if ("value" in $$props) $$invalidate(0, value = $$props.value);
	        if ("label" in $$props) $$invalidate(1, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(8, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("required" in $$props) $$invalidate(4, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(33, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(36, errors = $$props.errors);
	        if ("maxLength" in $$props) $$invalidate(34, maxLength = $$props.maxLength);
	        if ("accept" in $$props) $$invalidate(6, accept = $$props.accept);
	        if ("multiple" in $$props) $$invalidate(7, multiple = $$props.multiple);
	        if ("maxFiles" in $$props) $$invalidate(35, maxFiles = $$props.maxFiles);
	        if ("id" in $$props) $$invalidate(37, id = $$props.id);
	        if ("button" in $$props) $$invalidate(9, button = $$props.button);
	        if ("buttonDisplay" in $$props) $$invalidate(38, buttonDisplay = $$props.buttonDisplay);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*value*/1) {
	          // Computed values
	          $$invalidate(24, _fileNames = value ? [...value].map(f => f.name).join(", ") : undefined);
	        }
	        if ($$self.$$.dirty[0] & /*value*/1) {
	          $$invalidate(25, _hasValue = hasArrayValue(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/2) {
	          $$invalidate(26, _hasLabel = notEmpty$5(label));
	        }
	      };
	      return [value, label, display, hint, required, disabled, accept, multiple, placeholder, button, handleBlur, _dirty, _errors, _inputElement, _hasFocus, _theme, _shape, _density, _inputId, _clearId, _capId, _messageId, _statusIconId, _buttonDisplay, _fileNames, _hasValue, _hasLabel, handleClick, handleChanged, handleClear, theme, shape, density, validation, maxLength, maxFiles, errors, id, buttonDisplay, input_binding, input_binding_1];
	    }
	    class FilePicker extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1lszwxa-style")) add_css$5();
	        init(this, options, instance$5, create_fragment$5, safe_not_equal, {
	          display: 2,
	          theme: 30,
	          shape: 31,
	          density: 32,
	          value: 0,
	          label: 1,
	          placeholder: 8,
	          hint: 3,
	          required: 4,
	          disabled: 5,
	          validation: 33,
	          errors: 36,
	          maxLength: 34,
	          accept: 6,
	          multiple: 7,
	          maxFiles: 35,
	          id: 37,
	          button: 9,
	          buttonDisplay: 38,
	          handleBlur: 10
	        }, [-1, -1]);
	      }
	      get handleBlur() {
	        return this.$$.ctx[10];
	      }
	    }

	    /* src/NumberBox.svelte generated by Svelte v3.38.2 */
	    function add_css$4() {
	      var style = element("style");
	      style.id = "svelte-a4lkko-style";
	      style.textContent = ".pros-highlight-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-a4lkko .pros-input.svelte-a4lkko{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-a4lkko .pros-input.svelte-a4lkko{padding-top:18px}.pros-control-container.has-label.svelte-a4lkko input.svelte-a4lkko::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-a4lkko.svelte-a4lkko{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-a4lkko.svelte-a4lkko::after{content:\" *\"}.pros-action-button.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-a4lkko svg.svelte-a4lkko{width:24px;height:24px}.pros-action-button.svelte-a4lkko.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-a4lkko.svelte-a4lkko{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-a4lkko svg.svelte-a4lkko{width:auto;height:auto}.pros-direction-button.svelte-a4lkko.svelte-a4lkko{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;padding:0;height:50%}.pros-direction-button.svelte-a4lkko svg.svelte-a4lkko{width:auto;height:auto}.pros-control-container.svelte-a4lkko.svelte-a4lkko{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-a4lkko .pros-control-label.svelte-a4lkko,.pros-control-container.has-focus.svelte-a4lkko .pros-control-label.svelte-a4lkko{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-a4lkko .pros-highlight-container.svelte-a4lkko{cursor:default}.pros-control-container.has-focus.svelte-a4lkko .pros-input.svelte-a4lkko{cursor:text}.pros-control-container.has-focus.svelte-a4lkko .pros-highlight-container.svelte-a4lkko{border-width:2px}.pros-control-container.has-focus.svelte-a4lkko .pros-input-container.svelte-a4lkko{margin-left:11px}.pros-control-container.has-focus.svelte-a4lkko .pros-end-cap.svelte-a4lkko:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-a4lkko input.svelte-a4lkko::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-a4lkko.svelte-a4lkko{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-a4lkko .pros-status-icon.svelte-a4lkko{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-a4lkko .pros-status-icon svg.svelte-a4lkko{height:100%;width:100%}.pros-message-container.svelte-a4lkko .pros-message.svelte-a4lkko{flex:1}.pros-global-wrapper[pos--shape=sharp].svelte-a4lkko .pros-highlight-container.svelte-a4lkko{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-control-label.svelte-a4lkko{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{height:36px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-a4lkko{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container .pros-input-container .pros-input.svelte-a4lkko{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-label .pros-input.svelte-a4lkko{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-value .pros-control-label.svelte-a4lkko,.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-control-label.svelte-a4lkko{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-a4lkko{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-a4lkko .pros-control-container.has-focus .pros-input-container.svelte-a4lkko{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-input.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container input.svelte-a4lkko::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.allow-hover .pros-highlight-container.svelte-a4lkko:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.error .pros-highlight-container.svelte-a4lkko{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.svelte-a4lkko{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-end-cap.svelte-a4lkko{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.svelte-a4lkko{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container .pros-status-icon.svelte-a4lkko{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.error.svelte-a4lkko{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container .pros-message-container.error .pros-status-icon.svelte-a4lkko{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled.svelte-a4lkko{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-highlight-container.svelte-a4lkko{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-input.svelte-a4lkko{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-message-container.svelte-a4lkko{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-control-container.disabled .pros-end-cap.svelte-a4lkko{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-direction-button.allow-hover.svelte-a4lkko:hover{color:#027aae;background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-a4lkko .pros-action-button.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-highlight-container.svelte-a4lkko{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-input.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container input.svelte-a4lkko::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.allow-hover .pros-highlight-container.svelte-a4lkko:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.error .pros-highlight-container.svelte-a4lkko{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.has-focus .pros-highlight-container.svelte-a4lkko{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.svelte-a4lkko{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container .pros-status-icon.svelte-a4lkko{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.error.svelte-a4lkko{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container .pros-message-container.error .pros-status-icon.svelte-a4lkko{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled.svelte-a4lkko{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-highlight-container.svelte-a4lkko{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-input.svelte-a4lkko{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-control-container.disabled .pros-message-container.svelte-a4lkko{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-direction-button.allow-hover.svelte-a4lkko:hover{color:#3ab4eb;background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-a4lkko .pros-action-button.svelte-a4lkko:hover{background-color:rgba(0, 0, 0, 0.05)}";
	      append(document.head, style);
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_4$4(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "id", /*_labelId*/ctx[24]);
	          attr(div, "class", "pros-control-label svelte-a4lkko");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[5]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[0] & /*_labelId*/16777216) {
	            attr(div, "id", /*_labelId*/ctx[24]);
	          }
	          if (dirty[0] & /*required*/32) {
	            toggle_class(div, "required", /*required*/ctx[5]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (27:8) {#if _showClear}
	    function create_if_block_3$4(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-a4lkko");
	          attr(div, "id", /*_clearId*/ctx[26]);
	          attr(div, "class", "pros-action-button clear svelte-a4lkko");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "mousedown", /*handleClear*/ctx[6]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_clearId*/67108864) {
	            attr(div, "id", /*_clearId*/ctx[26]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (49:4) {#if display !== 'custom'}
	    function create_if_block$4(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[16] && /*_errors*/ctx[17].length > 0) return create_if_block_1$4;
	        if (/*hint*/ctx[4] && /*_hasFocus*/ctx[20]) return create_if_block_2$4;
	        return create_else_block$4;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-a4lkko");
	          toggle_class(div, "error", /*_dirty*/ctx[16] && /*_errors*/ctx[17].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/196608) {
	            toggle_class(div, "error", /*_dirty*/ctx[16] && /*_errors*/ctx[17].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (65:6) {:else}
	    function create_else_block$4(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[29]);
	          attr(div, "class", "pros-message svelte-a4lkko");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (58:34) 
	    function create_if_block_2$4(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[4]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-a4lkko");
	          attr(div0, "id", /*_statusIconId*/ctx[30]);
	          attr(div0, "class", "pros-status-icon svelte-a4lkko");
	          attr(div1, "id", /*_messageId*/ctx[29]);
	          attr(div1, "class", "pros-message svelte-a4lkko");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/1073741824) {
	            attr(div0, "id", /*_statusIconId*/ctx[30]);
	          }
	          if (dirty[0] & /*hint*/16) set_data(t1, /*hint*/ctx[4]);
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div1, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (51:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$4(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[17][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-a4lkko");
	          attr(div0, "id", /*_statusIconId*/ctx[30]);
	          attr(div0, "class", "pros-status-icon error svelte-a4lkko");
	          attr(div1, "id", /*_messageId*/ctx[29]);
	          attr(div1, "class", "pros-message error svelte-a4lkko");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/1073741824) {
	            attr(div0, "id", /*_statusIconId*/ctx[30]);
	          }
	          if (dirty[0] & /*_errors*/131072 && t1_value !== (t1_value = /*_errors*/ctx[17][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div1, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$4(ctx) {
	      let div7;
	      let div6;
	      let t0;
	      let div5;
	      let div4;
	      let div0;
	      let input;
	      let t1;
	      let t2;
	      let div3;
	      let div1;
	      let svg0;
	      let path0;
	      let t3;
	      let div2;
	      let svg1;
	      let path1;
	      let t4;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[31] && create_if_block_4$4(ctx);
	      let if_block1 = /*_showClear*/ctx[32] && create_if_block_3$4(ctx);
	      let if_block2 = /*display*/ctx[2] !== "custom" && create_if_block$4(ctx);
	      return {
	        c() {
	          div7 = element("div");
	          div6 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div5 = element("div");
	          div4 = element("div");
	          div0 = element("div");
	          input = element("input");
	          t1 = space();
	          if (if_block1) if_block1.c();
	          t2 = space();
	          div3 = element("div");
	          div1 = element("div");
	          svg0 = svg_element("svg");
	          path0 = svg_element("path");
	          t3 = space();
	          div2 = element("div");
	          svg1 = svg_element("svg");
	          path1 = svg_element("path");
	          t4 = space();
	          if (if_block2) if_block2.c();
	          attr(input, "id", /*_inputId*/ctx[25]);
	          attr(input, "class", "pros-input single-line buttons svelte-a4lkko");
	          input.disabled = /*disabled*/ctx[1];
	          attr(input, "placeholder", /*placeholder*/ctx[3]);
	          attr(div0, "class", "pros-input-container svelte-a4lkko");
	          attr(path0, "d", "M16.9999 9C16.872 9 16.744 8.95117 16.6464 8.85352L8.99989 1.20703L1.3534 8.85352C1.15809 9.04883 0.841682 9.04883 0.64637 8.85352C0.451057 8.6582 0.451057 8.3418 0.64637 8.14648L8.64637 0.146484C8.84168 -0.0488281 9.15809 -0.0488281 9.3534 0.146484L17.3534 8.14648C17.5487 8.3418 17.5487 8.6582 17.3534 8.85352C17.2557 8.95117 17.1278 9 16.9999 9Z");
	          attr(svg0, "width", "18");
	          attr(svg0, "height", "9");
	          attr(svg0, "viewBox", "0 0 18 9");
	          attr(svg0, "fill", "currentColor");
	          attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg0, "class", "svelte-a4lkko");
	          attr(div1, "id", /*_upId*/ctx[27]);
	          attr(div1, "class", "pros-direction-button svelte-a4lkko");
	          toggle_class(div1, "allow-hover", ! /*disabled*/ctx[1]);
	          attr(path1, "d", "M8.5 9C8.37207 9 8.24414 8.95117 8.14648 8.85352L0.146484 0.853516C-0.0488281 0.658203 -0.0488281 0.341797 0.146484 0.146484C0.341797 -0.048828 0.658203 -0.0488281 0.853516 0.146484L8.5 7.79297L16.1465 0.146484C16.3418 -0.0488281 16.6582 -0.0488281 16.8535 0.146484C17.0488 0.341797 17.0488 0.658203 16.8535 0.853516L8.85352 8.85352C8.75586 8.95117 8.62793 9 8.5 9Z");
	          attr(svg1, "width", "18");
	          attr(svg1, "height", "9");
	          attr(svg1, "viewBox", "0 0 18 9");
	          attr(svg1, "fill", "currentColor");
	          attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg1, "class", "svelte-a4lkko");
	          attr(div2, "id", /*_downId*/ctx[28]);
	          attr(div2, "class", "pros-direction-button svelte-a4lkko");
	          toggle_class(div2, "allow-hover", ! /*disabled*/ctx[1]);
	          attr(div3, "class", "pros-end-cap fill svelte-a4lkko");
	          attr(div4, "class", "pros-content-container svelte-a4lkko");
	          attr(div5, "class", "pros-highlight-container svelte-a4lkko");
	          attr(div6, "class", "pros-control-container svelte-a4lkko");
	          toggle_class(div6, "has-value", /*_hasValue*/ctx[15]);
	          toggle_class(div6, "has-label", /*_hasLabel*/ctx[31]);
	          toggle_class(div6, "has-focus", /*_hasFocus*/ctx[20]);
	          toggle_class(div6, "custom-layout", /*display*/ctx[2] === "custom");
	          toggle_class(div6, "error", /*_dirty*/ctx[16] && /*_errors*/ctx[17].length > 0);
	          toggle_class(div6, "disabled", /*disabled*/ctx[1]);
	          toggle_class(div6, "allow-hover", ! /*disabled*/ctx[1]);
	          attr(div7, "class", "pros-global-wrapper pros-form-control svelte-a4lkko");
	          attr(div7, "pos--theme", /*_theme*/ctx[21]);
	          attr(div7, "pos--shape", /*_shape*/ctx[22]);
	          attr(div7, "pos--density", /*_density*/ctx[23]);
	        },
	        m(target, anchor) {
	          insert(target, div7, anchor);
	          append(div7, div6);
	          if (if_block0) if_block0.m(div6, null);
	          append(div6, t0);
	          append(div6, div5);
	          append(div5, div4);
	          append(div4, div0);
	          append(div0, input);
	          set_input_value(input, /*_rawValue*/ctx[18]);
	          /*input_binding*/
	          ctx[56](input);
	          append(div4, t1);
	          if (if_block1) if_block1.m(div4, null);
	          append(div4, t2);
	          append(div4, div3);
	          append(div3, div1);
	          append(div1, svg0);
	          append(svg0, path0);
	          append(div3, t3);
	          append(div3, div2);
	          append(div2, svg1);
	          append(svg1, path1);
	          append(div6, t4);
	          if (if_block2) if_block2.m(div6, null);
	          if (!mounted) {
	            dispose = [listen(input, "input", /*input_input_handler*/ctx[55]), listen(input, "keydown", /*handleKeyDown*/ctx[7]), listen(input, "blur", /*handleBlur*/ctx[8]), listen(input, "focus", /*handleFocus*/ctx[9]), listen(div1, "click", /*handleStepUp*/ctx[11]), listen(div1, "mousedown", /*mousedown_handler*/ctx[57]), listen(div1, "mouseup", /*mouseup_handler*/ctx[58]), listen(div1, "mouseleave", /*endPressAndHold*/ctx[14]), listen(div2, "click", /*handleStepDown*/ctx[12]), listen(div2, "mousedown", /*mousedown_handler_1*/ctx[59]), listen(div2, "mouseup", /*mouseup_handler_1*/ctx[60]), listen(div2, "mouseleave", /*endPressAndHold*/ctx[14]), listen(div5, "click", /*handleClick*/ctx[10])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[31]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_4$4(ctx);
	              if_block0.c();
	              if_block0.m(div6, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[0] & /*_inputId*/33554432) {
	            attr(input, "id", /*_inputId*/ctx[25]);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            input.disabled = /*disabled*/ctx[1];
	          }
	          if (dirty[0] & /*placeholder*/8) {
	            attr(input, "placeholder", /*placeholder*/ctx[3]);
	          }
	          if (dirty[0] & /*_rawValue*/262144 && input.value !== /*_rawValue*/ctx[18]) {
	            set_input_value(input, /*_rawValue*/ctx[18]);
	          }
	          if (/*_showClear*/ctx[32]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_3$4(ctx);
	              if_block1.c();
	              if_block1.m(div4, t2);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*_upId*/134217728) {
	            attr(div1, "id", /*_upId*/ctx[27]);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            toggle_class(div1, "allow-hover", ! /*disabled*/ctx[1]);
	          }
	          if (dirty[0] & /*_downId*/268435456) {
	            attr(div2, "id", /*_downId*/ctx[28]);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            toggle_class(div2, "allow-hover", ! /*disabled*/ctx[1]);
	          }
	          if (/*display*/ctx[2] !== "custom") {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block$4(ctx);
	              if_block2.c();
	              if_block2.m(div6, null);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (dirty[0] & /*_hasValue*/32768) {
	            toggle_class(div6, "has-value", /*_hasValue*/ctx[15]);
	          }
	          if (dirty[1] & /*_hasLabel*/1) {
	            toggle_class(div6, "has-label", /*_hasLabel*/ctx[31]);
	          }
	          if (dirty[0] & /*_hasFocus*/1048576) {
	            toggle_class(div6, "has-focus", /*_hasFocus*/ctx[20]);
	          }
	          if (dirty[0] & /*display*/4) {
	            toggle_class(div6, "custom-layout", /*display*/ctx[2] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/196608) {
	            toggle_class(div6, "error", /*_dirty*/ctx[16] && /*_errors*/ctx[17].length > 0);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            toggle_class(div6, "disabled", /*disabled*/ctx[1]);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            toggle_class(div6, "allow-hover", ! /*disabled*/ctx[1]);
	          }
	          if (dirty[0] & /*_theme*/2097152) {
	            attr(div7, "pos--theme", /*_theme*/ctx[21]);
	          }
	          if (dirty[0] & /*_shape*/4194304) {
	            attr(div7, "pos--shape", /*_shape*/ctx[22]);
	          }
	          if (dirty[0] & /*_density*/8388608) {
	            attr(div7, "pos--density", /*_density*/ctx[23]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div7);
	          if (if_block0) if_block0.d();
	          /*input_binding*/
	          ctx[56](null);
	          if (if_block1) if_block1.d();
	          if (if_block2) if_block2.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function makeNumber(input) {
	      if (!hasValue$3(input)) {
	        return null;
	      }
	      return typeof input === "string" ? Number(input.trim()) : input;
	    }
	    function hasValue$3(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty$4(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$4($$self, $$props, $$invalidate) {
	      let _hasValue;
	      let _hasLabel;
	      let _showClear;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(73, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape theme (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = null
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        min = undefined
	      } = $$props; // Minimum acceptable value
	      let {
	        max = undefined
	      } = $$props; // maximum acceptable value
	      let {
	        step = 1
	      } = $$props; // Amount to increase/decrease each time
	      let {
	        clear = false
	      } = $$props; // Allow value to be cleared
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _speedUpTimer = undefined; //
	      let _pressAndHoldInterval = undefined; //
	      let _rawValue = null; // Current value of control
	      let _lastValue = null;
	      let _decimalLength = undefined;
	      let _inputElement = undefined;
	      let _hasFocus = false;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _upId = null;
	      let _downId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      onMount(() => {
	        $$invalidate(18, _rawValue = value);
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(2, display = hasValue$3(display) ? display : "form");
	        $$invalidate(35, theme = hasValue$3(theme) ? theme : "light");
	        $$invalidate(36, shape = hasValue$3(shape) ? shape : "round");
	        $$invalidate(37, density = hasValue$3(density) ? density : "standard");
	        $$invalidate(0, label = hasValue$3(label) ? label : "");
	        $$invalidate(3, placeholder = hasValue$3(placeholder) ? placeholder : "");
	        $$invalidate(4, hint = hasValue$3(hint) ? hint : "");
	        $$invalidate(33, value = hasValue$3(value) && !isNaN(value) ? Number(value) : null);
	        $$invalidate(5, required = hasValue$3(required) ? required : false);
	        $$invalidate(1, disabled = hasValue$3(disabled) ? disabled : false);
	        $$invalidate(34, clear = hasValue$3(clear) ? clear : false);
	        $$invalidate(41, validation = hasValue$3(validation) ? validation : true);
	        $$invalidate(40, step = hasValue$3(step) && !isNaN(step) && Number(step) > 0 ? Number(step) : 1);
	        $$invalidate(38, min = hasValue$3(min) && !isNaN(min) ? Number(min) : undefined);
	        $$invalidate(39, max = hasValue$3(max) && !isNaN(max) ? Number(max) : undefined);
	        setDecimalLength();
	        $$invalidate(24, _labelId = hasValue$3(id) ? `${id}-label` : undefined);
	        $$invalidate(25, _inputId = hasValue$3(id) ? `${id}-input` : undefined);
	        $$invalidate(26, _clearId = hasValue$3(id) ? `${id}-clear` : undefined);
	        $$invalidate(27, _upId = hasValue$3(id) ? `${id}-up` : undefined);
	        $$invalidate(28, _downId = hasValue$3(id) ? `${id}-down` : "pros-options-container");
	        $$invalidate(29, _messageId = hasValue$3(id) ? `${id}-message` : undefined);
	        $$invalidate(30, _statusIconId = hasValue$3(id) ? `${id}-status-icon` : undefined);

	        // Check if this is a programmatic update
	        if (value !== _lastValue) {
	          $$invalidate(18, _rawValue = value);
	          _lastValue = value;
	        }
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(21, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(21, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(21, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(22, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(22, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(22, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(23, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(23, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(23, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function handleClear(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        $$invalidate(18, _rawValue = null);
	        valueChanged.call(this);
	      }
	      function handleKeyDown(event) {
	        checkControlValue.call(this);
	      }
	      function handleBlur(event) {
	        $$invalidate(20, _hasFocus = false);
	        checkControlValue.call(this);
	      }
	      function isValidInput() {
	        if (_rawValue === null) {
	          return true;
	        }
	        let testValue = typeof _rawValue === "string" ? Number(_rawValue.trim()) : _rawValue;
	        if (isNaN(testValue)) {
	          return false;
	        }
	        if (hasValue$3(min) && testValue < min) {
	          return false;
	        }
	        if (hasValue$3(max) && testValue > max) {
	          return false;
	        }
	        return true;
	      }
	      function isStep(testValue) {
	        let base = min !== null && min !== undefined && min !== "" ? min : 0;
	        if (getDecimal((testValue - base) / step) !== 0) {
	          return false;
	        }
	        return true;
	      }
	      function makeValid(input, isUp = true) {
	        if (!hasValue$3(input)) {
	          return input;
	        }
	        let myValue = input;
	        if (hasValue$3(min) && input < min) {
	          myValue = min;
	        }
	        if (hasValue$3(max) && input > max) {
	          myValue = max;
	        }
	        if (!isStep(input)) {
	          myValue = isUp ? roundUp(input) : roundDown(input);
	        }
	        return myValue;
	      }
	      function getDecimal(input) {
	        let decimals = input.toFixed(_decimalLength).split(".");
	        return decimals.length > 1 ? Number(decimals[1]) : 0;
	      }
	      function getValueString(input) {
	        if (input === null) {
	          return null;
	        }
	        if (input === 0) {
	          return "0";
	        }
	        return hasValue$3(_decimalLength) ? input.toFixed(_decimalLength) : `${input}`;
	      }
	      function handleFocus(event) {
	        $$invalidate(20, _hasFocus = true);
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	        $$invalidate(20, _hasFocus = true);
	        _inputElement.focus();
	      }
	      function handleStepUp() {
	        if (disabled) {
	          return;
	        }
	        stepUp.call(this);
	        valueChanged();
	      }
	      function handleStepDown() {
	        if (disabled) {
	          return;
	        }
	        stepDown.call(this);
	        valueChanged();
	      }
	      function stepUp() {
	        let myValue = hasValue$3(min) ? min : 0;
	        if (hasValue$3(_rawValue)) {
	          myValue = makeNumber(_rawValue) + step;
	          myValue = makeValid(myValue);
	        }
	        $$invalidate(18, _rawValue = getValueString(myValue));
	      }
	      function stepDown() {
	        let myValue = hasValue$3(min) ? min : 0;
	        if (hasValue$3(_rawValue)) {
	          myValue = makeNumber(_rawValue) - step;
	          myValue = makeValid(myValue, false);
	        }
	        $$invalidate(18, _rawValue = getValueString(myValue));
	      }
	      function startPressAndHold(event, isUp) {
	        event.preventDefault();
	        let directionFunction = isUp ? stepUp.bind(this) : stepDown.bind(this);
	        _pressAndHoldInterval = window.setInterval(directionFunction, 300);
	        _speedUpTimer = window.setTimeout(() => {
	          window.clearInterval(_pressAndHoldInterval);
	          _pressAndHoldInterval = window.setInterval(directionFunction, 50);
	        }, 2000);
	      }
	      function endPressAndHold(isUp) {
	        isUp ? stepUp.bind(this) : stepDown.bind(this);
	        if (_speedUpTimer) {
	          window.clearTimeout(_speedUpTimer);
	        }
	        if (_pressAndHoldInterval) {
	          window.clearInterval(_pressAndHoldInterval);
	        }
	        _pressAndHoldInterval = null;
	        _speedUpTimer = null;
	        valueChanged.bind(this);
	      }
	      function roundUp(value) {
	        if (value > 0) return Math.ceil(value / step) * step;else if (value < 0) return Math.floor(value / step) * step;else return step;
	      }
	      function roundDown(value) {
	        if (value > 0) return Math.floor(value / step) * step;else if (value < 0) return Math.ceil(value / step) * step;else return step;
	      }
	      function setDecimalLength() {
	        let test = `${step}`;
	        let decimals = test.split(".");
	        _decimalLength = decimals.length > 1 ? decimals[1].length : undefined;
	      }
	      function checkControlValue() {
	        $$invalidate(16, _dirty = true);
	        if (isValidInput()) {
	          $$invalidate(18, _rawValue = getValueString(makeValid(makeNumber(_rawValue))));
	        } else {
	          $$invalidate(18, _rawValue = _rawValue.trim());
	        }
	        valueChanged.call(this);
	      }
	      function valueChanged() {
	        $$invalidate(16, _dirty = true);
	        $$invalidate(33, value = makeNumber(_rawValue));
	        _lastValue = value;
	        doValidate.call(this);
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(17, _errors = errors ? errors : []);
	        if (required) {
	          if (!hasValue$3(value)) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (!hasValue$3(value)) {
	          if (required) {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        } else {
	          if (isNaN(_rawValue)) {
	            _builtInErrors.push($_("validateNotANumber"));
	          } else {
	            let testValue = Number(_rawValue);
	            if (hasValue$3(min) && testValue < min) {
	              _builtInErrors.push($_("validateLessThanMin", {
	                values: {
	                  0: min
	                }
	              }));
	            }
	            if (hasValue$3(max) && testValue > max) {
	              _builtInErrors.push($_("validateMoreThanMax", {
	                values: {
	                  0: max
	                }
	              }));
	            }
	            if (!isStep(testValue)) {
	              _builtInErrors.push($_("validateNotAStepValue", {
	                values: {
	                  0: step
	                }
	              }));
	            }
	          }
	        }
	        if (validation) {
	          $$invalidate(17, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (hasValue$3(value) && !valid && !_dirty) {
	              $$invalidate(16, _dirty = true);
	            }
	          }
	        });
	      }
	      function input_input_handler() {
	        _rawValue = this.value;
	        $$invalidate(18, _rawValue);
	      }
	      function input_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(19, _inputElement);
	        });
	      }
	      const mousedown_handler = event => startPressAndHold(event, true);
	      const mouseup_handler = () => endPressAndHold(true);
	      const mousedown_handler_1 = event => startPressAndHold(event, false);
	      const mouseup_handler_1 = () => endPressAndHold(false);
	      $$self.$$set = $$props => {
	        if ("display" in $$props) $$invalidate(2, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(35, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(36, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(37, density = $$props.density);
	        if ("value" in $$props) $$invalidate(33, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(3, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(4, hint = $$props.hint);
	        if ("min" in $$props) $$invalidate(38, min = $$props.min);
	        if ("max" in $$props) $$invalidate(39, max = $$props.max);
	        if ("step" in $$props) $$invalidate(40, step = $$props.step);
	        if ("clear" in $$props) $$invalidate(34, clear = $$props.clear);
	        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(41, validation = $$props.validation);
	        if ("required" in $$props) $$invalidate(5, required = $$props.required);
	        if ("errors" in $$props) $$invalidate(42, errors = $$props.errors);
	        if ("id" in $$props) $$invalidate(43, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[1] & /*value*/4) {
	          // Computed values
	          $$invalidate(15, _hasValue = hasValue$3(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          $$invalidate(31, _hasLabel = notEmpty$4(label));
	        }
	        if ($$self.$$.dirty[0] & /*disabled, _hasValue*/32770 | $$self.$$.dirty[1] & /*clear*/8) {
	          $$invalidate(32, _showClear = clear && !disabled && _hasValue);
	        }
	      };
	      return [label, disabled, display, placeholder, hint, required, handleClear, handleKeyDown, handleBlur, handleFocus, handleClick, handleStepUp, handleStepDown, startPressAndHold, endPressAndHold, _hasValue, _dirty, _errors, _rawValue, _inputElement, _hasFocus, _theme, _shape, _density, _labelId, _inputId, _clearId, _upId, _downId, _messageId, _statusIconId, _hasLabel, _showClear, value, clear, theme, shape, density, min, max, step, validation, errors, id, isValidInput, isStep, makeNumber, makeValid, getDecimal, getValueString, stepUp, stepDown, roundUp, roundDown, setDecimalLength, input_input_handler, input_binding, mousedown_handler, mouseup_handler, mousedown_handler_1, mouseup_handler_1];
	    }
	    class NumberBox extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-a4lkko-style")) add_css$4();
	        init(this, options, instance$4, create_fragment$4, safe_not_equal, {
	          display: 2,
	          theme: 35,
	          shape: 36,
	          density: 37,
	          value: 33,
	          label: 0,
	          placeholder: 3,
	          hint: 4,
	          min: 38,
	          max: 39,
	          step: 40,
	          clear: 34,
	          disabled: 1,
	          validation: 41,
	          required: 5,
	          errors: 42,
	          id: 43,
	          handleClear: 6,
	          handleKeyDown: 7,
	          handleBlur: 8,
	          isValidInput: 44,
	          isStep: 45,
	          makeNumber: 46,
	          makeValid: 47,
	          getDecimal: 48,
	          getValueString: 49,
	          handleFocus: 9,
	          handleClick: 10,
	          handleStepUp: 11,
	          handleStepDown: 12,
	          stepUp: 50,
	          stepDown: 51,
	          startPressAndHold: 13,
	          endPressAndHold: 14,
	          roundUp: 52,
	          roundDown: 53,
	          setDecimalLength: 54
	        }, [-1, -1, -1]);
	      }
	      get handleClear() {
	        return this.$$.ctx[6];
	      }
	      get handleKeyDown() {
	        return this.$$.ctx[7];
	      }
	      get handleBlur() {
	        return this.$$.ctx[8];
	      }
	      get isValidInput() {
	        return this.$$.ctx[44];
	      }
	      get isStep() {
	        return this.$$.ctx[45];
	      }
	      get makeNumber() {
	        return makeNumber;
	      }
	      get makeValid() {
	        return this.$$.ctx[47];
	      }
	      get getDecimal() {
	        return this.$$.ctx[48];
	      }
	      get getValueString() {
	        return this.$$.ctx[49];
	      }
	      get handleFocus() {
	        return this.$$.ctx[9];
	      }
	      get handleClick() {
	        return this.$$.ctx[10];
	      }
	      get handleStepUp() {
	        return this.$$.ctx[11];
	      }
	      get handleStepDown() {
	        return this.$$.ctx[12];
	      }
	      get stepUp() {
	        return this.$$.ctx[50];
	      }
	      get stepDown() {
	        return this.$$.ctx[51];
	      }
	      get startPressAndHold() {
	        return this.$$.ctx[13];
	      }
	      get endPressAndHold() {
	        return this.$$.ctx[14];
	      }
	      get roundUp() {
	        return this.$$.ctx[52];
	      }
	      get roundDown() {
	        return this.$$.ctx[53];
	      }
	      get setDecimalLength() {
	        return this.$$.ctx[54];
	      }
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    var isArray$1 = isArray;

	    /** Detect free variable `global` from Node.js. */
	    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	    var freeGlobal$1 = freeGlobal;

	    /** Detect free variable `self`. */
	    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	    /** Used as a reference to the global object. */
	    var root = freeGlobal$1 || freeSelf || Function('return this')();

	    var root$1 = root;

	    /** Built-in value references. */
	    var Symbol$1 = root$1.Symbol;

	    var Symbol$2 = Symbol$1;

	    /** Used for built-in method references. */
	    var objectProto$4 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString$1 = objectProto$4.toString;

	    /** Built-in value references. */
	    var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
	          tag = value[symToStringTag$1];

	      try {
	        value[symToStringTag$1] = undefined;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString$1.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag$1] = tag;
	        } else {
	          delete value[symToStringTag$1];
	        }
	      }
	      return result;
	    }

	    /** Used for built-in method references. */
	    var objectProto$3 = Object.prototype;

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto$3.toString;

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /** `Object#toString` result references. */
	    var nullTag = '[object Null]',
	        undefinedTag = '[object Undefined]';

	    /** Built-in value references. */
	    var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /** `Object#toString` result references. */
	    var symbolTag = '[object Symbol]';

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /** Used to match property names within property paths. */
	    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	        reIsPlainProp = /^\w*$/;

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray$1(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /** `Object#toString` result references. */
	    var asyncTag = '[object AsyncFunction]',
	        funcTag = '[object Function]',
	        genTag = '[object GeneratorFunction]',
	        proxyTag = '[object Proxy]';

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = root$1['__core-js_shared__'];

	    var coreJsData$1 = coreJsData;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /** Used for built-in method references. */
	    var funcProto$1 = Function.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString$1 = funcProto$1.toString;

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString$1.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Used to match `RegExp`
	     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	     */
	    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	    /** Used to detect host constructors (Safari). */
	    var reIsHostCtor = /^\[object .+?Constructor\]$/;

	    /** Used for built-in method references. */
	    var funcProto = Function.prototype,
	        objectProto$2 = Object.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * Gets the value at `key` of `object`.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function getValue(object, key) {
	      return object == null ? undefined : object[key];
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }

	    /* Built-in method references that are verified to be native. */
	    var nativeCreate = getNative(Object, 'create');

	    var nativeCreate$1 = nativeCreate;

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /** Used to stand-in for `undefined` hash values. */
	    var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	    /** Used for built-in method references. */
	    var objectProto$1 = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate$1) {
	        var result = data[key];
	        return result === HASH_UNDEFINED$1 ? undefined : result;
	      }
	      return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
	    }

	    /** Used for built-in method references. */
	    var objectProto = Object.prototype;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }

	    /** Used to stand-in for `undefined` hash values. */
	    var HASH_UNDEFINED = '__lodash_hash_undefined__';

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype;

	    /** Built-in value references. */
	    var splice = arrayProto.splice;

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /* Built-in method references that are verified to be native. */
	    var Map$1 = getNative(root$1, 'Map');

	    var Map$2 = Map$1;

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map$2 || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /** Error message constants. */
	    var FUNC_ERROR_TEXT$1 = 'Expected a function';

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT$1);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /** Used as the maximum memoize cache size. */
	    var MAX_MEMOIZE_SIZE = 500;

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /** Used to match property names within property paths. */
	    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	    /** Used to match backslashes in property paths. */
	    var reEscapeChar = /\\(\\)?/g;

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    var stringToPath$1 = stringToPath;

	    /**
	     * A specialized version of `_.map` for arrays without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} [array] The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }

	    /** Used as references for various `Number` constants. */
	    var INFINITY$1 = 1 / 0;

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray$1(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString$1(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray$1(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
	    }

	    /** Used as references for various `Number` constants. */
	    var INFINITY = 1 / 0;

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = function() {
	      return root$1.Date.now();
	    };

	    var now$1 = now;

	    /** Used to match a single whitespace character. */
	    var reWhitespace = /\s/;

	    /**
	     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	     * character of `string`.
	     *
	     * @private
	     * @param {string} string The string to inspect.
	     * @returns {number} Returns the index of the last non-whitespace character.
	     */
	    function trimmedEndIndex(string) {
	      var index = string.length;

	      while (index-- && reWhitespace.test(string.charAt(index))) {}
	      return index;
	    }

	    /** Used to match leading whitespace. */
	    var reTrimStart = /^\s+/;

	    /**
	     * The base implementation of `_.trim`.
	     *
	     * @private
	     * @param {string} string The string to trim.
	     * @returns {string} Returns the trimmed string.
	     */
	    function baseTrim(string) {
	      return string
	        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	        : string;
	    }

	    /** Used as references for various `Number` constants. */
	    var NAN = 0 / 0;

	    /** Used to detect bad signed hexadecimal string values. */
	    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	    /** Used to detect binary string values. */
	    var reIsBinary = /^0b[01]+$/i;

	    /** Used to detect octal string values. */
	    var reIsOctal = /^0o[0-7]+$/i;

	    /** Built-in method references without a dependency on `root`. */
	    var freeParseInt = parseInt;

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /** Error message constants. */
	    var FUNC_ERROR_TEXT = 'Expected a function';

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeMax = Math.max,
	        nativeMin = Math.min;

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now$1();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }

	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now$1());
	      }

	      function debounced() {
	        var time = now$1(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /* src/SelectBox.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1$1
	    } = globals;
	    function add_css$3() {
	      var style = element("style");
	      style.id = "svelte-1c84wsf-style";
	      style.textContent = ".pros-highlight-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1c84wsf .pros-input.svelte-1c84wsf{width:100%;outline:none !important;border:none;padding:0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer}.pros-control-container.has-label.svelte-1c84wsf .pros-input.svelte-1c84wsf{padding-top:18px}.pros-control-container.has-label.svelte-1c84wsf .pros-input.placeholder.svelte-1c84wsf{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1c84wsf.svelte-1c84wsf{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1c84wsf.svelte-1c84wsf::after{content:\" *\"}.pros-action-button.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1c84wsf svg.svelte-1c84wsf{width:24px;height:24px}.pros-action-button.svelte-1c84wsf.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1c84wsf.svelte-1c84wsf{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-end-cap.svelte-1c84wsf svg.svelte-1c84wsf{width:auto;height:auto}.pros-control-container.svelte-1c84wsf.svelte-1c84wsf{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1c84wsf .pros-control-label.svelte-1c84wsf,.pros-control-container.has-focus.svelte-1c84wsf .pros-control-label.svelte-1c84wsf{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{cursor:default}.pros-control-container.has-focus.svelte-1c84wsf .pros-input.svelte-1c84wsf{cursor:text}.pros-control-container.has-focus.svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{border-width:2px}.pros-control-container.has-focus.svelte-1c84wsf .pros-input-container.svelte-1c84wsf{margin-left:11px}.pros-control-container.has-focus.svelte-1c84wsf .pros-end-cap.svelte-1c84wsf:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1c84wsf .pros-input.placeholder.svelte-1c84wsf{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1c84wsf .pros-status-icon.svelte-1c84wsf{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1c84wsf .pros-status-icon svg.svelte-1c84wsf{height:100%;width:100%}.pros-message-container.svelte-1c84wsf .pros-message.svelte-1c84wsf{flex:1}.pros-options-wrapper.svelte-1c84wsf.svelte-1c84wsf{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;z-index:1001;overflow:hidden}.pros-options-wrapper.open.svelte-1c84wsf.svelte-1c84wsf{display:inherit}.pros-options-container.svelte-1c84wsf.svelte-1c84wsf{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options-search.svelte-1c84wsf{width:100%;padding:0 8px;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options.svelte-1c84wsf{width:100%;overflow:auto;max-height:160px;margin:8px 0;padding:0 8px;box-sizing:border-box}.pros-options-container.svelte-1c84wsf .pros-options .pros-options-virtual-container.svelte-1c84wsf{position:relative;height:500px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list.svelte-1c84wsf{position:absolute;top:0;left:0;right:0}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;height:36px;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;padding:0 8px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row.svelte-1c84wsf:not(:last-of-type){margin-bottom:4px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row .pros-option.svelte-1c84wsf{flex:1}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-option-row .pros-option-details.svelte-1c84wsf{font-size:12px}.pros-options-container.svelte-1c84wsf .pros-options .pros-option-list .pros-empty-row.svelte-1c84wsf{display:flex;justify-content:flex-start;align-items:center;height:36px;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;padding:0 8px}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar{width:6px;height:6px}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar-track{background-color:transparent}.pros-options-container.svelte-1c84wsf .svelte-1c84wsf::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-global-wrapper[pos--shape=sharp].svelte-1c84wsf .pros-highlight-container.svelte-1c84wsf{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-control-label.svelte-1c84wsf{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{height:36px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1c84wsf{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container .pros-input-container .pros-input.svelte-1c84wsf{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-label .pros-input.svelte-1c84wsf{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-value .pros-control-label.svelte-1c84wsf,.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-control-label.svelte-1c84wsf{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1c84wsf{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1c84wsf .pros-control-container.has-focus .pros-input-container.svelte-1c84wsf{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-input.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-input.placeholder.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.allow-hover .pros-highlight-container.svelte-1c84wsf:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.error .pros-highlight-container.svelte-1c84wsf{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.svelte-1c84wsf{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-end-cap.svelte-1c84wsf{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.svelte-1c84wsf{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container .pros-status-icon.svelte-1c84wsf{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.error.svelte-1c84wsf{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1c84wsf{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled.svelte-1c84wsf{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-highlight-container.svelte-1c84wsf{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-input.svelte-1c84wsf{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-message-container.svelte-1c84wsf{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-control-container.disabled .pros-end-cap.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-action-button.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-highlight-container.svelte-1c84wsf{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-input.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-input.placeholder.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.allow-hover .pros-highlight-container.svelte-1c84wsf:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.error .pros-highlight-container.svelte-1c84wsf{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.has-focus .pros-highlight-container.svelte-1c84wsf{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.svelte-1c84wsf{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container .pros-status-icon.svelte-1c84wsf{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.error.svelte-1c84wsf{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1c84wsf{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled.svelte-1c84wsf{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-highlight-container.svelte-1c84wsf{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-input.svelte-1c84wsf{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-control-container.disabled .pros-message-container.svelte-1c84wsf{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-action-button.svelte-1c84wsf:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.svelte-1c84wsf{border-color:#ffffff;background-color:#ffffff}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.downward.svelte-1c84wsf{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=light].svelte-1c84wsf .pros-highlight-container.open.upward.svelte-1c84wsf{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.svelte-1c84wsf{border-color:#2b2b2b;background-color:#2b2b2b}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.downward.svelte-1c84wsf{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=dark].svelte-1c84wsf .pros-highlight-container.open.upward.svelte-1c84wsf{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px}.pros-options-wrapper.svelte-1c84wsf.svelte-1c84wsf{display:none}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf.svelte-1c84wsf{background-color:#FFFFFF;color:#363636;border-color:transparent}.pros-options-wrapper[pos--theme=light].downward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 16px 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px;border-top:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].upward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 -16px 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row .pros-option-details.svelte-1c84wsf{color:#adadad}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.highlight.svelte-1c84wsf{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected.svelte-1c84wsf{background-color:#027aae;color:white}.pros-options-wrapper[pos--theme=light].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected .pros-option-details.svelte-1c84wsf{color:#dbdbdb}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf.svelte-1c84wsf{background-color:#2b2b2b;color:#ffffff;border-color:transparent}.pros-options-wrapper[pos--theme=dark].downward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px;border-top:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].upward.svelte-1c84wsf.svelte-1c84wsf{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf{color:#ffffff}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row .pros-option-details.svelte-1c84wsf{color:#ebebeb}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.highlight.svelte-1c84wsf{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.svelte-1c84wsf:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected.svelte-1c84wsf{background-color:#3ab4eb;color:#212121}.pros-options-wrapper[pos--theme=dark].svelte-1c84wsf .pros-options-container .pros-options .pros-option-row.selected .pros-option-details.svelte-1c84wsf{color:#ebebeb}";
	      append(document_1$1.head, style);
	    }
	    function get_each_context$1(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[119] = list[i];
	      child_ctx[120] = list;
	      child_ctx[121] = i;
	      return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_14(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "id", /*_labelId*/ctx[41]);
	          attr(div, "class", "pros-control-label svelte-1c84wsf");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[7]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[1] & /*_labelId*/1024) {
	            attr(div, "id", /*_labelId*/ctx[41]);
	          }
	          if (dirty[0] & /*required*/128) {
	            toggle_class(div, "required", /*required*/ctx[7]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (34:10) {#if placeholder}
	    function create_if_block_13(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*placeholder*/ctx[24]);
	          attr(div, "class", "pros-input placeholder svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*placeholder*/16777216) set_data(t, /*placeholder*/ctx[24]);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (31:29) 
	    function create_if_block_12(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*_display*/ctx[3]);
	          attr(div, "class", "pros-input svelte-1c84wsf");
	          attr(div, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_display*/8) set_data(t, /*_display*/ctx[3]);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (29:10) {#if _displayHtml}
	    function create_if_block_11(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "class", "pros-input svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          div.innerHTML = /*_displayHtml*/ctx[14];
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_displayHtml*/16384) div.innerHTML = /*_displayHtml*/ctx[14];
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (39:8) {#if _showClear}
	    function create_if_block_10$1(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1c84wsf");
	          attr(div, "id", /*_clearId*/ctx[43]);
	          attr(div, "class", "pros-action-button clear-value svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "click", /*handleClear*/ctx[34]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_clearId*/4096) {
	            attr(div, "id", /*_clearId*/ctx[43]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (53:6) {#if _showOptions && !disabled}
	    function create_if_block_3$3(ctx) {
	      let div4;
	      let div3;
	      let t0;
	      let div2;
	      let div1;
	      let div0;
	      let t1;
	      let positionOptions_action;
	      let globalClicks_action;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*search*/ctx[6] && create_if_block_9$1(ctx);
	      let each_value = /*_virtualOptions*/ctx[38];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
	      }
	      const out = i => transition_out(each_blocks[i], 1, 1, () => {
	        each_blocks[i] = null;
	      });
	      let if_block1 = /*_virtualOptions*/ctx[38].length === 0 && create_if_block_4$3(ctx);
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          t1 = space();
	          if (if_block1) if_block1.c();
	          attr(div0, "class", "pros-option-list svelte-1c84wsf");
	          attr(div1, "class", "pros-options-virtual-container svelte-1c84wsf");
	          attr(div2, "id", /*_optionsId*/ctx[45]);
	          attr(div2, "class", "pros-options svelte-1c84wsf");
	          attr(div3, "id", "pros-options-container");
	          attr(div3, "class", "pros-options-container svelte-1c84wsf");
	          attr(div4, "class", "pros-options-wrapper svelte-1c84wsf");
	          attr(div4, "pos--theme", /*_theme*/ctx[21]);
	          attr(div4, "pos--shape", /*_shape*/ctx[22]);
	          attr(div4, "pos--density", /*_density*/ctx[23]);
	          toggle_class(div4, "open", /*_positioned*/ctx[16]);
	          toggle_class(div4, "upward", /*_upward*/ctx[15]);
	          toggle_class(div4, "downward", ! /*_upward*/ctx[15]);
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          if (if_block0) if_block0.m(div3, null);
	          append(div3, t0);
	          append(div3, div2);
	          append(div2, div1);
	          append(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	          append(div0, t1);
	          if (if_block1) if_block1.m(div0, null);
	          /*div0_binding*/
	          ctx[104](div0);
	          /*div1_binding*/
	          ctx[105](div1);
	          /*div2_binding*/
	          ctx[106](div2);
	          /*div4_binding*/
	          ctx[107](div4);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div2, "scroll", /*_handleOptionsScrollDebounce*/ctx[52]), listen(div2, "mousedown", preventClickPropagation$2), listen(div2, "mouseup", preventClickPropagation$2), action_destroyer(positionOptions_action = /*positionOptions*/ctx[26].call(null, div4)), action_destroyer(globalClicks_action = /*globalClicks*/ctx[25].call(null, div4))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*search*/ctx[6]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	              if (dirty[0] & /*search*/64) {
	                transition_in(if_block0, 1);
	              }
	            } else {
	              if_block0 = create_if_block_9$1(ctx);
	              if_block0.c();
	              transition_in(if_block0, 1);
	              if_block0.m(div3, t0);
	            }
	          } else if (if_block0) {
	            group_outros();
	            transition_out(if_block0, 1, 1, () => {
	              if_block0 = null;
	            });
	            check_outros();
	          }
	          if (dirty[0] & /*_searchOptions, _highlightIndex, handleMouseEnterOption, handleMouseLeaveOption, preventClickPropagation, _theme, multiple*/941633540 | dirty[1] & /*isOptionSelected, _virtualOptions, handleOptionClicked*/37748864) {
	            each_value = /*_virtualOptions*/ctx[38];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context$1(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	                transition_in(each_blocks[i], 1);
	              } else {
	                each_blocks[i] = create_each_block$1(child_ctx);
	                each_blocks[i].c();
	                transition_in(each_blocks[i], 1);
	                each_blocks[i].m(div0, t1);
	              }
	            }
	            group_outros();
	            for (i = each_value.length; i < each_blocks.length; i += 1) {
	              out(i);
	            }
	            check_outros();
	          }
	          if (/*_virtualOptions*/ctx[38].length === 0) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_4$3(ctx);
	              if_block1.c();
	              if_block1.m(div0, null);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (!current || dirty[1] & /*_optionsId*/16384) {
	            attr(div2, "id", /*_optionsId*/ctx[45]);
	          }
	          if (!current || dirty[0] & /*_theme*/2097152) {
	            attr(div4, "pos--theme", /*_theme*/ctx[21]);
	          }
	          if (!current || dirty[0] & /*_shape*/4194304) {
	            attr(div4, "pos--shape", /*_shape*/ctx[22]);
	          }
	          if (!current || dirty[0] & /*_density*/8388608) {
	            attr(div4, "pos--density", /*_density*/ctx[23]);
	          }
	          if (dirty[0] & /*_positioned*/65536) {
	            toggle_class(div4, "open", /*_positioned*/ctx[16]);
	          }
	          if (dirty[0] & /*_upward*/32768) {
	            toggle_class(div4, "upward", /*_upward*/ctx[15]);
	          }
	          if (dirty[0] & /*_upward*/32768) {
	            toggle_class(div4, "downward", ! /*_upward*/ctx[15]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block0);
	          for (let i = 0; i < each_value.length; i += 1) {
	            transition_in(each_blocks[i]);
	          }
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block0);
	          each_blocks = each_blocks.filter(Boolean);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            transition_out(each_blocks[i]);
	          }
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div4);
	          if (if_block0) if_block0.d();
	          destroy_each(each_blocks, detaching);
	          if (if_block1) if_block1.d();
	          /*div0_binding*/
	          ctx[104](null);
	          /*div1_binding*/
	          ctx[105](null);
	          /*div2_binding*/
	          ctx[106](null);
	          /*div4_binding*/
	          ctx[107](null);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (56:10) {#if search}
	    function create_if_block_9$1(ctx) {
	      let div;
	      let textbox;
	      let updating_value;
	      let updating_inputElement;
	      let current;
	      function textbox_value_binding(value) {
	        /*textbox_value_binding*/ctx[97](value);
	      }
	      function textbox_inputElement_binding(value) {
	        /*textbox_inputElement_binding*/ctx[98](value);
	      }
	      let textbox_props = {
	        id: /*_optionsSearchId*/ctx[46],
	        placeholder: "Search",
	        density: "high",
	        display: "custom",
	        icon: "general/veneer/search-o.svg",
	        theme: /*_theme*/ctx[21]
	      };
	      if (/*_searchText*/ctx[11] !== void 0) {
	        textbox_props.value = /*_searchText*/ctx[11];
	      }
	      if (/*_searchElement*/ctx[19] !== void 0) {
	        textbox_props.inputElement = /*_searchElement*/ctx[19];
	      }
	      textbox = new TextBox({
	        props: textbox_props
	      });
	      binding_callbacks.push(() => bind(textbox, "value", textbox_value_binding));
	      binding_callbacks.push(() => bind(textbox, "inputElement", textbox_inputElement_binding));
	      textbox.$on("changed", /*handleSearchChanged*/ctx[35]);
	      return {
	        c() {
	          div = element("div");
	          create_component(textbox.$$.fragment);
	          attr(div, "class", "pros-options-search svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          mount_component(textbox, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const textbox_changes = {};
	          if (dirty[1] & /*_optionsSearchId*/32768) textbox_changes.id = /*_optionsSearchId*/ctx[46];
	          if (dirty[0] & /*_theme*/2097152) textbox_changes.theme = /*_theme*/ctx[21];
	          if (!updating_value && dirty[0] & /*_searchText*/2048) {
	            updating_value = true;
	            textbox_changes.value = /*_searchText*/ctx[11];
	            add_flush_callback(() => updating_value = false);
	          }
	          if (!updating_inputElement && dirty[0] & /*_searchElement*/524288) {
	            updating_inputElement = true;
	            textbox_changes.inputElement = /*_searchElement*/ctx[19];
	            add_flush_callback(() => updating_inputElement = false);
	          }
	          textbox.$set(textbox_changes);
	        },
	        i(local) {
	          if (current) return;
	          transition_in(textbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(textbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          destroy_component(textbox);
	        }
	      };
	    }

	    // (83:18) {:else}
	    function create_else_block_1$1(ctx) {
	      let div;
	      let t;
	      let if_block1_anchor;
	      function select_block_type_2(ctx, dirty) {
	        if (/*option*/ctx[119].displayHtml) return create_if_block_8$1;
	        return create_else_block_2$1;
	      }
	      let current_block_type = select_block_type_2(ctx);
	      let if_block0 = current_block_type(ctx);
	      let if_block1 = /*option*/ctx[119].details && create_if_block_7$1(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block0.c();
	          t = space();
	          if (if_block1) if_block1.c();
	          if_block1_anchor = empty$1();
	          attr(div, "pros-tooltip", "");
	          attr(div, "role", "option");
	          attr(div, "class", "pros-option svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block0.m(div, null);
	          insert(target, t, anchor);
	          if (if_block1) if_block1.m(target, anchor);
	          insert(target, if_block1_anchor, anchor);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type_2(ctx)) && if_block0) {
	            if_block0.p(ctx, dirty);
	          } else {
	            if_block0.d(1);
	            if_block0 = current_block_type(ctx);
	            if (if_block0) {
	              if_block0.c();
	              if_block0.m(div, null);
	            }
	          }
	          if (/*option*/ctx[119].details) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_7$1(ctx);
	              if_block1.c();
	              if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block0.d();
	          if (detaching) detach(t);
	          if (if_block1) if_block1.d(detaching);
	          if (detaching) detach(if_block1_anchor);
	        }
	      };
	    }

	    // (76:18) {#if multiple}
	    function create_if_block_5$2(ctx) {
	      let checkbox;
	      let updating_label;
	      let updating_value;
	      let t;
	      let if_block_anchor;
	      let current;
	      function checkbox_label_binding(value) {
	        /*checkbox_label_binding*/ctx[99](value, /*option*/ctx[119]);
	      }
	      function checkbox_value_binding(value) {
	        /*checkbox_value_binding*/ctx[100](value, /*option*/ctx[119]);
	      }
	      let checkbox_props = {
	        display: "custom",
	        theme: /*_theme*/ctx[21]
	      };
	      if (/*option*/ctx[119].display !== void 0) {
	        checkbox_props.label = /*option*/ctx[119].display;
	      }
	      if (/*option*/ctx[119].selected !== void 0) {
	        checkbox_props.value = /*option*/ctx[119].selected;
	      }
	      checkbox = new CheckBox({
	        props: checkbox_props
	      });
	      binding_callbacks.push(() => bind(checkbox, "label", checkbox_label_binding));
	      binding_callbacks.push(() => bind(checkbox, "value", checkbox_value_binding));
	      let if_block = /*option*/ctx[119].details && create_if_block_6$1(ctx);
	      return {
	        c() {
	          create_component(checkbox.$$.fragment);
	          t = space();
	          if (if_block) if_block.c();
	          if_block_anchor = empty$1();
	        },
	        m(target, anchor) {
	          mount_component(checkbox, target, anchor);
	          insert(target, t, anchor);
	          if (if_block) if_block.m(target, anchor);
	          insert(target, if_block_anchor, anchor);
	          current = true;
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          const checkbox_changes = {};
	          if (dirty[0] & /*_theme*/2097152) checkbox_changes.theme = /*_theme*/ctx[21];
	          if (!updating_label && dirty[1] & /*_virtualOptions*/128) {
	            updating_label = true;
	            checkbox_changes.label = /*option*/ctx[119].display;
	            add_flush_callback(() => updating_label = false);
	          }
	          if (!updating_value && dirty[1] & /*_virtualOptions*/128) {
	            updating_value = true;
	            checkbox_changes.value = /*option*/ctx[119].selected;
	            add_flush_callback(() => updating_value = false);
	          }
	          checkbox.$set(checkbox_changes);
	          if (/*option*/ctx[119].details) {
	            if (if_block) {
	              if_block.p(ctx, dirty);
	            } else {
	              if_block = create_if_block_6$1(ctx);
	              if_block.c();
	              if_block.m(if_block_anchor.parentNode, if_block_anchor);
	            }
	          } else if (if_block) {
	            if_block.d(1);
	            if_block = null;
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(checkbox.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(checkbox.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          destroy_component(checkbox, detaching);
	          if (detaching) detach(t);
	          if (if_block) if_block.d(detaching);
	          if (detaching) detach(if_block_anchor);
	        }
	      };
	    }

	    // (87:20) {:else}
	    function create_else_block_2$1(ctx) {
	      let t_value = /*option*/ctx[119].display + "";
	      let t;
	      return {
	        c() {
	          t = text(t_value);
	        },
	        m(target, anchor) {
	          insert(target, t, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_virtualOptions*/128 && t_value !== (t_value = /*option*/ctx[119].display + "")) set_data(t, t_value);
	        },
	        d(detaching) {
	          if (detaching) detach(t);
	        }
	      };
	    }

	    // (85:20) {#if option.displayHtml}
	    function create_if_block_8$1(ctx) {
	      let html_tag;
	      let raw_value = /*option*/ctx[119].displayHtml + "";
	      let html_anchor;
	      return {
	        c() {
	          html_anchor = empty$1();
	          html_tag = new HtmlTag(html_anchor);
	        },
	        m(target, anchor) {
	          html_tag.m(raw_value, target, anchor);
	          insert(target, html_anchor, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_virtualOptions*/128 && raw_value !== (raw_value = /*option*/ctx[119].displayHtml + "")) html_tag.p(raw_value);
	        },
	        d(detaching) {
	          if (detaching) detach(html_anchor);
	          if (detaching) html_tag.d();
	        }
	      };
	    }

	    // (91:18) {#if option.details}
	    function create_if_block_7$1(ctx) {
	      let div;
	      let t_value = /*option*/ctx[119].details + "";
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(t_value);
	          attr(div, "class", "pros-option-details svelte-1c84wsf");
	          attr(div, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_virtualOptions*/128 && t_value !== (t_value = /*option*/ctx[119].details + "")) set_data(t, t_value);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (78:20) {#if option.details}
	    function create_if_block_6$1(ctx) {
	      let div;
	      let t_value = /*option*/ctx[119].details + "";
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(t_value);
	          attr(div, "class", "pros-option-details svelte-1c84wsf");
	          attr(div, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_virtualOptions*/128 && t_value !== (t_value = /*option*/ctx[119].details + "")) set_data(t, t_value);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (74:16) {#each _virtualOptions as option}
	    function create_each_block$1(ctx) {
	      let div;
	      let current_block_type_index;
	      let if_block;
	      let current;
	      let mounted;
	      let dispose;
	      const if_block_creators = [create_if_block_5$2, create_else_block_1$1];
	      const if_blocks = [];
	      function select_block_type_1(ctx, dirty) {
	        if (/*multiple*/ctx[2]) return 0;
	        return 1;
	      }
	      current_block_type_index = select_block_type_1(ctx);
	      if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      function click_handler(...args) {
	        return /*click_handler*/ctx[101](/*option*/ctx[119], ...args);
	      }
	      function mouseenter_handler(...args) {
	        return /*mouseenter_handler*/ctx[102](/*option*/ctx[119], ...args);
	      }
	      function mouseleave_handler(...args) {
	        return /*mouseleave_handler*/ctx[103](/*option*/ctx[119], ...args);
	      }
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-option-row svelte-1c84wsf");
	          toggle_class(div, "selected", /*isOptionSelected*/ctx[53](/*option*/ctx[119]));
	          toggle_class(div, "highlight", /*_searchOptions*/ctx[12].indexOf(/*option*/ctx[119]) === /*_highlightIndex*/ctx[13]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_blocks[current_block_type_index].m(div, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div, "click", click_handler), listen(div, "mouseenter", mouseenter_handler), listen(div, "mouseleave", mouseleave_handler), listen(div, "mouseleaveon:mousedown", preventClickPropagation$2), listen(div, "mouseup", preventClickPropagation$2)];
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type_1(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros();
	            transition_out(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros();
	            if_block = if_blocks[current_block_type_index];
	            if (!if_block) {
	              if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block.c();
	            } else {
	              if_block.p(ctx, dirty);
	            }
	            transition_in(if_block, 1);
	            if_block.m(div, null);
	          }
	          if (dirty[1] & /*isOptionSelected, _virtualOptions*/4194432) {
	            toggle_class(div, "selected", /*isOptionSelected*/ctx[53](/*option*/ctx[119]));
	          }
	          if (dirty[0] & /*_searchOptions, _highlightIndex*/12288 | dirty[1] & /*_virtualOptions*/128) {
	            toggle_class(div, "highlight", /*_searchOptions*/ctx[12].indexOf(/*option*/ctx[119]) === /*_highlightIndex*/ctx[13]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_blocks[current_block_type_index].d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (99:16) {#if _virtualOptions.length === 0}
	    function create_if_block_4$3(ctx) {
	      let div;
	      let t_value = /*$_*/ctx[51]("noValues") + "";
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(t_value);
	          attr(div, "class", "pros-empty-row svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*$_*/1048576 && t_value !== (t_value = /*$_*/ctx[51]("noValues") + "")) set_data(t, t_value);
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (112:4) {#if display !== 'custom'}
	    function create_if_block$3(ctx) {
	      let div;
	      function select_block_type_3(ctx, dirty) {
	        if (/*_dirty*/ctx[8] && /*_errors*/ctx[9].length > 0) return create_if_block_1$3;
	        if (/*hint*/ctx[5] && /*_showOptions*/ctx[10]) return create_if_block_2$3;
	        return create_else_block$3;
	      }
	      let current_block_type = select_block_type_3(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-1c84wsf");
	          toggle_class(div, "error", /*_dirty*/ctx[8] && /*_errors*/ctx[9].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type_3(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/768) {
	            toggle_class(div, "error", /*_dirty*/ctx[8] && /*_errors*/ctx[9].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (128:6) {:else}
	    function create_else_block$3(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[47]);
	          attr(div, "class", "pros-message svelte-1c84wsf");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_messageId*/65536) {
	            attr(div, "id", /*_messageId*/ctx[47]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (121:37) 
	    function create_if_block_2$3(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[5]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1c84wsf");
	          attr(div0, "id", /*_statusIconId*/ctx[48]);
	          attr(div0, "class", "pros-status-icon svelte-1c84wsf");
	          attr(div1, "id", /*_messageId*/ctx[47]);
	          attr(div1, "class", "pros-message svelte-1c84wsf");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/131072) {
	            attr(div0, "id", /*_statusIconId*/ctx[48]);
	          }
	          if (dirty[0] & /*hint*/32) set_data(t1, /*hint*/ctx[5]);
	          if (dirty[1] & /*_messageId*/65536) {
	            attr(div1, "id", /*_messageId*/ctx[47]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (114:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1$3(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[9][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1c84wsf");
	          attr(div0, "id", /*_statusIconId*/ctx[48]);
	          attr(div0, "class", "pros-status-icon error svelte-1c84wsf");
	          attr(div1, "id", /*_messageId*/ctx[47]);
	          attr(div1, "class", "pros-message error svelte-1c84wsf");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/131072) {
	            attr(div0, "id", /*_statusIconId*/ctx[48]);
	          }
	          if (dirty[0] & /*_errors*/512 && t1_value !== (t1_value = /*_errors*/ctx[9][0] + "")) set_data(t1, t1_value);
	          if (dirty[1] & /*_messageId*/65536) {
	            attr(div1, "id", /*_messageId*/ctx[47]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment$3(ctx) {
	      let div5;
	      let div4;
	      let t0;
	      let div3;
	      let div2;
	      let div0;
	      let t1;
	      let t2;
	      let div1;
	      let svg;
	      let path;
	      let t3;
	      let t4;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[50] && create_if_block_14(ctx);
	      function select_block_type(ctx, dirty) {
	        if (/*_displayHtml*/ctx[14]) return create_if_block_11;
	        if (/*_display*/ctx[3]) return create_if_block_12;
	        if (/*placeholder*/ctx[24]) return create_if_block_13;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block1 = current_block_type && current_block_type(ctx);
	      let if_block2 = /*_showClear*/ctx[49] && create_if_block_10$1(ctx);
	      let if_block3 = /*_showOptions*/ctx[10] && ! /*disabled*/ctx[1] && create_if_block_3$3(ctx);
	      let if_block4 = /*display*/ctx[4] !== "custom" && create_if_block$3(ctx);
	      return {
	        c() {
	          div5 = element("div");
	          div4 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div3 = element("div");
	          div2 = element("div");
	          div0 = element("div");
	          if (if_block1) if_block1.c();
	          t1 = space();
	          if (if_block2) if_block2.c();
	          t2 = space();
	          div1 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t3 = space();
	          if (if_block3) if_block3.c();
	          t4 = space();
	          if (if_block4) if_block4.c();
	          attr(div0, "class", "pros-input-container svelte-1c84wsf");
	          attr(path, "d", "M12.5 17C12.3721 17 12.2441 16.9512 12.1465 16.8535L4.14648 8.85352C3.95117 8.6582 3.95117 8.3418 4.14648 8.14648C4.3418 7.95117 4.6582 7.95117 4.85352 8.14648L12.5 15.793L20.1465 8.14648C20.3418 7.95117 20.6582 7.95117 20.8535 8.14648C21.0488 8.3418 21.0488 8.6582 20.8535 8.85352L12.8535 16.8535C12.7559 16.9512 12.6279 17 12.5 17Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1c84wsf");
	          attr(div1, "id", /*_capId*/ctx[44]);
	          attr(div1, "class", "pros-end-cap svelte-1c84wsf");
	          attr(div1, "disabled", /*disabled*/ctx[1]);
	          attr(div2, "class", "pros-content-container svelte-1c84wsf");
	          attr(div3, "id", /*_inputId*/ctx[42]);
	          attr(div3, "class", "pros-highlight-container svelte-1c84wsf");
	          attr(div3, "tabindex", "0");
	          toggle_class(div3, "open", /*_showOptions*/ctx[10]);
	          toggle_class(div3, "upward", /*_upward*/ctx[15]);
	          toggle_class(div3, "downward", ! /*_upward*/ctx[15]);
	          attr(div4, "class", "pros-control-container svelte-1c84wsf");
	          toggle_class(div4, "has-value", /*_hasValue*/ctx[36]);
	          toggle_class(div4, "has-label", /*_hasLabel*/ctx[50]);
	          toggle_class(div4, "has-focus", /*_hasFocus*/ctx[17] && ! /*_showOptions*/ctx[10]);
	          toggle_class(div4, "custom-layout", /*display*/ctx[4] === "custom");
	          toggle_class(div4, "error", /*_dirty*/ctx[8] && /*_errors*/ctx[9].length > 0);
	          toggle_class(div4, "disabled", /*disabled*/ctx[1]);
	          toggle_class(div4, "allow-hover", ! /*disabled*/ctx[1] && ! /*_showOptions*/ctx[10]);
	          attr(div5, "class", "pros-global-wrapper pros-form-control svelte-1c84wsf");
	          attr(div5, "pos--theme", /*_theme*/ctx[21]);
	          attr(div5, "pos--shape", /*_shape*/ctx[22]);
	          attr(div5, "pos--density", /*_density*/ctx[23]);
	        },
	        m(target, anchor) {
	          insert(target, div5, anchor);
	          append(div5, div4);
	          if (if_block0) if_block0.m(div4, null);
	          append(div4, t0);
	          append(div4, div3);
	          append(div3, div2);
	          append(div2, div0);
	          if (if_block1) if_block1.m(div0, null);
	          append(div2, t1);
	          if (if_block2) if_block2.m(div2, null);
	          append(div2, t2);
	          append(div2, div1);
	          append(div1, svg);
	          append(svg, path);
	          append(div3, t3);
	          if (if_block3) if_block3.m(div3, null);
	          /*div3_binding*/
	          ctx[108](div3);
	          append(div4, t4);
	          if (if_block4) if_block4.m(div4, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div3, "mouseup", /*handleMouseUp*/ctx[55]), listen(div3, "mousedown", /*handleMouseDown*/ctx[54]), listen(div3, "click", /*handleClick*/ctx[33]), listen(div3, "keydown", /*handleKeyDown*/ctx[32]), listen(div3, "focus", /*handleFocus*/ctx[30]), listen(div3, "focusout", /*handleBlur*/ctx[31])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[50]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_14(ctx);
	              if_block0.c();
	              if_block0.m(div4, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
	            if_block1.p(ctx, dirty);
	          } else {
	            if (if_block1) if_block1.d(1);
	            if_block1 = current_block_type && current_block_type(ctx);
	            if (if_block1) {
	              if_block1.c();
	              if_block1.m(div0, null);
	            }
	          }
	          if (/*_showClear*/ctx[49]) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block_10$1(ctx);
	              if_block2.c();
	              if_block2.m(div2, t2);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (!current || dirty[1] & /*_capId*/8192) {
	            attr(div1, "id", /*_capId*/ctx[44]);
	          }
	          if (!current || dirty[0] & /*disabled*/2) {
	            attr(div1, "disabled", /*disabled*/ctx[1]);
	          }
	          if (/*_showOptions*/ctx[10] && ! /*disabled*/ctx[1]) {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	              if (dirty[0] & /*_showOptions, disabled*/1026) {
	                transition_in(if_block3, 1);
	              }
	            } else {
	              if_block3 = create_if_block_3$3(ctx);
	              if_block3.c();
	              transition_in(if_block3, 1);
	              if_block3.m(div3, null);
	            }
	          } else if (if_block3) {
	            group_outros();
	            transition_out(if_block3, 1, 1, () => {
	              if_block3 = null;
	            });
	            check_outros();
	          }
	          if (!current || dirty[1] & /*_inputId*/2048) {
	            attr(div3, "id", /*_inputId*/ctx[42]);
	          }
	          if (dirty[0] & /*_showOptions*/1024) {
	            toggle_class(div3, "open", /*_showOptions*/ctx[10]);
	          }
	          if (dirty[0] & /*_upward*/32768) {
	            toggle_class(div3, "upward", /*_upward*/ctx[15]);
	          }
	          if (dirty[0] & /*_upward*/32768) {
	            toggle_class(div3, "downward", ! /*_upward*/ctx[15]);
	          }
	          if (/*display*/ctx[4] !== "custom") {
	            if (if_block4) {
	              if_block4.p(ctx, dirty);
	            } else {
	              if_block4 = create_if_block$3(ctx);
	              if_block4.c();
	              if_block4.m(div4, null);
	            }
	          } else if (if_block4) {
	            if_block4.d(1);
	            if_block4 = null;
	          }
	          if (dirty[1] & /*_hasValue*/32) {
	            toggle_class(div4, "has-value", /*_hasValue*/ctx[36]);
	          }
	          if (dirty[1] & /*_hasLabel*/524288) {
	            toggle_class(div4, "has-label", /*_hasLabel*/ctx[50]);
	          }
	          if (dirty[0] & /*_hasFocus, _showOptions*/132096) {
	            toggle_class(div4, "has-focus", /*_hasFocus*/ctx[17] && ! /*_showOptions*/ctx[10]);
	          }
	          if (dirty[0] & /*display*/16) {
	            toggle_class(div4, "custom-layout", /*display*/ctx[4] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/768) {
	            toggle_class(div4, "error", /*_dirty*/ctx[8] && /*_errors*/ctx[9].length > 0);
	          }
	          if (dirty[0] & /*disabled*/2) {
	            toggle_class(div4, "disabled", /*disabled*/ctx[1]);
	          }
	          if (dirty[0] & /*disabled, _showOptions*/1026) {
	            toggle_class(div4, "allow-hover", ! /*disabled*/ctx[1] && ! /*_showOptions*/ctx[10]);
	          }
	          if (!current || dirty[0] & /*_theme*/2097152) {
	            attr(div5, "pos--theme", /*_theme*/ctx[21]);
	          }
	          if (!current || dirty[0] & /*_shape*/4194304) {
	            attr(div5, "pos--shape", /*_shape*/ctx[22]);
	          }
	          if (!current || dirty[0] & /*_density*/8388608) {
	            attr(div5, "pos--density", /*_density*/ctx[23]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block3);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block3);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div5);
	          if (if_block0) if_block0.d();
	          if (if_block1) {
	            if_block1.d();
	          }
	          if (if_block2) if_block2.d();
	          if (if_block3) if_block3.d();
	          /*div3_binding*/
	          ctx[108](null);
	          if (if_block4) if_block4.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    const OPTION_ROW_HEIGHT = 40;
	    const OPTION_SPACE_BETWEEN = 4;
	    const VIRTUAL_ITEM_COUNT = 20;
	    function preventClickPropagation$2(event) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	    function notEmpty$3(test) {
	      return test !== undefined && test !== null;
	    }
	    function instance$3($$self, $$props, $$invalidate) {
	      let _showClear;
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(51, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      const _handleOptionsScrollDebounce = debounce(handleOptionScroll, 200, {
	        maxWait: 500,
	        trailing: true
	      });
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        globalKeyListener = null
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, form-inline, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = undefined
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        search = false
	      } = $$props; // Allow options to be searched
	      let {
	        clear = false
	      } = $$props; // Allow value to be cleared
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        options = []
	      } = $$props; // Options to choose from
	      let {
	        multiple = false
	      } = $$props; // Allow multi-selection
	      let {
	        idKey = null
	      } = $$props;
	      let {
	        valuePath
	      } = $$props;
	      let {
	        id = null
	      } = $$props;
	      let {
	        _dirty = false
	      } = $$props; // Has the user changed the value (yes = dirty)
	      let {
	        _errors = []
	      } = $$props; // Combined validation errors
	      let {
	        _builtInErrors = []
	      } = $$props; // Built in validation errors
	      let {
	        _showOptions = false
	      } = $$props; // Is Selector visible?
	      let {
	        _searchText = null
	      } = $$props; // Current user search text
	      let {
	        _searchOptions = []
	      } = $$props; // Current set of options matching _searchText
	      let {
	        _highlightIndex = 0
	      } = $$props; // Index of option user currently has highlighted
	      let {
	        _globalClicksNode = null
	      } = $$props; // Active Global clicks node for selecting in list
	      let {
	        _lastValue
	      } = $$props; // Last control value so we can filter out extra change events and normalize programmatic changes
	      let {
	        _display
	      } = $$props; // String to display based on selection
	      let {
	        _displayHtml
	      } = $$props; // String to display based on selection
	      let {
	        _openNode = undefined
	      } = $$props;
	      let {
	        _openParent = undefined
	      } = $$props;
	      let {
	        _upward = false
	      } = $$props;
	      let {
	        _positioned = false
	      } = $$props;
	      let {
	        _hasFocus = false
	      } = $$props;
	      let {
	        _highlightElement
	      } = $$props;
	      let {
	        _searchElement
	      } = $$props;
	      let {
	        _optionsWrapper
	      } = $$props;
	      let {
	        _suppressFocus
	      } = $$props;
	      let {
	        _lastValid
	      } = $$props;
	      let {
	        _themeEventListener
	      } = $$props;
	      let {
	        _shapeEventListener
	      } = $$props;
	      let {
	        _densityEventListener
	      } = $$props;
	      let {
	        _theme
	      } = $$props;
	      let {
	        _shape
	      } = $$props;
	      let {
	        _density
	      } = $$props;
	      let {
	        _lastTheme
	      } = $$props;
	      let {
	        _lastShape
	      } = $$props;
	      let {
	        _lastDensity
	      } = $$props;
	      let {
	        _lastSearchText
	      } = $$props;
	      let {
	        _options = []
	      } = $$props;
	      let {
	        _lastOptions = []
	      } = $$props;
	      let {
	        _isNullValid = false
	      } = $$props;
	      let _virtualContainer;
	      let _virtualOptions = [];
	      let _optionListContainer;
	      let _optionsScrollContainer;
	      let _viewportTop = 0;
	      let _mouseOverOption = false;
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _capId = null;
	      let _optionsId = null;
	      let _optionsSearchId = null;
	      let _messageId = null;
	      let _statusIconId = null;

	      // onCreate
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_showOptions) {
	          closeOptions();
	        }
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(2, multiple = notEmpty$3(multiple) ? multiple : false);
	        $$invalidate(4, display = notEmpty$3(display) ? display : "form");
	        $$invalidate(64, theme = notEmpty$3(theme) ? theme : "light");
	        $$invalidate(65, shape = notEmpty$3(shape) ? shape : "round");
	        $$invalidate(66, density = notEmpty$3(density) ? density : "standard");
	        $$invalidate(0, label = notEmpty$3(label) ? label : "");
	        $$invalidate(5, hint = notEmpty$3(hint) ? hint : "");
	        $$invalidate(7, required = notEmpty$3(required) ? required : false);
	        $$invalidate(1, disabled = notEmpty$3(disabled) ? disabled : false);
	        $$invalidate(58, clear = notEmpty$3(clear) ? clear : false);
	        $$invalidate(6, search = notEmpty$3(search) ? search : false);
	        $$invalidate(67, validation = notEmpty$3(validation) ? validation : true);
	        $$invalidate(41, _labelId = hasValue(id) ? `${id}-label` : undefined);
	        $$invalidate(42, _inputId = hasValue(id) ? `${id}-input` : undefined);
	        $$invalidate(43, _clearId = hasValue(id) ? `${id}-clear` : undefined);
	        $$invalidate(44, _capId = hasValue(id) ? `${id}-cap` : undefined);
	        $$invalidate(45, _optionsId = hasValue(id) ? `${id}-options` : undefined);
	        $$invalidate(46, _optionsSearchId = hasValue(id) ? `${id}-options-search-input` : undefined);
	        $$invalidate(47, _messageId = hasValue(id) ? `${id}-message` : undefined);
	        $$invalidate(48, _statusIconId = hasValue(id) ? `${id}-status-icon` : undefined);
	        if (multiple) {
	          $$invalidate(57, value = hasValue(value) && Array.isArray(value) ? value : []);
	        } else {
	          $$invalidate(57, value = hasValue(value) ? value : undefined);
	        }
	        if (theme !== _lastTheme) {
	          $$invalidate(77, _lastTheme = theme);
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(21, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              $$invalidate(74, _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(21, _theme = event.detail.theme);
	                }
	              }));
	            }
	          } else {
	            $$invalidate(21, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          $$invalidate(78, _lastShape = shape);
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(22, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              $$invalidate(75, _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(22, _shape = event.detail.shape);
	                }
	              }));
	            }
	          } else {
	            $$invalidate(22, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          $$invalidate(79, _lastDensity = density);
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(23, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              $$invalidate(76, _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(23, _density = event.detail.density);
	                }
	              }));
	            }
	          } else {
	            $$invalidate(23, _density = density);
	          }
	        }

	        // handleSearchChanged();
	        doValidate.call(this);
	      });
	      function updateDisplay() {
	        $$invalidate(3, _display = "");
	        if (multiple) {
	          if (value && value.length > 0) {
	            let _selectedOptions = _options.filter(o => {
	              return o.selected;
	            });
	            $$invalidate(3, _display = _selectedOptions.map(o => {
	              return o.display;
	            }).join(", "));
	          }
	        } else {
	          if (notEmpty$3(valuePath)) {
	            let found = _options.find(o => {
	              return get(o.value, valuePath) === get(value, valuePath);
	            });
	            $$invalidate(14, _displayHtml = found ? found.displayHtml : null);
	            $$invalidate(3, _display = found ? found.display : null);
	          } else {
	            let found = _options.find(o => {
	              if (idKey) {
	                return value ? o.value[idKey] === value[idKey] : false;
	              } else {
	                return o.value === value;
	              }
	            });
	            $$invalidate(14, _displayHtml = found ? found.displayHtml : null);
	            $$invalidate(3, _display = found ? found.display : null);
	          }
	        }
	      }
	      function isOptionSelected(option) {
	        if (multiple) {
	          return;
	        }
	        if (valuePath) {
	          return value && get(value, valuePath) === get(option.value, valuePath);
	        } else {
	          return value && value === option.value;
	        }
	      }
	      function isSameValue(value1, value2) {
	        if (!hasValue(value1) && !hasValue(value2)) {
	          return true;
	        }
	        if (idKey) {
	          return value1[idKey] === value2[idKey];
	        }
	        if (hasValue(value1) && !hasValue(value2) || !hasValue(value1) && hasValue(value2)) {
	          return false;
	        }
	        if (multiple) {
	          let array1 = Array.isArray(value1) ? value1 : [value1];
	          let array2 = Array.isArray(value2) ? value2 : [value2];
	          if (value1.length !== value2.length) {
	            return false;
	          }
	          if (valuePath) {
	            array1 = value1.map(v => {
	              return v[valuePath];
	            });
	            array2 = value2.map(v => {
	              return v[valuePath];
	            });
	          }
	          let sameValues = true;
	          array1.forEach(v => {
	            if (!array2.includes(v)) {
	              sameValues = false;
	            }
	          });
	          return sameValues;
	        } else {
	          let test1 = valuePath ? value1[valuePath] : value1;
	          let test2 = valuePath ? value2[valuePath] : value2;
	          return test1 === test2;
	        }
	      }
	      function isSameOptions(array1, array2) {
	        if (array1.length !== array2.length) {
	          // console.log('Detected difference - length', array1, array2);
	          return false;
	        }
	        for (let i = 0; i < array1.length; i++) {
	          const isObject1 = typeof array1[i].value === "object" && typeof array1[i] !== null;
	          const isObject2 = typeof array2[i].value === "object" && typeof array2[i] !== null;
	          if (isObject1 !== isObject2) {
	            // console.log('Detected difference - type', isObject1, isObject2);
	            return false;
	          }
	          if (array1[i].display !== array2[i].display) {
	            // console.log('Detected difference - display', array1[i], array2[i]);
	            return false;
	          }
	          if (array1[i].details !== array2[i].details) {
	            // console.log('Detected difference - display', array1[i], array2[i]);
	            return false;
	          }
	          if (isObject1 && valuePath && get(array1[i], valuePath) !== get(array2[i], valuePath)) {
	            // console.log('Detected difference - valuePath', array1[i].value, array2[i].value);
	            return false;
	          }
	          if (!isObject1 && array1[i].value !== array2[i].value) {
	            // console.log('Detected difference - value', array1[i].value, array2[i].value);
	            return false;
	          }
	        }
	        return true;
	      }
	      function globalClicks(node) {
	        // console.log('globalClicks');
	        $$invalidate(69, _globalClicksNode = node);
	        $$invalidate(62, globalClickListener = event => {
	          // event.preventDefault();
	          event.stopPropagation();
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (!containsClick) {
	            // console.log('SB: globalClicks: close Options');
	            closeOptions(true);
	          }
	        });
	        $$invalidate(63, globalKeyListener = event => {
	          myKeyDown.call(this, event);
	        });

	        // Necessary to prevent handling click that opens panel
	        setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	          document.addEventListener("keydown", globalKeyListener);
	        }); // let searchBox = node.querySelector('.pros-search-input');
	        //
	        // if (searchBox) {
	        //   searchBox.focus();
	      } // }

	      function positionOptions(node) {
	        // console.log('positionOptions');
	        $$invalidate(70, _openNode = node);
	        $$invalidate(71, _openParent = node.parentElement);

	        // console.log('positionOptions', _openNode, _openParent);
	        // Reparent options to end of DOM so it is on top
	        // We reparent options back when options are closed
	        document.body.appendChild(node);
	        setTimeout(positionNode);
	        document.addEventListener("wheel", handleScroll);
	        window.addEventListener("scroll", handleScroll, true);
	        window.addEventListener("resize", handleScroll);
	        return {
	          destroy() {
	            // console.log('Remove option listeners - positionOptions')
	            document.removeEventListener("wheel", handleScroll);
	            window.removeEventListener("scroll", handleScroll);
	            window.removeEventListener("resize", handleScroll);
	          }
	        };
	      }
	      function positionNode(event) {
	        // console.log('positionNode');
	        if (!_openParent) {
	          return;
	        }
	        let adjustedTop;
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        $$invalidate(15, _upward = false);
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          $$invalidate(15, _upward = true);
	          adjustedTop = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight}px` : `0px`;
	        }
	        if (event) {
	          let scrollTop = event.target.scrollTop;
	          let scrollBottom = scrollTop + event.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop) {
	            adjustedTop = 0 + "px";
	          }
	          if (_openParent.offsetParent.offsetTop > scrollBottom) {
	            adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	          }
	        }
	        $$invalidate(70, _openNode.style.left = `${rect.left}px`, _openNode);
	        $$invalidate(70, _openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`, _openNode);
	        $$invalidate(70, _openNode.style.width = `${rect.width}px`, _openNode);
	        if (!_positioned) {
	          // Let DOM update with new position before showing
	          setTimeout(() => {
	            // console.log('set options visible');
	            $$invalidate(16, _positioned = true);

	            // Let DOM update with visible options before doing work in options panel
	            setTimeout(() => {
	              // console.log('set focus - positionNode');
	              handleSearchChanged();
	              handleOptionScroll();
	              scrollToSelected();
	              if (search && _searchElement) {
	                _searchElement.focus();
	              }
	            });
	          });
	        }
	      } //setTimeout(positionNode, 10);

	      function handleScroll(event) {
	        // console.log('handleScroll');
	        let isOptionScroll = false;
	        let test = event.target;
	        while (test) {
	          if (test.id === "pros-options-container") {
	            isOptionScroll = true;
	            break;
	          }
	          test = test.parentElement;
	        }
	        if (!isOptionScroll) {
	          // console.log('reposition Options due to scroll');
	          positionNode(event);
	        }
	      }
	      function closeOptions(keepFocus = false) {
	        // console.log('closeOptions', keepFocus);
	        // Re-parent options
	        if (_openParent) {
	          _openParent.appendChild(_openNode);
	        }
	        $$invalidate(70, _openNode = undefined);
	        $$invalidate(71, _openParent = undefined);
	        $$invalidate(12, _searchOptions = _options);
	        $$invalidate(11, _searchText = null);
	        $$invalidate(13, _highlightIndex = 0);
	        if (globalClickListener) {
	          document.removeEventListener("click", globalClickListener);
	          $$invalidate(62, globalClickListener = null);
	        }
	        if (globalKeyListener) {
	          document.removeEventListener("keydown", globalKeyListener);
	          $$invalidate(63, globalKeyListener = null);
	        }
	        if (keepFocus) {
	          // console.log('SB: closeOptions:focus Highlight')
	          setTimeout(() => {
	            _highlightElement.focus();
	          });
	        }
	        $$invalidate(16, _positioned = false);
	        $$invalidate(10, _showOptions = false);
	      }
	      function openOptions(event) {
	        //console.log('openOptions');
	        _highlightElement.focus();
	        $$invalidate(10, _showOptions = true);
	      }
	      function myKeyDown(event) {
	        // console.log('Key Down - Global', event);
	        switch (event.key) {
	          case "Enter":
	            // console.log('SB: myKeyDown:Enter');
	            event.stopPropagation();
	            if (_showOptions) {
	              let selectedOption = _searchOptions.find(option => {
	                return option.value === value;
	              });
	              let selectedIndex = _searchOptions.indexOf(selectedOption);
	              if (multiple) {
	                toggleOption(_searchOptions[_highlightIndex]);
	              } else {
	                if (_highlightIndex !== selectedIndex) {
	                  toggleOption(_searchOptions[_highlightIndex]);
	                }
	              }
	            } else {
	              openOptions();
	            }
	            break;
	          case "Escape":
	            console.log("SB: myKeyDown:Escape");
	            if (_showOptions) {
	              event.stopPropagation();
	              event.preventDefault();
	              closeOptions(true);
	            } else {
	              _highlightElement.blur();
	            }
	            break;
	          case "ArrowDown":
	            // console.log('SB: myKeyDown:ArrowDown');
	            event.stopPropagation();
	            event.preventDefault();
	            if (_showOptions && !_mouseOverOption) {
	              if (_highlightIndex < _searchOptions.length - 1) {
	                $$invalidate(13, _highlightIndex++, _highlightIndex);
	              }
	              scrollOptionIntoView.call(this, _highlightIndex);
	            }
	            break;
	          case "ArrowUp":
	            // console.log('SB: myKeyDown:ArrowUp');
	            event.stopPropagation();
	            event.preventDefault();
	            if (_showOptions && !_mouseOverOption) {
	              if (_highlightIndex > 0) {
	                $$invalidate(13, _highlightIndex--, _highlightIndex);
	              }
	              scrollOptionIntoView.call(this, _highlightIndex);
	            }
	            break;
	        }
	      }
	      function handleMouseEnterOption(option) {
	        _mouseOverOption = true;
	        $$invalidate(13, _highlightIndex = _searchOptions.indexOf(option));
	      }
	      function handleMouseLeaveOption() {
	        _mouseOverOption = false;
	      }
	      function handleFocus(event) {
	        if (!_suppressFocus) {
	          $$invalidate(17, _hasFocus = true);
	        } // console.log('SB: handleFocus');
	      }
	      function handleBlur(event) {
	        if (!_showOptions) {
	          // console.log('SB: handleBlur:SetFocus');
	          $$invalidate(17, _hasFocus = false);
	        } // console.log(`handleBlur`, event);
	        // closeOptions(false)
	      }
	      function handleKeyDown(event) {
	        // console.log('Key Down - Container', event);
	        if (_showOptions || event.isComposing || event.keyCode === 229) {
	          return;
	        }
	        switch (event.key) {
	          case "Shift":
	          case "Alt":
	          case "Ctrl":
	          case "Tab":
	            return;
	          case "Enter":
	          case "ArrowDown":
	          case " ":
	            // console.log('SB: handleKeyDown:' + event.key);
	            event.stopPropagation();
	            event.preventDefault();
	            openOptions();
	            break;
	          case "Escape":
	            // console.log('SB: handleKeyDown:Escape');
	            _highlightElement.blur();
	            break;
	          default:
	            event.stopPropagation();
	            event.preventDefault();
	            if (search) {
	              if ([...event.key].length === 1) {
	                let char = String.fromCharCode(event.keyCode);
	                if (!event.shiftKey) {
	                  char = char.toLocaleLowerCase();
	                }
	                $$invalidate(11, _searchText = "" + char);
	                setTimeout(() => {
	                  handleSearchChanged();
	                }, 10);
	                openOptions();
	              }
	            }
	        }
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	        if (_showOptions) {
	          // console.log('SB: handleClick:Close');
	          closeOptions(true);
	        } else {
	          // event.stopPropagation();
	          // event.preventDefault();
	          // console.log('SB: handleClick:Open');
	          openOptions();
	        }
	      }
	      function handleMouseDown(event) {
	        $$invalidate(72, _suppressFocus = true);
	      }
	      function handleMouseUp(event) {
	        $$invalidate(72, _suppressFocus = false);
	      }
	      function handleClear(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        $$invalidate(57, value = multiple ? [] : undefined);
	        _options.forEach(o => {
	          o.selected = false;
	        });
	        $$invalidate(12, _searchOptions = _options);
	        valueChanged.call(this);
	      }
	      function handleOptionClicked(option, event) {
	        // event.stopPropagation();
	        // event.preventDefault();
	        if (multiple) {
	          handleSelectionChanged();
	          return;
	        }
	        _options.forEach(o => {
	          o.selected = false;
	        });
	        option.selected = !option.selected;
	        handleSelectionChanged(option);
	      }
	      function toggleOption(option) {
	        option.selected = !option.selected;
	        handleSelectionChanged(option);
	      }
	      function handleSelectionChanged(option, event) {
	        if (notEmpty$3(event)) {
	          event.preventDefault();
	          event.stopPropagation();
	        }
	        if (multiple) {
	          let selectedOptions = _options.filter(o => {
	            return o.selected;
	          });
	          $$invalidate(57, value = selectedOptions.map(o => {
	            return o.value;
	          }));
	        } else {
	          // console.log('SB: handleSelectionChanged: Close Options');
	          $$invalidate(57, value = option.value);
	          closeOptions(true);
	        }
	        valueChanged.call(this);
	      }
	      function scrollToSelected() {
	        const found = _searchOptions.find(o => {
	          return isOptionSelected(o);
	        });
	        if (found) {
	          $$invalidate(13, _highlightIndex = _searchOptions.indexOf(found));
	          const scrollTo = _highlightIndex * OPTION_ROW_HEIGHT;
	          $$invalidate(40, _optionsScrollContainer.scrollTop = scrollTo, _optionsScrollContainer);
	        }
	        setTimeout(() => {
	          handleOptionScroll();
	        }, 10);
	      }
	      function scrollOptionIntoView(index) {
	        if (!_globalClicksNode) {
	          return;
	        }
	        const targetTop = index * OPTION_ROW_HEIGHT;
	        const targetBottom = targetTop + OPTION_ROW_HEIGHT;
	        const currentTop = _optionsScrollContainer.scrollTop;
	        const currentBottom = currentTop + _optionsScrollContainer.offsetHeight;
	        if (targetTop < currentTop) {
	          _optionsScrollContainer.scrollTo({
	            top: targetTop,
	            left: 0,
	            behavior: "smooth"
	          });
	        }
	        if (targetBottom > currentBottom) {
	          _optionsScrollContainer.scrollTo({
	            top: targetBottom - _optionsScrollContainer.offsetHeight,
	            left: 0,
	            behavior: "smooth"
	          });
	        }
	      }
	      function handleOptionScroll(event) {
	        if (!_optionsScrollContainer) {
	          return;
	        }
	        const scrollTop = _optionsScrollContainer.scrollTop;

	        // If we have no items account for 'No Items' message which takes space of 1 item
	        const filteredCount = _searchOptions.length > 0 ? _searchOptions.length : 1;

	        // Calculate the virtual container height
	        const virtualHeight = filteredCount * OPTION_ROW_HEIGHT - OPTION_SPACE_BETWEEN;
	        $$invalidate(37, _virtualContainer.style.height = `${virtualHeight}px`, _virtualContainer);

	        // Height of the virtual view port that we absolute position
	        const viewPortHeight = VIRTUAL_ITEM_COUNT * OPTION_ROW_HEIGHT;
	        if (virtualHeight <= viewPortHeight) {
	          $$invalidate(38, _virtualOptions = _searchOptions);
	          return;
	        }
	        if (_virtualOptions.length === 0 || scrollTop < _viewportTop + viewPortHeight / 4 || scrollTop > _viewportTop + viewPortHeight - viewPortHeight / 4) {
	          // Need to reset view port
	          let itemIndex = Math.floor(scrollTop / OPTION_ROW_HEIGHT) - VIRTUAL_ITEM_COUNT / 2;
	          if (itemIndex < 0) {
	            itemIndex = 0;
	          }
	          if (itemIndex > _searchOptions.length - VIRTUAL_ITEM_COUNT) {
	            itemIndex = _searchOptions.length - VIRTUAL_ITEM_COUNT;
	          }
	          $$invalidate(38, _virtualOptions = [..._searchOptions].splice(itemIndex, VIRTUAL_ITEM_COUNT));
	          _viewportTop = itemIndex * OPTION_ROW_HEIGHT;
	          $$invalidate(39, _optionListContainer.style.top = `${_viewportTop}px`, _optionListContainer);
	        }
	      }
	      function handleSearchChanged(event) {
	        $$invalidate(13, _highlightIndex = 0);
	        if (_searchText === undefined || _searchText === null || _searchText === "") {
	          $$invalidate(12, _searchOptions = _options);
	          $$invalidate(80, _lastSearchText = null);
	        } else {
	          let myText = _searchText.toLocaleLowerCase();
	          if (myText !== _lastSearchText) {
	            $$invalidate(80, _lastSearchText = myText);
	            $$invalidate(12, _searchOptions = _options.filter(option => {
	              return option.display.toLocaleLowerCase().includes(myText) || option.details && option.details.toLocaleLowerCase().includes(myText);
	            }));
	          }
	        }
	        if (_optionsScrollContainer) {
	          $$invalidate(40, _optionsScrollContainer.scrollTop = 0, _optionsScrollContainer);
	        }
	        setTimeout(() => {
	          positionNode();
	          handleOptionScroll();
	        }, 10);
	      }
	      function handleClearSearch(event) {
	        event.stopPropagation();
	        _searchElement.focus();
	        $$invalidate(12, _searchOptions = _options);
	        $$invalidate(11, _searchText = null);
	      }

	      // Others
	      function valueChanged() {
	        $$invalidate(8, _dirty = true);
	        $$invalidate(59, _lastValue = value);
	        doValidate.call(this);
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        $$invalidate(68, _builtInErrors = []);
	        $$invalidate(9, _errors = errors ? errors : []);
	        if (required) {
	          if (multiple) {
	            if (value.length === 0) {
	              _builtInErrors.push($_("validateRequired"));
	            }
	          } else {
	            if (!hasValue(value)) {
	              _builtInErrors.push($_("validateRequired"));
	            }
	          }
	        }
	        if (validation) {
	          $$invalidate(9, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            $$invalidate(73, _lastValid = valid);
	            dispatch("valid", valid);
	            if (multiple) {
	              if (value.length > 0 && !valid && !_dirty) {
	                $$invalidate(8, _dirty = true);
	              }
	            } else {
	              if (hasValue(value) && !valid && !_dirty) {
	                $$invalidate(8, _dirty = true);
	              }
	            }
	          }
	        });
	      }
	      function hasValue(test) {
	        if (test === undefined) {
	          return false;
	        }
	        return _isNullValid ? true : test !== null;
	      }
	      function textbox_value_binding(value) {
	        _searchText = value;
	        $$invalidate(11, _searchText);
	      }
	      function textbox_inputElement_binding(value) {
	        _searchElement = value;
	        $$invalidate(19, _searchElement);
	      }
	      function checkbox_label_binding(value, option) {
	        if ($$self.$$.not_equal(option.display, value)) {
	          option.display = value;
	          $$invalidate(38, _virtualOptions);
	        }
	      }
	      function checkbox_value_binding(value, option) {
	        if ($$self.$$.not_equal(option.selected, value)) {
	          option.selected = value;
	          $$invalidate(38, _virtualOptions);
	        }
	      }
	      const click_handler = (option, event) => handleOptionClicked(option);
	      const mouseenter_handler = (option, event) => handleMouseEnterOption(option);
	      const mouseleave_handler = (option, event) => handleMouseLeaveOption();
	      function div0_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _optionListContainer = $$value;
	          $$invalidate(39, _optionListContainer);
	        });
	      }
	      function div1_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _virtualContainer = $$value;
	          $$invalidate(37, _virtualContainer);
	        });
	      }
	      function div2_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _optionsScrollContainer = $$value;
	          $$invalidate(40, _optionsScrollContainer);
	        });
	      }
	      function div4_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _optionsWrapper = $$value;
	          $$invalidate(20, _optionsWrapper);
	        });
	      }
	      function div3_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _highlightElement = $$value;
	          $$invalidate(18, _highlightElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("globalClickListener" in $$props) $$invalidate(62, globalClickListener = $$props.globalClickListener);
	        if ("globalKeyListener" in $$props) $$invalidate(63, globalKeyListener = $$props.globalKeyListener);
	        if ("display" in $$props) $$invalidate(4, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(64, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(65, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(66, density = $$props.density);
	        if ("value" in $$props) $$invalidate(57, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(24, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(5, hint = $$props.hint);
	        if ("search" in $$props) $$invalidate(6, search = $$props.search);
	        if ("clear" in $$props) $$invalidate(58, clear = $$props.clear);
	        if ("required" in $$props) $$invalidate(7, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(1, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(67, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(82, errors = $$props.errors);
	        if ("options" in $$props) $$invalidate(83, options = $$props.options);
	        if ("multiple" in $$props) $$invalidate(2, multiple = $$props.multiple);
	        if ("idKey" in $$props) $$invalidate(84, idKey = $$props.idKey);
	        if ("valuePath" in $$props) $$invalidate(85, valuePath = $$props.valuePath);
	        if ("id" in $$props) $$invalidate(86, id = $$props.id);
	        if ("_dirty" in $$props) $$invalidate(8, _dirty = $$props._dirty);
	        if ("_errors" in $$props) $$invalidate(9, _errors = $$props._errors);
	        if ("_builtInErrors" in $$props) $$invalidate(68, _builtInErrors = $$props._builtInErrors);
	        if ("_showOptions" in $$props) $$invalidate(10, _showOptions = $$props._showOptions);
	        if ("_searchText" in $$props) $$invalidate(11, _searchText = $$props._searchText);
	        if ("_searchOptions" in $$props) $$invalidate(12, _searchOptions = $$props._searchOptions);
	        if ("_highlightIndex" in $$props) $$invalidate(13, _highlightIndex = $$props._highlightIndex);
	        if ("_globalClicksNode" in $$props) $$invalidate(69, _globalClicksNode = $$props._globalClicksNode);
	        if ("_lastValue" in $$props) $$invalidate(59, _lastValue = $$props._lastValue);
	        if ("_display" in $$props) $$invalidate(3, _display = $$props._display);
	        if ("_displayHtml" in $$props) $$invalidate(14, _displayHtml = $$props._displayHtml);
	        if ("_openNode" in $$props) $$invalidate(70, _openNode = $$props._openNode);
	        if ("_openParent" in $$props) $$invalidate(71, _openParent = $$props._openParent);
	        if ("_upward" in $$props) $$invalidate(15, _upward = $$props._upward);
	        if ("_positioned" in $$props) $$invalidate(16, _positioned = $$props._positioned);
	        if ("_hasFocus" in $$props) $$invalidate(17, _hasFocus = $$props._hasFocus);
	        if ("_highlightElement" in $$props) $$invalidate(18, _highlightElement = $$props._highlightElement);
	        if ("_searchElement" in $$props) $$invalidate(19, _searchElement = $$props._searchElement);
	        if ("_optionsWrapper" in $$props) $$invalidate(20, _optionsWrapper = $$props._optionsWrapper);
	        if ("_suppressFocus" in $$props) $$invalidate(72, _suppressFocus = $$props._suppressFocus);
	        if ("_lastValid" in $$props) $$invalidate(73, _lastValid = $$props._lastValid);
	        if ("_themeEventListener" in $$props) $$invalidate(74, _themeEventListener = $$props._themeEventListener);
	        if ("_shapeEventListener" in $$props) $$invalidate(75, _shapeEventListener = $$props._shapeEventListener);
	        if ("_densityEventListener" in $$props) $$invalidate(76, _densityEventListener = $$props._densityEventListener);
	        if ("_theme" in $$props) $$invalidate(21, _theme = $$props._theme);
	        if ("_shape" in $$props) $$invalidate(22, _shape = $$props._shape);
	        if ("_density" in $$props) $$invalidate(23, _density = $$props._density);
	        if ("_lastTheme" in $$props) $$invalidate(77, _lastTheme = $$props._lastTheme);
	        if ("_lastShape" in $$props) $$invalidate(78, _lastShape = $$props._lastShape);
	        if ("_lastDensity" in $$props) $$invalidate(79, _lastDensity = $$props._lastDensity);
	        if ("_lastSearchText" in $$props) $$invalidate(80, _lastSearchText = $$props._lastSearchText);
	        if ("_options" in $$props) $$invalidate(60, _options = $$props._options);
	        if ("_lastOptions" in $$props) $$invalidate(61, _lastOptions = $$props._lastOptions);
	        if ("_isNullValid" in $$props) $$invalidate(81, _isNullValid = $$props._isNullValid);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*multiple*/4 | $$self.$$.dirty[1] & /*_lastOptions, _options, value, _lastValue*/1946157056 | $$self.$$.dirty[2] & /*options, valuePath*/10485760) {
	          // Computed values
	          {
	            if (options) {
	              // Detect changes to options from the outside
	              if (!isSameOptions(options, _lastOptions)) {
	                // console.log('SelectBox: Updating options', options);
	                $$invalidate(61, _lastOptions = options);
	                $$invalidate(60, _options = []);
	                options.forEach(o => {
	                  _options.push(Object.assign({}, o));
	                });
	                $$invalidate(81, _isNullValid = !!options.find(o => {
	                  return o.value === null;
	                }));
	              }
	              $$invalidate(12, _searchOptions = _options);
	              setTimeout(() => {
	                handleOptionScroll();
	              }, 10);
	            }
	            if (!isSameValue(value, _lastValue)) {
	              $$invalidate(59, _lastValue = value);
	              if (multiple) {
	                _options.forEach(o => {
	                  delete o.selected;
	                });
	                if (value && value.length > 0) {
	                  value.forEach(v => {
	                    let found = _options.find(o => {
	                      const value1 = valuePath ? o.value[valuePath] : o.value;
	                      const value2 = valuePath ? v[valuePath] : v;
	                      return value1 === value2;
	                    });
	                    if (found) {
	                      found.selected = true;
	                    }
	                  });
	                }
	              }
	            }
	            updateDisplay();
	          }
	        }
	        if ($$self.$$.dirty[0] & /*multiple, _display*/12 | $$self.$$.dirty[1] & /*value*/67108864) {
	          $$invalidate(36, _hasValue = multiple ? hasValue(value) && value.length > 0 : hasValue(value) || _display);
	        }
	        if ($$self.$$.dirty[0] & /*disabled*/2 | $$self.$$.dirty[1] & /*clear, _hasValue*/134217760) {
	          $$invalidate(49, _showClear = clear && !disabled && _hasValue);
	        }
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          $$invalidate(50, _hasLabel = notEmpty$3(label) && label.trim() !== "");
	        }
	      };
	      return [label, disabled, multiple, _display, display, hint, search, required, _dirty, _errors, _showOptions, _searchText, _searchOptions, _highlightIndex, _displayHtml, _upward, _positioned, _hasFocus, _highlightElement, _searchElement, _optionsWrapper, _theme, _shape, _density, placeholder, globalClicks, positionOptions, preventClickPropagation$2, handleMouseEnterOption, handleMouseLeaveOption, handleFocus, handleBlur, handleKeyDown, handleClick, handleClear, handleSearchChanged, _hasValue, _virtualContainer, _virtualOptions, _optionListContainer, _optionsScrollContainer, _labelId, _inputId, _clearId, _capId, _optionsId, _optionsSearchId, _messageId, _statusIconId, _showClear, _hasLabel, $_, _handleOptionsScrollDebounce, isOptionSelected, handleMouseDown, handleMouseUp, handleOptionClicked, value, clear, _lastValue, _options, _lastOptions, globalClickListener, globalKeyListener, theme, shape, density, validation, _builtInErrors, _globalClicksNode, _openNode, _openParent, _suppressFocus, _lastValid, _themeEventListener, _shapeEventListener, _densityEventListener, _lastTheme, _lastShape, _lastDensity, _lastSearchText, _isNullValid, errors, options, idKey, valuePath, id, positionNode, handleScroll, closeOptions, openOptions, myKeyDown, handleSelectionChanged, scrollToSelected, scrollOptionIntoView, handleOptionScroll, handleClearSearch, textbox_value_binding, textbox_inputElement_binding, checkbox_label_binding, checkbox_value_binding, click_handler, mouseenter_handler, mouseleave_handler, div0_binding, div1_binding, div2_binding, div4_binding, div3_binding];
	    }
	    class SelectBox extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document_1$1.getElementById("svelte-1c84wsf-style")) add_css$3();
	        init(this, options, instance$3, create_fragment$3, safe_not_equal, {
	          globalClickListener: 62,
	          globalKeyListener: 63,
	          display: 4,
	          theme: 64,
	          shape: 65,
	          density: 66,
	          value: 57,
	          label: 0,
	          placeholder: 24,
	          hint: 5,
	          search: 6,
	          clear: 58,
	          required: 7,
	          disabled: 1,
	          validation: 67,
	          errors: 82,
	          options: 83,
	          multiple: 2,
	          idKey: 84,
	          valuePath: 85,
	          id: 86,
	          _dirty: 8,
	          _errors: 9,
	          _builtInErrors: 68,
	          _showOptions: 10,
	          _searchText: 11,
	          _searchOptions: 12,
	          _highlightIndex: 13,
	          _globalClicksNode: 69,
	          _lastValue: 59,
	          _display: 3,
	          _displayHtml: 14,
	          _openNode: 70,
	          _openParent: 71,
	          _upward: 15,
	          _positioned: 16,
	          _hasFocus: 17,
	          _highlightElement: 18,
	          _searchElement: 19,
	          _optionsWrapper: 20,
	          _suppressFocus: 72,
	          _lastValid: 73,
	          _themeEventListener: 74,
	          _shapeEventListener: 75,
	          _densityEventListener: 76,
	          _theme: 21,
	          _shape: 22,
	          _density: 23,
	          _lastTheme: 77,
	          _lastShape: 78,
	          _lastDensity: 79,
	          _lastSearchText: 80,
	          _options: 60,
	          _lastOptions: 61,
	          _isNullValid: 81,
	          globalClicks: 25,
	          positionOptions: 26,
	          positionNode: 87,
	          handleScroll: 88,
	          preventClickPropagation: 27,
	          closeOptions: 89,
	          openOptions: 90,
	          myKeyDown: 91,
	          handleMouseEnterOption: 28,
	          handleMouseLeaveOption: 29,
	          handleFocus: 30,
	          handleBlur: 31,
	          handleKeyDown: 32,
	          handleClick: 33,
	          handleClear: 34,
	          handleSelectionChanged: 92,
	          scrollToSelected: 93,
	          scrollOptionIntoView: 94,
	          handleOptionScroll: 95,
	          handleSearchChanged: 35,
	          handleClearSearch: 96
	        }, [-1, -1, -1, -1]);
	      }
	      get globalClicks() {
	        return this.$$.ctx[25];
	      }
	      get positionOptions() {
	        return this.$$.ctx[26];
	      }
	      get positionNode() {
	        return this.$$.ctx[87];
	      }
	      get handleScroll() {
	        return this.$$.ctx[88];
	      }
	      get preventClickPropagation() {
	        return preventClickPropagation$2;
	      }
	      get closeOptions() {
	        return this.$$.ctx[89];
	      }
	      get openOptions() {
	        return this.$$.ctx[90];
	      }
	      get myKeyDown() {
	        return this.$$.ctx[91];
	      }
	      get handleMouseEnterOption() {
	        return this.$$.ctx[28];
	      }
	      get handleMouseLeaveOption() {
	        return this.$$.ctx[29];
	      }
	      get handleFocus() {
	        return this.$$.ctx[30];
	      }
	      get handleBlur() {
	        return this.$$.ctx[31];
	      }
	      get handleKeyDown() {
	        return this.$$.ctx[32];
	      }
	      get handleClick() {
	        return this.$$.ctx[33];
	      }
	      get handleClear() {
	        return this.$$.ctx[34];
	      }
	      get handleSelectionChanged() {
	        return this.$$.ctx[92];
	      }
	      get scrollToSelected() {
	        return this.$$.ctx[93];
	      }
	      get scrollOptionIntoView() {
	        return this.$$.ctx[94];
	      }
	      get handleOptionScroll() {
	        return this.$$.ctx[95];
	      }
	      get handleSearchChanged() {
	        return this.$$.ctx[35];
	      }
	      get handleClearSearch() {
	        return this.$$.ctx[96];
	      }
	    }

	    /* src/TextArea.svelte generated by Svelte v3.38.2 */
	    function add_css$2() {
	      var style = element("style");
	      style.id = "svelte-g0o7ej-style";
	      style.textContent = ".pros-highlight-container.svelte-g0o7ej.svelte-g0o7ej{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-highlight-container.svelte-g0o7ej.svelte-g0o7ej{height:auto}.pros-content-container.svelte-g0o7ej.svelte-g0o7ej{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-g0o7ej.svelte-g0o7ej{width:100%;height:100%;margin:0 4px 4px 12px}.pros-input-container.svelte-g0o7ej .pros-input.svelte-g0o7ej{margin:0;min-height:120px;padding:0 36px 0 0;width:100%;outline:none !important;border:none;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;resize:vertical;cursor:pointer}.pros-input-container.svelte-g0o7ej textarea.svelte-g0o7ej{font-family:inherit}.pros-control-container.has-label.svelte-g0o7ej .pros-input-container.svelte-g0o7ej{margin-top:20px}.pros-control-container.has-label.svelte-g0o7ej textarea.svelte-g0o7ej::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-label.has-focus.svelte-g0o7ej .pros-highlight-container .pros-input-container.svelte-g0o7ej{margin-top:19px !important;margin-bottom:3px !important;margin-right:3px !important}.pros-control-label.svelte-g0o7ej.svelte-g0o7ej{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-g0o7ej.svelte-g0o7ej::after{content:\" *\"}.pros-action-button.svelte-g0o7ej.svelte-g0o7ej{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-g0o7ej svg.svelte-g0o7ej{width:24px;height:24px}.pros-action-button.absolute.svelte-g0o7ej.svelte-g0o7ej{position:absolute;top:8px;right:8px;margin-right:0}.pros-action-button.svelte-g0o7ej.svelte-g0o7ej:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-control-container.svelte-g0o7ej.svelte-g0o7ej{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-g0o7ej .pros-control-label.svelte-g0o7ej,.pros-control-container.has-focus.svelte-g0o7ej .pros-control-label.svelte-g0o7ej{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-g0o7ej .pros-highlight-container.svelte-g0o7ej{cursor:default}.pros-control-container.has-focus.svelte-g0o7ej .pros-input.svelte-g0o7ej{cursor:text}.pros-control-container.has-focus.svelte-g0o7ej .pros-highlight-container.svelte-g0o7ej{border-width:2px}.pros-control-container.has-focus.svelte-g0o7ej .pros-input-container.svelte-g0o7ej{margin-left:11px}.pros-control-container.has-focus.svelte-g0o7ej .pros-action-button:last-child.absolute.svelte-g0o7ej{margin-right:0}.pros-control-container.has-focus.svelte-g0o7ej textarea.svelte-g0o7ej::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-g0o7ej.svelte-g0o7ej{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-g0o7ej .pros-status-icon.svelte-g0o7ej{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-g0o7ej .pros-status-icon svg.svelte-g0o7ej{height:100%;width:100%}.pros-message-container.svelte-g0o7ej .pros-message.svelte-g0o7ej{flex:1}.pros-global-wrapper[pos--shape=sharp].svelte-g0o7ej .pros-highlight-container.svelte-g0o7ej{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-control-label.svelte-g0o7ej{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-highlight-container.svelte-g0o7ej{height:36px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-highlight-container.textarea.svelte-g0o7ej{height:auto}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-g0o7ej{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-input-container .pros-input.svelte-g0o7ej{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container.has-label .pros-input.svelte-g0o7ej{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container.has-value .pros-control-label.svelte-g0o7ej,.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container.has-focus .pros-control-label.svelte-g0o7ej{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-g0o7ej{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container.has-focus .pros-input-container.svelte-g0o7ej{margin-left:7px}.pros-global-wrapper[pos--density=high].svelte-g0o7ej .pros-control-container .pros-action-button.absolute.svelte-g0o7ej{top:0}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.svelte-g0o7ej{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-highlight-container.svelte-g0o7ej{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-input.svelte-g0o7ej{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container textarea.svelte-g0o7ej::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.allow-hover .pros-highlight-container.svelte-g0o7ej:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.error .pros-highlight-container.svelte-g0o7ej{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.has-focus .pros-highlight-container.svelte-g0o7ej{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-message-container.svelte-g0o7ej{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-message-container .pros-status-icon.svelte-g0o7ej{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-message-container.error.svelte-g0o7ej{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container .pros-message-container.error .pros-status-icon.svelte-g0o7ej{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.disabled.svelte-g0o7ej{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.disabled .pros-highlight-container.svelte-g0o7ej{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.disabled .pros-input.svelte-g0o7ej{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-control-container.disabled .pros-message-container.svelte-g0o7ej{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-g0o7ej .pros-action-button.svelte-g0o7ej:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.svelte-g0o7ej{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-highlight-container.svelte-g0o7ej{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-input.svelte-g0o7ej{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container textarea.svelte-g0o7ej::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.allow-hover .pros-highlight-container.svelte-g0o7ej:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.error .pros-highlight-container.svelte-g0o7ej{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.has-focus .pros-highlight-container.svelte-g0o7ej{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-message-container.svelte-g0o7ej{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-message-container .pros-status-icon.svelte-g0o7ej{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-message-container.error.svelte-g0o7ej{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container .pros-message-container.error .pros-status-icon.svelte-g0o7ej{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.disabled.svelte-g0o7ej{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.disabled .pros-highlight-container.svelte-g0o7ej{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.disabled .pros-input.svelte-g0o7ej{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-control-container.disabled .pros-message-container.svelte-g0o7ej{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-g0o7ej .pros-action-button.svelte-g0o7ej:hover{background-color:rgba(0, 0, 0, 0.05)}.svelte-g0o7ej.svelte-g0o7ej::-webkit-scrollbar{width:6px;height:6px}.svelte-g0o7ej.svelte-g0o7ej::-webkit-scrollbar-track{background-color:transparent}.svelte-g0o7ej.svelte-g0o7ej::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}";
	      append(document.head, style);
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_5$1(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[1]);
	          attr(div, "id", /*_labelId*/ctx[22]);
	          attr(div, "class", "pros-control-label svelte-g0o7ej");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[5]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/2) set_data(t, /*label*/ctx[1]);
	          if (dirty[0] & /*_labelId*/4194304) {
	            attr(div, "id", /*_labelId*/ctx[22]);
	          }
	          if (dirty[0] & /*required*/32) {
	            toggle_class(div, "required", /*required*/ctx[5]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (31:4) {#if _hasValue && !disabled  && _hasFocus}
	    function create_if_block_4$2(ctx) {
	      let div;
	      let svg;
	      let path;
	      let initElements_action;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(path, "class", "svelte-g0o7ej");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-g0o7ej");
	          attr(div, "id", /*_clearId*/ctx[24]);
	          attr(div, "class", "pros-action-button absolute svelte-g0o7ej");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = [listen(div, "mousedown", /*handleClear*/ctx[13]), action_destroyer(initElements_action = /*initElements*/ctx[30].call(null, div))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_clearId*/16777216) {
	            attr(div, "id", /*_clearId*/ctx[24]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (39:4) {#if display !== 'custom'}
	    function create_if_block$2(ctx) {
	      let div;
	      let t;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[14] && /*_errors*/ctx[15].length > 0) return create_if_block_2$2;
	        if (/*hint*/ctx[3] && /*_hasFocus*/ctx[18]) return create_if_block_3$2;
	        return create_else_block$2;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block0 = current_block_type(ctx);
	      let if_block1 = /*maxLength*/ctx[4] && /*_hasFocus*/ctx[18] && create_if_block_1$2(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block0.c();
	          t = space();
	          if (if_block1) if_block1.c();
	          attr(div, "class", "pros-message-container svelte-g0o7ej");
	          toggle_class(div, "error", /*_dirty*/ctx[14] && /*_errors*/ctx[15].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block0.m(div, null);
	          append(div, t);
	          if (if_block1) if_block1.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
	            if_block0.p(ctx, dirty);
	          } else {
	            if_block0.d(1);
	            if_block0 = current_block_type(ctx);
	            if (if_block0) {
	              if_block0.c();
	              if_block0.m(div, t);
	            }
	          }
	          if (/*maxLength*/ctx[4] && /*_hasFocus*/ctx[18]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_1$2(ctx);
	              if_block1.c();
	              if_block1.m(div, null);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*_dirty, _errors*/49152) {
	            toggle_class(div, "error", /*_dirty*/ctx[14] && /*_errors*/ctx[15].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block0.d();
	          if (if_block1) if_block1.d();
	        }
	      };
	    }

	    // (55:6) {:else}
	    function create_else_block$2(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[25]);
	          attr(div, "class", "pros-message svelte-g0o7ej");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (48:34) 
	    function create_if_block_3$2(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(path, "class", "svelte-g0o7ej");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-g0o7ej");
	          attr(div0, "id", /*_statusIconId*/ctx[26]);
	          attr(div0, "class", "pros-status-icon svelte-g0o7ej");
	          attr(div1, "id", /*_messageId*/ctx[25]);
	          attr(div1, "class", "pros-message svelte-g0o7ej");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/67108864) {
	            attr(div0, "id", /*_statusIconId*/ctx[26]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div1, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (41:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_2$2(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[15][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(path, "class", "svelte-g0o7ej");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-g0o7ej");
	          attr(div0, "id", /*_statusIconId*/ctx[26]);
	          attr(div0, "class", "pros-status-icon error svelte-g0o7ej");
	          attr(div1, "id", /*_messageId*/ctx[25]);
	          attr(div1, "class", "pros-message error svelte-g0o7ej");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/67108864) {
	            attr(div0, "id", /*_statusIconId*/ctx[26]);
	          }
	          if (dirty[0] & /*_errors*/32768 && t1_value !== (t1_value = /*_errors*/ctx[15][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/33554432) {
	            attr(div1, "id", /*_messageId*/ctx[25]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (58:6) {#if maxLength && _hasFocus}
	    function create_if_block_1$2(ctx) {
	      let div;
	      let t0_value = /*value*/ctx[0].length + "";
	      let t0;
	      let t1;
	      let t2;
	      return {
	        c() {
	          div = element("div");
	          t0 = text(t0_value);
	          t1 = text("/");
	          t2 = text(/*maxLength*/ctx[4]);
	          attr(div, "id", /*_constraintId*/ctx[27]);
	          attr(div, "class", "pros-constraint svelte-g0o7ej");
	          toggle_class(div, "error", /*value*/ctx[0].length > /*maxLength*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t0);
	          append(div, t1);
	          append(div, t2);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*value*/1 && t0_value !== (t0_value = /*value*/ctx[0].length + "")) set_data(t0, t0_value);
	          if (dirty[0] & /*maxLength*/16) set_data(t2, /*maxLength*/ctx[4]);
	          if (dirty[0] & /*_constraintId*/134217728) {
	            attr(div, "id", /*_constraintId*/ctx[27]);
	          }
	          if (dirty[0] & /*value, maxLength*/17) {
	            toggle_class(div, "error", /*value*/ctx[0].length > /*maxLength*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }
	    function create_fragment$2(ctx) {
	      let div4;
	      let div3;
	      let t0;
	      let div2;
	      let div1;
	      let div0;
	      let textarea;
	      let t1;
	      let t2;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[29] && create_if_block_5$1(ctx);
	      let if_block1 = /*_hasValue*/ctx[28] && ! /*disabled*/ctx[6] && /*_hasFocus*/ctx[18] && create_if_block_4$2(ctx);
	      let if_block2 = /*display*/ctx[2] !== "custom" && create_if_block$2(ctx);
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          textarea = element("textarea");
	          t1 = space();
	          if (if_block1) if_block1.c();
	          t2 = space();
	          if (if_block2) if_block2.c();
	          attr(textarea, "class", "pros-input multi-line svelte-g0o7ej");
	          attr(textarea, "id", /*_inputId*/ctx[23]);
	          textarea.disabled = /*disabled*/ctx[6];
	          attr(textarea, "placeholder", /*placeholder*/ctx[7]);
	          attr(div0, "class", "pros-input-container svelte-g0o7ej");
	          attr(div1, "class", "pros-content-container svelte-g0o7ej");
	          attr(div2, "class", "pros-highlight-container textarea svelte-g0o7ej");
	          attr(div3, "class", "pros-control-container svelte-g0o7ej");
	          toggle_class(div3, "has-value", /*_hasValue*/ctx[28]);
	          toggle_class(div3, "has-label", /*_hasLabel*/ctx[29]);
	          toggle_class(div3, "has-focus", /*_hasFocus*/ctx[18]);
	          toggle_class(div3, "custom-layout", /*display*/ctx[2] === "custom");
	          toggle_class(div3, "error", /*_dirty*/ctx[14] && /*_errors*/ctx[15].length > 0);
	          toggle_class(div3, "disabled", /*disabled*/ctx[6]);
	          toggle_class(div3, "allow-hover", ! /*disabled*/ctx[6]);
	          attr(div4, "class", "pros-global-wrapper pros-form-control svelte-g0o7ej");
	          attr(div4, "pos--theme", /*_theme*/ctx[19]);
	          attr(div4, "pos--shape", /*_shape*/ctx[20]);
	          attr(div4, "pos--density", /*_density*/ctx[21]);
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          if (if_block0) if_block0.m(div3, null);
	          append(div3, t0);
	          append(div3, div2);
	          append(div2, div1);
	          append(div1, div0);
	          append(div0, textarea);
	          set_input_value(textarea, /*_untrimmedValue*/ctx[16]);
	          /*textarea_binding*/
	          ctx[42](textarea);
	          append(div3, t1);
	          if (if_block1) if_block1.m(div3, null);
	          append(div3, t2);
	          if (if_block2) if_block2.m(div3, null);
	          if (!mounted) {
	            dispose = [listen(textarea, "input", /*textarea_input_handler*/ctx[41]), listen(textarea, "input", /*valueChanged*/ctx[31]), listen(textarea, "focus", /*handleFocus*/ctx[8]), listen(textarea, "blur", /*handleBlur*/ctx[9]), listen(textarea, "mouseup", /*endClick*/ctx[11]), listen(textarea, "mousedown", /*startClick*/ctx[10]), listen(div2, "click", /*handleClick*/ctx[12])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[29]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_5$1(ctx);
	              if_block0.c();
	              if_block0.m(div3, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (dirty[0] & /*_inputId*/8388608) {
	            attr(textarea, "id", /*_inputId*/ctx[23]);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            textarea.disabled = /*disabled*/ctx[6];
	          }
	          if (dirty[0] & /*placeholder*/128) {
	            attr(textarea, "placeholder", /*placeholder*/ctx[7]);
	          }
	          if (dirty[0] & /*_untrimmedValue*/65536) {
	            set_input_value(textarea, /*_untrimmedValue*/ctx[16]);
	          }
	          if (/*_hasValue*/ctx[28] && ! /*disabled*/ctx[6] && /*_hasFocus*/ctx[18]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_4$2(ctx);
	              if_block1.c();
	              if_block1.m(div3, t2);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (/*display*/ctx[2] !== "custom") {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block$2(ctx);
	              if_block2.c();
	              if_block2.m(div3, null);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (dirty[0] & /*_hasValue*/268435456) {
	            toggle_class(div3, "has-value", /*_hasValue*/ctx[28]);
	          }
	          if (dirty[0] & /*_hasLabel*/536870912) {
	            toggle_class(div3, "has-label", /*_hasLabel*/ctx[29]);
	          }
	          if (dirty[0] & /*_hasFocus*/262144) {
	            toggle_class(div3, "has-focus", /*_hasFocus*/ctx[18]);
	          }
	          if (dirty[0] & /*display*/4) {
	            toggle_class(div3, "custom-layout", /*display*/ctx[2] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/49152) {
	            toggle_class(div3, "error", /*_dirty*/ctx[14] && /*_errors*/ctx[15].length > 0);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            toggle_class(div3, "disabled", /*disabled*/ctx[6]);
	          }
	          if (dirty[0] & /*disabled*/64) {
	            toggle_class(div3, "allow-hover", ! /*disabled*/ctx[6]);
	          }
	          if (dirty[0] & /*_theme*/524288) {
	            attr(div4, "pos--theme", /*_theme*/ctx[19]);
	          }
	          if (dirty[0] & /*_shape*/1048576) {
	            attr(div4, "pos--shape", /*_shape*/ctx[20]);
	          }
	          if (dirty[0] & /*_density*/2097152) {
	            attr(div4, "pos--density", /*_density*/ctx[21]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div4);
	          if (if_block0) if_block0.d();
	          /*textarea_binding*/
	          ctx[42](null);
	          if (if_block1) if_block1.d();
	          if (if_block2) if_block2.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function hasValue$2(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty$2(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance$2($$self, $$props, $$invalidate) {
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(55, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = ""
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        maxLength = undefined
	      } = $$props; // Max length of value allowed
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        regex = undefined
	      } = $$props; // Regex string to evaluate during built in validation
	      let {
	        regexkey = undefined
	      } = $$props; // PrintOS validation id
	      let {
	        regexmessage = undefined
	      } = $$props; // custom validation message for use with regexKey
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _untrimmedValue = ""; // Actual value bound to input box (may include extra whitespace)
	      let _lastValue = ""; // Last trimmed value so we can filter out extra change events based on trimmed value
	      let _clearButton = undefined;
	      let _textAreaControl = undefined;
	      let _inputElement = undefined;
	      let _hasFocus = false;
	      let _startHeight = 120;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _printos = window.$printos;
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      let _constraintId = null;
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(2, display = hasValue$2(display) ? display : "form");
	        $$invalidate(32, theme = hasValue$2(theme) ? theme : "light");
	        $$invalidate(33, shape = hasValue$2(shape) ? shape : "round");
	        $$invalidate(34, density = hasValue$2(density) ? density : "standard");
	        $$invalidate(1, label = hasValue$2(label) ? label : "");
	        $$invalidate(3, hint = hasValue$2(hint) ? hint : "");
	        $$invalidate(0, value = hasValue$2(value) ? value : "");
	        $$invalidate(4, maxLength = hasValue$2(maxLength) && maxLength !== "" && !isNaN(maxLength) && Number(maxLength) >= 0 ? Number(maxLength) : undefined);
	        $$invalidate(36, regex = hasValue$2(regex) ? regex : undefined);
	        $$invalidate(37, regexkey = hasValue$2(regexkey) ? regexkey : undefined);
	        $$invalidate(5, required = hasValue$2(required) ? required : false);
	        $$invalidate(6, disabled = hasValue$2(disabled) ? disabled : false);
	        $$invalidate(35, validation = hasValue$2(validation) ? validation : true);
	        $$invalidate(22, _labelId = hasValue$2(id) ? `${id}-label` : undefined);
	        $$invalidate(23, _inputId = hasValue$2(id) ? `${id}-input` : undefined);
	        $$invalidate(24, _clearId = hasValue$2(id) ? `${id}-clear` : undefined);
	        $$invalidate(25, _messageId = hasValue$2(id) ? `${id}-message` : undefined);
	        $$invalidate(26, _statusIconId = hasValue$2(id) ? `${id}-status-icon` : undefined);
	        $$invalidate(27, _constraintId = hasValue$2(id) ? `${id}-constraint` : undefined);

	        // Check if this is a programmatic update
	        if (value !== _lastValue) {
	          $$invalidate(16, _untrimmedValue = value);
	          _lastValue = value;
	        }
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(19, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(19, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(19, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(20, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(20, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(20, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(21, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(21, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(21, _density = density);
	          }
	        }
	        positionClearButton();
	        doValidate.call(this);
	      });
	      function initElements(node) {
	        let parent = node.parentElement;
	        _clearButton = parent.querySelector("#pros-clear-button");
	        _textAreaControl = parent.querySelector("#pros-control-container");
	      }
	      function positionClearButton() {
	        if (!_clearButton || !_textAreaControl) {
	          return;
	        }

	        // Adjust clear button position by scrollbar width (which also includes 2px from border)
	        // _clearButton.style.right = `${_textAreaControl.offsetWidth - _textAreaControl.clientWidth - 2}px`;
	        _clearButton.style.right = `${_textAreaControl.offsetWidth - _textAreaControl.clientWidth + 10}px`;
	      }
	      function handleFocus(event) {
	        $$invalidate(18, _hasFocus = true);
	      } // _inputElement.SelectionStart = 0;
	      // _inputElement.SelectionLength = _inputElement.Text.Length;

	      function handleBlur(event) {
	        $$invalidate(18, _hasFocus = false);
	      }
	      function startClick(event) {
	        if (event.currentTarget.id === "pros-text-area") {
	          _startHeight = event.currentTarget.clientHeight;
	        }
	      }
	      function endClick(event) {
	        let isResize = false;
	        if (event.currentTarget.id === "pros-text-area") {
	          isResize = event.currentTarget.clientHeight !== _startHeight;
	        }
	        if (isResize) {
	          event.stopPropagation();
	        }
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	        $$invalidate(18, _hasFocus = true);
	        _inputElement.focus();
	      }
	      function handleClear(event) {
	        event.preventDefault();
	        if (event.which !== 1) {
	          return;
	        }

	        // Clear the input value
	        $$invalidate(16, _untrimmedValue = "");
	        $$invalidate(18, _hasFocus = true);
	        _inputElement.focus();
	        valueChanged.call(this);
	      }
	      function valueChanged() {
	        $$invalidate(14, _dirty = true);
	        $$invalidate(0, value = _untrimmedValue.trim());
	        if (value === _lastValue) {
	          return;
	        }
	        _lastValue = value;
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(15, _errors = errors ? errors : []);
	        if (required) {
	          if (!value || value === "") {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (hasValue$2(maxLength)) {
	          if (value && value.trim().length > maxLength) {
	            _builtInErrors.push($_("validateTooLong"));
	          }
	        }
	        let myRegex;
	        if (hasValue$2(regexkey) && _printos) {
	          myRegex = _printos.client.v1.getValidator(regexkey);
	          if (!myRegex) {
	            console.warn("Could not find PrintOS validator", regexkey);
	          }
	        } else {
	          myRegex = regex;
	          if (regexmessage) {
	            myRegex.message = regexmessage;
	          }
	        }
	        if (hasValue$2(myRegex) && notEmpty$2(value) && notEmpty$2(myRegex.expression)) {
	          let exp = notEmpty$2(myRegex.flags) ? new RegExp(myRegex.expression, myRegex.flags) : new RegExp(myRegex.expression);
	          if (!exp.test(value)) {
	            const myMessage = myRegex.message ? unescape(myRegex.message) : $_("validateRegex");
	            _builtInErrors.push(myMessage);
	          }
	        }
	        if (validation) {
	          $$invalidate(15, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (notEmpty$2(value) && !valid && !_dirty) {
	              $$invalidate(14, _dirty = true);
	            }
	          }
	        });
	      }
	      function textarea_input_handler() {
	        _untrimmedValue = this.value;
	        $$invalidate(16, _untrimmedValue);
	      }
	      function textarea_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(17, _inputElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("display" in $$props) $$invalidate(2, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(32, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(33, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(34, density = $$props.density);
	        if ("value" in $$props) $$invalidate(0, value = $$props.value);
	        if ("label" in $$props) $$invalidate(1, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(7, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("maxLength" in $$props) $$invalidate(4, maxLength = $$props.maxLength);
	        if ("required" in $$props) $$invalidate(5, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(6, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(35, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(38, errors = $$props.errors);
	        if ("regex" in $$props) $$invalidate(36, regex = $$props.regex);
	        if ("regexkey" in $$props) $$invalidate(37, regexkey = $$props.regexkey);
	        if ("regexmessage" in $$props) $$invalidate(39, regexmessage = $$props.regexmessage);
	        if ("id" in $$props) $$invalidate(40, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*value*/1) {
	          // Computed values
	          $$invalidate(28, _hasValue = notEmpty$2(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/2) {
	          $$invalidate(29, _hasLabel = notEmpty$2(label));
	        }
	      };
	      return [value, label, display, hint, maxLength, required, disabled, placeholder, handleFocus, handleBlur, startClick, endClick, handleClick, handleClear, _dirty, _errors, _untrimmedValue, _inputElement, _hasFocus, _theme, _shape, _density, _labelId, _inputId, _clearId, _messageId, _statusIconId, _constraintId, _hasValue, _hasLabel, initElements, valueChanged, theme, shape, density, validation, regex, regexkey, errors, regexmessage, id, textarea_input_handler, textarea_binding];
	    }
	    class TextArea extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-g0o7ej-style")) add_css$2();
	        init(this, options, instance$2, create_fragment$2, safe_not_equal, {
	          display: 2,
	          theme: 32,
	          shape: 33,
	          density: 34,
	          value: 0,
	          label: 1,
	          placeholder: 7,
	          hint: 3,
	          maxLength: 4,
	          required: 5,
	          disabled: 6,
	          validation: 35,
	          errors: 38,
	          regex: 36,
	          regexkey: 37,
	          regexmessage: 39,
	          id: 40,
	          handleFocus: 8,
	          handleBlur: 9,
	          startClick: 10,
	          endClick: 11,
	          handleClick: 12,
	          handleClear: 13
	        }, [-1, -1]);
	      }
	      get handleFocus() {
	        return this.$$.ctx[8];
	      }
	      get handleBlur() {
	        return this.$$.ctx[9];
	      }
	      get startClick() {
	        return this.$$.ctx[10];
	      }
	      get endClick() {
	        return this.$$.ctx[11];
	      }
	      get handleClick() {
	        return this.$$.ctx[12];
	      }
	      get handleClear() {
	        return this.$$.ctx[13];
	      }
	    }

	    /* src/TextBox.svelte generated by Svelte v3.38.2 */
	    const {
	      document: document_1
	    } = globals;
	    function add_css$1() {
	      var style = element("style");
	      style.id = "svelte-1wnlerg-style";
	      style.textContent = ".pros-highlight-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1wnlerg .pros-input.svelte-1wnlerg{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-1wnlerg .pros-input.svelte-1wnlerg{padding-top:18px}.pros-control-container.has-label.svelte-1wnlerg input.svelte-1wnlerg::placeholder{opacity:0;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-label.svelte-1wnlerg.svelte-1wnlerg{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1wnlerg.svelte-1wnlerg::after{content:\" *\"}.pros-action-button.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:center;align-items:center;width:32px;height:32px;cursor:pointer;border-radius:4px;margin:0 8px}.pros-action-button.svelte-1wnlerg svg.svelte-1wnlerg{width:24px;height:24px}.pros-action-button.svelte-1wnlerg.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-end-cap.svelte-1wnlerg.svelte-1wnlerg{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-control-container.svelte-1wnlerg.svelte-1wnlerg{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1wnlerg .pros-control-label.svelte-1wnlerg,.pros-control-container.has-focus.svelte-1wnlerg .pros-control-label.svelte-1wnlerg{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{cursor:default}.pros-control-container.has-focus.svelte-1wnlerg .pros-input.svelte-1wnlerg{cursor:text}.pros-control-container.has-focus.svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{border-width:2px}.pros-control-container.has-focus.svelte-1wnlerg .pros-input-container.svelte-1wnlerg{margin-left:11px}.pros-control-container.has-focus.svelte-1wnlerg .pros-end-cap.svelte-1wnlerg:last-child{width:47px;padding:0}.pros-control-container.has-focus.svelte-1wnlerg input.svelte-1wnlerg::placeholder{opacity:1;transition:opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-message-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1wnlerg .pros-status-icon.svelte-1wnlerg{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1wnlerg .pros-status-icon svg.svelte-1wnlerg{height:100%;width:100%}.pros-message-container.svelte-1wnlerg .pros-message.svelte-1wnlerg{flex:1}.pros-spinner-container.svelte-1wnlerg.svelte-1wnlerg{padding:16px}.pros-options-wrapper.svelte-1wnlerg.svelte-1wnlerg{position:fixed;display:none;max-width:100%;border-width:1px;border-style:solid;box-sizing:border-box;z-index:1001;overflow:hidden}.pros-options-wrapper.open.svelte-1wnlerg.svelte-1wnlerg{display:inherit}.pros-options-container.svelte-1wnlerg.svelte-1wnlerg{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%}.pros-options-container.svelte-1wnlerg .pros-options.svelte-1wnlerg{width:100%;overflow:auto;max-height:160px;padding:8px;box-sizing:border-box}.pros-options-container.svelte-1wnlerg .pros-options .pros-option-list .pros-option-row.svelte-1wnlerg{display:flex;justify-content:flex-start;align-items:center;line-height:24px;border-radius:8px;font-size:16px;font-weight:400;cursor:pointer;padding:6px 8px}.pros-options-container.svelte-1wnlerg .pros-options .pros-option-list .pros-option-row.svelte-1wnlerg:not(:last-of-type){margin-bottom:4px}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar{width:6px;height:6px}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar-track{background-color:transparent}.pros-options-container.svelte-1wnlerg .svelte-1wnlerg::-webkit-scrollbar-thumb{background-color:#CCCCCC;border-radius:6px}.pros-global-wrapper[pos--shape=sharp].svelte-1wnlerg .pros-highlight-container.svelte-1wnlerg{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-control-label.svelte-1wnlerg{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{height:36px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1wnlerg{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container .pros-input-container .pros-input.svelte-1wnlerg{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-label .pros-input.svelte-1wnlerg{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-value .pros-control-label.svelte-1wnlerg,.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-control-label.svelte-1wnlerg{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1wnlerg{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1wnlerg .pros-control-container.has-focus .pros-input-container.svelte-1wnlerg{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-input.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container input.svelte-1wnlerg::placeholder{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.allow-hover .pros-highlight-container.svelte-1wnlerg:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.error .pros-highlight-container.svelte-1wnlerg{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.svelte-1wnlerg{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-end-cap.svelte-1wnlerg{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.svelte-1wnlerg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container .pros-status-icon.svelte-1wnlerg{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.error.svelte-1wnlerg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1wnlerg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled.svelte-1wnlerg{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-highlight-container.svelte-1wnlerg{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-input.svelte-1wnlerg{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-message-container.svelte-1wnlerg{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.disabled .pros-end-cap.svelte-1wnlerg{color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-action-button.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-highlight-container.svelte-1wnlerg{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-input.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container input.svelte-1wnlerg::placeholder{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.allow-hover .pros-highlight-container.svelte-1wnlerg:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.error .pros-highlight-container.svelte-1wnlerg{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.svelte-1wnlerg{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.svelte-1wnlerg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container .pros-status-icon.svelte-1wnlerg{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.error.svelte-1wnlerg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1wnlerg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled.svelte-1wnlerg{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-highlight-container.svelte-1wnlerg{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-input.svelte-1wnlerg{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.disabled .pros-message-container.svelte-1wnlerg{color:#585858 !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-action-button.svelte-1wnlerg:hover{background-color:rgba(0, 0, 0, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.svelte-1wnlerg{border-color:#ffffff !important;background-color:#ffffff !important}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.downward.svelte-1wnlerg{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=light].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.upward.svelte-1wnlerg{box-shadow:0 0 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.svelte-1wnlerg{border-color:#2b2b2b !important;background-color:#2b2b2b !important}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.downward.svelte-1wnlerg{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0}.pros-global-wrapper[pos--theme=dark].svelte-1wnlerg .pros-control-container.has-focus .pros-highlight-container.open.upward.svelte-1wnlerg{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px}.pros-options-wrapper[pos--theme=light].svelte-1wnlerg.svelte-1wnlerg{background-color:#FFFFFF;color:#363636;border-color:transparent}.pros-options-wrapper[pos--theme=light].downward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 16px 16px rgba(33, 33, 33, 0.14);border-radius:0 0 12px 12px;border-top:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].upward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 -16px 16px rgba(33, 33, 33, 0.14);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(0, 0, 0, 0.05)}.pros-options-wrapper[pos--theme=light].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:rgba(33, 33, 33, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg.svelte-1wnlerg{background-color:#2b2b2b;color:#ffffff;border-color:transparent}.pros-options-wrapper[pos--theme=dark].downward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0 8px 8px rgba(33, 33, 33, 0.05);border-radius:0 0 12px 12px;border-top:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].upward.svelte-1wnlerg.svelte-1wnlerg{box-shadow:0px -8px 8px rgba(33, 33, 33, 0.05);border-radius:12px 12px 0 0;border-bottom:1px solid rgba(255, 255, 255, 0.05)}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg{color:#ffffff}.pros-options-wrapper[pos--theme=dark].svelte-1wnlerg .pros-options-container .pros-options .pros-option-row.svelte-1wnlerg:hover{transition:background-color 100ms linear 0s, color 100ms linear 0s;background-color:#404040}";
	      append(document_1.head, style);
	    }
	    function get_each_context(ctx, list, i) {
	      const child_ctx = ctx.slice();
	      child_ctx[91] = list[i];
	      return child_ctx;
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_10(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[1]);
	          attr(div, "id", /*_labelId*/ctx[35]);
	          attr(div, "class", "pros-control-label svelte-1wnlerg");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[8]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/2) set_data(t, /*label*/ctx[1]);
	          if (dirty[1] & /*_labelId*/16) {
	            attr(div, "id", /*_labelId*/ctx[35]);
	          }
	          if (dirty[0] & /*required*/256) {
	            toggle_class(div, "required", /*required*/ctx[8]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (42:10) {:else}
	    function create_else_block_2(ctx) {
	      let input;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          input = element("input");
	          attr(input, "id", /*_inputId*/ctx[36]);
	          attr(input, "type", "text");
	          attr(input, "class", "pros-input svelte-1wnlerg");
	          input.disabled = /*disabled*/ctx[9];
	          attr(input, "placeholder", /*placeholder*/ctx[11]);
	          attr(input, "autocomplete", /*autocomplete*/ctx[10]);
	        },
	        m(target, anchor) {
	          insert(target, input, anchor);
	          set_input_value(input, /*_untrimmedValue*/ctx[23]);
	          /*input_binding_1*/
	          ctx[69](input);
	          if (!mounted) {
	            dispose = [listen(input, "input", /*input_input_handler_1*/ctx[68]), listen(input, "input", /*valueChanged*/ctx[47]), listen(input, "focus", /*handleFocus*/ctx[13]), listen(input, "blur", /*handleBlur*/ctx[14])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_inputId*/32) {
	            attr(input, "id", /*_inputId*/ctx[36]);
	          }
	          if (dirty[0] & /*disabled*/512) {
	            input.disabled = /*disabled*/ctx[9];
	          }
	          if (dirty[0] & /*placeholder*/2048) {
	            attr(input, "placeholder", /*placeholder*/ctx[11]);
	          }
	          if (dirty[0] & /*autocomplete*/1024) {
	            attr(input, "autocomplete", /*autocomplete*/ctx[10]);
	          }
	          if (dirty[0] & /*_untrimmedValue*/8388608 && input.value !== /*_untrimmedValue*/ctx[23]) {
	            set_input_value(input, /*_untrimmedValue*/ctx[23]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(input);
	          /*input_binding_1*/
	          ctx[69](null);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (28:10) {#if password}
	    function create_if_block_9(ctx) {
	      let input;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          input = element("input");
	          attr(input, "id", /*_inputId*/ctx[36]);
	          attr(input, "type", "password");
	          attr(input, "class", "pros-input svelte-1wnlerg");
	          input.disabled = /*disabled*/ctx[9];
	          attr(input, "placeholder", /*placeholder*/ctx[11]);
	          attr(input, "autocomplete", /*_autocomplete*/ctx[34]);
	        },
	        m(target, anchor) {
	          insert(target, input, anchor);
	          set_input_value(input, /*_untrimmedValue*/ctx[23]);
	          /*input_binding*/
	          ctx[67](input);
	          if (!mounted) {
	            dispose = [listen(input, "input", /*input_input_handler*/ctx[66]), listen(input, "input", /*valueChanged*/ctx[47]), listen(input, "focus", /*handleFocus*/ctx[13]), listen(input, "blur", /*handleBlur*/ctx[14])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_inputId*/32) {
	            attr(input, "id", /*_inputId*/ctx[36]);
	          }
	          if (dirty[0] & /*disabled*/512) {
	            input.disabled = /*disabled*/ctx[9];
	          }
	          if (dirty[0] & /*placeholder*/2048) {
	            attr(input, "placeholder", /*placeholder*/ctx[11]);
	          }
	          if (dirty[1] & /*_autocomplete*/8) {
	            attr(input, "autocomplete", /*_autocomplete*/ctx[34]);
	          }
	          if (dirty[0] & /*_untrimmedValue*/8388608 && input.value !== /*_untrimmedValue*/ctx[23]) {
	            set_input_value(input, /*_untrimmedValue*/ctx[23]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(input);
	          /*input_binding*/
	          ctx[67](null);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (58:8) {#if _hasValue && !disabled && _hasFocus}
	    function create_if_block_8(ctx) {
	      let div;
	      let svg;
	      let path;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          attr(path, "d", "M12.55 11.85L18.55 5.85C18.75 5.65 18.75 5.35 18.55 5.15C18.35 4.95 18.05 4.95 17.85 5.15L11.85 11.15L5.85001 5.15C5.65001 4.95 5.35 4.95 5.15 5.15C4.95 5.35 4.95 5.65 5.15 5.85L11.15 11.85L5.15 17.85C4.95 18.05 4.95 18.35 5.15 18.55C5.25 18.65 5.34999 18.65 5.54999 18.65C5.74999 18.65 5.85002 18.65 5.95002 18.55L11.95 12.55L17.95 18.55C18.05 18.65 18.15 18.65 18.35 18.65C18.55 18.65 18.65 18.65 18.75 18.55C18.95 18.35 18.95 18.05 18.75 17.85L12.55 11.85Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1wnlerg");
	          attr(div, "id", /*_clearId*/ctx[37]);
	          attr(div, "class", "pros-action-button svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, svg);
	          append(svg, path);
	          if (!mounted) {
	            dispose = listen(div, "mousedown", /*handleClear*/ctx[17]);
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_clearId*/64) {
	            attr(div, "id", /*_clearId*/ctx[37]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          mounted = false;
	          dispose();
	        }
	      };
	    }

	    // (65:8) {#if iconName || iconPath || iconUrl}
	    function create_if_block_7(ctx) {
	      let div;
	      let icon;
	      let updating_name;
	      let updating_path;
	      let updating_url;
	      let current;
	      function icon_name_binding(value) {
	        /*icon_name_binding*/ctx[70](value);
	      }
	      function icon_path_binding(value) {
	        /*icon_path_binding*/ctx[71](value);
	      }
	      function icon_url_binding(value) {
	        /*icon_url_binding*/ctx[72](value);
	      }
	      let icon_props = {
	        id: /*_capId*/ctx[38],
	        theme: /*_theme*/ctx[28]
	      };
	      if (/*iconName*/ctx[5] !== void 0) {
	        icon_props.name = /*iconName*/ctx[5];
	      }
	      if (/*iconPath*/ctx[6] !== void 0) {
	        icon_props.path = /*iconPath*/ctx[6];
	      }
	      if (/*iconUrl*/ctx[7] !== void 0) {
	        icon_props.url = /*iconUrl*/ctx[7];
	      }
	      icon = new Icon$1({
	        props: icon_props
	      });
	      binding_callbacks.push(() => bind(icon, "name", icon_name_binding));
	      binding_callbacks.push(() => bind(icon, "path", icon_path_binding));
	      binding_callbacks.push(() => bind(icon, "url", icon_url_binding));
	      return {
	        c() {
	          div = element("div");
	          create_component(icon.$$.fragment);
	          attr(div, "class", "pros-end-cap svelte-1wnlerg");
	          attr(div, "disabled", /*disabled*/ctx[9]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          mount_component(icon, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_changes = {};
	          if (dirty[1] & /*_capId*/128) icon_changes.id = /*_capId*/ctx[38];
	          if (dirty[0] & /*_theme*/268435456) icon_changes.theme = /*_theme*/ctx[28];
	          if (!updating_name && dirty[0] & /*iconName*/32) {
	            updating_name = true;
	            icon_changes.name = /*iconName*/ctx[5];
	            add_flush_callback(() => updating_name = false);
	          }
	          if (!updating_path && dirty[0] & /*iconPath*/64) {
	            updating_path = true;
	            icon_changes.path = /*iconPath*/ctx[6];
	            add_flush_callback(() => updating_path = false);
	          }
	          if (!updating_url && dirty[0] & /*iconUrl*/128) {
	            updating_url = true;
	            icon_changes.url = /*iconUrl*/ctx[7];
	            add_flush_callback(() => updating_url = false);
	          }
	          icon.$set(icon_changes);
	          if (!current || dirty[0] & /*disabled*/512) {
	            attr(div, "disabled", /*disabled*/ctx[9]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          destroy_component(icon);
	        }
	      };
	    }

	    // (72:6) {#if _showSuggestions && !disabled}
	    function create_if_block_4$1(ctx) {
	      let div;
	      let current_block_type_index;
	      let if_block;
	      let globalClicks_action;
	      let positionOptions_action;
	      let current;
	      let mounted;
	      let dispose;
	      const if_block_creators = [create_if_block_5, create_if_block_6, create_else_block_1];
	      const if_blocks = [];
	      function select_block_type_1(ctx, dirty) {
	        if (/*_loadingSuggestions*/ctx[31]) return 0;
	        if (/*_suggestions*/ctx[32].length > 0) return 1;
	        return 2;
	      }
	      current_block_type_index = select_block_type_1(ctx);
	      if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-options-wrapper svelte-1wnlerg");
	          attr(div, "pos--theme", /*_theme*/ctx[28]);
	          attr(div, "pos--shape", /*_shape*/ctx[29]);
	          attr(div, "pos--density", /*_density*/ctx[30]);
	          toggle_class(div, "open", /*_showSuggestions*/ctx[33]);
	          toggle_class(div, "upward", /*_upward*/ctx[25]);
	          toggle_class(div, "downward", ! /*_upward*/ctx[25]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_blocks[current_block_type_index].m(div, null);
	          current = true;
	          if (!mounted) {
	            dispose = [action_destroyer(globalClicks_action = /*globalClicks*/ctx[18].call(null, div)), action_destroyer(positionOptions_action = /*positionOptions*/ctx[19].call(null, div))];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          let previous_block_index = current_block_type_index;
	          current_block_type_index = select_block_type_1(ctx);
	          if (current_block_type_index === previous_block_index) {
	            if_blocks[current_block_type_index].p(ctx, dirty);
	          } else {
	            group_outros();
	            transition_out(if_blocks[previous_block_index], 1, 1, () => {
	              if_blocks[previous_block_index] = null;
	            });
	            check_outros();
	            if_block = if_blocks[current_block_type_index];
	            if (!if_block) {
	              if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	              if_block.c();
	            } else {
	              if_block.p(ctx, dirty);
	            }
	            transition_in(if_block, 1);
	            if_block.m(div, null);
	          }
	          if (!current || dirty[0] & /*_theme*/268435456) {
	            attr(div, "pos--theme", /*_theme*/ctx[28]);
	          }
	          if (!current || dirty[0] & /*_shape*/536870912) {
	            attr(div, "pos--shape", /*_shape*/ctx[29]);
	          }
	          if (!current || dirty[0] & /*_density*/1073741824) {
	            attr(div, "pos--density", /*_density*/ctx[30]);
	          }
	          if (dirty[1] & /*_showSuggestions*/4) {
	            toggle_class(div, "open", /*_showSuggestions*/ctx[33]);
	          }
	          if (dirty[0] & /*_upward*/33554432) {
	            toggle_class(div, "upward", /*_upward*/ctx[25]);
	          }
	          if (dirty[0] & /*_upward*/33554432) {
	            toggle_class(div, "downward", ! /*_upward*/ctx[25]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_blocks[current_block_type_index].d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (93:10) {:else}
	    function create_else_block_1(ctx) {
	      let div4;
	      let div3;
	      let div2;
	      let div1;
	      let div0;
	      let t_value = /*$_*/ctx[45]("noSuggestions") + "";
	      let t;
	      let mounted;
	      let dispose;
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          t = text(t_value);
	          attr(div0, "pros-tooltip", "");
	          attr(div0, "role", "option");
	          attr(div0, "class", "pros-option svelte-1wnlerg");
	          attr(div1, "class", "pros-option-row svelte-1wnlerg");
	          attr(div2, "class", "pros-option-list svelte-1wnlerg");
	          attr(div3, "class", "pros-options svelte-1wnlerg");
	          attr(div4, "id", /*_optionsId*/ctx[42]);
	          attr(div4, "class", "pros-options-container svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          append(div3, div2);
	          append(div2, div1);
	          append(div1, div0);
	          append(div0, t);
	          if (!mounted) {
	            dispose = [listen(div1, "mousedown", preventClickPropagation$1), listen(div1, "mouseup", preventClickPropagation$1)];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*$_*/16384 && t_value !== (t_value = /*$_*/ctx[45]("noSuggestions") + "")) set_data(t, t_value);
	          if (dirty[1] & /*_optionsId*/2048) {
	            attr(div4, "id", /*_optionsId*/ctx[42]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div4);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (79:10) {#if _suggestions.length > 0}
	    function create_if_block_6(ctx) {
	      let div2;
	      let div1;
	      let div0;
	      let each_value = /*_suggestions*/ctx[32];
	      let each_blocks = [];
	      for (let i = 0; i < each_value.length; i += 1) {
	        each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	      }
	      return {
	        c() {
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].c();
	          }
	          attr(div0, "class", "pros-option-list svelte-1wnlerg");
	          attr(div1, "class", "pros-options svelte-1wnlerg");
	          attr(div2, "id", /*_optionsId*/ctx[42]);
	          attr(div2, "class", "pros-options-container svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div2, anchor);
	          append(div2, div1);
	          append(div1, div0);
	          for (let i = 0; i < each_blocks.length; i += 1) {
	            each_blocks[i].m(div0, null);
	          }
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*preventClickPropagation*/1048576 | dirty[1] & /*handleSuggestionClicked, _suggestions*/32770) {
	            each_value = /*_suggestions*/ctx[32];
	            let i;
	            for (i = 0; i < each_value.length; i += 1) {
	              const child_ctx = get_each_context(ctx, each_value, i);
	              if (each_blocks[i]) {
	                each_blocks[i].p(child_ctx, dirty);
	              } else {
	                each_blocks[i] = create_each_block(child_ctx);
	                each_blocks[i].c();
	                each_blocks[i].m(div0, null);
	              }
	            }
	            for (; i < each_blocks.length; i += 1) {
	              each_blocks[i].d(1);
	            }
	            each_blocks.length = each_value.length;
	          }
	          if (dirty[1] & /*_optionsId*/2048) {
	            attr(div2, "id", /*_optionsId*/ctx[42]);
	          }
	        },
	        i: noop,
	        o: noop,
	        d(detaching) {
	          if (detaching) detach(div2);
	          destroy_each(each_blocks, detaching);
	        }
	      };
	    }

	    // (74:8) {#if _loadingSuggestions}
	    function create_if_block_5(ctx) {
	      let div;
	      let spinner;
	      let current;
	      spinner = new Spinner({
	        props: {
	          diameter: "24"
	        }
	      });
	      return {
	        c() {
	          div = element("div");
	          create_component(spinner.$$.fragment);
	          attr(div, "class", "pros-spinner-container svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          mount_component(spinner, div, null);
	          current = true;
	        },
	        p: noop,
	        i(local) {
	          if (current) return;
	          transition_in(spinner.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(spinner.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          destroy_component(spinner);
	        }
	      };
	    }

	    // (83:16) {#each _suggestions as suggestion}
	    function create_each_block(ctx) {
	      let div1;
	      let div0;
	      let raw_value = /*suggestion*/ctx[91].modifiedDisplay + "";
	      let t;
	      let mounted;
	      let dispose;
	      function click_handler(...args) {
	        return /*click_handler*/ctx[73](/*suggestion*/ctx[91], ...args);
	      }
	      return {
	        c() {
	          div1 = element("div");
	          div0 = element("div");
	          t = space();
	          attr(div0, "pros-tooltip", "");
	          attr(div0, "role", "option");
	          attr(div0, "class", "pros-option svelte-1wnlerg");
	          attr(div1, "class", "pros-option-row svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div1, anchor);
	          append(div1, div0);
	          div0.innerHTML = raw_value;
	          append(div1, t);
	          if (!mounted) {
	            dispose = [listen(div1, "click", click_handler), listen(div1, "mousedown", preventClickPropagation$1), listen(div1, "mouseup", preventClickPropagation$1)];
	            mounted = true;
	          }
	        },
	        p(new_ctx, dirty) {
	          ctx = new_ctx;
	          if (dirty[1] & /*_suggestions*/2 && raw_value !== (raw_value = /*suggestion*/ctx[91].modifiedDisplay + "")) div0.innerHTML = raw_value;
	        },
	        d(detaching) {
	          if (detaching) detach(div1);
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }

	    // (111:4) {#if display !== 'custom'}
	    function create_if_block$1(ctx) {
	      let div;
	      let t;
	      function select_block_type_2(ctx, dirty) {
	        if (/*_dirty*/ctx[21] && /*_errors*/ctx[22].length > 0) return create_if_block_2$1;
	        if (/*hint*/ctx[3] && /*_hasFocus*/ctx[27]) return create_if_block_3$1;
	        return create_else_block$1;
	      }
	      let current_block_type = select_block_type_2(ctx);
	      let if_block0 = current_block_type(ctx);
	      let if_block1 = /*maxLength*/ctx[4] && /*_hasFocus*/ctx[27] && create_if_block_1$1(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block0.c();
	          t = space();
	          if (if_block1) if_block1.c();
	          attr(div, "class", "pros-message-container svelte-1wnlerg");
	          toggle_class(div, "error", /*_dirty*/ctx[21] && /*_errors*/ctx[22].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block0.m(div, null);
	          append(div, t);
	          if (if_block1) if_block1.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type_2(ctx)) && if_block0) {
	            if_block0.p(ctx, dirty);
	          } else {
	            if_block0.d(1);
	            if_block0 = current_block_type(ctx);
	            if (if_block0) {
	              if_block0.c();
	              if_block0.m(div, t);
	            }
	          }
	          if (/*maxLength*/ctx[4] && /*_hasFocus*/ctx[27]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	            } else {
	              if_block1 = create_if_block_1$1(ctx);
	              if_block1.c();
	              if_block1.m(div, null);
	            }
	          } else if (if_block1) {
	            if_block1.d(1);
	            if_block1 = null;
	          }
	          if (dirty[0] & /*_dirty, _errors*/6291456) {
	            toggle_class(div, "error", /*_dirty*/ctx[21] && /*_errors*/ctx[22].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block0.d();
	          if (if_block1) if_block1.d();
	        }
	      };
	    }

	    // (127:6) {:else}
	    function create_else_block$1(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[39]);
	          attr(div, "class", "pros-message svelte-1wnlerg");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_messageId*/256) {
	            attr(div, "id", /*_messageId*/ctx[39]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (120:34) 
	    function create_if_block_3$1(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[3]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1wnlerg");
	          attr(div0, "id", /*_statusIconId*/ctx[40]);
	          attr(div0, "class", "pros-status-icon svelte-1wnlerg");
	          attr(div1, "id", /*_messageId*/ctx[39]);
	          attr(div1, "class", "pros-message svelte-1wnlerg");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/512) {
	            attr(div0, "id", /*_statusIconId*/ctx[40]);
	          }
	          if (dirty[0] & /*hint*/8) set_data(t1, /*hint*/ctx[3]);
	          if (dirty[1] & /*_messageId*/256) {
	            attr(div1, "id", /*_messageId*/ctx[39]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (113:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_2$1(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[22][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1wnlerg");
	          attr(div0, "id", /*_statusIconId*/ctx[40]);
	          attr(div0, "class", "pros-status-icon error svelte-1wnlerg");
	          attr(div1, "id", /*_messageId*/ctx[39]);
	          attr(div1, "class", "pros-message error svelte-1wnlerg");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[1] & /*_statusIconId*/512) {
	            attr(div0, "id", /*_statusIconId*/ctx[40]);
	          }
	          if (dirty[0] & /*_errors*/4194304 && t1_value !== (t1_value = /*_errors*/ctx[22][0] + "")) set_data(t1, t1_value);
	          if (dirty[1] & /*_messageId*/256) {
	            attr(div1, "id", /*_messageId*/ctx[39]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (130:6) {#if maxLength && _hasFocus}
	    function create_if_block_1$1(ctx) {
	      let div;
	      let t0_value = /*value*/ctx[0].length + "";
	      let t0;
	      let t1;
	      let t2;
	      return {
	        c() {
	          div = element("div");
	          t0 = text(t0_value);
	          t1 = text("/");
	          t2 = text(/*maxLength*/ctx[4]);
	          attr(div, "id", /*_constraintId*/ctx[41]);
	          attr(div, "class", "pros-constraint");
	          toggle_class(div, "error", /*value*/ctx[0].length > /*maxLength*/ctx[4]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t0);
	          append(div, t1);
	          append(div, t2);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*value*/1 && t0_value !== (t0_value = /*value*/ctx[0].length + "")) set_data(t0, t0_value);
	          if (dirty[0] & /*maxLength*/16) set_data(t2, /*maxLength*/ctx[4]);
	          if (dirty[1] & /*_constraintId*/1024) {
	            attr(div, "id", /*_constraintId*/ctx[41]);
	          }
	          if (dirty[0] & /*value, maxLength*/17) {
	            toggle_class(div, "error", /*value*/ctx[0].length > /*maxLength*/ctx[4]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }
	    function create_fragment$1(ctx) {
	      let div4;
	      let div3;
	      let t0;
	      let div2;
	      let div1;
	      let div0;
	      let t1;
	      let t2;
	      let t3;
	      let t4;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[44] && create_if_block_10(ctx);
	      function select_block_type(ctx, dirty) {
	        if (/*password*/ctx[12]) return create_if_block_9;
	        return create_else_block_2;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block1 = current_block_type(ctx);
	      let if_block2 = /*_hasValue*/ctx[43] && ! /*disabled*/ctx[9] && /*_hasFocus*/ctx[27] && create_if_block_8(ctx);
	      let if_block3 = (/*iconName*/ctx[5] || /*iconPath*/ctx[6] || /*iconUrl*/ctx[7]) && create_if_block_7(ctx);
	      let if_block4 = /*_showSuggestions*/ctx[33] && ! /*disabled*/ctx[9] && create_if_block_4$1(ctx);
	      let if_block5 = /*display*/ctx[2] !== "custom" && create_if_block$1(ctx);
	      return {
	        c() {
	          div4 = element("div");
	          div3 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div2 = element("div");
	          div1 = element("div");
	          div0 = element("div");
	          if_block1.c();
	          t1 = space();
	          if (if_block2) if_block2.c();
	          t2 = space();
	          if (if_block3) if_block3.c();
	          t3 = space();
	          if (if_block4) if_block4.c();
	          t4 = space();
	          if (if_block5) if_block5.c();
	          attr(div0, "class", "pros-input-container svelte-1wnlerg");
	          attr(div1, "class", "pros-content-container svelte-1wnlerg");
	          attr(div2, "class", "pros-highlight-container svelte-1wnlerg");
	          toggle_class(div2, "open", /*_showSuggestions*/ctx[33]);
	          toggle_class(div2, "upward", /*_upward*/ctx[25]);
	          toggle_class(div2, "downward", /*_showSuggestions*/ctx[33] && ! /*_upward*/ctx[25]);
	          attr(div3, "class", "pros-control-container svelte-1wnlerg");
	          toggle_class(div3, "has-value", /*_hasValue*/ctx[43]);
	          toggle_class(div3, "has-label", /*_hasLabel*/ctx[44]);
	          toggle_class(div3, "has-focus", /*_hasFocus*/ctx[27]);
	          toggle_class(div3, "custom-layout", /*display*/ctx[2] === "custom");
	          toggle_class(div3, "error", /*_dirty*/ctx[21] && /*_errors*/ctx[22].length > 0);
	          toggle_class(div3, "disabled", /*disabled*/ctx[9]);
	          toggle_class(div3, "allow-hover", ! /*disabled*/ctx[9]);
	          attr(div4, "class", "pros-global-wrapper pros-form-control svelte-1wnlerg");
	          attr(div4, "pos--theme", /*_theme*/ctx[28]);
	          attr(div4, "pos--shape", /*_shape*/ctx[29]);
	          attr(div4, "pos--density", /*_density*/ctx[30]);
	        },
	        m(target, anchor) {
	          insert(target, div4, anchor);
	          append(div4, div3);
	          if (if_block0) if_block0.m(div3, null);
	          append(div3, t0);
	          append(div3, div2);
	          append(div2, div1);
	          append(div1, div0);
	          if_block1.m(div0, null);
	          append(div1, t1);
	          if (if_block2) if_block2.m(div1, null);
	          append(div1, t2);
	          if (if_block3) if_block3.m(div1, null);
	          append(div2, t3);
	          if (if_block4) if_block4.m(div2, null);
	          /*div2_binding*/
	          ctx[74](div2);
	          append(div3, t4);
	          if (if_block5) if_block5.m(div3, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div2, "mouseup", handleMouseUp), listen(div2, "mousedown", handleMouseDown), listen(div2, "keydown", /*handleKeyDown*/ctx[15]), listen(div2, "focus", /*handleFocus*/ctx[13]), listen(div2, "blur", /*handleBlur*/ctx[14]), listen(div2, "click", /*handleClick*/ctx[16])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[44]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_10(ctx);
	              if_block0.c();
	              if_block0.m(div3, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
	            if_block1.p(ctx, dirty);
	          } else {
	            if_block1.d(1);
	            if_block1 = current_block_type(ctx);
	            if (if_block1) {
	              if_block1.c();
	              if_block1.m(div0, null);
	            }
	          }
	          if (/*_hasValue*/ctx[43] && ! /*disabled*/ctx[9] && /*_hasFocus*/ctx[27]) {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block_8(ctx);
	              if_block2.c();
	              if_block2.m(div1, t2);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (/*iconName*/ctx[5] || /*iconPath*/ctx[6] || /*iconUrl*/ctx[7]) {
	            if (if_block3) {
	              if_block3.p(ctx, dirty);
	              if (dirty[0] & /*iconName, iconPath, iconUrl*/224) {
	                transition_in(if_block3, 1);
	              }
	            } else {
	              if_block3 = create_if_block_7(ctx);
	              if_block3.c();
	              transition_in(if_block3, 1);
	              if_block3.m(div1, null);
	            }
	          } else if (if_block3) {
	            group_outros();
	            transition_out(if_block3, 1, 1, () => {
	              if_block3 = null;
	            });
	            check_outros();
	          }
	          if (/*_showSuggestions*/ctx[33] && ! /*disabled*/ctx[9]) {
	            if (if_block4) {
	              if_block4.p(ctx, dirty);
	              if (dirty[0] & /*disabled*/512 | dirty[1] & /*_showSuggestions*/4) {
	                transition_in(if_block4, 1);
	              }
	            } else {
	              if_block4 = create_if_block_4$1(ctx);
	              if_block4.c();
	              transition_in(if_block4, 1);
	              if_block4.m(div2, null);
	            }
	          } else if (if_block4) {
	            group_outros();
	            transition_out(if_block4, 1, 1, () => {
	              if_block4 = null;
	            });
	            check_outros();
	          }
	          if (dirty[1] & /*_showSuggestions*/4) {
	            toggle_class(div2, "open", /*_showSuggestions*/ctx[33]);
	          }
	          if (dirty[0] & /*_upward*/33554432) {
	            toggle_class(div2, "upward", /*_upward*/ctx[25]);
	          }
	          if (dirty[0] & /*_upward*/33554432 | dirty[1] & /*_showSuggestions*/4) {
	            toggle_class(div2, "downward", /*_showSuggestions*/ctx[33] && ! /*_upward*/ctx[25]);
	          }
	          if (/*display*/ctx[2] !== "custom") {
	            if (if_block5) {
	              if_block5.p(ctx, dirty);
	            } else {
	              if_block5 = create_if_block$1(ctx);
	              if_block5.c();
	              if_block5.m(div3, null);
	            }
	          } else if (if_block5) {
	            if_block5.d(1);
	            if_block5 = null;
	          }
	          if (dirty[1] & /*_hasValue*/4096) {
	            toggle_class(div3, "has-value", /*_hasValue*/ctx[43]);
	          }
	          if (dirty[1] & /*_hasLabel*/8192) {
	            toggle_class(div3, "has-label", /*_hasLabel*/ctx[44]);
	          }
	          if (dirty[0] & /*_hasFocus*/134217728) {
	            toggle_class(div3, "has-focus", /*_hasFocus*/ctx[27]);
	          }
	          if (dirty[0] & /*display*/4) {
	            toggle_class(div3, "custom-layout", /*display*/ctx[2] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/6291456) {
	            toggle_class(div3, "error", /*_dirty*/ctx[21] && /*_errors*/ctx[22].length > 0);
	          }
	          if (dirty[0] & /*disabled*/512) {
	            toggle_class(div3, "disabled", /*disabled*/ctx[9]);
	          }
	          if (dirty[0] & /*disabled*/512) {
	            toggle_class(div3, "allow-hover", ! /*disabled*/ctx[9]);
	          }
	          if (!current || dirty[0] & /*_theme*/268435456) {
	            attr(div4, "pos--theme", /*_theme*/ctx[28]);
	          }
	          if (!current || dirty[0] & /*_shape*/536870912) {
	            attr(div4, "pos--shape", /*_shape*/ctx[29]);
	          }
	          if (!current || dirty[0] & /*_density*/1073741824) {
	            attr(div4, "pos--density", /*_density*/ctx[30]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block3);
	          transition_in(if_block4);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block3);
	          transition_out(if_block4);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div4);
	          if (if_block0) if_block0.d();
	          if_block1.d();
	          if (if_block2) if_block2.d();
	          if (if_block3) if_block3.d();
	          if (if_block4) if_block4.d();
	          /*div2_binding*/
	          ctx[74](null);
	          if (if_block5) if_block5.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function preventClickPropagation$1(event) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	    function handleMouseDown(event) {} // _suppressFocus = true;

	    function handleMouseUp(event) {} // _suppressFocus = false;

	    function hasValue$1(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty$1(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance$1($$self, $$props, $$invalidate) {
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(45, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        globalKeyListener = null
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = ""
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        placeholder = ""
	      } = $$props; // Placeholder text to display in text box when no value
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        maxLength = undefined
	      } = $$props; // Max length of value allowed
	      let {
	        iconName = undefined
	      } = $$props;
	      let {
	        iconPath = undefined
	      } = $$props;
	      let {
	        iconUrl = undefined
	      } = $$props;
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        regex = undefined
	      } = $$props; // Regex object to evaluate during built in validation
	      let {
	        regexkey = undefined
	      } = $$props; // PrintOS validation id
	      let {
	        regexmessage = undefined
	      } = $$props; // custom validation message for use with regexKey
	      let {
	        callbacks = {}
	      } = $$props;
	      let {
	        _suggestionsDebounce = debounce(getSuggestions, 700, {
	          maxWait: 5000,
	          trailing: true
	        })
	      } = $$props;
	      let {
	        inputElement
	      } = $$props;
	      let {
	        password
	      } = $$props;
	      let {
	        autocomplete = false
	      } = $$props;
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _untrimmedValue = ""; // Actual value bound to input box (may include extra whitespace)
	      let _lastValue = ""; // Last trimmed value so we can filter out extra change events based on trimmed value
	      let _inputElement = undefined;
	      let _openNode = undefined;
	      let _openParent = undefined;
	      let _upward = false;
	      let _highlightElement;
	      let _hasFocus = false;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _loadingSuggestions = false;
	      let _suggestions;
	      let _showSuggestions = false; // Is Selector visible?
	      let _printos = window.$printos;
	      let _autocomplete = "off";
	      let _labelId = null;
	      let _inputId = null;
	      let _clearId = null;
	      let _capId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      let _constraintId = null;
	      let _optionsId = null;
	      onMount(() => {
	        $$invalidate(56, inputElement = _inputElement);
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(2, display = hasValue$1(display) ? display : "form");
	        $$invalidate(50, theme = hasValue$1(theme) ? theme : "light");
	        $$invalidate(51, shape = hasValue$1(shape) ? shape : "round");
	        $$invalidate(52, density = hasValue$1(density) ? density : "standard");
	        $$invalidate(1, label = hasValue$1(label) ? label : "");
	        $$invalidate(3, hint = hasValue$1(hint) ? hint : "");
	        $$invalidate(0, value = hasValue$1(value) ? value : "");
	        $$invalidate(4, maxLength = hasValue$1(maxLength) && maxLength !== "" && !isNaN(maxLength) && Number(maxLength) >= 0 ? Number(maxLength) : undefined);
	        $$invalidate(54, regex = hasValue$1(regex) ? regex : undefined);
	        $$invalidate(55, regexkey = hasValue$1(regexkey) ? regexkey : undefined);
	        $$invalidate(8, required = hasValue$1(required) ? required : false);
	        $$invalidate(9, disabled = hasValue$1(disabled) ? disabled : false);
	        $$invalidate(53, validation = hasValue$1(validation) ? validation : true);
	        $$invalidate(10, autocomplete = hasValue$1(autocomplete) ? autocomplete : false);
	        $$invalidate(34, _autocomplete = autocomplete ? "on" : "off");
	        $$invalidate(35, _labelId = hasValue$1(id) ? `${id}-label` : undefined);
	        $$invalidate(36, _inputId = hasValue$1(id) ? `${id}-input` : undefined);
	        $$invalidate(37, _clearId = hasValue$1(id) ? `${id}-clear` : undefined);
	        $$invalidate(38, _capId = hasValue$1(id) ? `${id}-cap` : undefined);
	        $$invalidate(42, _optionsId = hasValue$1(id) ? `${id}-options` : "pros-options-container");
	        $$invalidate(39, _messageId = hasValue$1(id) ? `${id}-message` : undefined);
	        $$invalidate(40, _statusIconId = hasValue$1(id) ? `${id}-status-icon` : undefined);
	        $$invalidate(41, _constraintId = hasValue$1(id) ? `${id}-constraint` : undefined);

	        // Check if this is a programmatic update
	        if (value !== _lastValue) {
	          $$invalidate(23, _untrimmedValue = value);
	          _lastValue = value;
	        }
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(28, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(28, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(28, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(29, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(29, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(29, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(30, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(30, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(30, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function handleFocus(event) {
	        $$invalidate(27, _hasFocus = true);
	      }
	      function handleBlur(event) {
	        if (!_showSuggestions) {
	          $$invalidate(27, _hasFocus = false);
	        }
	      }
	      function handleKeyDown(event) {
	        if (!get(callbacks, "suggest")) {
	          return;
	        }
	        if (_showSuggestions) {
	          // Ignore this handler if option are open
	          // console.log('SB: handleKeyDown:Ignore');
	          return;
	        }
	        switch (event.key) {
	          case "Enter":
	          case "ArrowDown":
	            // console.log('SB: handleKeyDown:' + event.key);
	            event.stopPropagation();
	            event.preventDefault();
	            openOptions();
	            break;
	          case "Escape":
	            // console.log('SB: handleKeyDown:Escape');
	            event.stopPropagation();
	            event.preventDefault();
	            _highlightElement.blur();
	            break;
	        }
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	        if (_showSuggestions) {
	          // console.log('SB: handleClick:Close');
	          closeOptions(true);
	        } else if (_suggestions && _suggestions.length > 0) {
	          openOptions();
	        } else if (notEmpty$1(value)) {
	          _suggestionsDebounce();
	        }
	      }
	      function handleClear(event) {
	        event.preventDefault();
	        if (event.which !== 1) {
	          return;
	        }

	        // Clear the input value
	        $$invalidate(23, _untrimmedValue = "");
	        $$invalidate(27, _hasFocus = true);
	        _inputElement.focus();
	        valueChanged.call(this);
	      }
	      function getSuggestions(suppressOpen = false) {
	        if (!get(callbacks, "suggest")) {
	          return;
	        }
	        if (_loadingSuggestions) {
	          _suggestionsDebounce();
	          return;
	        }
	        if (!notEmpty$1(value)) {
	          $$invalidate(32, _suggestions = []);
	          closeOptions(true);
	          return;
	        }
	        $$invalidate(31, _loadingSuggestions = true);
	        if (!suppressOpen && !_showSuggestions && _hasFocus) {
	          openOptions();
	        }
	        return callbacks.suggest(value).then(resp => {
	          $$invalidate(32, _suggestions = []);
	          if (!resp || !Array.isArray(resp)) {
	            closeOptions(true);
	            return;
	          }
	          $$invalidate(32, _suggestions = resp.map(suggestion => {
	            let lc = suggestion.display.toLocaleLowerCase();
	            let test = value.toLocaleLowerCase();
	            let lastIndex = 0;
	            let testIndex = lc.indexOf(test);
	            let mySuggestion = "";
	            while (testIndex !== -1) {
	              mySuggestion += suggestion.display.substring(lastIndex, testIndex);
	              mySuggestion += "<b>";
	              mySuggestion += suggestion.display.substring(testIndex, testIndex + test.length);
	              mySuggestion += "</b>";
	              lastIndex = testIndex + test.length;
	              testIndex = lc.indexOf(test, lastIndex);
	            }
	            mySuggestion += suggestion.display.substring(lastIndex);
	            return {
	              display: suggestion.display,
	              modifiedDisplay: mySuggestion,
	              value: suggestion.value
	            };
	          }));
	          $$invalidate(31, _loadingSuggestions = false);
	          _inputElement.focus();
	        });
	      }
	      function handleSuggestionClicked(suggestion) {
	        closeOptions();
	        $$invalidate(23, _untrimmedValue = suggestion.display);
	        valueChanged.call(this, null, true);
	        getSuggestions(true);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("suggested", suggestion.value);
	        });
	      }
	      function globalClicks(node) {
	        $$invalidate(48, globalClickListener = event => {
	          let elements = [node];

	          // Change NodeList to Array to use some()
	          elements = Array.prototype.slice.call(elements);
	          let containsClick = elements.some(element => {
	            return element.contains(event.target);
	          });
	          if (!containsClick) {
	            // console.log('SB: globalClicks: close Options');
	            closeOptions();
	          }
	        });
	        $$invalidate(49, globalKeyListener = event => {}); // myKeyDown.call(this, event); // myKeyDown function is not defined?

	        // Necessary to prevent handling click that opens panel
	        window.setTimeout(() => {
	          document.addEventListener("click", globalClickListener);
	          document.addEventListener("keydown", globalKeyListener);
	        }, 0);
	      }
	      function positionOptions(node) {
	        _openNode = node;
	        _openParent = node.parentElement;

	        // console.log('positionOptions', _openNode, _openParent);
	        document.body.appendChild(node);
	        positionNode();
	        document.addEventListener("wheel", handleScroll);
	        window.addEventListener("scroll", handleScroll, true);
	        window.addEventListener("resize", handleScroll);
	        return {
	          destroy() {
	            document.removeEventListener("wheel", handleScroll);
	            window.removeEventListener("scroll", handleScroll);
	            window.removeEventListener("resize", handleScroll);
	          }
	        };
	      }
	      function positionNode(event) {
	        if (!_openParent) {
	          document.removeEventListener("wheel", handleScroll);
	          window.removeEventListener("scroll", handleScroll);
	          window.removeEventListener("resize", handleScroll);
	          return;
	        }
	        let adjustedTop;
	        let bodyRect = document.body.getBoundingClientRect();
	        let rect = _openParent.getBoundingClientRect();
	        $$invalidate(25, _upward = false);
	        if (_openNode.offsetHeight >= bodyRect.bottom - rect.bottom) {
	          $$invalidate(25, _upward = true);
	          adjustedTop = rect.top >= _openNode.offsetHeight ? `${rect.top - _openNode.offsetHeight}px` : `0px`;
	        }
	        if (event) {
	          let scrollTop = event.target.scrollTop;
	          let scrollBottom = scrollTop + event.target.clientHeight;
	          if (_openParent.offsetParent.offsetTop < scrollTop) {
	            adjustedTop = 0 + "px";
	          }
	          if (_openParent.offsetParent.offsetTop > scrollBottom) {
	            adjustedTop = `${rect.top - _openNode.offsetHeight}px`;
	          }
	        }
	        _openNode.style.left = `${rect.left}px`;
	        _openNode.style.top = adjustedTop ? adjustedTop : `${rect.bottom}px`;
	        _openNode.style.width = `${rect.width}px`;
	      }
	      function handleScroll(event) {
	        let isOptionScroll = false;
	        let test = event.target;
	        while (test) {
	          if (test.id === _optionsId) {
	            isOptionScroll = true;
	            break;
	          }
	          test = test.parentElement;
	        }
	        if (!isOptionScroll) {
	          // console.log('SB: scrollListener:Close Options');
	          //closeOptions();
	          positionNode(event);
	        }
	      }
	      function closeOptions(keepFocus = false) {
	        // console.log('SB: closeOptions: keepFocus=' + keepFocus);
	        // Re-parent options
	        if (_openParent) {
	          _openParent.appendChild(_openNode);
	        }
	        _openNode = undefined;
	        _openParent = undefined;
	        if (globalClickListener) {
	          document.removeEventListener("click", globalClickListener);
	          $$invalidate(48, globalClickListener = null);
	        }
	        if (globalKeyListener) {
	          document.removeEventListener("keydown", globalKeyListener);
	          $$invalidate(49, globalKeyListener = null);
	        }
	        if (keepFocus) {
	          // console.log('SB: closeOptions:focus Highlight')
	          _inputElement.focus();
	          $$invalidate(27, _hasFocus = true);
	        }
	        $$invalidate(33, _showSuggestions = false);
	        document.removeEventListener("wheel", handleScroll);
	        window.removeEventListener("scroll", handleScroll);
	        window.removeEventListener("resize", handleScroll);
	      }
	      function openOptions(event) {
	        $$invalidate(33, _showSuggestions = true);
	        _inputElement.focus();
	      }
	      function valueChanged(event, suppressSuggest = false) {
	        $$invalidate(21, _dirty = true);
	        $$invalidate(0, value = _untrimmedValue.trim());
	        if (value === _lastValue) {
	          return;
	        }

	        // console.log('suppressSuggest', suppressSuggest);
	        if (!suppressSuggest && get(callbacks, "suggest")) {
	          _suggestionsDebounce();
	        }
	        _lastValue = value;
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(22, _errors = errors ? errors : []);
	        if (required) {
	          if (!value || value === "") {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (hasValue$1(maxLength)) {
	          if (value && value.trim().length > maxLength) {
	            _builtInErrors.push($_("validateTooLong"));
	          }
	        }
	        let myRegex;
	        if (hasValue$1(regexkey) && _printos) {
	          myRegex = _printos.client.v1.getValidator(regexkey);
	          if (!myRegex) {
	            console.log("Could not find PrintOS validator", regexkey);
	          }
	        } else {
	          myRegex = regex;
	          if (regexmessage) {
	            myRegex.message = regexmessage;
	          }
	        }
	        if (hasValue$1(myRegex) && notEmpty$1(value) && notEmpty$1(myRegex.expression)) {
	          let exp = notEmpty$1(myRegex.flags) ? new RegExp(myRegex.expression, myRegex.flags) : new RegExp(myRegex.expression);
	          if (!exp.test(value)) {
	            const myMessage = myRegex.message ? unescape(myRegex.message) : $_("validateRegex");
	            _builtInErrors.push(myMessage);
	          }
	        }
	        if (validation) {
	          $$invalidate(22, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (notEmpty$1(value) && !valid && !_dirty) {
	              $$invalidate(21, _dirty = true);
	            }
	          }
	        });
	      }
	      function input_input_handler() {
	        _untrimmedValue = this.value;
	        $$invalidate(23, _untrimmedValue);
	      }
	      function input_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(24, _inputElement);
	        });
	      }
	      function input_input_handler_1() {
	        _untrimmedValue = this.value;
	        $$invalidate(23, _untrimmedValue);
	      }
	      function input_binding_1($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _inputElement = $$value;
	          $$invalidate(24, _inputElement);
	        });
	      }
	      function icon_name_binding(value) {
	        iconName = value;
	        $$invalidate(5, iconName);
	      }
	      function icon_path_binding(value) {
	        iconPath = value;
	        $$invalidate(6, iconPath);
	      }
	      function icon_url_binding(value) {
	        iconUrl = value;
	        $$invalidate(7, iconUrl);
	      }
	      const click_handler = (suggestion, event) => handleSuggestionClicked(suggestion);
	      function div2_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _highlightElement = $$value;
	          $$invalidate(26, _highlightElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("globalClickListener" in $$props) $$invalidate(48, globalClickListener = $$props.globalClickListener);
	        if ("globalKeyListener" in $$props) $$invalidate(49, globalKeyListener = $$props.globalKeyListener);
	        if ("display" in $$props) $$invalidate(2, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(50, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(51, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(52, density = $$props.density);
	        if ("value" in $$props) $$invalidate(0, value = $$props.value);
	        if ("label" in $$props) $$invalidate(1, label = $$props.label);
	        if ("placeholder" in $$props) $$invalidate(11, placeholder = $$props.placeholder);
	        if ("hint" in $$props) $$invalidate(3, hint = $$props.hint);
	        if ("maxLength" in $$props) $$invalidate(4, maxLength = $$props.maxLength);
	        if ("iconName" in $$props) $$invalidate(5, iconName = $$props.iconName);
	        if ("iconPath" in $$props) $$invalidate(6, iconPath = $$props.iconPath);
	        if ("iconUrl" in $$props) $$invalidate(7, iconUrl = $$props.iconUrl);
	        if ("required" in $$props) $$invalidate(8, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(9, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(53, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(57, errors = $$props.errors);
	        if ("regex" in $$props) $$invalidate(54, regex = $$props.regex);
	        if ("regexkey" in $$props) $$invalidate(55, regexkey = $$props.regexkey);
	        if ("regexmessage" in $$props) $$invalidate(58, regexmessage = $$props.regexmessage);
	        if ("callbacks" in $$props) $$invalidate(59, callbacks = $$props.callbacks);
	        if ("_suggestionsDebounce" in $$props) $$invalidate(60, _suggestionsDebounce = $$props._suggestionsDebounce);
	        if ("inputElement" in $$props) $$invalidate(56, inputElement = $$props.inputElement);
	        if ("password" in $$props) $$invalidate(12, password = $$props.password);
	        if ("autocomplete" in $$props) $$invalidate(10, autocomplete = $$props.autocomplete);
	        if ("id" in $$props) $$invalidate(61, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[0] & /*value*/1) {
	          // Computed values
	          $$invalidate(43, _hasValue = notEmpty$1(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/2) {
	          $$invalidate(44, _hasLabel = notEmpty$1(label));
	        }
	      };
	      return [value, label, display, hint, maxLength, iconName, iconPath, iconUrl, required, disabled, autocomplete, placeholder, password, handleFocus, handleBlur, handleKeyDown, handleClick, handleClear, globalClicks, positionOptions, preventClickPropagation$1, _dirty, _errors, _untrimmedValue, _inputElement, _upward, _highlightElement, _hasFocus, _theme, _shape, _density, _loadingSuggestions, _suggestions, _showSuggestions, _autocomplete, _labelId, _inputId, _clearId, _capId, _messageId, _statusIconId, _constraintId, _optionsId, _hasValue, _hasLabel, $_, handleSuggestionClicked, valueChanged, globalClickListener, globalKeyListener, theme, shape, density, validation, regex, regexkey, inputElement, errors, regexmessage, callbacks, _suggestionsDebounce, id, positionNode, handleScroll, closeOptions, openOptions, input_input_handler, input_binding, input_input_handler_1, input_binding_1, icon_name_binding, icon_path_binding, icon_url_binding, click_handler, div2_binding];
	    }
	    class TextBox extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document_1.getElementById("svelte-1wnlerg-style")) add_css$1();
	        init(this, options, instance$1, create_fragment$1, safe_not_equal, {
	          globalClickListener: 48,
	          globalKeyListener: 49,
	          display: 2,
	          theme: 50,
	          shape: 51,
	          density: 52,
	          value: 0,
	          label: 1,
	          placeholder: 11,
	          hint: 3,
	          maxLength: 4,
	          iconName: 5,
	          iconPath: 6,
	          iconUrl: 7,
	          required: 8,
	          disabled: 9,
	          validation: 53,
	          errors: 57,
	          regex: 54,
	          regexkey: 55,
	          regexmessage: 58,
	          callbacks: 59,
	          _suggestionsDebounce: 60,
	          inputElement: 56,
	          password: 12,
	          autocomplete: 10,
	          id: 61,
	          handleFocus: 13,
	          handleBlur: 14,
	          handleKeyDown: 15,
	          handleClick: 16,
	          handleClear: 17,
	          globalClicks: 18,
	          positionOptions: 19,
	          positionNode: 62,
	          handleScroll: 63,
	          preventClickPropagation: 20,
	          closeOptions: 64,
	          openOptions: 65
	        }, [-1, -1, -1, -1]);
	      }
	      get handleFocus() {
	        return this.$$.ctx[13];
	      }
	      get handleBlur() {
	        return this.$$.ctx[14];
	      }
	      get handleKeyDown() {
	        return this.$$.ctx[15];
	      }
	      get handleClick() {
	        return this.$$.ctx[16];
	      }
	      get handleClear() {
	        return this.$$.ctx[17];
	      }
	      get globalClicks() {
	        return this.$$.ctx[18];
	      }
	      get positionOptions() {
	        return this.$$.ctx[19];
	      }
	      get positionNode() {
	        return this.$$.ctx[62];
	      }
	      get handleScroll() {
	        return this.$$.ctx[63];
	      }
	      get preventClickPropagation() {
	        return preventClickPropagation$1;
	      }
	      get closeOptions() {
	        return this.$$.ctx[64];
	      }
	      get openOptions() {
	        return this.$$.ctx[65];
	      }
	    }

	    /* src/TimeBox.svelte generated by Svelte v3.38.2 */
	    function add_css() {
	      var style = element("style");
	      style.id = "svelte-1x8iibg-style";
	      style.textContent = ".pros-time-container.svelte-1x8iibg.svelte-1x8iibg{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;font-size:14px;line-height:20px}.pros-time-container.svelte-1x8iibg .time-input.svelte-1x8iibg{display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:4px;min-width:32px}.pros-time-container.svelte-1x8iibg .time-input.selected.svelte-1x8iibg{background-color:#027aae;color:white}.pros-time-container.svelte-1x8iibg .colon.svelte-1x8iibg{font-weight:bold;margin:0 2px}.pros-time-container.svelte-1x8iibg .colon.svelte-1x8iibg::after{content:\":\"}.pros-highlight-container.svelte-1x8iibg.svelte-1x8iibg{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;height:48px;border-radius:12px;border-style:solid;border-width:1px;outline:none;overflow:hidden;cursor:pointer}.pros-content-container.svelte-1x8iibg.svelte-1x8iibg{display:flex;justify-content:flex-start;align-items:center;flex:1;position:relative;width:100%;height:100%}.pros-input-container.svelte-1x8iibg.svelte-1x8iibg{display:flex;justify-content:flex-start;align-items:center;flex:1;height:100%;margin-left:12px;min-width:0}.pros-input-container.svelte-1x8iibg .pros-input.svelte-1x8iibg{width:100%;outline:none !important;border:none;padding:0 16px 0 0;background:transparent;font-size:16px;line-height:24px;color:inherit;box-sizing:border-box;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:pointer;font-family:inherit !important}.pros-control-container.has-label.svelte-1x8iibg .pros-input.svelte-1x8iibg{padding-top:18px}.pros-control-label.svelte-1x8iibg.svelte-1x8iibg{position:absolute;top:0;left:0;transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s;transform:translate(16px, 14px);transform-origin:left top;will-change:font-family, transform;line-height:24px;color:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:calc(100% - 16px)}.pros-control-label.required.svelte-1x8iibg.svelte-1x8iibg::after{content:\" *\"}.pros-end-cap.svelte-1x8iibg.svelte-1x8iibg{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;width:48px;box-sizing:border-box;padding:1px 0}.pros-control-container.svelte-1x8iibg.svelte-1x8iibg{box-sizing:border-box;position:relative;width:100%;margin:0;font-size:16px}.pros-control-container.has-value.svelte-1x8iibg .pros-control-label.svelte-1x8iibg,.pros-control-container.has-focus.svelte-1x8iibg .pros-control-label.svelte-1x8iibg{font-size:12px;line-height:16px;transform:translate(12px, 8px);transition:font-family 300ms linear 0s, transform 150ms cubic-bezier(0, 0, 0.2, 1) 0s}.pros-control-container.has-focus.svelte-1x8iibg .pros-highlight-container.svelte-1x8iibg{cursor:default}.pros-control-container.has-focus.svelte-1x8iibg .pros-input.svelte-1x8iibg{cursor:text}.pros-control-container.has-focus.svelte-1x8iibg .pros-highlight-container.svelte-1x8iibg{border-width:2px}.pros-control-container.has-focus.svelte-1x8iibg .pros-input-container.svelte-1x8iibg{margin-left:11px}.pros-control-container.has-focus.svelte-1x8iibg .pros-end-cap.svelte-1x8iibg:last-child{width:47px;padding:0}.pros-message-container.svelte-1x8iibg.svelte-1x8iibg{display:flex;justify-content:flex-start;align-items:center;font-size:14px;min-height:18px;max-height:18px;width:100%;margin-top:2px}.pros-message-container.svelte-1x8iibg .pros-status-icon.svelte-1x8iibg{height:16px;width:16px;margin-right:4px}.pros-message-container.svelte-1x8iibg .pros-status-icon svg.svelte-1x8iibg{height:100%;width:100%}.pros-message-container.svelte-1x8iibg .pros-message.svelte-1x8iibg{flex:1}.pros-global-wrapper[pos--shape=sharp].svelte-1x8iibg .pros-highlight-container.svelte-1x8iibg{border-radius:0}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container .pros-control-label.svelte-1x8iibg{transform:translate(12px, 9px);line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container .pros-highlight-container.svelte-1x8iibg{height:36px}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container .pros-highlight-container.textarea .pros-input.svelte-1x8iibg{margin-top:14px;padding:0 36px 0 0}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container .pros-input-container .pros-input.svelte-1x8iibg{line-height:20px}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container.has-label .pros-input.svelte-1x8iibg{padding-top:14px}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container.has-value .pros-control-label.svelte-1x8iibg,.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container.has-focus .pros-control-label.svelte-1x8iibg{line-height:16px;transform:translate(10px, 2px)}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container.has-focus .pros-highlight-container.textarea .pros-input.svelte-1x8iibg{margin-top:13px}.pros-global-wrapper[pos--density=high].svelte-1x8iibg .pros-control-container.has-focus .pros-input-container.svelte-1x8iibg{margin-left:7px}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.svelte-1x8iibg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-highlight-container.svelte-1x8iibg{border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-input.svelte-1x8iibg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.allow-hover .pros-highlight-container.svelte-1x8iibg:hover{background-color:rgba(33, 33, 33, 0.05);border-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.error .pros-highlight-container.svelte-1x8iibg{border-color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.has-focus .pros-highlight-container.svelte-1x8iibg{background-color:#ffffff !important;border-color:#027aae !important}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-end-cap.svelte-1x8iibg{color:#363636}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-message-container.svelte-1x8iibg{color:#212121}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-message-container .pros-status-icon.svelte-1x8iibg{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-message-container.error.svelte-1x8iibg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1x8iibg{color:#be1313}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.disabled.svelte-1x8iibg{user-select:none;color:#adadad}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.disabled .pros-highlight-container.svelte-1x8iibg{border-color:#adadad;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.disabled .pros-input.svelte-1x8iibg{color:#adadad;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.disabled .pros-message-container.svelte-1x8iibg{color:#adadad !important}.pros-global-wrapper[pos--theme=light].svelte-1x8iibg .pros-control-container.disabled .pros-end-cap.svelte-1x8iibg{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.svelte-1x8iibg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-highlight-container.svelte-1x8iibg{border-color:#dbdbdb}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-input.svelte-1x8iibg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.allow-hover .pros-highlight-container.svelte-1x8iibg:hover{background-color:rgba(255, 255, 255, 0.05);border-color:#737373}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.error .pros-highlight-container.svelte-1x8iibg{border-color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.has-focus .pros-highlight-container.svelte-1x8iibg{background-color:rgba(255, 255, 255, 0.05) !important;border-color:#3ab4eb !important}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-message-container.svelte-1x8iibg{color:#ffffff}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-message-container .pros-status-icon.svelte-1x8iibg{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-message-container.error.svelte-1x8iibg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container .pros-message-container.error .pros-status-icon.svelte-1x8iibg{color:#eb5e5e}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.disabled.svelte-1x8iibg{user-select:none;color:#585858}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.disabled .pros-highlight-container.svelte-1x8iibg{border-color:#404040;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.disabled .pros-input.svelte-1x8iibg{color:#585858;user-select:none;cursor:default}.pros-global-wrapper[pos--theme=dark].svelte-1x8iibg .pros-control-container.disabled .pros-message-container.svelte-1x8iibg{color:#585858 !important}";
	      append(document.head, style);
	    }

	    // (11:4) {#if _hasLabel}
	    function create_if_block_4(ctx) {
	      let div;
	      let t;
	      return {
	        c() {
	          div = element("div");
	          t = text(/*label*/ctx[0]);
	          attr(div, "id", /*_labelId*/ctx[27]);
	          attr(div, "class", "pros-control-label svelte-1x8iibg");
	          attr(div, "pros-tooltip", "");
	          toggle_class(div, "required", /*required*/ctx[6]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          append(div, t);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*label*/1) set_data(t, /*label*/ctx[0]);
	          if (dirty[0] & /*_labelId*/134217728) {
	            attr(div, "id", /*_labelId*/ctx[27]);
	          }
	          if (dirty[0] & /*required*/64) {
	            toggle_class(div, "required", /*required*/ctx[6]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (29:8) {#if iconName || iconPath || iconUrl}
	    function create_if_block_3(ctx) {
	      let div;
	      let icon;
	      let updating_name;
	      let updating_path;
	      let updating_url;
	      let current;
	      function icon_name_binding(value) {
	        /*icon_name_binding*/ctx[57](value);
	      }
	      function icon_path_binding(value) {
	        /*icon_path_binding*/ctx[58](value);
	      }
	      function icon_url_binding(value) {
	        /*icon_url_binding*/ctx[59](value);
	      }
	      let icon_props = {
	        id: /*_capId*/ctx[28],
	        theme: /*_theme*/ctx[24]
	      };
	      if (/*iconName*/ctx[3] !== void 0) {
	        icon_props.name = /*iconName*/ctx[3];
	      }
	      if (/*iconPath*/ctx[4] !== void 0) {
	        icon_props.path = /*iconPath*/ctx[4];
	      }
	      if (/*iconUrl*/ctx[5] !== void 0) {
	        icon_props.url = /*iconUrl*/ctx[5];
	      }
	      icon = new Icon$1({
	        props: icon_props
	      });
	      binding_callbacks.push(() => bind(icon, "name", icon_name_binding));
	      binding_callbacks.push(() => bind(icon, "path", icon_path_binding));
	      binding_callbacks.push(() => bind(icon, "url", icon_url_binding));
	      return {
	        c() {
	          div = element("div");
	          create_component(icon.$$.fragment);
	          attr(div, "class", "pros-end-cap svelte-1x8iibg");
	          attr(div, "disabled", /*disabled*/ctx[7]);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          mount_component(icon, div, null);
	          current = true;
	        },
	        p(ctx, dirty) {
	          const icon_changes = {};
	          if (dirty[0] & /*_capId*/268435456) icon_changes.id = /*_capId*/ctx[28];
	          if (dirty[0] & /*_theme*/16777216) icon_changes.theme = /*_theme*/ctx[24];
	          if (!updating_name && dirty[0] & /*iconName*/8) {
	            updating_name = true;
	            icon_changes.name = /*iconName*/ctx[3];
	            add_flush_callback(() => updating_name = false);
	          }
	          if (!updating_path && dirty[0] & /*iconPath*/16) {
	            updating_path = true;
	            icon_changes.path = /*iconPath*/ctx[4];
	            add_flush_callback(() => updating_path = false);
	          }
	          if (!updating_url && dirty[0] & /*iconUrl*/32) {
	            updating_url = true;
	            icon_changes.url = /*iconUrl*/ctx[5];
	            add_flush_callback(() => updating_url = false);
	          }
	          icon.$set(icon_changes);
	          if (!current || dirty[0] & /*disabled*/128) {
	            attr(div, "disabled", /*disabled*/ctx[7]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(icon.$$.fragment, local);
	          current = true;
	        },
	        o(local) {
	          transition_out(icon.$$.fragment, local);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          destroy_component(icon);
	        }
	      };
	    }

	    // (37:4) {#if display !== 'custom'}
	    function create_if_block(ctx) {
	      let div;
	      function select_block_type(ctx, dirty) {
	        if (/*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0) return create_if_block_1;
	        if (/*hint*/ctx[2] && /*_hasFocus*/ctx[23]) return create_if_block_2;
	        return create_else_block;
	      }
	      let current_block_type = select_block_type(ctx);
	      let if_block = current_block_type(ctx);
	      return {
	        c() {
	          div = element("div");
	          if_block.c();
	          attr(div, "class", "pros-message-container svelte-1x8iibg");
	          toggle_class(div, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	          if_block.m(div, null);
	        },
	        p(ctx, dirty) {
	          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
	            if_block.p(ctx, dirty);
	          } else {
	            if_block.d(1);
	            if_block = current_block_type(ctx);
	            if (if_block) {
	              if_block.c();
	              if_block.m(div, null);
	            }
	          }
	          if (dirty[0] & /*_dirty, _errors*/6144) {
	            toggle_class(div, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	          if_block.d();
	        }
	      };
	    }

	    // (53:6) {:else}
	    function create_else_block(ctx) {
	      let div;
	      return {
	        c() {
	          div = element("div");
	          attr(div, "id", /*_messageId*/ctx[29]);
	          attr(div, "class", "pros-message svelte-1x8iibg");
	        },
	        m(target, anchor) {
	          insert(target, div, anchor);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div);
	        }
	      };
	    }

	    // (46:34) 
	    function create_if_block_2(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(/*hint*/ctx[2]);
	          attr(path, "d", "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM11.5 16.5C11.5 16.8 11.7 17 12 17C12.3 17 12.5 16.8 12.5 16.5V11.5C12.5 11.2 12.3 11 12 11C11.7 11 11.5 11.2 11.5 11.5V16.5ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1x8iibg");
	          attr(div0, "id", /*_statusIconId*/ctx[30]);
	          attr(div0, "class", "pros-status-icon svelte-1x8iibg");
	          attr(div1, "id", /*_messageId*/ctx[29]);
	          attr(div1, "class", "pros-message svelte-1x8iibg");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/1073741824) {
	            attr(div0, "id", /*_statusIconId*/ctx[30]);
	          }
	          if (dirty[0] & /*hint*/4) set_data(t1, /*hint*/ctx[2]);
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div1, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }

	    // (39:6) {#if _dirty && _errors.length > 0}
	    function create_if_block_1(ctx) {
	      let div0;
	      let svg;
	      let path;
	      let t0;
	      let div1;
	      let t1_value = /*_errors*/ctx[12][0] + "";
	      let t1;
	      return {
	        c() {
	          div0 = element("div");
	          svg = svg_element("svg");
	          path = svg_element("path");
	          t0 = space();
	          div1 = element("div");
	          t1 = text(t1_value);
	          attr(path, "d", "M12.5 2C6.97711 2 2.5 6.47711 2.5 12C2.5 17.5228 6.97711 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47711 18.0228 2 12.5 2ZM18.0001 12.5H7.00006C6.72369 12.5 6.50006 12.2764 6.50006 12C6.50006 11.7236 6.72369 11.5 7.00006 11.5H18.0001C18.2764 11.5 18.5001 11.7236 18.5001 12C18.5001 12.2764 18.2764 12.5 18.0001 12.5Z");
	          attr(svg, "width", "24");
	          attr(svg, "height", "24");
	          attr(svg, "viewBox", "0 0 24 24");
	          attr(svg, "fill", "currentColor");
	          attr(svg, "xmlns", "http://www.w3.org/2000/svg");
	          attr(svg, "class", "svelte-1x8iibg");
	          attr(div0, "id", /*_statusIconId*/ctx[30]);
	          attr(div0, "class", "pros-status-icon error svelte-1x8iibg");
	          attr(div1, "id", /*_messageId*/ctx[29]);
	          attr(div1, "class", "pros-message error svelte-1x8iibg");
	          attr(div1, "pros-tooltip", "");
	        },
	        m(target, anchor) {
	          insert(target, div0, anchor);
	          append(div0, svg);
	          append(svg, path);
	          insert(target, t0, anchor);
	          insert(target, div1, anchor);
	          append(div1, t1);
	        },
	        p(ctx, dirty) {
	          if (dirty[0] & /*_statusIconId*/1073741824) {
	            attr(div0, "id", /*_statusIconId*/ctx[30]);
	          }
	          if (dirty[0] & /*_errors*/4096 && t1_value !== (t1_value = /*_errors*/ctx[12][0] + "")) set_data(t1, t1_value);
	          if (dirty[0] & /*_messageId*/536870912) {
	            attr(div1, "id", /*_messageId*/ctx[29]);
	          }
	        },
	        d(detaching) {
	          if (detaching) detach(div0);
	          if (detaching) detach(t0);
	          if (detaching) detach(div1);
	        }
	      };
	    }
	    function create_fragment(ctx) {
	      let div9;
	      let div8;
	      let t0;
	      let div7;
	      let div6;
	      let div5;
	      let div4;
	      let div0;
	      let t1;
	      let t2;
	      let div1;
	      let t3;
	      let div2;
	      let t4;
	      let t5;
	      let div3;
	      let t6;
	      let t7;
	      let t8;
	      let current;
	      let mounted;
	      let dispose;
	      let if_block0 = /*_hasLabel*/ctx[32] && create_if_block_4(ctx);
	      let if_block1 = (/*iconName*/ctx[3] || /*iconPath*/ctx[4] || /*iconUrl*/ctx[5]) && create_if_block_3(ctx);
	      let if_block2 = /*display*/ctx[1] !== "custom" && create_if_block(ctx);
	      return {
	        c() {
	          div9 = element("div");
	          div8 = element("div");
	          if (if_block0) if_block0.c();
	          t0 = space();
	          div7 = element("div");
	          div6 = element("div");
	          div5 = element("div");
	          div4 = element("div");
	          div0 = element("div");
	          t1 = text(/*_hour*/ctx[15]);
	          t2 = space();
	          div1 = element("div");
	          t3 = space();
	          div2 = element("div");
	          t4 = text(/*_minute*/ctx[17]);
	          t5 = space();
	          div3 = element("div");
	          t6 = text(/*_ampm*/ctx[19]);
	          t7 = space();
	          if (if_block1) if_block1.c();
	          t8 = space();
	          if (if_block2) if_block2.c();
	          attr(div0, "class", "time-input svelte-1x8iibg");
	          attr(div0, "tabindex", "0");
	          toggle_class(div0, "selected", /*_hourSelected*/ctx[20]);
	          attr(div1, "class", "colon svelte-1x8iibg");
	          attr(div2, "class", "time-input svelte-1x8iibg");
	          attr(div2, "tabindex", "0");
	          toggle_class(div2, "selected", /*_minuteSelected*/ctx[21]);
	          attr(div3, "class", "time-input svelte-1x8iibg");
	          attr(div3, "tabindex", "0");
	          toggle_class(div3, "selected", /*_ampmSelected*/ctx[22]);
	          attr(div4, "class", "pros-input pros-time-container svelte-1x8iibg");
	          attr(div5, "class", "pros-input-container svelte-1x8iibg");
	          attr(div6, "class", "pros-content-container svelte-1x8iibg");
	          attr(div7, "class", "pros-highlight-container svelte-1x8iibg");
	          attr(div8, "class", "pros-control-container svelte-1x8iibg");
	          toggle_class(div8, "has-value", /*_hasValue*/ctx[31]);
	          toggle_class(div8, "has-label", /*_hasLabel*/ctx[32]);
	          toggle_class(div8, "has-focus", /*_hasFocus*/ctx[23]);
	          toggle_class(div8, "custom-layout", /*display*/ctx[1] === "custom");
	          toggle_class(div8, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          toggle_class(div8, "disabled", /*disabled*/ctx[7]);
	          toggle_class(div8, "allow-hover", ! /*disabled*/ctx[7]);
	          attr(div9, "class", "pros-global-wrapper pros-form-control svelte-1x8iibg");
	          attr(div9, "pos--theme", /*_theme*/ctx[24]);
	          attr(div9, "pos--shape", /*_shape*/ctx[25]);
	          attr(div9, "pos--density", /*_density*/ctx[26]);
	        },
	        m(target, anchor) {
	          insert(target, div9, anchor);
	          append(div9, div8);
	          if (if_block0) if_block0.m(div8, null);
	          append(div8, t0);
	          append(div8, div7);
	          append(div7, div6);
	          append(div6, div5);
	          append(div5, div4);
	          append(div4, div0);
	          append(div0, t1);
	          /*div0_binding*/
	          ctx[54](div0);
	          append(div4, t2);
	          append(div4, div1);
	          append(div4, t3);
	          append(div4, div2);
	          append(div2, t4);
	          /*div2_binding*/
	          ctx[55](div2);
	          append(div4, t5);
	          append(div4, div3);
	          append(div3, t6);
	          /*div3_binding*/
	          ctx[56](div3);
	          append(div6, t7);
	          if (if_block1) if_block1.m(div6, null);
	          /*div7_binding*/
	          ctx[60](div7);
	          append(div8, t8);
	          if (if_block2) if_block2.m(div8, null);
	          current = true;
	          if (!mounted) {
	            dispose = [listen(div0, "click", /*selectHour*/ctx[33]), listen(div0, "focus", /*selectHour*/ctx[33]), listen(div0, "blur", /*deselectHour*/ctx[34]), listen(div0, "keydown", /*handleHourKey*/ctx[39]), listen(div2, "click", /*selectMinute*/ctx[35]), listen(div2, "focus", /*selectMinute*/ctx[35]), listen(div2, "blur", /*deselectMinute*/ctx[36]), listen(div2, "keydown", /*handleMinuteKey*/ctx[40]), listen(div3, "click", /*selectAmPm*/ctx[37]), listen(div3, "focus", /*selectAmPm*/ctx[37]), listen(div3, "blur", /*deselectAmPm*/ctx[38]), listen(div3, "keydown", /*handleAmPmKey*/ctx[41]), listen(div7, "focus", /*handleFocus*/ctx[8]), listen(div7, "blur", /*handleBlur*/ctx[9]), listen(div7, "click", /*handleClick*/ctx[10])];
	            mounted = true;
	          }
	        },
	        p(ctx, dirty) {
	          if (/*_hasLabel*/ctx[32]) {
	            if (if_block0) {
	              if_block0.p(ctx, dirty);
	            } else {
	              if_block0 = create_if_block_4(ctx);
	              if_block0.c();
	              if_block0.m(div8, t0);
	            }
	          } else if (if_block0) {
	            if_block0.d(1);
	            if_block0 = null;
	          }
	          if (!current || dirty[0] & /*_hour*/32768) set_data(t1, /*_hour*/ctx[15]);
	          if (dirty[0] & /*_hourSelected*/1048576) {
	            toggle_class(div0, "selected", /*_hourSelected*/ctx[20]);
	          }
	          if (!current || dirty[0] & /*_minute*/131072) set_data(t4, /*_minute*/ctx[17]);
	          if (dirty[0] & /*_minuteSelected*/2097152) {
	            toggle_class(div2, "selected", /*_minuteSelected*/ctx[21]);
	          }
	          if (!current || dirty[0] & /*_ampm*/524288) set_data(t6, /*_ampm*/ctx[19]);
	          if (dirty[0] & /*_ampmSelected*/4194304) {
	            toggle_class(div3, "selected", /*_ampmSelected*/ctx[22]);
	          }
	          if (/*iconName*/ctx[3] || /*iconPath*/ctx[4] || /*iconUrl*/ctx[5]) {
	            if (if_block1) {
	              if_block1.p(ctx, dirty);
	              if (dirty[0] & /*iconName, iconPath, iconUrl*/56) {
	                transition_in(if_block1, 1);
	              }
	            } else {
	              if_block1 = create_if_block_3(ctx);
	              if_block1.c();
	              transition_in(if_block1, 1);
	              if_block1.m(div6, null);
	            }
	          } else if (if_block1) {
	            group_outros();
	            transition_out(if_block1, 1, 1, () => {
	              if_block1 = null;
	            });
	            check_outros();
	          }
	          if (/*display*/ctx[1] !== "custom") {
	            if (if_block2) {
	              if_block2.p(ctx, dirty);
	            } else {
	              if_block2 = create_if_block(ctx);
	              if_block2.c();
	              if_block2.m(div8, null);
	            }
	          } else if (if_block2) {
	            if_block2.d(1);
	            if_block2 = null;
	          }
	          if (dirty[1] & /*_hasValue*/1) {
	            toggle_class(div8, "has-value", /*_hasValue*/ctx[31]);
	          }
	          if (dirty[1] & /*_hasLabel*/2) {
	            toggle_class(div8, "has-label", /*_hasLabel*/ctx[32]);
	          }
	          if (dirty[0] & /*_hasFocus*/8388608) {
	            toggle_class(div8, "has-focus", /*_hasFocus*/ctx[23]);
	          }
	          if (dirty[0] & /*display*/2) {
	            toggle_class(div8, "custom-layout", /*display*/ctx[1] === "custom");
	          }
	          if (dirty[0] & /*_dirty, _errors*/6144) {
	            toggle_class(div8, "error", /*_dirty*/ctx[11] && /*_errors*/ctx[12].length > 0);
	          }
	          if (dirty[0] & /*disabled*/128) {
	            toggle_class(div8, "disabled", /*disabled*/ctx[7]);
	          }
	          if (dirty[0] & /*disabled*/128) {
	            toggle_class(div8, "allow-hover", ! /*disabled*/ctx[7]);
	          }
	          if (!current || dirty[0] & /*_theme*/16777216) {
	            attr(div9, "pos--theme", /*_theme*/ctx[24]);
	          }
	          if (!current || dirty[0] & /*_shape*/33554432) {
	            attr(div9, "pos--shape", /*_shape*/ctx[25]);
	          }
	          if (!current || dirty[0] & /*_density*/67108864) {
	            attr(div9, "pos--density", /*_density*/ctx[26]);
	          }
	        },
	        i(local) {
	          if (current) return;
	          transition_in(if_block1);
	          current = true;
	        },
	        o(local) {
	          transition_out(if_block1);
	          current = false;
	        },
	        d(detaching) {
	          if (detaching) detach(div9);
	          if (if_block0) if_block0.d();
	          /*div0_binding*/
	          ctx[54](null);
	          /*div2_binding*/
	          ctx[55](null);
	          /*div3_binding*/
	          ctx[56](null);
	          if (if_block1) if_block1.d();
	          /*div7_binding*/
	          ctx[60](null);
	          if (if_block2) if_block2.d();
	          mounted = false;
	          run_all(dispose);
	        }
	      };
	    }
	    function preventClickPropagation(event) {
	      event.stopPropagation();
	      event.preventDefault();
	    }

	    function hasValue(test) {
	      return test !== undefined && test !== null;
	    }
	    function notEmpty(test) {
	      return test !== undefined && test !== null && test.trim() !== "";
	    }
	    function instance($$self, $$props, $$invalidate) {
	      let _hasValue;
	      let _hasLabel;
	      let $_;
	      component_subscribe($$self, X, $$value => $$invalidate(72, $_ = $$value));
	      const dispatch = createEventDispatcher();
	      const INCREMENTS = [1, 5, 10, 15, 30, 60];
	      let {
	        globalClickListener = null
	      } = $$props;
	      let {
	        globalKeyListener = null
	      } = $$props;
	      let {
	        display = "form"
	      } = $$props; // Layout interaction (reserved space, alignment policies) (form, custom)
	      let {
	        theme = "auto"
	      } = $$props; // Color theme (auto/dark/light)
	      let {
	        shape = "round"
	      } = $$props; // Shape style (round/sharp)
	      let {
	        density = "standard"
	      } = $$props; // Density style (standard/high)
	      let {
	        value = ""
	      } = $$props; // Current value of control
	      let {
	        label = ""
	      } = $$props; // Control label
	      let {
	        hint = ""
	      } = $$props; // Hint/Helper text to display when no validation errors to display
	      let {
	        iconName = undefined
	      } = $$props;
	      let {
	        iconPath = undefined
	      } = $$props;
	      let {
	        iconUrl = undefined
	      } = $$props;
	      let {
	        required = false
	      } = $$props; // Is value required to be valid?
	      let {
	        disabled = false
	      } = $$props; // Is Control disabled?
	      let {
	        validation = true
	      } = $$props; // Do we include built in validation?
	      let {
	        errors = []
	      } = $$props; // Custom external validation errors
	      let {
	        increment = 1
	      } = $$props;
	      let {
	        id = null
	      } = $$props;

	      // Internal Data
	      let _dirty = false; // Has the user changed the value (yes = dirty)

	      let _errors = []; // Combined validation errors
	      let _builtInErrors = []; // Built in validation errors
	      let _lastValid;
	      let _lastValue = ""; // Last trimmed value so we can filter out extra change events based on trimmed value
	      let _highlightElement;
	      let _hourControl;
	      let _hour;
	      let _minuteControl;
	      let _minute;
	      let _ampmControl;
	      let _ampm;
	      let _hourSelected;
	      let _minuteSelected;
	      let _ampmSelected;
	      let _trackFirstKey = null;
	      let _increment;
	      let _validMinutes = [];
	      let _hasFocus = false;
	      let _themeEventListener;
	      let _shapeEventListener;
	      let _densityEventListener;
	      let _theme;
	      let _shape;
	      let _density;
	      let _lastTheme;
	      let _lastShape;
	      let _lastDensity;
	      let _labelId = null;
	      let _capId = null;
	      let _messageId = null;
	      let _statusIconId = null;
	      onMount(() => {
	        doValidate();
	      });
	      onDestroy(() => {
	        if (_themeEventListener) {
	          window.removeEventListener("posh-theme-changed", _themeEventListener);
	        }
	        if (_shapeEventListener) {
	          window.removeEventListener("posh-shape-changed", _shapeEventListener);
	        }
	        if (_densityEventListener) {
	          window.removeEventListener("posh-density-changed", _densityEventListener);
	        }
	      });
	      beforeUpdate(() => {
	        // Normalize external changes
	        $$invalidate(1, display = hasValue(display) ? display : "form");
	        $$invalidate(43, theme = hasValue(theme) ? theme : "light");
	        $$invalidate(44, shape = hasValue(shape) ? shape : "round");
	        $$invalidate(45, density = hasValue(density) ? density : "standard");
	        $$invalidate(0, label = hasValue(label) ? label : "");
	        $$invalidate(2, hint = hasValue(hint) ? hint : "");
	        $$invalidate(42, value = hasValue(value) ? value : "");
	        $$invalidate(6, required = hasValue(required) ? required : false);
	        $$invalidate(7, disabled = hasValue(disabled) ? disabled : false);
	        $$invalidate(46, validation = hasValue(validation) ? validation : true);
	        $$invalidate(27, _labelId = hasValue(id) ? `${id}-label` : undefined);
	        $$invalidate(28, _capId = hasValue(id) ? `${id}-cap` : undefined);
	        $$invalidate(29, _messageId = hasValue(id) ? `${id}-message` : undefined);
	        $$invalidate(30, _statusIconId = hasValue(id) ? `${id}-status-icon` : undefined);
	        let myIncrement = increment ? Number(increment) : 1;
	        if (!INCREMENTS.includes(myIncrement)) {
	          console.warn("TimeBox - Invalid Increments (1, 5, 10, 15, 30, 60)");
	          myIncrement = 1;
	        }
	        if (myIncrement !== _increment) {
	          _increment = myIncrement;
	          let test = 0;
	          while (test < 60) {
	            _validMinutes.push(test);
	            test += _increment;
	          }
	        }

	        // Check if this is a programmatic update
	        if (value !== _lastValue) {
	          _lastValue = value;
	          parseValue();
	        }
	        if (theme !== _lastTheme) {
	          _lastTheme = theme;
	          if (theme === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--theme");
	            $$invalidate(24, _theme = themeAttribute ? themeAttribute : "light");
	            if (!_themeEventListener) {
	              // Only start listening once
	              _themeEventListener = window.addEventListener("posh-theme-changed", event => {
	                if (theme === "auto") {
	                  $$invalidate(24, _theme = event.detail.theme);
	                }
	              });
	            }
	          } else {
	            $$invalidate(24, _theme = theme);
	          }
	        }
	        if (shape !== _lastShape) {
	          _lastShape = shape;
	          if (shape === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--shape");
	            $$invalidate(25, _shape = themeAttribute ? themeAttribute : "round");
	            if (!_shapeEventListener) {
	              // Only start listening once
	              _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
	                if (shape === "auto") {
	                  $$invalidate(25, _shape = event.detail.shape);
	                }
	              });
	            }
	          } else {
	            $$invalidate(25, _shape = shape);
	          }
	        }
	        if (density !== _lastDensity) {
	          _lastDensity = density;
	          if (density === "auto") {
	            let themeAttribute = window.document.body.getAttribute("pos--density");
	            $$invalidate(26, _density = themeAttribute ? themeAttribute : "standard");
	            if (!_densityEventListener) {
	              // Only start listening once
	              _densityEventListener = window.addEventListener("posh-density-changed", event => {
	                if (density === "auto") {
	                  $$invalidate(26, _density = event.detail.density);
	                }
	              });
	            }
	          } else {
	            $$invalidate(26, _density = density);
	          }
	        }
	        doValidate.call(this);
	      });
	      function parseValue() {
	        if (!value) {
	          $$invalidate(42, value = "00:00");
	        }
	        let split = value.split(":");
	        let hour = Number(split[0]);
	        if (hour > 12) {
	          hour -= 12;
	          $$invalidate(19, _ampm = "PM");
	        } else {
	          if (hour === 0) {
	            hour = 12;
	          }
	          $$invalidate(19, _ampm = "AM");
	        }
	        $$invalidate(15, _hour = "" + hour);
	        $$invalidate(17, _minute = split[1]);
	      }
	      function handleFocus(event) {
	        console.log("handleFocus");
	        $$invalidate(23, _hasFocus = true);
	        selectHour();
	      }
	      function handleBlur(event) {
	        console.log("handleBlur");
	        $$invalidate(23, _hasFocus = false);
	        clearSelection();
	      }
	      function handleKeyDown(event) {
	        switch (event.key) {
	          case "Escape":
	            // console.log('SB: handleKeyDown:Escape');
	            event.stopPropagation();
	            event.preventDefault();
	            _highlightElement.blur();
	            clearSelection();
	            break;
	        }
	      }
	      function handleClick(event) {
	        if (disabled) {
	          return;
	        }
	      }

	      // Methods
	      function selectHour() {
	        $$invalidate(20, _hourSelected = true);
	        $$invalidate(21, _minuteSelected = false);
	        $$invalidate(22, _ampmSelected = false);
	        _trackFirstKey = null;
	        _hourControl.focus();
	      }
	      function deselectHour() {
	        $$invalidate(20, _hourSelected = false);
	      }
	      function selectMinute() {
	        $$invalidate(20, _hourSelected = false);
	        $$invalidate(21, _minuteSelected = true);
	        $$invalidate(22, _ampmSelected = false);
	        _trackFirstKey = null;
	        _minuteControl.focus();
	      }
	      function deselectMinute() {
	        $$invalidate(21, _minuteSelected = false);
	        snapMinutesToIncrement();
	      } //updateValue();

	      function selectAmPm() {
	        $$invalidate(20, _hourSelected = false);
	        $$invalidate(21, _minuteSelected = false);
	        $$invalidate(22, _ampmSelected = true);
	        _trackFirstKey = null;
	        _ampmControl.focus();
	      }
	      function deselectAmPm() {
	        $$invalidate(22, _ampmSelected = false);
	      }
	      function clearSelection() {
	        $$invalidate(20, _hourSelected = false);
	        $$invalidate(21, _minuteSelected = false);
	        $$invalidate(22, _ampmSelected = true);
	        _trackFirstKey = null;
	        _hourControl.blur();
	        _minuteControl.blur();
	        _ampmControl.blur();
	      }
	      function snapMinutesToIncrement() {
	        let test = Number(_minute);
	        if (!_validMinutes.includes(test)) {
	          let adjusted = Math.floor(test / _increment) * _increment;
	          $$invalidate(17, _minute = adjusted < 10 ? `0${adjusted}` : `${adjusted}`);
	        }
	      }
	      function handleHourKey(e) {
	        const numberKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
	        const specialKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
	        const isNumber = numberKeys.includes(e.key);
	        const isSpecialKey = specialKeys.includes(e.key);
	        if (!isNumber && !isSpecialKey) {
	          return;
	        }
	        let num = _hour ? Number(_hour) : 12;
	        if (isSpecialKey) {
	          switch (e.key) {
	            case "ArrowUp":
	              num++;
	              if (num > 12) {
	                num = 1;
	              }
	              $$invalidate(15, _hour = `${num}`);
	              break;
	            case "ArrowDown":
	              num--;
	              if (num < 1) {
	                num = 12;
	              }
	              $$invalidate(15, _hour = `${num}`);
	              break;
	            case "ArrowLeft":
	              selectAmPm();
	              break;
	            case "ArrowRight":
	              selectMinute();
	              break;
	          }
	        } else {
	          if (_trackFirstKey) {
	            if (_trackFirstKey === "0") {
	              $$invalidate(15, _hour = e.key);
	            } else {
	              if (e.key === "0" || e.key === "1" || e.key === "2") {
	                $$invalidate(15, _hour += e.key);
	              } else {
	                $$invalidate(15, _hour = e.key);
	              }
	            }
	            _trackFirstKey = null;
	          } else {
	            if (e.key === "0" || e.key === "1") {
	              $$invalidate(15, _hour = e.key);
	              _trackFirstKey = e.key;
	            } else {
	              $$invalidate(15, _hour = e.key);
	            }
	          }
	        }
	        updateValue();
	      }
	      function handleMinuteKey(e) {
	        const numberKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
	        const specialKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
	        const isNumber = numberKeys.includes(e.key);
	        const isSpecialKey = specialKeys.includes(e.key);
	        if (!isNumber && !isSpecialKey) {
	          return;
	        }
	        let num = _minute ? Number(_minute) : 0;
	        if (isSpecialKey) {
	          switch (e.key) {
	            case "ArrowUp":
	              num = Math.floor((num + _increment) / _increment) * _increment;
	              if (num > 59) {
	                num = 0;
	              }
	              $$invalidate(17, _minute = num < 10 ? `0${num}` : `${num}`);
	              break;
	            case "ArrowDown":
	              num = Math.floor((num - _increment) / _increment) * _increment;
	              if (num < 0) {
	                num = 60 + num;
	              }
	              $$invalidate(17, _minute = num < 10 ? `0${num}` : `${num}`);
	              break;
	            case "ArrowLeft":
	              selectHour();
	              break;
	            case "ArrowRight":
	              selectAmPm();
	              break;
	          }
	        } else {
	          if (_trackFirstKey) {
	            if (_trackFirstKey === "0") {
	              $$invalidate(17, _minute = `0${e.key}`);
	            } else {
	              $$invalidate(17, _minute += e.key);
	            }
	            snapMinutesToIncrement();
	            _trackFirstKey = null;
	          } else {
	            if (e.key === "0" || e.key === "1" || e.key === "2" || e.key === "3" || e.key === "4" || e.key === "5") {
	              $$invalidate(17, _minute = e.key);
	              _trackFirstKey = e.key;
	            } else {
	              $$invalidate(17, _minute = `0${e.key}`);
	            }
	          }
	        }
	        updateValue();
	      }
	      function handleAmPmKey(e) {
	        const specialKeys = ["A", "P", "a", "p", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
	        const isSpecialKey = specialKeys.includes(e.key);
	        if (!isSpecialKey) {
	          return;
	        }
	        switch (e.key) {
	          case "ArrowUp":
	          case "ArrowDown":
	            $$invalidate(19, _ampm = _ampm === "AM" ? "PM" : "AM");
	            break;
	          case "ArrowLeft":
	            selectMinute();
	            break;
	          case "ArrowRight":
	            selectHour();
	            break;
	          case "A":
	          case "a":
	            $$invalidate(19, _ampm = "AM");
	            break;
	          case "P":
	          case "p":
	            $$invalidate(19, _ampm = "PM");
	            break;
	        }
	        updateValue();
	      }
	      function updateValue() {
	        let hour = Number(_hour);
	        if (_ampm === "PM") {
	          if (hour < 12) {
	            hour += 12; // E.G. 1:35 PM ==> 13:25 and 12:35 PM ==> 12:25
	          }
	        } else {
	          if (hour === 12) {
	            hour = 0; // E.G. 12:35 AM ==> 00:35
	          }
	        }
	        let minute = Number(_minute);
	        let myValue = hour < 10 ? "0" : "";
	        myValue += hour + ":";
	        myValue += minute < 10 ? "0" : "";
	        myValue += minute;
	        $$invalidate(42, value = myValue);
	        valueChanged();
	      }
	      function valueChanged(event) {
	        $$invalidate(11, _dirty = true);
	        if (value === _lastValue) {
	          return;
	        }
	        _lastValue = value;
	        doValidate.call(this);

	        // Avoid short circuit handling if changed handler changes a state value
	        window.setTimeout(() => {
	          dispatch("changed", value);
	        });
	      }
	      function doValidate() {
	        _builtInErrors = [];
	        $$invalidate(12, _errors = errors ? errors : []);
	        if (required) {
	          if (!value || value === "") {
	            _builtInErrors.push($_("validateRequired"));
	          }
	        }
	        if (validation) {
	          $$invalidate(12, _errors = _errors.concat(_builtInErrors));
	        }
	        window.setTimeout(() => {
	          let valid = _errors.length === 0;
	          if (_lastValid !== valid) {
	            _lastValid = valid;
	            dispatch("valid", valid);
	            if (notEmpty(value) && !valid && !_dirty) {
	              $$invalidate(11, _dirty = true);
	            }
	          }
	        });
	      }
	      function div0_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _hourControl = $$value;
	          $$invalidate(14, _hourControl);
	        });
	      }
	      function div2_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _minuteControl = $$value;
	          $$invalidate(16, _minuteControl);
	        });
	      }
	      function div3_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _ampmControl = $$value;
	          $$invalidate(18, _ampmControl);
	        });
	      }
	      function icon_name_binding(value) {
	        iconName = value;
	        $$invalidate(3, iconName);
	      }
	      function icon_path_binding(value) {
	        iconPath = value;
	        $$invalidate(4, iconPath);
	      }
	      function icon_url_binding(value) {
	        iconUrl = value;
	        $$invalidate(5, iconUrl);
	      }
	      function div7_binding($$value) {
	        binding_callbacks[$$value ? "unshift" : "push"](() => {
	          _highlightElement = $$value;
	          $$invalidate(13, _highlightElement);
	        });
	      }
	      $$self.$$set = $$props => {
	        if ("globalClickListener" in $$props) $$invalidate(47, globalClickListener = $$props.globalClickListener);
	        if ("globalKeyListener" in $$props) $$invalidate(48, globalKeyListener = $$props.globalKeyListener);
	        if ("display" in $$props) $$invalidate(1, display = $$props.display);
	        if ("theme" in $$props) $$invalidate(43, theme = $$props.theme);
	        if ("shape" in $$props) $$invalidate(44, shape = $$props.shape);
	        if ("density" in $$props) $$invalidate(45, density = $$props.density);
	        if ("value" in $$props) $$invalidate(42, value = $$props.value);
	        if ("label" in $$props) $$invalidate(0, label = $$props.label);
	        if ("hint" in $$props) $$invalidate(2, hint = $$props.hint);
	        if ("iconName" in $$props) $$invalidate(3, iconName = $$props.iconName);
	        if ("iconPath" in $$props) $$invalidate(4, iconPath = $$props.iconPath);
	        if ("iconUrl" in $$props) $$invalidate(5, iconUrl = $$props.iconUrl);
	        if ("required" in $$props) $$invalidate(6, required = $$props.required);
	        if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
	        if ("validation" in $$props) $$invalidate(46, validation = $$props.validation);
	        if ("errors" in $$props) $$invalidate(49, errors = $$props.errors);
	        if ("increment" in $$props) $$invalidate(50, increment = $$props.increment);
	        if ("id" in $$props) $$invalidate(51, id = $$props.id);
	      };
	      $$self.$$.update = () => {
	        if ($$self.$$.dirty[1] & /*value*/2048) {
	          // Computed values
	          $$invalidate(31, _hasValue = notEmpty(value));
	        }
	        if ($$self.$$.dirty[0] & /*label*/1) {
	          $$invalidate(32, _hasLabel = notEmpty(label));
	        }
	      };
	      return [label, display, hint, iconName, iconPath, iconUrl, required, disabled, handleFocus, handleBlur, handleClick, _dirty, _errors, _highlightElement, _hourControl, _hour, _minuteControl, _minute, _ampmControl, _ampm, _hourSelected, _minuteSelected, _ampmSelected, _hasFocus, _theme, _shape, _density, _labelId, _capId, _messageId, _statusIconId, _hasValue, _hasLabel, selectHour, deselectHour, selectMinute, deselectMinute, selectAmPm, deselectAmPm, handleHourKey, handleMinuteKey, handleAmPmKey, value, theme, shape, density, validation, globalClickListener, globalKeyListener, errors, increment, id, handleKeyDown, preventClickPropagation, div0_binding, div2_binding, div3_binding, icon_name_binding, icon_path_binding, icon_url_binding, div7_binding];
	    }
	    class TimeBox extends SvelteComponent {
	      constructor(options) {
	        super();
	        if (!document.getElementById("svelte-1x8iibg-style")) add_css();
	        init(this, options, instance, create_fragment, safe_not_equal, {
	          globalClickListener: 47,
	          globalKeyListener: 48,
	          display: 1,
	          theme: 43,
	          shape: 44,
	          density: 45,
	          value: 42,
	          label: 0,
	          hint: 2,
	          iconName: 3,
	          iconPath: 4,
	          iconUrl: 5,
	          required: 6,
	          disabled: 7,
	          validation: 46,
	          errors: 49,
	          increment: 50,
	          id: 51,
	          handleFocus: 8,
	          handleBlur: 9,
	          handleKeyDown: 52,
	          handleClick: 10,
	          preventClickPropagation: 53
	        }, [-1, -1, -1]);
	      }
	      get handleFocus() {
	        return this.$$.ctx[8];
	      }
	      get handleBlur() {
	        return this.$$.ctx[9];
	      }
	      get handleKeyDown() {
	        return this.$$.ctx[52];
	      }
	      get handleClick() {
	        return this.$$.ctx[10];
	      }
	      get preventClickPropagation() {
	        return preventClickPropagation;
	      }
	    }

	    exports.CheckBox = CheckBox;
	    exports.ColorPicker = ColorPicker;
	    exports.DatePicker = DatePicker;
	    exports.FilePicker = FilePicker;
	    exports.NumberBox = NumberBox;
	    exports.RadioButtonGroup = RadioButtonGroup;
	    exports.SelectBox = SelectBox;
	    exports.TextArea = TextArea;
	    exports.TextBox = TextBox;
	    exports.TimeBox = TimeBox;

	    Object.defineProperty(exports, '__esModule', { value: true });

	})));
	});

	var name$8 = 'prosCheckBox';
	function prosCheckBox() {
	  'ngInject';

	  return {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      hint: '@',
	      value: '=?',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      errors: '=?',
	      valid: '=?',
	      changed: '&'
	    },
	    link: checkBoxLink,
	    controller: checkBoxController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  //////////////////////

	  function checkBoxLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-check-box(value='vm.myValue' disabled required)
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      hint: scope.vm.hint,
	      value: scope.vm.value,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors
	    };
	    scope.vm.checkBox = new forms.CheckBox({
	      target: element[0],
	      props: props
	    });

	    // Watch for programmatic changes
	    scope.$watch('vm.id', function (id) {
	      scope.vm.checkBox.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.checkBox.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.checkBox.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.checkBox.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.checkBox.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.checkBox.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.checkBox.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.checkBox.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.checkBox.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.checkBox.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.checkBox.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.checkBox.$set({
	        errors: errors
	      });
	    });

	    // Update parent
	    scope.vm.checkBox.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.checkBox.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.checkBox.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function checkBoxController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    function onInit() {}
	  }
	}

	var name$7 = 'prosColorPicker';
	function prosColorPicker() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      value: '=?',
	      clear: '=?',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      errors: '=?',
	      valid: '=?',
	      changed: '&'
	    },
	    link: colorPickerLink,
	    controller: colorPickerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function colorPickerLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-color-picker(value='vm.myValue' disabled required)
	    var clear = hasValue(scope.vm.clear) ? scope.vm.clear : attrs.hasOwnProperty('clear');
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      value: scope.vm.value,
	      clear: clear,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors
	    };
	    scope.vm.colorPicker = new forms.ColorPicker({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.colorPicker.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.colorPicker.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.colorPicker.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.colorPicker.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.colorPicker.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.colorPicker.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.colorPicker.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.colorPicker.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.colorPicker.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (hasValue(scope.vm.clear)) {
	        scope.vm.colorPicker.$set({
	          clear: clear
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.colorPicker.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.colorPicker.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.colorPicker.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.colorPicker.$set({
	        errors: errors
	      });
	    });
	    scope.vm.colorPicker.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.colorPicker.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.colorPicker.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function colorPickerController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$6 = 'prosDatePicker';
	function prosDatePicker(
	  // Directive angular dependencies
	) {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      value: '=?',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      format: '@',
	      clear: '=?',
	      required: '=?',
	      disabled: '=?',
	      valid: '=?',
	      changed: '&',
	      validation: '=?',
	      errors: '=?',
	      min: '=?',
	      max: '=?'
	    },
	    link: datePickerLink,
	    controller: datePickerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function datePickerLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-date-picker(value='vm.myValue' disabled required)
	    var clear = hasValue(scope.vm.clear) ? scope.vm.clear : attrs.hasOwnProperty('clear');
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      value: scope.vm.value,
	      format: scope.vm.format,
	      clear: clear,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors,
	      min: scope.vm.min,
	      max: scope.vm.max
	    };
	    scope.vm.datePicker = new forms.DatePicker({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.datePicker.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.datePicker.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.datePicker.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.datePicker.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.datePicker.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.datePicker.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.datePicker.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.datePicker.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.datePicker.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.format', function (format) {
	      scope.vm.datePicker.$set({
	        format: format
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (scope.vm.required !== undefined) {
	        scope.vm.datePicker.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (hasValue(scope.vm.clear)) {
	        scope.vm.datePicker.$set({
	          clear: clear
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (scope.vm.disabled !== undefined) {
	        scope.vm.datePicker.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (scope.vm.clear !== undefined) {
	        scope.vm.datePicker.$set({
	          clear: clear
	        });
	      }
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.datePicker.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.datePicker.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.datePicker.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.datePicker.$set({
	        errors: errors
	      });
	    });
	    scope.$watch('vm.min', function (min) {
	      scope.vm.datePicker.$set({
	        min: min
	      });
	    });
	    scope.$watch('vm.max', function (max) {
	      scope.vm.datePicker.$set({
	        max: max
	      });
	    });
	    scope.vm.datePicker.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.datePicker.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.datePicker.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function datePickerController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$5 = 'prosFilePicker';
	function prosFilePicker() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      value: '=',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      accept: '@',
	      multiple: '=?',
	      maxFiles: '@',
	      maxLength: '@',
	      required: '=?',
	      disabled: '=?',
	      clear: '=?',
	      changed: '&',
	      validation: '=?',
	      valid: '=?',
	      errors: '=?'
	    },
	    link: filePickerLink,
	    controller: filePickerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function filePickerLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-file-picker(value='vm.myValue' disabled required)
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var clear = hasValue(scope.vm.clear) ? scope.vm.clear : attrs.hasOwnProperty('clear');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      value: scope.vm.value,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      required: required,
	      disabled: disabled,
	      clear: clear,
	      validation: scope.vm.validation,
	      details: scope.vm.details,
	      accept: scope.vm.accept,
	      multiple: scope.vm.multiple,
	      maxFiles: scope.vm.maxFiles,
	      maxLength: scope.vm.maxLength,
	      valid: scope.vm.valid,
	      errors: scope.vm.errors
	    };
	    scope.vm.filePicker = new forms.FilePicker({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.filePicker.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.filePicker.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.filePicker.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.filePicker.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.filePicker.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.filePicker.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.filePicker.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.filePicker.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.filePicker.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (scope.vm.required !== undefined) {
	        scope.vm.filePicker.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (scope.vm.disabled !== undefined) {
	        scope.vm.filePicker.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (scope.vm.clear !== undefined) {
	        scope.vm.filePicker.$set({
	          clear: clear
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.filePicker.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.filePicker.$set({
	        errors: errors
	      });
	    });
	    scope.$watch('vm.accept', function (accept) {
	      scope.vm.filePicker.$set({
	        accept: accept
	      });
	    });
	    scope.$watch('vm.multiple', function (multiple) {
	      scope.vm.filePicker.$set({
	        multiple: multiple
	      });
	    });
	    scope.$watch('vm.maxFiles', function (maxFiles) {
	      scope.vm.filePicker.$set({
	        maxFiles: maxFiles
	      });
	    });
	    scope.$watch('vm.maxLength', function (maxLength) {
	      scope.vm.filePicker.$set({
	        maxLength: maxLength
	      });
	    });
	    scope.vm.filePicker.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.filePicker.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });
	    scope.$on('$destroy', function () {
	      scope.vm.filePicker.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function filePickerController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$4 = 'prosNumberBox';
	function prosNumberBox() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      value: '=?',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      min: '@',
	      max: '@',
	      step: '@',
	      required: '=?',
	      disabled: '=?',
	      validation: '=?',
	      valid: '=?',
	      errors: '=?',
	      changed: '&'
	    },
	    link: numberBoxLink,
	    controller: numberBoxController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function numberBoxLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-check-box(value='vm.myValue' disabled required)
	    var clear = hasValue(scope.vm.clear) ? scope.vm.clear : attrs.hasOwnProperty('clear');
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      value: scope.vm.value,
	      min: scope.vm.min,
	      max: scope.vm.max,
	      step: scope.vm.step,
	      clear: clear,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors
	    };
	    scope.vm.numberBox = new forms.NumberBox({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.numberBox.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.numberBox.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.numberBox.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.numberBox.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.numberBox.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.numberBox.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.numberBox.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.numberBox.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.numberBox.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.min', function (min) {
	      scope.vm.numberBox.$set({
	        min: min
	      });
	    });
	    scope.$watch('vm.max', function (max) {
	      scope.vm.numberBox.$set({
	        max: max
	      });
	    });
	    scope.$watch('vm.step', function (step) {
	      scope.vm.numberBox.$set({
	        step: step
	      });
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (hasValue(scope.vm.clear)) {
	        scope.vm.numberBox.$set({
	          clear: clear
	        });
	      }
	    });
	    scope.$watch('vm.required', function (required) {
	      if (scope.vm.required !== undefined) {
	        scope.vm.numberBox.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (scope.vm.disabled !== undefined) {
	        scope.vm.numberBox.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.numberBox.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.numberBox.$set({
	        errors: errors
	      });
	    });
	    scope.vm.numberBox.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.numberBox.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });
	    scope.$on('$destroy', function () {
	      scope.vm.numberBox.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function numberBoxController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$3 = 'prosRadioButtonGroup';
	function prosRadioButtonGroup() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      hint: '@',
	      options: '=',
	      value: '=?',
	      orientation: '@',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      errors: '=?',
	      valid: '=?',
	      changed: '&'
	    },
	    link: radioButtonGroupLink,
	    controller: radioButtonGroupController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function radioButtonGroupLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-radio-button-group(value='vm.myValue' disabled required)
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      hint: scope.vm.hint,
	      options: scope.vm.options,
	      value: scope.vm.value,
	      orientation: scope.vm.orientation,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors
	    };
	    scope.vm.radioButtonGroup = new forms.RadioButtonGroup({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.radioButtonGroup.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.radioButtonGroup.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.radioButtonGroup.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.radioButtonGroup.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.radioButtonGroup.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.radioButtonGroup.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.radioButtonGroup.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.radioButtonGroup.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.options', function (options) {
	      scope.vm.radioButtonGroup.$set({
	        options: options
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (scope.vm.required !== undefined) {
	        scope.vm.radioButtonGroup.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (scope.vm.disabled !== undefined) {
	        scope.vm.radioButtonGroup.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.radioButtonGroup.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.radioButtonGroup.$set({
	        errors: errors
	      });
	    });
	    scope.$watch('vm.orientation', function (orientation) {
	      scope.vm.radioButtonGroup.$set({
	        orientation: orientation
	      });
	    });
	    scope.vm.radioButtonGroup.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.radioButtonGroup.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });
	    scope.$on('$destroy', function () {
	      scope.vm.radioButtonGroup.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function radioButtonGroupController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$2 = 'prosSelectBox';
	function prosSelectBox() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      options: '=',
	      valuePath: '@',
	      value: '=?',
	      multiple: '=?',
	      search: '=?',
	      clear: '=?',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      errors: '=?',
	      valid: '=?',
	      changed: '&'
	    },
	    link: selectBoxLink,
	    controller: selectBoxController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function selectBoxLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-select-box(value='vm.myValue' disabled required)
	    var multiple = hasValue(scope.vm.multiple) ? scope.vm.multiple : attrs.hasOwnProperty('multiple');
	    var search = hasValue(scope.vm.search) ? scope.vm.search : attrs.hasOwnProperty('search');
	    var clear = hasValue(scope.vm.clear) ? scope.vm.clear : attrs.hasOwnProperty('clear');
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      options: scope.vm.options,
	      valuePath: scope.vm.valuePath,
	      value: scope.vm.value,
	      multiple: multiple,
	      search: search,
	      clear: clear,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      errors: scope.vm.errors
	    };
	    scope.vm.selectBox = new forms.SelectBox({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.selectBox.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.selectBox.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.selectBox.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.selectBox.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.selectBox.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.selectBox.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.selectBox.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.selectBox.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.options', function (options) {
	      if (hasValue(scope.vm.options)) {
	        scope.vm.selectBox.$set({
	          options: options
	        });
	      }
	    });
	    scope.$watch('vm.valuePath', function (valuePath) {
	      if (hasValue(scope.vm.valuePath)) {
	        scope.vm.selectBox.$set({
	          valuePath: valuePath
	        });
	      }
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.selectBox.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.multiple', function (multiple) {
	      if (hasValue(scope.vm.multiple)) {
	        scope.vm.selectBox.$set({
	          multiple: multiple
	        });
	      }
	    });
	    scope.$watch('vm.search', function (search) {
	      if (hasValue(scope.vm.search)) {
	        scope.vm.selectBox.$set({
	          search: search
	        });
	      }
	    });
	    scope.$watch('vm.clear', function (clear) {
	      if (hasValue(scope.vm.clear)) {
	        scope.vm.selectBox.$set({
	          clear: clear
	        });
	      }
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.selectBox.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.selectBox.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.selectBox.$set({
	        errors: errors
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.selectBox.$set({
	          required: required
	        });
	      }
	    });
	    scope.vm.selectBox.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.selectBox.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.selectBox.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function selectBoxController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name$1 = 'prosTextArea';
	function prosTextArea() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      value: '=?',
	      maxLength: '@',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      regex: '=?',
	      regexkey: '=?',
	      regexmessage: '@',
	      errors: '=?',
	      valid: '=?',
	      changed: '&'
	    },
	    link: textAreaLink,
	    controller: textAreaController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function textAreaLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-check-box(value='vm.myValue' disabled required)
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      value: scope.vm.value,
	      maxLength: scope.vm.maxLength,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      regex: scope.vm.regex,
	      regexkey: scope.vm.regexkey,
	      regexmessage: scope.vm.regexmessage,
	      errors: scope.vm.errors
	    };
	    scope.vm.textArea = new forms.TextArea({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.textArea.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.textArea.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.textArea.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.textArea.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.textArea.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.textArea.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.textArea.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.textArea.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.textArea.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.maxLength', function (maxLength) {
	      scope.vm.textArea.$set({
	        maxLength: maxLength
	      });
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.textArea.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.textArea.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.textArea.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.regex', function (regex) {
	      scope.vm.textArea.$set({
	        regex: regex
	      });
	    });
	    scope.$watch('vm.regexkey', function (regexkey) {
	      scope.vm.textArea.$set({
	        regexkey: regexkey
	      });
	    });
	    scope.$watch('vm.regexmessage', function (regexmessage) {
	      scope.vm.textArea.$set({
	        regexmessage: regexmessage
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.textArea.$set({
	        errors: errors
	      });
	    });
	    scope.vm.textArea.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.textArea.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.textArea.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function textAreaController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var name = 'prosTextBox';
	function prosTextBox() {
	  'ngInject';

	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      display: '@',
	      theme: '@',
	      shape: '@',
	      density: '@',
	      label: '@',
	      placeholder: '@',
	      hint: '@',
	      iconName: '@',
	      iconPath: '@',
	      iconUrl: '@',
	      value: '=?',
	      maxLength: '@',
	      disabled: '=?',
	      validation: '=?',
	      required: '=?',
	      password: '=?',
	      regex: '=?',
	      regexkey: '@',
	      regexmessage: '@',
	      errors: '=?',
	      valid: '=?',
	      changed: '&',
	      callbacks: '=?',
	      suggested: '&'
	    },
	    link: textBoxLink,
	    controller: textBoxController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;

	  //////////////////////

	  function textBoxLink(scope, element, attrs) {
	    // Allow attribute without value
	    // For Example: pros-check-box(value='vm.myValue' disabled required)
	    var disabled = hasValue(scope.vm.disabled) ? scope.vm.disabled : attrs.hasOwnProperty('disabled');
	    var required = hasValue(scope.vm.required) ? scope.vm.required : attrs.hasOwnProperty('required');
	    var password = hasValue(scope.vm.password) ? scope.vm.password : attrs.hasOwnProperty('password');
	    var props = {
	      id: scope.vm.id,
	      display: scope.vm.display,
	      theme: scope.vm.theme,
	      shape: scope.vm.shape,
	      density: scope.vm.density,
	      label: scope.vm.label,
	      placeholder: scope.vm.placeholder,
	      hint: scope.vm.hint,
	      iconName: scope.vm.iconName,
	      iconPath: scope.vm.iconPath,
	      iconUrl: scope.vm.iconUrl,
	      value: scope.vm.value,
	      maxLength: scope.vm.maxLength,
	      disabled: disabled,
	      validation: scope.vm.validation,
	      required: required,
	      password: password,
	      regex: scope.vm.regex,
	      regexkey: scope.vm.regexkey,
	      regexmessage: scope.vm.regexmessage,
	      errors: scope.vm.errors,
	      callbacks: scope.vm.callbacks
	    };
	    scope.vm.textBox = new forms.TextBox({
	      target: element[0],
	      props: props
	    });
	    scope.$watch('vm.id', function (id) {
	      scope.vm.textBox.$set({
	        id: id
	      });
	    });
	    scope.$watch('vm.display', function (display) {
	      scope.vm.textBox.$set({
	        display: display
	      });
	    });
	    scope.$watch('vm.theme', function (theme) {
	      scope.vm.textBox.$set({
	        theme: theme
	      });
	    });
	    scope.$watch('vm.shape', function (shape) {
	      scope.vm.textBox.$set({
	        shape: shape
	      });
	    });
	    scope.$watch('vm.density', function (density) {
	      scope.vm.textBox.$set({
	        density: density
	      });
	    });
	    scope.$watch('vm.label', function (label) {
	      scope.vm.textBox.$set({
	        label: label
	      });
	    });
	    scope.$watch('vm.placeholder', function (placeholder) {
	      scope.vm.textBox.$set({
	        placeholder: placeholder
	      });
	    });
	    scope.$watch('vm.hint', function (hint) {
	      scope.vm.textBox.$set({
	        hint: hint
	      });
	    });
	    scope.$watch('vm.iconName', function (iconName) {
	      scope.vm.textBox.$set({
	        iconName: iconName
	      });
	    });
	    scope.$watch('vm.iconPath', function (iconPath) {
	      scope.vm.textBox.$set({
	        iconPath: iconPath
	      });
	    });
	    scope.$watch('vm.iconUrl', function (iconUrl) {
	      scope.vm.textBox.$set({
	        iconUrl: iconUrl
	      });
	    });
	    scope.$watch('vm.value', function (value) {
	      scope.vm.textBox.$set({
	        value: value
	      });
	    });
	    scope.$watch('vm.maxLength', function (maxLength) {
	      scope.vm.textBox.$set({
	        maxLength: maxLength
	      });
	    });
	    scope.$watch('vm.disabled', function (disabled) {
	      if (hasValue(scope.vm.disabled)) {
	        scope.vm.textBox.$set({
	          disabled: disabled
	        });
	      }
	    });
	    scope.$watch('vm.validation', function (validation) {
	      scope.vm.textBox.$set({
	        validation: validation
	      });
	    });
	    scope.$watch('vm.required', function (required) {
	      if (hasValue(scope.vm.required)) {
	        scope.vm.textBox.$set({
	          required: required
	        });
	      }
	    });
	    scope.$watch('vm.password', function (password) {
	      if (hasValue(scope.vm.password)) {
	        scope.vm.textBox.$set({
	          password: password
	        });
	      }
	    });
	    scope.$watch('vm.regex', function (regex) {
	      scope.vm.textBox.$set({
	        regex: regex
	      });
	    });
	    scope.$watch('vm.regexkey', function (regexkey) {
	      scope.vm.textBox.$set({
	        regexkey: regexkey
	      });
	    });
	    scope.$watch('vm.regexmessage', function (regexmessage) {
	      scope.vm.textBox.$set({
	        regexmessage: regexmessage
	      });
	    });
	    scope.$watch('vm.errors', function (errors) {
	      scope.vm.textBox.$set({
	        errors: errors
	      });
	    });
	    scope.$watch('vm.callbacks', function (callbacks) {
	      scope.vm.textBox.$set({
	        callbacks: callbacks
	      });
	    });
	    scope.vm.textBox.$on('valid', function (event) {
	      scope.$parent.$apply(function () {
	        scope.vm.valid = event.detail;
	        scope.$emit('update:valid', event);
	      });
	    });
	    scope.vm.textBox.$on('changed', function (event) {
	      // Need to make sure that the variable value is updated in the parent scope before we tell parent value changed
	      scope.$parent.$apply(function () {
	        scope.vm.value = event.detail;
	      });

	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('changed', event);
	        scope.vm.changed();
	      });
	    });
	    scope.vm.textBox.$on('suggested', function (event) {
	      // Want to put this on Angular thread to make sure we pick up any changes made by parent
	      scope.$parent.$applyAsync(function () {
	        scope.$emit('suggested', event);
	        scope.vm.suggested({
	          suggestion: event.detail
	        });
	      });
	    });

	    // Destroy
	    scope.$on('$destroy', function () {
	      scope.vm.textBox.$destroy();
	    });

	    // Helpers
	    function hasValue(value) {
	      return value !== undefined && value !== null;
	    }
	  }

	  /** @ngInject */
	  function textBoxController() {
	    var vm = this;
	    vm.$onInit = onInit;
	    return;
	    function onInit() {}
	  }
	}

	var forms_module = angular.module('printos.forms', []).directive(name$8, prosCheckBox).directive(name$7, prosColorPicker).directive(name$6, prosDatePicker).directive(name$5, prosFilePicker).directive(name$4, prosNumberBox).directive(name$3, prosRadioButtonGroup).directive(name$2, prosSelectBox).directive(name$1, prosTextArea).directive(name, prosTextBox).name;

	return forms_module;

})));
